webpackJsonp([114276838955818,60335399758886],{

/***/ 103:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Jack's site Hopefully"}}},"layoutContext":{}}

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(213);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(103);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(2);
	var factory = __webpack_require__(154);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(298);
	var isArguments = __webpack_require__(297);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 297:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 298:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(429);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(296);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(411);
	
	var _HelmetConstants = __webpack_require__(185);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 185:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(5);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(185);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(305);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(450);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(130);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VerticalTimeline = function VerticalTimeline(_ref) {
	  var animate = _ref.animate,
	      children = _ref.children,
	      className = _ref.className;
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)(className, 'vertical-timeline', {
	        'vertical-timeline--animate': animate
	      })
	    },
	    children
	  );
	};
	
	VerticalTimeline.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired,
	  className: _propTypes2.default.string,
	  animate: _propTypes2.default.bool
	};
	
	VerticalTimeline.defaultProps = {
	  animate: true,
	  className: ''
	};
	
	exports.default = VerticalTimeline;

/***/ }),

/***/ 431:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(130);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactVisibilitySensor = __webpack_require__(433);
	
	var _reactVisibilitySensor2 = _interopRequireDefault(_reactVisibilitySensor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VerticalTimelineElement = function (_Component) {
	  _inherits(VerticalTimelineElement, _Component);
	
	  function VerticalTimelineElement(props) {
	    _classCallCheck(this, VerticalTimelineElement);
	
	    var _this = _possibleConstructorReturn(this, (VerticalTimelineElement.__proto__ || Object.getPrototypeOf(VerticalTimelineElement)).call(this, props));
	
	    _this.onVisibilitySensorChange = _this.onVisibilitySensorChange.bind(_this);
	    _this.state = { visible: false };
	    return _this;
	  }
	
	  _createClass(VerticalTimelineElement, [{
	    key: 'onVisibilitySensorChange',
	    value: function onVisibilitySensorChange(isVisible) {
	      if (isVisible) {
	        this.setState({ visible: true });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          id = _props.id,
	          children = _props.children,
	          icon = _props.icon,
	          iconStyle = _props.iconStyle,
	          iconOnClick = _props.iconOnClick,
	          date = _props.date,
	          position = _props.position,
	          style = _props.style,
	          className = _props.className;
	
	
	      return _react2.default.createElement(
	        'div',
	        {
	          id: id,
	          className: (0, _classnames2.default)(className, 'vertical-timeline-element', {
	            'vertical-timeline-element--left': position === 'left',
	            'vertical-timeline-element--right': position === 'right',
	            'vertical-timeline-element--no-children': children === ''
	          }),
	          style: style
	        },
	        _react2.default.createElement(
	          _reactVisibilitySensor2.default,
	          { onChange: this.onVisibilitySensorChange },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'span',
	              { // eslint-disable-line jsx-a11y/no-static-element-interactions
	                style: iconStyle,
	                onClick: iconOnClick,
	                className: 'vertical-timeline-element-icon ' + (this.state.visible ? 'bounce-in' : 'is-hidden')
	              },
	              icon
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: 'vertical-timeline-element-content ' + (this.state.visible ? 'bounce-in' : 'is-hidden')
	              },
	              children,
	              _react2.default.createElement(
	                'span',
	                { className: 'vertical-timeline-element-date' },
	                date
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return VerticalTimelineElement;
	}(_react.Component);
	
	VerticalTimelineElement.propTypes = {
	  id: _propTypes2.default.string,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  className: _propTypes2.default.string,
	  icon: _propTypes2.default.element,
	  iconStyle: _propTypes2.default.shape({}),
	  iconOnClick: _propTypes2.default.func,
	  style: _propTypes2.default.shape({}),
	  date: _propTypes2.default.string,
	  position: _propTypes2.default.string
	};
	
	VerticalTimelineElement.defaultProps = {
	  id: '',
	  children: '',
	  className: '',
	  icon: null,
	  iconStyle: null,
	  style: null,
	  date: '',
	  position: '',
	  iconOnClick: null
	};
	
	exports.default = VerticalTimelineElement;

/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// this should be the entry point to your library
	module.exports = {
	  VerticalTimeline: __webpack_require__(430).default, // eslint-disable-line global-require
	  VerticalTimelineElement: __webpack_require__(431).default // eslint-disable-line global-require
	};

/***/ }),

/***/ 306:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 432:
/***/ (function(module, exports) {

	// Tell whether the rect is visible, given an offset
	//
	// return: boolean
	module.exports = function (offset, rect, containmentRect) {
	  var offsetDir = offset.direction;
	  var offsetVal = offset.value;
	
	  // Rules for checking different kind of offsets. In example if the element is
	  // 90px below viewport and offsetTop is 100, it is considered visible.
	  switch (offsetDir) {
	  case 'top':
	    return ((containmentRect.top + offsetVal) < rect.top) &&
	      (containmentRect.bottom > rect.bottom) &&
	      (containmentRect.left < rect.left) &&
	      (containmentRect.right > rect.right);
	
	  case 'left':
	    return ((containmentRect.left + offsetVal) < rect.left) &&
	      (containmentRect.bottom > rect.bottom) &&
	      (containmentRect.top < rect.top) &&
	      (containmentRect.right > rect.right);
	
	  case 'bottom':
	    return ((containmentRect.bottom - offsetVal) > rect.bottom) &&
	      (containmentRect.left < rect.left) &&
	      (containmentRect.right > rect.right) &&
	      (containmentRect.top < rect.top);
	
	  case 'right':
	    return ((containmentRect.right - offsetVal) > rect.right) &&
	      (containmentRect.left < rect.left) &&
	      (containmentRect.top < rect.top) &&
	      (containmentRect.bottom > rect.bottom);
	  }
	}


/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(2);
	var ReactDOM = __webpack_require__(105);
	var PropTypes = __webpack_require__(6);
	var createReactClass = __webpack_require__(295);
	var isVisibleWithOffset = __webpack_require__(432)
	
	var containmentPropType = PropTypes.any;
	
	if (typeof window !== 'undefined') {
	  containmentPropType = PropTypes.instanceOf(window.Element);
	}
	
	function throttle (callback, limit) {
	    var wait = false;
	    return function () {
	        if (!wait) {
	            wait = true;
	            setTimeout(function () {
	                callback();
	                wait = false;
	            }, limit);
	        }
	    }
	}
	
	function debounce(func, wait) {
	  var timeout;
	  return function() {
	    var context = this, args = arguments;
	    var later = function() {
	      timeout = null;
	      func.apply(context, args);
	    };
	    clearTimeout(timeout);
	    timeout = setTimeout(later, wait);
	  };
	}
	
	module.exports = createReactClass({
	  displayName: 'VisibilitySensor',
	
	  propTypes: {
	    onChange: PropTypes.func,
	    active: PropTypes.bool,
	    partialVisibility: PropTypes.oneOfType([
	      PropTypes.bool,
	      PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	    ]),
	    delayedCall: PropTypes.bool,
	    offset: PropTypes.oneOfType([
	      PropTypes.shape({
	        top: PropTypes.number,
	        left: PropTypes.number,
	        bottom: PropTypes.number,
	        right: PropTypes.number
	      }),
	      // deprecated offset property
	      PropTypes.shape({
	        direction: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	        value: PropTypes.number
	      })
	    ]),
	    scrollCheck: PropTypes.bool,
	    scrollDelay: PropTypes.number,
	    scrollThrottle: PropTypes.number,
	    resizeCheck: PropTypes.bool,
	    resizeDelay: PropTypes.number,
	    resizeThrottle: PropTypes.number,
	    intervalCheck: PropTypes.bool,
	    intervalDelay: PropTypes.number,
	    containment: containmentPropType,
	    children: PropTypes.oneOfType([
	      PropTypes.element,
	      PropTypes.func,
	    ]),
	    minTopValue: PropTypes.number,
	  },
	
	  getDefaultProps: function () {
	    return {
	      active: true,
	      partialVisibility: false,
	      minTopValue: 0,
	      scrollCheck: false,
	      scrollDelay: 250,
	      scrollThrottle: -1,
	      resizeCheck: false,
	      resizeDelay: 250,
	      resizeThrottle: -1,
	      intervalCheck: true,
	      intervalDelay: 100,
	      delayedCall: false,
	      offset: {},
	      containment: null,
	      children: React.createElement('span')
	    };
	  },
	
	  getInitialState: function () {
	    return {
	      isVisible: null,
	      visibilityRect: {}
	    };
	  },
	
	  componentDidMount: function () {
	    this.node = ReactDOM.findDOMNode(this);
	    if (this.props.active) {
	      this.startWatching();
	    }
	  },
	
	  componentWillUnmount: function () {
	    this.stopWatching();
	  },
	
	  componentWillReceiveProps: function (nextProps) {
	    if (nextProps.active && !this.props.active) {
	      this.setState(this.getInitialState());
	      this.startWatching();
	    } else if (!nextProps.active) {
	      this.stopWatching();
	    }
	  },
	
	  getContainer: function () {
	    return this.props.containment || window;
	  },
	
	  addEventListener: function (target, event, delay, throttle) {
	    if (!this.debounceCheck) {
	      this.debounceCheck = {};
	    }
	
	    var timeout;
	    var func;
	
	    var later = function () {
	      timeout = null;
	      this.check();
	    }.bind(this);
	
	    if (throttle > -1) {
	      func = function () {
	        if (!timeout) {
	          timeout = setTimeout(later, throttle || 0);
	        }
	      };
	    } else {
	      func = function () {
	        clearTimeout(timeout);
	        timeout = setTimeout(later, delay || 0);
	      };
	    }
	
	    var info = {
	      target: target,
	      fn: func,
	      getLastTimeout: function () {
	        return timeout;
	      },
	    };
	
	    target.addEventListener(event, info.fn);
	    this.debounceCheck[event] = info;
	  },
	
	  startWatching: function () {
	    if (this.debounceCheck || this.interval) { return; }
	
	    if (this.props.intervalCheck) {
	      this.interval = setInterval(this.check, this.props.intervalDelay);
	    }
	
	    if (this.props.scrollCheck) {
	      this.addEventListener(
	        this.getContainer(),
	        'scroll',
	        this.props.scrollDelay,
	        this.props.scrollThrottle
	      );
	    }
	
	    if (this.props.resizeCheck) {
	      this.addEventListener(
	        window,
	        'resize',
	        this.props.resizeDelay,
	        this.props.resizeThrottle
	      );
	    }
	
	    // if dont need delayed call, check on load ( before the first interval fires )
	    !this.props.delayedCall && this.check();
	  },
	
	  stopWatching: function () {
	    if (this.debounceCheck) {
	      // clean up event listeners and their debounce callers
	      for (var debounceEvent in this.debounceCheck) {
	        if (this.debounceCheck.hasOwnProperty(debounceEvent)) {
	          var debounceInfo = this.debounceCheck[debounceEvent];
	
	          clearTimeout(debounceInfo.getLastTimeout());
	          debounceInfo.target.removeEventListener(
	            debounceEvent, debounceInfo.fn
	          );
	
	          this.debounceCheck[debounceEvent] = null;
	        }
	      }
	    }
	    this.debounceCheck = null;
	
	    if (this.interval) { this.interval = clearInterval(this.interval); }
	  },
	
	  /**
	   * Check if the element is within the visible viewport
	   */
	  check: function () {
	    var el = this.node;
	    var rect;
	    var containmentRect;
	    // if the component has rendered to null, dont update visibility
	    if (!el) {
	      return this.state;
	    }
	
	    rect = el.getBoundingClientRect();
	
	    if (this.props.containment) {
	      var containmentDOMRect = this.props.containment.getBoundingClientRect();
	      containmentRect = {
	        top: containmentDOMRect.top,
	        left: containmentDOMRect.left,
	        bottom: containmentDOMRect.bottom,
	        right: containmentDOMRect.right,
	      }
	    } else {
	      containmentRect = {
	        top: 0,
	        left: 0,
	        bottom: window.innerHeight || document.documentElement.clientHeight,
	        right: window.innerWidth || document.documentElement.clientWidth
	      };
	    }
	
	    // Check if visibility is wanted via offset?
	    var offset = this.props.offset || {};
	    var hasValidOffset = typeof offset === 'object';
	    if (hasValidOffset) {
	      containmentRect.top += offset.top || 0;
	      containmentRect.left += offset.left || 0;
	      containmentRect.bottom -= offset.bottom || 0;
	      containmentRect.right -= offset.right || 0;
	    }
	
	    var visibilityRect = {
	      top: rect.top >= containmentRect.top,
	      left: rect.left >= containmentRect.left,
	      bottom: rect.bottom <= containmentRect.bottom,
	      right: rect.right <= containmentRect.right
	    };
	
	    var isVisible = (
	      visibilityRect.top &&
	      visibilityRect.left &&
	      visibilityRect.bottom &&
	      visibilityRect.right
	    );
	
	    // check for partial visibility
	    if (this.props.partialVisibility) {
	      var partialVisible =
	          rect.top <= containmentRect.bottom && rect.bottom >= containmentRect.top &&
	          rect.left <= containmentRect.right && rect.right >= containmentRect.left;
	
	      // account for partial visibility on a single edge
	      if (typeof this.props.partialVisibility === 'string') {
	        partialVisible = visibilityRect[this.props.partialVisibility]
	      }
	
	      // if we have minimum top visibility set by props, lets check, if it meets the passed value
	      // so if for instance element is at least 200px in viewport, then show it.
	      isVisible = this.props.minTopValue
	        ? partialVisible && rect.top <= (containmentRect.bottom - this.props.minTopValue)
	        : partialVisible
	    }
	
	    // Deprecated options for calculating offset.
	    if (typeof offset.direction === 'string' &&
	        typeof offset.value === 'number') {
	      console.warn('[notice] offset.direction and offset.value have been deprecated. They still work for now, but will be removed in next major version. Please upgrade to the new syntax: { %s: %d }', offset.direction, offset.value)
	
	      isVisible = isVisibleWithOffset(offset, rect, containmentRect);
	    }
	
	    var state = this.state;
	    // notify the parent when the value changes
	    if (this.state.isVisible !== isVisible) {
	      state = {
	        isVisible: isVisible,
	        visibilityRect: visibilityRect
	      };
	      this.setState(state);
	      if (this.props.onChange) this.props.onChange(isVisible, visibilityRect);
	    }
	
	    return state;
	  },
	
	  render: function () {
	    if (this.props.children instanceof Function) {
	      return this.props.children({
	        isVisible: this.state.isVisible,
	        visibilityRect: this.state.visibilityRect,
	      });
	    }
	    return React.Children.only(this.props.children);
	  }
	});


/***/ }),

/***/ 450:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(127);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var footer = function footer() {
	  return _react2.default.createElement(
	    'section',
	    { className: 'black' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container footer' },
	      _react2.default.createElement(
	        'div',
	        { className: 'flex-row footer-row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-col flex' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'hey there'
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            'would you like to reach out?'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-row' },
	          _react2.default.createElement(
	            'a',
	            { href: 'https://medium.com/@jacklye' },
	            _react2.default.createElement('img', { src: _index.medium, className: 'footer-icons', alt: '' })
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://github.com/catncradle' },
	            _react2.default.createElement('img', { className: 'footer-icons', src: _index.github, alt: 'github' })
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.linkedin.com/in/jacklye/' },
	            _react2.default.createElement('img', { src: _index.linkedin, alt: '', className: 'footer-icons' })
	          ),
	          _react2.default.createElement(
	            'a',
	            null,
	            _react2.default.createElement('img', { src: _index.email, alt: '', className: 'footer-icons' })
	          )
	        )
	      )
	    )
	  );
	};
	exports.default = footer;
	module.exports = exports['default'];

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(98);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'header' },
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Jack Lye'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'header-nav' },
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: '#intro' },
	            'Intro'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: '#one' },
	            'What I Do'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: '#two' },
	            'Who I Am'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: '#work' },
	            'My Work'
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: '#contact' },
	            'Contact'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 451:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 452:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 453:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _cat = __webpack_require__(451);
	
	Object.defineProperty(exports, 'cat', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_cat).default;
	  }
	});
	
	var _lifeGuard = __webpack_require__(454);
	
	Object.defineProperty(exports, 'lifeGuard', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_lifeGuard).default;
	  }
	});
	
	var _coding = __webpack_require__(452);
	
	Object.defineProperty(exports, 'coding', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_coding).default;
	  }
	});
	
	var _medical = __webpack_require__(455);
	
	Object.defineProperty(exports, 'medical', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_medical).default;
	  }
	});
	
	var _professor = __webpack_require__(456);
	
	Object.defineProperty(exports, 'professor', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_professor).default;
	  }
	});
	
	var _elearning = __webpack_require__(453);
	
	Object.defineProperty(exports, 'fellow', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_elearning).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 454:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 455:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 456:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Intro = function Intro() {
	  return _react2.default.createElement(
	    "section",
	    { id: "intro", className: "main style1 dark fullscreen" },
	    _react2.default.createElement(
	      "div",
	      { className: "main-content" },
	      _react2.default.createElement(
	        "div",
	        { className: "heading-primary" },
	        _react2.default.createElement(
	          "h2",
	          { className: "heading-primary-main" },
	          "Howdy."
	        ),
	        _react2.default.createElement(
	          "span",
	          { className: "heading-primary-secondary" },
	          "My name is Jack nice to meet you!",
	          _react2.default.createElement("br", null),
	          "I'm a software engineer based in New York City."
	        )
	      ),
	      _react2.default.createElement(
	        "footer",
	        null,
	        _react2.default.createElement("a", { href: "#one", className: "button button-down" })
	      )
	    )
	  );
	};
	
	exports.default = Intro;
	module.exports = exports["default"];

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.portfolio = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _img = __webpack_require__(212);
	
	var _index = __webpack_require__(127);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Materialize = typeof window !== 'undefined' ? __webpack_require__(128) : null;
	
	var portfolio = exports.portfolio = function (_Component) {
	  _inherits(portfolio, _Component);
	
	  function portfolio(props) {
	    _classCallCheck(this, portfolio);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      item1: false,
	      item2: false,
	      item3: false
	    };
	    return _this;
	  }
	
	  portfolio.prototype.componentDidMount = function componentDidMount() {
	    console.log('here');
	
	    console.log('here');
	    var elems = document.querySelectorAll('.modal');
	    var instances = Materialize.Modal.init(elems);
	  };
	
	  portfolio.prototype.render = function render() {
	    return _react2.default.createElement(
	      'section',
	      { className: 'portfolio', id: 'work' },
	      _react2.default.createElement(
	        'header',
	        { className: 'center portfolio-header teal lighten-4' },
	        'My Portfolio'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'portfolio-items' },
	        _react2.default.createElement(
	          'div',
	          { className: 'portfolio-item' },
	          _react2.default.createElement(
	            'a',
	            { className: 'modal-trigger', href: '#modal1' },
	            _react2.default.createElement('img', {
	              src: _img.suitz,
	              alt: 'portfolio item 1',
	              className: 'portfolio-image responsive-img'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'portfolio-item' },
	          _react2.default.createElement(
	            'a',
	            { className: 'modal-trigger', href: '#modal2' },
	            _react2.default.createElement('img', {
	              src: _img.suitsCard,
	              alt: 'portfolio item 2',
	              className: 'portfolio-image responsive-img'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'portfolio-item' },
	          _react2.default.createElement(
	            'a',
	            { className: 'modal-trigger', href: '#modal3' },
	            _react2.default.createElement('img', {
	              src: _img.coffeeFindr,
	              alt: '',
	              className: 'portfolio-image responsive-img'
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { id: 'modal1', className: 'modal' },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-content' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            'Suitsz Ecommerce site '
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'An Ecommerce site built with Fullstack Javascript, using React/Redux on the front end, Express for the backend with postgreSQL with Sequelize as the ORM, and deployed on heroku'
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://suitz.herokuapp.com/' },
	            _react2.default.createElement('img', {
	              src: _img.suitz,
	              alt: 'portfolio item 1',
	              className: 'portfolio-image responsive-img'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-footer' },
	          _react2.default.createElement(
	            'a',
	            {
	              href: 'https://suitz.herokuapp.com/',
	              className: 'modal-close waves-effect waves-green btn-flat'
	            },
	            'Click here to visit'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { id: 'modal2', className: 'modal' },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-content' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            'Suits - Card Game Generator'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'A double interfaced card game generator, which allows a user to scaffold out rules for a game, allow them to to choose the amount of players, how the phases of a turn play out, and how the game is won. The game runs on a validator function and is built on React/Node and Firebase.'
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://suits-card-generator.firebaseapp.com/' },
	            _react2.default.createElement('img', {
	              src: _img.suitsCard,
	              alt: 'portfolio item 2',
	              className: 'portfolio-image responsive-img'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-footer' },
	          _react2.default.createElement(
	            'a',
	            {
	              href: 'https://www.youtube.com/watch?v=GQEp18eyhEo',
	              className: 'modal-close waves-effect waves-green btn-flat'
	            },
	            'View Presentation!'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { id: 'modal3', className: 'modal' },
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-content' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            'Coffee Findr'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'A webapp built in React, using the google maps API to find the five closest coffee shops to the user\'s device location or by dropping a pin, the user can then get the walking distance/time for each coffee shop by clicking the coffee cups that show up on the map.'
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.youtube.com/watch?v=2-PhtikiXgE' },
	            _react2.default.createElement('img', {
	              src: _img.coffeeFindr,
	              alt: 'portfolio item 2',
	              className: 'portfolio-image responsive-img'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-footer' },
	          _react2.default.createElement(
	            'a',
	            {
	              href: 'https://www.youtube.com/watch?v=2-PhtikiXgE',
	              className: 'modal-close waves-effect waves-green btn-flat'
	            },
	            'View Presentation!'
	          )
	        )
	      )
	    );
	  };
	
	  return portfolio;
	}(_react.Component);
	
	exports.default = portfolio;

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var storyComp = function storyComp(_ref) {
	  var info = _ref.info;
	  return _react2.default.createElement(
	    'section',
	    {
	      className: 'story-' + info.direction,
	      id: info.direction === 'right' ? 'one' : 'two',
	      style: { backgroundImage: 'url(' + info.pic + ')' }
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'story-' + info.direction + '-box' },
	      _react2.default.createElement(
	        'div',
	        { className: 'flex-col' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'teal-text text-darken-1 text-outline' },
	          info.title
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'white-text text-outline' },
	          info.text
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'white-text text-outline' },
	          info.text2
	        )
	      )
	    )
	  );
	};
	
	exports.default = storyComp;
	module.exports = exports['default'];

/***/ }),

/***/ 457:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEACAQAAAD2e2DtAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfiBR8WLREF831PAAAdEklEQVR42u2deXxV1bXHfzuRkBDCpBVlUKsMcQZKZVIZouJEiwyCVEJRnxPFGS0+fSpqrYrUVqt9bZ1A6/gQRMWhCTMUQcA6lDBHhoBKFEIYk/zeHwnx5ubm7DOtve/NzTef4qc5J3utvfY6++yzh7UU6jnMRCd0QAtkIQtNkRX1k4F9KIn62YMSlOAHrEeBKrWtvzTKtgLhQ4X2yEZndEY2OqNtoDpuQUH1z9eqwnbdwqfeOABboi+6Ihud0QkZIiL2Yy0KUIBVmKu+s13fsEh4B2AmzsEA5KALUswJxefIRz7mq1226x+UhHUANkYvDMAAnIVG1pQox6fIRz4Wqb227eGXBHQAdsNADEAfoY7eDwfxL+TjYyxRtK2KVxLKAdgeV2I0TratR51sxCuYptbYVsMLCeIAzMJQ5KJfQui7FNPweqIME+PeoEzF+RiNwWhiWxNPHMJsTMMsdcC2Ijri2gF4JnIxCsfY1sM3P+BNTMPCxBsZxAG8mItYP/gPc3mEbXsmEFQcwk9tt1rIbOQNbGzbsgkAU/krfmm7tYTYxjvY1LaFo4mjMQAbIRcTcZJtPUQpxh/xlPretho/EicOwHRcgzvR3rYeRijBs5iidthWo5I4cACm4Abci9a29TDKfvwF98fDSoJ1B+BZeBbdbGthhR2YoKbZVsKqA7AVHsE1Blfx4o/5GKe+sKmANeNTcSwKcG1SNz9wLlbyCWbZU8BSD8Az8Az62Kt2nLENt6nX7Yi28Pwxi1PwaUPzR9AGr/GfzLYh2ngPwOF4Em1sVDXuOYgpmKT2mRVq1AHYBM9gjNkKJhhf4HL1H5MCDb4CeCqWNTS/htOwnGNNCjTmAByLT3CKyaolKE3wPKeZWzMw8gpgJp5Brqkq1QvW4HL1mQlBBnoAnoZlDc3vkU5YyhtNCBJ3AF6NT+J4G2f80hh/5ltsLi1G9BXATPwFV0pXoV6zESPVJ5ICBB2A7fABTpVUPik4hGvUVLnixV4BPBmLG5o/BBrhJf5WrnihHoA98R5ayamddDyFW2TOJos4AC/Gmwm2jz/+eROjJU4ZCLwCmIuZDc0fOsPxgcQ3QegOwAl4EQ274CXoh/kMfRkt1FcAFSbjNnMWSUIKcaFaHWaBIToAG+H5hq9+cXZikFoSXnGhOQAb4W1cYsMiScc+DFJ5YRUW0hiACs83NL8hMjCD3cMqLKxB4OSGzt8gTTGbncMpKhQH4ISGoZ9hjsJHbBdGQSGMAZiLF+0fMElCvsI5qjhoIYEbjhdjZsN3vyWWIidoLNOADsCeyGuY9bPIhxikDgUpINAYgCfjvYbmt8pATGWghzjAH7MdFifQge4DWIcCFGALdlcFha78716kIxNNkVn1byt0QAd0RAdYPLDliafVeP9/7NsBmImlcb/eX44VWFEV6nmTKvdYw9bogI7oinNwBlJtV8WRier3fv/UvwNMi+Mvf+JzzEE+5oVzAp9Z6IVzcDZ6xFF00kjKcb6a4+9PfToAr8bfbdc6JlsxC/mYIxOmkY1wFoZiOEL5Ag+V7eiqtvv5Q18OwNPwSdw9C6WYjqnIl4/pT4U+GIFhcRa/cC7O8/qS82uATH5lO+BWDcr5MUcz06y9mcJ+fJa7bFc+godMVf0l2zWNoIgT2dZs09ewRTPexk22jVBFBS80UeWxtutZTSHHMd1e41dbJJUjuNS2MUiS34azPuBU2VNZaruWJMk1vIr2EkXEsszZnM4K22bhItGgtGwSF1E8P+cVjMvvcv6MC2wbh5MlK/ii7dpxJ69jXIeV4uXWxwS/lKracMsVq+BzPMp2A7uwUzrv4R6LdiqmRNBNZnGr1eZfyV62m9aDtdpwqkVbvSxRpSkWK7SLN8XnW9/RYoP4jTWLDQi7MmfwkLXKzLf5pR/IasdwtiWbrWaaOx1dTQVTYYGluH7Eo7hXlYVSVDo6VmUWbRmRSbgJ9qEUpSjFHpSiCOuwHuuxTn0bikyF8XgUNmYr7lWuZgbdOcBYPG+hCsBO5Kr3gxXBDPTGAHRDZxzvaftLCb7CQizAoqALSzwN/8Dp4raKZj9OVRv0t7lwALZCAWyMvhdjpNrs94+Zhh4YgP7oiaCpWlZjAebiXbXbty6N8TSuEbNTXcxWF4dSDv/Xylvscb9zWlTszxe4O2R99nMGR/kP68x7LNhwWBjNfxbLjStexqt8atuJD7FQULN9nM5h/lyTY3jQsB23BI43yBQL+bv2cpAPTRWHcrEhDTfxNj99AS8IvV/SMSWoA4wzrDBZzN6etTyCo43vUdjFyfS8JZZdWWRUyzKeEaT507ndsFk302M4WabxWq43rOVhDvEFHutR3+NZYFTHd4I4wG8MG/RLr88Uh/FrwzpGU8K7ve1KYDvRUUptuvpt/kaGjfslPcUVY0d+aFS/utnIoZ4072R0kni6Xwe42qgRN3t5+pnBSdxvVD8dc9nBg/7dDO4mrKCfaSimcp1B8xV7efczhxsM6uaWEnrIhsC+3GdMMz/5iPgrg6bb637kzxQ+YGFmwi2vug/lxkHGFtjK6TVcN5XBzV9l7r/72Zp5xvTyx0YPzpxrTKtXvDrAEIMmcz3rx/6Gv6L9UcabXdfoKWM6dfLmAObm/x53rdNdcdz1R/OYu0PbbMwVhjR6yUvzX2zMUC63MTPF2LMSFtPcbVtnB0PTw4d4knsHWGTISN+5+/RjGt8wpFGYfOhuKYYjDenj9jgvzzSkUAVdrVezGfMNaRQ2y3mkqxr+1Yg2+9iituxYe2RMJXh61M1uH7bGPPQ3pFHY/Azvuzq0ejNMZBBPx4jav6w1VGEqthg5+LwAA/R7/dgM89DFgDZyfIRL9WGceApWQf6o2xJV6xO1dg9wvpHm340rXDR/GmYkePMDF+Al/ReB+gpBV+7d0Isdo39V2wFGGzHLvWqr7ham4OWE7fwjuQJPurjrQWwxoIvu9c4sI6d/V7o55pFwH35OuEj7xMsN6FEY3RtF9wBDDcT9I27UBzPhXfiNuCbmeJj9dLeoN5AvrsdxiNIj2gFMfAG8oE94wP74nQFNzJGCl118Eo5HoKifrohasazRIbA9CsXDPhejs+6oBVtjVZyFYAqDWeoXulv4OO4Q1mIPjomML1yzB7jSQNTvu7XNn4J/1MPmBwbxJu09k1AkrEVT1Ni9VNMB5L8AvsDftPfch7DPtsYLj7GL8w2qBE+Ia1HjJRDxxLMbPhUXPkq96nwDc/CRiaT2lvgSXZznP5iFzZDNGU4cp6o/OSPX4gaKV38t3tDoloG/CTf/ZqxEEbahqOrf79ACR1f9HIMe6OPqLO87mI3lKEBndMdF0L7bqzkVN+AppxtUCf+Cu0QtoDAQz8X4PT8W/wrVbv3gJEHpn3ESu2k1SOcAPsx/sazOcrbzsqi/uczD+Yli3dcAj+UB4Xb4RyyxjblXWGyhboWcHUV2+pZzLm/lT709JjySE7klRmnbeXSMu4/24ALPaGX/XbglYkUVZj9hoeQ4bcUl9vm/S99B7dmIo7gsqrzL6rj3Mtcalem2aTNbPOJgbQ1EO1+SLNKdn+Gw0GUu08+/uXCDsyOi/810uG+ma720M34eyvLHLbVFLhQWOVFT5bSQzyFt4MhgyVQidFMcxxKS5PUOd13vQbtLtU4ny7vRAjOFz66X6wI98dpQpd3jNkiSayc4ju+TThk72d2DhvO08laLtsfuqL2YvFBUHPmxprpHhHjCdxeFkthytJNbMc2Tlj/XyHpAuEWqgn4d/uaWnnubqrl+BU4MSdJ69FLvyVRCTVMHHa4edF8SgNs111+TqUM1OTX+n/A5gD3OO+OoQgvvkO/thHG4eNK0jCdoSvtMtE2qXkIpAMCWwhuvpmvyWw6B17NrsXkWFwRPpmqIVOjOD/k50umeXhEPJQeL+hp5nrMuIcX20U6wSONR35JY27QjSjtRuFUuBA6PAfzGkHDHVuedLuyEMMJAz4F+sTW+aIpRTpfVBiwTld8NOOwA2aKCZmkyeYWxC2k9hoUTUNYowzXXZQeC2cBhB+gsKsj5+Vch7ELYjV8kzLs/knM1kf3fFJWeDQBHAFTwdnTYG4RzTst+OC6ghAqMUl95UuknGITuaIO2aIOj8B22YSu2YTlmhRMi2jUpGIJn676sNnMdPASe8cjhx57HiQ41PtM0xguBJdzjvs5sy9u5oM5j5uVcwNv9B6f3obtmVSAE6zhRGeKOF4gKedKxgmmBD0dvcDvpy5Z8zFVcnn18jC0NOUBZrMXliBKvEm2b/pVjAIsjAPQInKT9bjczcEzjBKzHBFe7fdIxAes5IezVhJikYojj9YWi0rPlHaAczsseQaegl7uZLmFrzMFj8PJUt8RjmCOSfCmawU4X1Rp8Iyi7ygEkPwJXaBK4Bz37N0FRdwu7Yhk8xx8G0BvLfEfZ9CBFkwZvkaBsAz3ACqeLzEDPQKW/p+bqbuGlWAjPQZ2raI+FupX7wGThNMfrki+BbCCFmZBMyVTgeLV3oGweFfrds+yK1wOddmyC18V7Aed5UEkHaM8mKegkehrI2QGCjQAWqC+db2BrzAx82LUJZgqPBZxfTyuwV0yyQucUwYkGQOcA2k3ajsx0vsw0TPfd+UfSHtNFvwgcewBVhs8FZXdIQQvB4g9gk+P1YKOPGZrrN/sa+sWit3bpNggdNQlxXeT+8k2LlMDf4U6sc4oDwHQcH6Dsf6uNTpfZEhPdFuWCif6mhlziPApYLyg5S9YBnF8AHQMdAtO8ADDR03e/jnDdKRrn/YHCDhA0r5QTzg4QbP5hhtNFtsX4kOsyXjCBrfM4TNIBmsr2AM5hj4KMADYrxxkGjAw9XWs6RoZc4o84H1tL4FeAc67NIIvQKzXXBwvURqLMSpx3RBdhn5hkYQcocbwa5B3tGEeDPwlt/B9Jb/5EoFQAONopqrAiNrovyiNWHSCI5G2OVweJxBhIgY+Eli6x9RJIWAdwjqTT3WUpXpEqV/cSSFgHcB4DBPn+cHaANkL1kSpX5wDaqKq+SdgewPkVIPXBJvch6OwApS5L8U7COkB96wGcw8aIOkCGWOHQrGMFkbzT8epRLkvxilS5gHNWATkHyEgR/MaEZik2iGTnJ+Y7l6V4RapcnaXkHGBfiqabDoZzJx9EsnPO7m0uS/GKVLn2eoCSRHUA57ex1KhZbjTu3APsEZMr7ADNxKrV0AOEQ8L2AM4OsFyoPlLl2hsDJKwDOL8CZqHCZTleqMAsgVIrScoe4PsAJTv2AOpbLBaozWLBo6P1tAdwHgOsCVCybqv2DIHa6Mv0b8v9jlfD3tsQobGsA7RzvFrgspRYtNeEfX5NY1Lv7HcRrsH/INH5L+VmIEtSBD8xdHt+Vgcqe7DTRbXVOSi7D57SJ7oTcwC5NYg9sj2AswOsDTRU+6Xm+iOBxhjRfI9HXNzl/yvB+S9FewBJB+jglB9Q7UdhgLLPcA4Ar9w1mVseUW7cSbdT2e9fyvUAJSn4QaxwoDFOcLweZBSg36P3x9C+BRbjj67uW4IdvsrfAedEenI9wA8pontOdS+BFS5LiY3mJaAOYgg2h1CHzRjiLgysqsBkXxIma+Koye1EWgdmigYhudVJOnMClV2uTwXBroFT4ZZ6OR3MdBZ6llDonEmBreuMaRSUCmamqFLRpMXOPcBiHAhQdgoe1d2iVmJEoNO1ezFC6bagR8rbj1ugDVlRA+IW5fzJKrPFFQC2qFIA/KeQf5HkJ5razw1Yfj8XFu7qOxXF135iA/B+TzLu15b3rljrfFQp4M9iAsgyOubA430By1/mJisIW3ORj7IX+YsLQMWprmVM1enPpq4im/njT5UhYoKNxZ1JRV/H60HzZXfHCP1Nagf6405P8wLf4070V77G9IoYgwdcvAiIBzBGG+PoEsGJ4MqpOA4U8zAyqeIE1pB2mWY4WFhX/rEapaTw34JtU5k0gicIikiqSKFRstJ5Rx3ZBLfzDl0OtaoyckXbpi2gAKagVLCbIY52yhfO/oFfAxX4hbckMeZiBTMFvfBLdEcbtAGwDduwHDOxRLmaBGdjrAkcSblu9qjDy/Wi3QzpGBSdyseXczS7eIqYmSzC20XbZRlwOFy85DBQEwtMEdMCS2iGd2zmCpKBrXC3qIACwIwDDNLEwtRlFHPDSXgrKhOeKGzBKQwS41AvIRWvQtapf1yOF0jaWpN6ljOIx/Azkq+FlZk0powpwm0Smb2URwknK9Y84xwakpxnTPQC/CnXVcl7QkzGr0XbgyQPMXLDnnCOunqUN5CncmuEvFtEZPTkftH2IMmqpfLDb+egn2LOZDpHxVcMbfNGf3wi+UXAHphfY3V+CnWJn7zL6ImZgWIouyOvptBBwv5WP3IHX16VQzyS/RwSvOQIGb828PST0ctobM4yUXGJnz28Ez+qU95zDCXKAlMNDP0qKa1lHy4VFqmJtMk034u2sdnAkWGN0tmED/OARlqfwFJa8UPhNviRD2uLf0RYZJFu9lvgY3SZm/0C2oa5jJtcyCrn79jIt4zGvJ07hVsgkjtrq3C+uNBxWjNIPAHv6jeO1alPKnP4vgdZK3iJ0z7oOqSkMDeE6XBv1D5WwyaaTi44hbonhB1FBkDlnMtbnTeR19JE8Ww+XcdanjNb+BBPdC2nKUcIr8TEYmfMuVnOExd8ldYgkwSlf8ZJdJGigt05OeB4pIL5HKXd6nkN3xXc7ePEWz/qETFM4n2438tT4oO1ONkpgwDADHwJT8+qZzZjJYqwDUVV/+7E0WiPdtX/+ynCShBTgrXYhEJsqvq3omoBui3aoDt6im311HOjqk5YG+kAvUVTlFUySr3qfANz8JFF0yQHJ6nqLCSRpl4iGJT4MHdrVgah8vCQLbskCUtURBKaiOZQxCviwk/Df2nveUB4YjrZqbE0V2OqhJ2EdwYAQDE6K028PbbGKhxjwTTJwAEcG3nQtUaHrNZgqbgCrVyc59mBUSJRfhoAZtU85xz9Rg6+PUvPWPbS3aLmCG+HSl6i9mZEzZbzKGyD7wlN16xCd+fPQQDgU/iNUdMkA9+grSqL/EVUD6C+w2wDanSBdloYwM1405xlkoRXazY/aucN5jAjZt+NU/Qxd5iGDwInmG8gkm7RZ51rO0BjbBdNJ3uYBRgQ7Y21YTPMQxdDxqn/fKFOj/5VrWkZdcBQx3sOHtTfpHbjQqwyok8yEGNzbowtEzwH842oQ1yq3ndxWzPMaHgRhEA52qtamVZiTcwuDBjBzy0KU+kivbvajQsbhoMhMEvFSLQTwwFC3KOr40i85mYnvzqIkXjakE71l4dj/TLmrjkegbWaAG/hMVlNcHcj78LvEmadsBzvYQcOoRku00QCN8UH6iIPd/MGg9sTtNtEqrXqzyIrGyi8cYjPszofOJvzJn5vWyWS3pLpsjG3GVOtjK5TsrI182xbUsNc1kqKzTO5w7JWeW4t/KPSdxhUb697/2QKHxCLmxeUH3hd7K3o7MRdVjXr590Bmhrdplzs5UAXc7jBqjljM8Pp8AvvsajZQs/NDwD8H6NKbnbzSVitWwYnGTpC5Y7tujOCzPS1xzgcBvpzgJaBI3h540tvJ3vZ0eBJGmdecKM5X7SknWOwTofPKvU9noVJTsECL72AWqsGYngo4aCDsBEXqLGq2MWdmyxp6GLKvQ7Y2vi+9c1eD3czjdeGeLLYG1/xerrOgMyrrejoIdJxLKX/YFzhYo9frAB4BEeHFmLCHRWczYHeDp/ySeO2JEldZhWN0s0tDF32up8XiNBUcWhIsYZ07OEzzPah4brgoj3jYrFNp/ZoC2qXuZ8djNK2Ex8SPWhZyAn+wsiytwU77uNJgR3AyJnBWDzuN+ATFfvzhdC/YL7mNA7zfva3SqcTrExi/49eMzfB1k/DShiMwVfNYoxUvsf4TEMPDEB/9AwYb2cT5mEe5qoAp6bYEotwspid6mItTldBEnJEVOAJC95Lkt/x4sC6ZzCHD3M2N3icQF7H55jLECL1sjsLrFjvfDfauRrHMgurBTNXOYrGo7hXv3fQVVHp6IhsdEYntEQWstAUWchCOn7At7V+isIJG81UTMR9VvrPN5SLTAruKzLCig9XMj+sAO6m4Ym+MpWEwW6G/cCKZhbSsYs3+R1+WWz+sYan0iO5JfzqZIuHkHFmpf5AWfzAU63uW1gl8riIxxHTUcHneJTtpnVhp+b8Aw9ZtZPMo8IMfm7ZBcidvE4XYsJq4yv+2uKybyWPy1Xv5MB5OMPgc14RnyMCDuS/bBuHi0UjpnOs7fpVsYZX+Q/LKGAXxcFcZtsoJHeGMXPhXNVptutYTSHHucu9JWyRVI7iF7aNQZKsiEgCIVbdppbmtWJTxIk2ZwnYmhOsrPLFxsfb30c4ZZ6JpQbi2bunAvmYiumq1KRQpuIiXI1LrczyxWYJzvU+Z+ornjZvxJ9t17YWpZiOqch3l5EvGDwTIzDG0uR4XRSji5+lM58B1fkWhtqucUy2YhbyMUcXh8xnrTOQg0txCdrZrmZt1TDIW/LMw/h1gOZYKRzSNZg5Pscc5GOe2hVKcY1xJnpgIAbA9Q5Awzyu7vT3h75TKvAsLDQQTioY5ViBFShAAQqwSR+WKqqG6chGd/wc3XF6nNd0Mfr6XTENkFODuXjJds09cADrUIACbMFulKAEJVX/LUU6MtGk6n/NcRyOr/o5Ooh1DLIeffwlugcCOQDA3xqLJNBAXexAH7Xe/58H9HH+CeNtWyCpKUFfFWjnf1AHSMFrCD1zXgMuOYiLVMDA2oHfcmyMD9DPtiWSkgqMVIFjJwVeWlUHMBj/tm2LpGR88OYPwQEAtQsXodC2NZKOB1Uo2dLDSq2YjYU40qY9koy/quvCKSi0L132Ql7czpPVN97GcK/TWnUR2vYqtQSDsMeWRZKKt3FFWM0fogMAKg/9IbII00AEf8XwkA58AQjVAQC1HGfja9MWSSoeVNeF9/QDIY4BDsN2+BAeo3w04IoKjA9n5B+JwHIHW+F99DBhkaTiIK4M47s/GpH1Lmbi/+AvNFkDsSnB4KCTvrEROWShSjEIr8laJKnYgb4yzS/kAIA6hFENAd5DYj36BFvxc0LsmJWiGo+JCHXEmpQsDrber0P0nJ36Pc7HdkkJ9RzicfT1v9vHDeKbnngMXm1YLvZFMXL97fT1gvhJW7Ud5+FhUFpOvWMJusg3v4EeoBJeiGlIgLP9cQLxBCaGExlJh7F9r2yH1+E5CGxSUowx6l1TwowFW1Bb0BdPmJKWwCxBV3PNb9ABAFWm7sBgfB+8pHoLMRnnKqPLacaPPrA1nsCvTEtNCD7DDWqJaaHG4+2oHepK5KDAtNw4pwS34mfmm99CD1AJ03An/htxEN8jLngDt6ptdkRbPP3GE/E0vGSzrJ+sxTj1sT3xFkOuqQ3qYgzHVnsaWGc/7sPpNpvfag9QCZtiEm5CXIZ9E2Y2xksu8yQQPIPv2I6vZJiVAXP51D/YldNZYbtdjPCJn5xISQFP5+txmxc4HBb6zOKZPPBkvsIy2+0kQp6PFM7JCTvxJavxtsNntvdsiEkOT+LfjectlaCMb7O7bWvWjfXPQCfYAiMwBgmUKCKKLzAVL6si22o4EdcOUAk7Ihe5kI6CHS7f4FW8JLeXNzwSwAEAgAr9MAZD0dS2JloOYBamYraZ/TxJBjOZy7w4ni1YzOv9JZa1R4L0AJGwHQYiBwPQ2rYm1RRjDvLwodpgWxHvJKADHIanIwfn4VxkWVNhLxYiD//EKhMxymVIYAeohEegB3KQg14G4/mWYRnykIfF6qDt+gcl4R3gMMzEOeiGbGSjM5qJiCjBGqzGaqzCfLXbdn3Dot44QCQ8FtnVP+0D1JHYgtVYjdUowGpVL3cu1EsHiIRN0Bkd0CIiXXTkTwb2VcUO//FnD0pQgh+wDmvMpqGxwf8DAcaCPMSeyssAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMDUtMzFUMjI6NDU6MTcrMDI6MDB0hAHbAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE4LTA1LTMxVDIyOjQ1OjE3KzAyOjAwBdm5ZwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAAASUVORK5CYII="

/***/ }),

/***/ 458:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 459:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 460:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(465);
	
	Object.defineProperty(exports, 'react', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_react).default;
	  }
	});
	
	var _node = __webpack_require__(463);
	
	Object.defineProperty(exports, 'node', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_node).default;
	  }
	});
	
	var _psql = __webpack_require__(464);
	
	Object.defineProperty(exports, 'psql', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_psql).default;
	  }
	});
	
	var _googleMaps = __webpack_require__(460);
	
	Object.defineProperty(exports, 'googleMaps', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_googleMaps).default;
	  }
	});
	
	var _firebase = __webpack_require__(458);
	
	Object.defineProperty(exports, 'fireBase', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_firebase).default;
	  }
	});
	
	var _github = __webpack_require__(459);
	
	Object.defineProperty(exports, 'github', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_github).default;
	  }
	});
	
	var _medium = __webpack_require__(462);
	
	Object.defineProperty(exports, 'medium', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_medium).default;
	  }
	});
	
	var _email = __webpack_require__(457);
	
	Object.defineProperty(exports, 'email', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_email).default;
	  }
	});
	
	var _linkedin = __webpack_require__(461);
	
	Object.defineProperty(exports, 'linkedin', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_linkedin).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 461:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 462:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/node.4cac309e.png";

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/psql.e571c9c7.png";

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/react.76118ce2.png";

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _timelineEle = __webpack_require__(209);
	
	var _timelineEle2 = _interopRequireDefault(_timelineEle);
	
	var _index = __webpack_require__(204);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stuff = [{
	  title: 'FullStack Teaching Fellow',
	  text: '2018',
	  hidden: 'This is a postgraduate position offered to students after vetting them through an application and technical/behavioral interviews, here I got to mentor another cohort of students (mine was remote), and do other various duties for FullStack such as engineering and admissions interview.',
	  icon: _index.fellow
	}, {
	  title: 'FullStack Academy Web Development Fellowship',
	  text: '2018',
	  hidden: 'An intensive 5 month program done in conjuntion with New York\'s tech talent pipeline. A special offshoot of already stellar FullStack Academy BootCamp with a less than 6% acceptance rate. I would describe it as the best thing that ever happened to me, and I\'ve met some of my best friends here. Here I learned to build webapps in fullstack Javascript, using Node, Express, React PosgreSQL.',
	  icon: _index.coding
	}, {
	  title: 'Carnegie Hill Veterinarians Head Technician',
	  text: '2014-2018',
	  hidden: 'After getting my Technician Certification I worked here as the head technician, assisted in 6-12 surgical cases weekly. Numerous technician duties such as maintaining controlled substance logs, and managing non-office side of business.',
	  icon: _index.cat
	}, {
	  title: 'Carnegie Hill Veterinarians Intern/Technician',
	  text: '2012-2013',
	  hidden: 'Torwards the tail end of my education at SUNY Delhi I had to do a externship which I completed at Carnegie Hill Veterinarians. they decided to hire me after the externship and I worked as a veterinary assistant up until I got my certification',
	  icon: _index.cat
	}, {
	  title: 'SUNY Delhi',
	  text: '2009-2012',
	  hidden: 'I studied here! It was great, I learned about veterinary sciences, became eligible to take the VTNE to become a veterinary technician',
	  icon: _index.professor
	}, {
	  title: 'Lifeguard/Swimming Instructor',
	  text: '2007-2014',
	  hidden: 'I worked as a lifeguard for the last half of my highschool years at multiple places before becoming a swimming instructor, teach group or private classes for about 5 years',
	  icon: _index.lifeGuard
	}, {
	  title: 'Born',
	  text: 'I dunno haha, born in New York? 1991',
	  hidden: 'Yeah it was a great time! Born and raised in New York City, and lived here in lower Manhattan my whole life, and I can\'t see myself anywhere else!',
	  icon: _index.medical
	}];
	
	var time = function time() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'timeline' },
	    _react2.default.createElement(
	      'h1',
	      { className: 'timeline-header center' },
	      'Work/Experience... tap title for more info'
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'timeline-container center-align' },
	      stuff.map(function (timeEle, idx) {
	        timeEle.direction = !(idx % 2);
	        return _react2.default.createElement(_timelineEle2.default, _extends({ key: idx }, timeEle));
	      })
	    )
	  );
	};
	
	exports.default = time;
	module.exports = exports['default'];

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timelineEle = function timelineEle(_ref) {
	  var title = _ref.title,
	      text = _ref.text,
	      direction = _ref.direction,
	      hidden = _ref.hidden,
	      icon = _ref.icon;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'row container' },
	    _react2.default.createElement(
	      'div',
	      {
	        className: 'card small col s5  teal lighten-1 ' + (direction ? 'left' : 'right')
	      },
	      _react2.default.createElement(
	        'div',
	        { className: 'card-content' },
	        _react2.default.createElement(
	          'span',
	          { className: 'card-title activator grey-text text-darken-4' },
	          title,
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col s12' },
	              _react2.default.createElement('img', { src: icon, alt: 'education' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          text
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'card-reveal  cyan darken-1' },
	        _react2.default.createElement(
	          'span',
	          { className: 'card-title grey-text text-darken-4' },
	          title
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          hidden
	        )
	      )
	    )
	  );
	};
	
	exports.default = timelineEle;
	module.exports = exports['default'];

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactVerticalTimelineComponent = __webpack_require__(189);
	
	var _verticalTimelineEle = __webpack_require__(211);
	
	var _verticalTimelineEle2 = _interopRequireDefault(_verticalTimelineEle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Materialize = typeof window !== 'undefined' ? __webpack_require__(128) : null;
	
	// if (typeof window !== `undefined`) {
	//   Materialize  = require('../layouts/materialize-src/js/bin/materialize');
	// }
	
	var timeline = [{
	  date: '1991',
	  event: 'My Birthdate!',
	  location: 'New York',
	  roles: 'Born in Bellevue hospital in New York, so I\'ve been here my whole life!',
	  expansionText: 'not much to say other than I love being a New Yorker!'
	}, {
	  date: '2007-2013',
	  event: 'Water Safety Instructor/Lifeguard',
	  location: 'New York',
	  roles: 'Swimming instructor teaching classes usually of 6 students, averaging about 4-6 classes per 3 month cycle',
	  expansionText: 'I spent my junior/senior year of high school lifeguarding for a pool in the Lower East Side before becoming WSI certified and teaching group swim lessons'
	}, {
	  date: '2011-present',
	  event: 'Software Engineer',
	  location: 'New York',
	  roles: 'Creative Direction, User Experience, Visual Design, Project\n    Management, Team Leading',
	  expansionText: 'hhhhhhhhhhh'
	}, {
	  date: '2011-present',
	  event: 'Software Engineer',
	  location: 'New York',
	  roles: 'Creative Direction, User Experience, Visual Design, Project\n    Management, Team Leading',
	  expansionText: 'hhhhhhhhhhh'
	}];
	
	// const Timeline = () => {
	//   return (
	//     <VerticalTimeline>
	//       {timeline.map((event, idx) => {
	//         return <VerticalTimelineElement key={idx} {...event} />;
	//       })}
	//     </VerticalTimeline>
	//   );
	// };
	
	var Timeline = function (_Component) {
	  _inherits(Timeline, _Component);
	
	  function Timeline() {
	    _classCallCheck(this, Timeline);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Timeline.prototype.componentDidMount = function componentDidMount() {
	    document.addEventListener('DOMContentLoaded', function () {
	      var elems = document.querySelectorAll('.collapsible');
	      var instances = Materialize.Collapsible.init(elems);
	    });
	  };
	
	  Timeline.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactVerticalTimelineComponent.VerticalTimeline,
	      null,
	      timeline.map(function (event, idx) {
	        return _react2.default.createElement(_verticalTimelineEle2.default, _extends({ key: idx }, event));
	      })
	    );
	  };
	
	  return Timeline;
	}(_react.Component);
	
	exports.default = Timeline;
	module.exports = exports['default'];

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactVerticalTimelineComponent = __webpack_require__(189);
	
	__webpack_require__(306);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import WorkIcon from '@material-ui/icons/Work';
	
	var element = function element(_ref) {
	  var date = _ref.date,
	      event = _ref.event,
	      roles = _ref.roles,
	      expansionText = _ref.expansionText,
	      location = _ref.location;
	
	  return _react2.default.createElement(
	    _reactVerticalTimelineComponent.VerticalTimelineElement,
	    {
	      className: 'vertical-timeline-element--work',
	      date: date,
	      iconStyle: { background: 'rgb(33, 150, 243)', color: '#fff' }
	    },
	    _react2.default.createElement(
	      'ul',
	      { className: 'collapsible' },
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'collapsible-header indigo lighten-5 padding',
	            style: {}
	          },
	          _react2.default.createElement(
	            'h3',
	            { className: 'vertical-timeline-element-title' },
	            event
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'font-small' },
	            roles
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'collapsible-body' },
	          expansionText
	        )
	      )
	    )
	  );
	};
	exports.default = element;
	module.exports = exports['default'];

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/coffeeFindr.b77eb858.jpg";

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _suitz = __webpack_require__(470);
	
	Object.defineProperty(exports, 'suitz', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_suitz).default;
	  }
	});
	
	var _suitsCard = __webpack_require__(469);
	
	Object.defineProperty(exports, 'suitsCard', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_suitsCard).default;
	  }
	});
	
	var _coffeeFindr = __webpack_require__(466);
	
	Object.defineProperty(exports, 'coffeeFindr', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_coffeeFindr).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/laying.716a3481.jpg";

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic2.16c3fae6.jpg";

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/suitsCard.da279c9e.jpg";

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/suitz.c8711fb1.jpg";

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(410);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _header = __webpack_require__(203);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _intro = __webpack_require__(205);
	
	var _intro2 = _interopRequireDefault(_intro);
	
	var _storyComp = __webpack_require__(207);
	
	var _storyComp2 = _interopRequireDefault(_storyComp);
	
	var _verticalTimeline = __webpack_require__(210);
	
	var _verticalTimeline2 = _interopRequireDefault(_verticalTimeline);
	
	var _timeline = __webpack_require__(208);
	
	var _timeline2 = _interopRequireDefault(_timeline);
	
	var _portfolio = __webpack_require__(206);
	
	var _portfolio2 = _interopRequireDefault(_portfolio);
	
	var _footer = __webpack_require__(202);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	__webpack_require__(343);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var infoFile = {
	  one: {
	    pic: __webpack_require__(467),
	    title: 'FullStack Academy',
	    text: 'Currently I am a teaching Fellow for fullstack Academy, and a proud graduate of the FullStack Academy Web Development Fellowship.',
	    text2: 'Currently looking for new opportunities to utilize what I\'ve learned, and to learn!',
	    direction: 'right'
	  },
	  two: {
	    pic: __webpack_require__(468),
	    text: 'I was the head veterinary technician for a private veterinary practice for about 5 years before starting my software engineering journey. Hello world for me was in November of 2017, where I did a bunch of self learning before getting accepted into the Web Development Fellowship at Fullstack Academy in January 2018, a tuition free program with an acceptance rate of under 6% making it a program with a much harder entry than their normal programs.\n\n    ',
	    text2: 'I enjoy teaching and learning, whatever the context may be, whether it was training a new technician intern in a veterinary setting, or mentoring students going through the immersive program I like to surround myself with people who are eager to learn and teach, as we always end up lifting each other up, just like how my instructors used to say, "a rising tide lifts all boats!"',
	    title: 'Software Engineer',
	    direction: 'left'
	  }
	};
	
	var Layout = function Layout(_ref) {
	  var children = _ref.children,
	      data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    { className: '' },
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: data.site.siteMetadata.title,
	      meta: [{
	        name: 'description',
	        content: 'This is my going to be my professional website hopefully'
	      }, { name: 'keywords', content: 'Professional website' }]
	    }),
	    _react2.default.createElement(_header2.default, null),
	    _react2.default.createElement(_intro2.default, null),
	    _react2.default.createElement(_storyComp2.default, { info: infoFile.one }),
	    _react2.default.createElement(_timeline2.default, null),
	    _react2.default.createElement(_portfolio2.default, null),
	    _react2.default.createElement(_storyComp2.default, { info: infoFile.two }),
	    _react2.default.createElement(_footer2.default, null)
	  );
	};
	
	Layout.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = Layout;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 343:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	/*!
	 * Materialize v1.0.0-rc.2 (http://materializecss.com)
	 * Copyright 2014-2017 Materialize
	 * MIT License (https://raw.githubusercontent.com/Dogfalo/materialize/master/LICENSE)
	 */
	var _get = function get(object, property, receiver) {
	  if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
	    var parent = Object.getPrototypeOf(object);if (parent === null) {
	      return undefined;
	    } else {
	      return get(parent, property, receiver);
	    }
	  } else if ("value" in desc) {
	    return desc.value;
	  } else {
	    var getter = desc.get;if (getter === undefined) {
	      return undefined;
	    }return getter.call(receiver);
	  }
	};
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}();
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	/*! cash-dom 1.3.5, https://github.com/kenwheeler/cash @license MIT */
	(function (factory) {
	  window.cash = factory();
	})(function () {
	  var doc = document,
	      win = window,
	      ArrayProto = Array.prototype,
	      slice = ArrayProto.slice,
	      _filter = ArrayProto.filter,
	      push = ArrayProto.push;
	
	  var noop = function noop() {},
	      isFunction = function isFunction(item) {
	    // @see https://crbug.com/568448
	    return typeof item === typeof noop && item.call;
	  },
	      isString = function isString(item) {
	    return typeof item === typeof "";
	  };
	
	  var idMatch = /^#[\w-]*$/,
	      classMatch = /^\.[\w-]*$/,
	      htmlMatch = /<.+>/,
	      singlet = /^\w+$/;
	
	  function _find(selector, context) {
	    context = context || doc;
	    var elems = classMatch.test(selector) ? context.getElementsByClassName(selector.slice(1)) : singlet.test(selector) ? context.getElementsByTagName(selector) : context.querySelectorAll(selector);
	    return elems;
	  }
	
	  var frag;
	  function parseHTML(str) {
	    if (!frag) {
	      frag = doc.implementation.createHTMLDocument(null);
	      var base = frag.createElement("base");
	      base.href = doc.location.href;
	      frag.head.appendChild(base);
	    }
	
	    frag.body.innerHTML = str;
	
	    return frag.body.childNodes;
	  }
	
	  function onReady(fn) {
	    if (doc.readyState !== "loading") {
	      fn();
	    } else {
	      doc.addEventListener("DOMContentLoaded", fn);
	    }
	  }
	
	  function Init(selector, context) {
	    if (!selector) {
	      return this;
	    }
	
	    // If already a cash collection, don't do any further processing
	    if (selector.cash && selector !== win) {
	      return selector;
	    }
	
	    var elems = selector,
	        i = 0,
	        length;
	
	    if (isString(selector)) {
	      elems = idMatch.test(selector) ?
	      // If an ID use the faster getElementById check
	      doc.getElementById(selector.slice(1)) : htmlMatch.test(selector) ?
	      // If HTML, parse it into real elements
	      parseHTML(selector) :
	      // else use `find`
	      _find(selector, context);
	
	      // If function, use as shortcut for DOM ready
	    } else if (isFunction(selector)) {
	      onReady(selector);return this;
	    }
	
	    if (!elems) {
	      return this;
	    }
	
	    // If a single DOM element is passed in or received via ID, return the single element
	    if (elems.nodeType || elems === win) {
	      this[0] = elems;
	      this.length = 1;
	    } else {
	      // Treat like an array and loop through each item.
	      length = this.length = elems.length;
	      for (; i < length; i++) {
	        this[i] = elems[i];
	      }
	    }
	
	    return this;
	  }
	
	  function cash(selector, context) {
	    return new Init(selector, context);
	  }
	
	  var fn = cash.fn = cash.prototype = Init.prototype = { // jshint ignore:line
	    cash: true,
	    length: 0,
	    push: push,
	    splice: ArrayProto.splice,
	    map: ArrayProto.map,
	    init: Init
	  };
	
	  Object.defineProperty(fn, "constructor", { value: cash });
	
	  cash.parseHTML = parseHTML;
	  cash.noop = noop;
	  cash.isFunction = isFunction;
	  cash.isString = isString;
	
	  cash.extend = fn.extend = function (target) {
	    target = target || {};
	
	    var args = slice.call(arguments),
	        length = args.length,
	        i = 1;
	
	    if (args.length === 1) {
	      target = this;
	      i = 0;
	    }
	
	    for (; i < length; i++) {
	      if (!args[i]) {
	        continue;
	      }
	      for (var key in args[i]) {
	        if (args[i].hasOwnProperty(key)) {
	          target[key] = args[i][key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _each(collection, callback) {
	    var l = collection.length,
	        i = 0;
	
	    for (; i < l; i++) {
	      if (callback.call(collection[i], collection[i], i, collection) === false) {
	        break;
	      }
	    }
	  }
	
	  function matches(el, selector) {
	    var m = el && (el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector || el.oMatchesSelector);
	    return !!m && m.call(el, selector);
	  }
	
	  function getCompareFunction(selector) {
	    return (
	      /* Use browser's `matches` function if string */
	      isString(selector) ? matches :
	      /* Match a cash element */
	      selector.cash ? function (el) {
	        return selector.is(el);
	      } :
	      /* Direct comparison */
	      function (el, selector) {
	        return el === selector;
	      }
	    );
	  }
	
	  function unique(collection) {
	    return cash(slice.call(collection).filter(function (item, index, self) {
	      return self.indexOf(item) === index;
	    }));
	  }
	
	  cash.extend({
	    merge: function merge(first, second) {
	      var len = +second.length,
	          i = first.length,
	          j = 0;
	
	      for (; j < len; i++, j++) {
	        first[i] = second[j];
	      }
	
	      first.length = i;
	      return first;
	    },
	
	    each: _each,
	    matches: matches,
	    unique: unique,
	    isArray: Array.isArray,
	    isNumeric: function isNumeric(n) {
	      return !isNaN(parseFloat(n)) && isFinite(n);
	    }
	
	  });
	
	  var uid = cash.uid = "_cash" + Date.now();
	
	  function getDataCache(node) {
	    return node[uid] = node[uid] || {};
	  }
	
	  function setData(node, key, value) {
	    return getDataCache(node)[key] = value;
	  }
	
	  function getData(node, key) {
	    var c = getDataCache(node);
	    if (c[key] === undefined) {
	      c[key] = node.dataset ? node.dataset[key] : cash(node).attr("data-" + key);
	    }
	    return c[key];
	  }
	
	  function _removeData(node, key) {
	    var c = getDataCache(node);
	    if (c) {
	      delete c[key];
	    } else if (node.dataset) {
	      delete node.dataset[key];
	    } else {
	      cash(node).removeAttr("data-" + name);
	    }
	  }
	
	  fn.extend({
	    data: function data(name, value) {
	      if (isString(name)) {
	        return value === undefined ? getData(this[0], name) : this.each(function (v) {
	          return setData(v, name, value);
	        });
	      }
	
	      for (var key in name) {
	        this.data(key, name[key]);
	      }
	
	      return this;
	    },
	
	    removeData: function removeData(key) {
	      return this.each(function (v) {
	        return _removeData(v, key);
	      });
	    }
	
	  });
	
	  var notWhiteMatch = /\S+/g;
	
	  function getClasses(c) {
	    return isString(c) && c.match(notWhiteMatch);
	  }
	
	  function _hasClass(v, c) {
	    return v.classList ? v.classList.contains(c) : new RegExp("(^| )" + c + "( |$)", "gi").test(v.className);
	  }
	
	  function _addClass(v, c, spacedName) {
	    if (v.classList) {
	      v.classList.add(c);
	    } else if (spacedName.indexOf(" " + c + " ")) {
	      v.className += " " + c;
	    }
	  }
	
	  function _removeClass(v, c) {
	    if (v.classList) {
	      v.classList.remove(c);
	    } else {
	      v.className = v.className.replace(c, "");
	    }
	  }
	
	  fn.extend({
	    addClass: function addClass(c) {
	      var classes = getClasses(c);
	
	      return classes ? this.each(function (v) {
	        var spacedName = " " + v.className + " ";
	        _each(classes, function (c) {
	          _addClass(v, c, spacedName);
	        });
	      }) : this;
	    },
	
	    attr: function attr(name, value) {
	      if (!name) {
	        return undefined;
	      }
	
	      if (isString(name)) {
	        if (value === undefined) {
	          return this[0] ? this[0].getAttribute ? this[0].getAttribute(name) : this[0][name] : undefined;
	        }
	
	        return this.each(function (v) {
	          if (v.setAttribute) {
	            v.setAttribute(name, value);
	          } else {
	            v[name] = value;
	          }
	        });
	      }
	
	      for (var key in name) {
	        this.attr(key, name[key]);
	      }
	
	      return this;
	    },
	
	    hasClass: function hasClass(c) {
	      var check = false,
	          classes = getClasses(c);
	      if (classes && classes.length) {
	        this.each(function (v) {
	          check = _hasClass(v, classes[0]);
	          return !check;
	        });
	      }
	      return check;
	    },
	
	    prop: function prop(name, value) {
	      if (isString(name)) {
	        return value === undefined ? this[0][name] : this.each(function (v) {
	          v[name] = value;
	        });
	      }
	
	      for (var key in name) {
	        this.prop(key, name[key]);
	      }
	
	      return this;
	    },
	
	    removeAttr: function removeAttr(name) {
	      return this.each(function (v) {
	        if (v.removeAttribute) {
	          v.removeAttribute(name);
	        } else {
	          delete v[name];
	        }
	      });
	    },
	
	    removeClass: function removeClass(c) {
	      if (!arguments.length) {
	        return this.attr("class", "");
	      }
	      var classes = getClasses(c);
	      return classes ? this.each(function (v) {
	        _each(classes, function (c) {
	          _removeClass(v, c);
	        });
	      }) : this;
	    },
	
	    removeProp: function removeProp(name) {
	      return this.each(function (v) {
	        delete v[name];
	      });
	    },
	
	    toggleClass: function toggleClass(c, state) {
	      if (state !== undefined) {
	        return this[state ? "addClass" : "removeClass"](c);
	      }
	      var classes = getClasses(c);
	      return classes ? this.each(function (v) {
	        var spacedName = " " + v.className + " ";
	        _each(classes, function (c) {
	          if (_hasClass(v, c)) {
	            _removeClass(v, c);
	          } else {
	            _addClass(v, c, spacedName);
	          }
	        });
	      }) : this;
	    } });
	
	  fn.extend({
	    add: function add(selector, context) {
	      return unique(cash.merge(this, cash(selector, context)));
	    },
	
	    each: function each(callback) {
	      _each(this, callback);
	      return this;
	    },
	
	    eq: function eq(index) {
	      return cash(this.get(index));
	    },
	
	    filter: function filter(selector) {
	      if (!selector) {
	        return this;
	      }
	
	      var comparator = isFunction(selector) ? selector : getCompareFunction(selector);
	
	      return cash(_filter.call(this, function (e) {
	        return comparator(e, selector);
	      }));
	    },
	
	    first: function first() {
	      return this.eq(0);
	    },
	
	    get: function get(index) {
	      if (index === undefined) {
	        return slice.call(this);
	      }
	      return index < 0 ? this[index + this.length] : this[index];
	    },
	
	    index: function index(elem) {
	      var child = elem ? cash(elem)[0] : this[0],
	          collection = elem ? this : cash(child).parent().children();
	      return slice.call(collection).indexOf(child);
	    },
	
	    last: function last() {
	      return this.eq(-1);
	    }
	
	  });
	
	  var camelCase = function () {
	    var camelRegex = /(?:^\w|[A-Z]|\b\w)/g,
	        whiteSpace = /[\s-_]+/g;
	    return function (str) {
	      return str.replace(camelRegex, function (letter, index) {
	        return letter[index === 0 ? "toLowerCase" : "toUpperCase"]();
	      }).replace(whiteSpace, "");
	    };
	  }();
	
	  var getPrefixedProp = function () {
	    var cache = {},
	        doc = document,
	        div = doc.createElement("div"),
	        style = div.style;
	
	    return function (prop) {
	      prop = camelCase(prop);
	      if (cache[prop]) {
	        return cache[prop];
	      }
	
	      var ucProp = prop.charAt(0).toUpperCase() + prop.slice(1),
	          prefixes = ["webkit", "moz", "ms", "o"],
	          props = (prop + " " + prefixes.join(ucProp + " ") + ucProp).split(" ");
	
	      _each(props, function (p) {
	        if (p in style) {
	          cache[p] = prop = cache[prop] = p;
	          return false;
	        }
	      });
	
	      return cache[prop];
	    };
	  }();
	
	  cash.prefixedProp = getPrefixedProp;
	  cash.camelCase = camelCase;
	
	  fn.extend({
	    css: function css(prop, value) {
	      if (isString(prop)) {
	        prop = getPrefixedProp(prop);
	        return arguments.length > 1 ? this.each(function (v) {
	          return v.style[prop] = value;
	        }) : win.getComputedStyle(this[0])[prop];
	      }
	
	      for (var key in prop) {
	        this.css(key, prop[key]);
	      }
	
	      return this;
	    }
	
	  });
	
	  function compute(el, prop) {
	    return parseInt(win.getComputedStyle(el[0], null)[prop], 10) || 0;
	  }
	
	  _each(["Width", "Height"], function (v) {
	    var lower = v.toLowerCase();
	
	    fn[lower] = function () {
	      return this[0].getBoundingClientRect()[lower];
	    };
	
	    fn["inner" + v] = function () {
	      return this[0]["client" + v];
	    };
	
	    fn["outer" + v] = function (margins) {
	      return this[0]["offset" + v] + (margins ? compute(this, "margin" + (v === "Width" ? "Left" : "Top")) + compute(this, "margin" + (v === "Width" ? "Right" : "Bottom")) : 0);
	    };
	  });
	
	  function registerEvent(node, eventName, callback) {
	    var eventCache = getData(node, "_cashEvents") || setData(node, "_cashEvents", {});
	    eventCache[eventName] = eventCache[eventName] || [];
	    eventCache[eventName].push(callback);
	    node.addEventListener(eventName, callback);
	  }
	
	  function removeEvent(node, eventName, callback) {
	    var events = getData(node, "_cashEvents"),
	        eventCache = events && events[eventName],
	        index;
	
	    if (!eventCache) {
	      return;
	    }
	
	    if (callback) {
	      node.removeEventListener(eventName, callback);
	      index = eventCache.indexOf(callback);
	      if (index >= 0) {
	        eventCache.splice(index, 1);
	      }
	    } else {
	      _each(eventCache, function (event) {
	        node.removeEventListener(eventName, event);
	      });
	      eventCache = [];
	    }
	  }
	
	  fn.extend({
	    off: function off(eventName, callback) {
	      return this.each(function (v) {
	        return removeEvent(v, eventName, callback);
	      });
	    },
	
	    on: function on(eventName, delegate, callback, runOnce) {
	      // jshint ignore:line
	      var originalCallback;
	      if (!isString(eventName)) {
	        for (var key in eventName) {
	          this.on(key, delegate, eventName[key]);
	        }
	        return this;
	      }
	
	      if (isFunction(delegate)) {
	        callback = delegate;
	        delegate = null;
	      }
	
	      if (eventName === "ready") {
	        onReady(callback);
	        return this;
	      }
	
	      if (delegate) {
	        originalCallback = callback;
	        callback = function callback(e) {
	          var t = e.target;
	          while (!matches(t, delegate)) {
	            if (t === this || t === null) {
	              return t = false;
	            }
	
	            t = t.parentNode;
	          }
	
	          if (t) {
	            originalCallback.call(t, e);
	          }
	        };
	      }
	
	      return this.each(function (v) {
	        var _finalCallback = callback;
	        if (runOnce) {
	          _finalCallback = function finalCallback() {
	            callback.apply(this, arguments);
	            removeEvent(v, eventName, _finalCallback);
	          };
	        }
	        registerEvent(v, eventName, _finalCallback);
	      });
	    },
	
	    one: function one(eventName, delegate, callback) {
	      return this.on(eventName, delegate, callback, true);
	    },
	
	    ready: onReady,
	
	    /**
	     * Modified
	     * Triggers browser event
	     * @param String eventName
	     * @param Object data - Add properties to event object
	     */
	    trigger: function trigger(eventName, data) {
	      if (document.createEvent) {
	        var evt = document.createEvent('HTMLEvents');
	        evt.initEvent(eventName, true, false);
	        evt = this.extend(evt, data);
	        return this.each(function (v) {
	          return v.dispatchEvent(evt);
	        });
	      }
	    }
	
	  });
	
	  function encode(name, value) {
	    return "&" + encodeURIComponent(name) + "=" + encodeURIComponent(value).replace(/%20/g, "+");
	  }
	
	  function getSelectMultiple_(el) {
	    var values = [];
	    _each(el.options, function (o) {
	      if (o.selected) {
	        values.push(o.value);
	      }
	    });
	    return values.length ? values : null;
	  }
	
	  function getSelectSingle_(el) {
	    var selectedIndex = el.selectedIndex;
	    return selectedIndex >= 0 ? el.options[selectedIndex].value : null;
	  }
	
	  function getValue(el) {
	    var type = el.type;
	    if (!type) {
	      return null;
	    }
	    switch (type.toLowerCase()) {
	      case "select-one":
	        return getSelectSingle_(el);
	      case "select-multiple":
	        return getSelectMultiple_(el);
	      case "radio":
	        return el.checked ? el.value : null;
	      case "checkbox":
	        return el.checked ? el.value : null;
	      default:
	        return el.value ? el.value : null;
	    }
	  }
	
	  fn.extend({
	    serialize: function serialize() {
	      var query = "";
	
	      _each(this[0].elements || this, function (el) {
	        if (el.disabled || el.tagName === "FIELDSET") {
	          return;
	        }
	        var name = el.name;
	        switch (el.type.toLowerCase()) {
	          case "file":
	          case "reset":
	          case "submit":
	          case "button":
	            break;
	          case "select-multiple":
	            var values = getValue(el);
	            if (values !== null) {
	              _each(values, function (value) {
	                query += encode(name, value);
	              });
	            }
	            break;
	          default:
	            var value = getValue(el);
	            if (value !== null) {
	              query += encode(name, value);
	            }
	        }
	      });
	
	      return query.substr(1);
	    },
	
	    val: function val(value) {
	      if (value === undefined) {
	        return getValue(this[0]);
	      }
	
	      return this.each(function (v) {
	        return v.value = value;
	      });
	    }
	
	  });
	
	  function insertElement(el, child, prepend) {
	    if (prepend) {
	      var first = el.childNodes[0];
	      el.insertBefore(child, first);
	    } else {
	      el.appendChild(child);
	    }
	  }
	
	  function insertContent(parent, child, prepend) {
	    var str = isString(child);
	
	    if (!str && child.length) {
	      _each(child, function (v) {
	        return insertContent(parent, v, prepend);
	      });
	      return;
	    }
	
	    _each(parent, str ? function (v) {
	      return v.insertAdjacentHTML(prepend ? "afterbegin" : "beforeend", child);
	    } : function (v, i) {
	      return insertElement(v, i === 0 ? child : child.cloneNode(true), prepend);
	    });
	  }
	
	  fn.extend({
	    after: function after(selector) {
	      cash(selector).insertAfter(this);
	      return this;
	    },
	
	    append: function append(content) {
	      insertContent(this, content);
	      return this;
	    },
	
	    appendTo: function appendTo(parent) {
	      insertContent(cash(parent), this);
	      return this;
	    },
	
	    before: function before(selector) {
	      cash(selector).insertBefore(this);
	      return this;
	    },
	
	    clone: function clone() {
	      return cash(this.map(function (v) {
	        return v.cloneNode(true);
	      }));
	    },
	
	    empty: function empty() {
	      this.html("");
	      return this;
	    },
	
	    html: function html(content) {
	      if (content === undefined) {
	        return this[0].innerHTML;
	      }
	      var source = content.nodeType ? content[0].outerHTML : content;
	      return this.each(function (v) {
	        return v.innerHTML = source;
	      });
	    },
	
	    insertAfter: function insertAfter(selector) {
	      var _this = this;
	
	      cash(selector).each(function (el, i) {
	        var parent = el.parentNode,
	            sibling = el.nextSibling;
	        _this.each(function (v) {
	          parent.insertBefore(i === 0 ? v : v.cloneNode(true), sibling);
	        });
	      });
	
	      return this;
	    },
	
	    insertBefore: function insertBefore(selector) {
	      var _this2 = this;
	      cash(selector).each(function (el, i) {
	        var parent = el.parentNode;
	        _this2.each(function (v) {
	          parent.insertBefore(i === 0 ? v : v.cloneNode(true), el);
	        });
	      });
	      return this;
	    },
	
	    prepend: function prepend(content) {
	      insertContent(this, content, true);
	      return this;
	    },
	
	    prependTo: function prependTo(parent) {
	      insertContent(cash(parent), this, true);
	      return this;
	    },
	
	    remove: function remove() {
	      return this.each(function (v) {
	        if (!!v.parentNode) {
	          return v.parentNode.removeChild(v);
	        }
	      });
	    },
	
	    text: function text(content) {
	      if (content === undefined) {
	        return this[0].textContent;
	      }
	      return this.each(function (v) {
	        return v.textContent = content;
	      });
	    }
	
	  });
	
	  var docEl = doc.documentElement;
	
	  fn.extend({
	    position: function position() {
	      var el = this[0];
	      return {
	        left: el.offsetLeft,
	        top: el.offsetTop
	      };
	    },
	
	    offset: function offset() {
	      var rect = this[0].getBoundingClientRect();
	      return {
	        top: rect.top + win.pageYOffset - docEl.clientTop,
	        left: rect.left + win.pageXOffset - docEl.clientLeft
	      };
	    },
	
	    offsetParent: function offsetParent() {
	      return cash(this[0].offsetParent);
	    }
	
	  });
	
	  fn.extend({
	    children: function children(selector) {
	      var elems = [];
	      this.each(function (el) {
	        push.apply(elems, el.children);
	      });
	      elems = unique(elems);
	
	      return !selector ? elems : elems.filter(function (v) {
	        return matches(v, selector);
	      });
	    },
	
	    closest: function closest(selector) {
	      if (!selector || this.length < 1) {
	        return cash();
	      }
	      if (this.is(selector)) {
	        return this.filter(selector);
	      }
	      return this.parent().closest(selector);
	    },
	
	    is: function is(selector) {
	      if (!selector) {
	        return false;
	      }
	
	      var match = false,
	          comparator = getCompareFunction(selector);
	
	      this.each(function (el) {
	        match = comparator(el, selector);
	        return !match;
	      });
	
	      return match;
	    },
	
	    find: function find(selector) {
	      if (!selector || selector.nodeType) {
	        return cash(selector && this.has(selector).length ? selector : null);
	      }
	
	      var elems = [];
	      this.each(function (el) {
	        push.apply(elems, _find(selector, el));
	      });
	
	      return unique(elems);
	    },
	
	    has: function has(selector) {
	      var comparator = isString(selector) ? function (el) {
	        return _find(selector, el).length !== 0;
	      } : function (el) {
	        return el.contains(selector);
	      };
	
	      return this.filter(comparator);
	    },
	
	    next: function next() {
	      return cash(this[0].nextElementSibling);
	    },
	
	    not: function not(selector) {
	      if (!selector) {
	        return this;
	      }
	
	      var comparator = getCompareFunction(selector);
	
	      return this.filter(function (el) {
	        return !comparator(el, selector);
	      });
	    },
	
	    parent: function parent() {
	      var result = [];
	
	      this.each(function (item) {
	        if (item && item.parentNode) {
	          result.push(item.parentNode);
	        }
	      });
	
	      return unique(result);
	    },
	
	    parents: function parents(selector) {
	      var last,
	          result = [];
	
	      this.each(function (item) {
	        last = item;
	
	        while (last && last.parentNode && last !== doc.body.parentNode) {
	          last = last.parentNode;
	
	          if (!selector || selector && matches(last, selector)) {
	            result.push(last);
	          }
	        }
	      });
	
	      return unique(result);
	    },
	
	    prev: function prev() {
	      return cash(this[0].previousElementSibling);
	    },
	
	    siblings: function siblings(selector) {
	      var collection = this.parent().children(selector),
	          el = this[0];
	
	      return collection.filter(function (i) {
	        return i !== el;
	      });
	    }
	
	  });
	
	  return cash;
	});
	;
	var Component = function () {
	  /**
	   * Generic constructor for all components
	   * @constructor
	   * @param {Element} el
	   * @param {Object} options
	   */
	  function Component(classDef, el, options) {
	    _classCallCheck(this, Component);
	
	    // Display error if el is valid HTML Element
	    if (!(el instanceof Element)) {
	      console.error(Error(el + ' is not an HTML Element'));
	    }
	
	    // If exists, destroy and reinitialize in child
	    var ins = classDef.getInstance(el);
	    if (!!ins) {
	      ins.destroy();
	    }
	
	    this.el = el;
	    this.$el = cash(el);
	  }
	
	  /**
	   * Initializes components
	   * @param {class} classDef
	   * @param {Element | NodeList | jQuery} els
	   * @param {Object} options
	   */
	
	  _createClass(Component, null, [{
	    key: "init",
	    value: function init(classDef, els, options) {
	      var instances = null;
	      if (els instanceof Element) {
	        instances = new classDef(els, options);
	      } else if (!!els && (els.jquery || els.cash || els instanceof NodeList)) {
	        var instancesArr = [];
	        for (var i = 0; i < els.length; i++) {
	          instancesArr.push(new classDef(els[i], options));
	        }
	        instances = instancesArr;
	      }
	
	      return instances;
	    }
	  }]);
	
	  return Component;
	}();
	
	; // Required for Meteor package, the use of window prevents export by Meteor
	(function (window) {
	  if (window.Package) {
	    M = {};
	  } else {
	    window.M = {};
	  }
	
	  // Check for jQuery
	  M.jQueryLoaded = !!window.jQuery;
	})(window);
	
	// AMD
	if (true) {
	  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return M;
	  }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	  // Common JS
	} else if (typeof exports !== 'undefined' && !exports.nodeType) {
	  if (typeof module !== 'undefined' && !module.nodeType && module.exports) {
	    exports = module.exports = M;
	  }
	  exports.default = M;
	}
	
	M.keys = {
	  TAB: 9,
	  ENTER: 13,
	  ESC: 27,
	  ARROW_UP: 38,
	  ARROW_DOWN: 40
	};
	
	/**
	 * TabPress Keydown handler
	 */
	M.tabPressed = false;
	M.keyDown = false;
	var docHandleKeydown = function docHandleKeydown(e) {
	  M.keyDown = true;
	  if (e.which === M.keys.TAB || e.which === M.keys.ARROW_DOWN || e.which === M.keys.ARROW_UP) {
	    M.tabPressed = true;
	  }
	};
	var docHandleKeyup = function docHandleKeyup(e) {
	  M.keyDown = false;
	  if (e.which === M.keys.TAB || e.which === M.keys.ARROW_DOWN || e.which === M.keys.ARROW_UP) {
	    M.tabPressed = false;
	  }
	};
	var docHandleFocus = function docHandleFocus(e) {
	  if (M.keyDown) {
	    document.body.classList.add('keyboard-focused');
	  }
	};
	var docHandleBlur = function docHandleBlur(e) {
	  document.body.classList.remove('keyboard-focused');
	};
	document.addEventListener('keydown', docHandleKeydown, true);
	document.addEventListener('keyup', docHandleKeyup, true);
	document.addEventListener('focus', docHandleFocus, true);
	document.addEventListener('blur', docHandleBlur, true);
	
	/**
	 * Initialize jQuery wrapper for plugin
	 * @param {Class} plugin  javascript class
	 * @param {string} pluginName  jQuery plugin name
	 * @param {string} classRef  Class reference name
	 */
	M.initializeJqueryWrapper = function (plugin, pluginName, classRef) {
	  jQuery.fn[pluginName] = function (methodOrOptions) {
	    // Call plugin method if valid method name is passed in
	    if (plugin.prototype[methodOrOptions]) {
	      var params = Array.prototype.slice.call(arguments, 1);
	
	      // Getter methods
	      if (methodOrOptions.slice(0, 3) === 'get') {
	        var instance = this.first()[0][classRef];
	        return instance[methodOrOptions].apply(instance, params);
	      }
	
	      // Void methods
	      return this.each(function () {
	        var instance = this[classRef];
	        instance[methodOrOptions].apply(instance, params);
	      });
	
	      // Initialize plugin if options or no argument is passed in
	    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
	      plugin.init(this, arguments[0]);
	      return this;
	    }
	
	    // Return error if an unrecognized  method name is passed in
	    jQuery.error("Method " + methodOrOptions + " does not exist on jQuery." + pluginName);
	  };
	};
	
	/**
	 * Automatically initialize components
	 * @param {Element} context  DOM Element to search within for components
	 */
	M.AutoInit = function (context) {
	  // Use document.body if no context is given
	  var root = !!context ? context : document.body;
	
	  var registry = {
	    Autocomplete: root.querySelectorAll('.autocomplete:not(.no-autoinit)'),
	    Carousel: root.querySelectorAll('.carousel:not(.no-autoinit)'),
	    Chips: root.querySelectorAll('.chips:not(.no-autoinit)'),
	    Collapsible: root.querySelectorAll('.collapsible:not(.no-autoinit)'),
	    Datepicker: root.querySelectorAll('.datepicker:not(.no-autoinit)'),
	    Dropdown: root.querySelectorAll('.dropdown-trigger:not(.no-autoinit)'),
	    Materialbox: root.querySelectorAll('.materialboxed:not(.no-autoinit)'),
	    Modal: root.querySelectorAll('.modal:not(.no-autoinit)'),
	    Parallax: root.querySelectorAll('.parallax:not(.no-autoinit)'),
	    Pushpin: root.querySelectorAll('.pushpin:not(.no-autoinit)'),
	    ScrollSpy: root.querySelectorAll('.scrollspy:not(.no-autoinit)'),
	    FormSelect: root.querySelectorAll('select:not(.no-autoinit)'),
	    Sidenav: root.querySelectorAll('.sidenav:not(.no-autoinit)'),
	    Tabs: root.querySelectorAll('.tabs:not(.no-autoinit)'),
	    TapTarget: root.querySelectorAll('.tap-target:not(.no-autoinit)'),
	    Timepicker: root.querySelectorAll('.timepicker:not(.no-autoinit)'),
	    Tooltip: root.querySelectorAll('.tooltipped:not(.no-autoinit)'),
	    FloatingActionButton: root.querySelectorAll('.fixed-action-btn:not(.no-autoinit)')
	  };
	
	  for (var pluginName in registry) {
	    var plugin = M[pluginName];
	    plugin.init(registry[pluginName]);
	  }
	};
	
	/**
	 * Generate approximated selector string for a jQuery object
	 * @param {jQuery} obj  jQuery object to be parsed
	 * @returns {string}
	 */
	M.objectSelectorString = function (obj) {
	  var tagStr = obj.prop('tagName') || '';
	  var idStr = obj.attr('id') || '';
	  var classStr = obj.attr('class') || '';
	  return (tagStr + idStr + classStr).replace(/\s/g, '');
	};
	
	// Unique Random ID
	M.guid = function () {
	  function s4() {
	    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
	  }
	  return function () {
	    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
	  };
	}();
	
	/**
	 * Escapes hash from special characters
	 * @param {string} hash  String returned from this.hash
	 * @returns {string}
	 */
	M.escapeHash = function (hash) {
	  return hash.replace(/(:|\.|\[|\]|,|=|\/)/g, '\\$1');
	};
	
	M.elementOrParentIsFixed = function (element) {
	  var $element = $(element);
	  var $checkElements = $element.add($element.parents());
	  var isFixed = false;
	  $checkElements.each(function () {
	    if ($(this).css('position') === 'fixed') {
	      isFixed = true;
	      return false;
	    }
	  });
	  return isFixed;
	};
	
	/**
	 * @typedef {Object} Edges
	 * @property {Boolean} top  If the top edge was exceeded
	 * @property {Boolean} right  If the right edge was exceeded
	 * @property {Boolean} bottom  If the bottom edge was exceeded
	 * @property {Boolean} left  If the left edge was exceeded
	 */
	
	/**
	 * @typedef {Object} Bounding
	 * @property {Number} left  left offset coordinate
	 * @property {Number} top  top offset coordinate
	 * @property {Number} width
	 * @property {Number} height
	 */
	
	/**
	 * Escapes hash from special characters
	 * @param {Element} container  Container element that acts as the boundary
	 * @param {Bounding} bounding  element bounding that is being checked
	 * @param {Number} offset  offset from edge that counts as exceeding
	 * @returns {Edges}
	 */
	M.checkWithinContainer = function (container, bounding, offset) {
	  var edges = {
	    top: false,
	    right: false,
	    bottom: false,
	    left: false
	  };
	
	  var containerRect = container.getBoundingClientRect();
	  // If body element is smaller than viewport, use viewport height instead.
	  var containerBottom = container === document.body ? Math.max(containerRect.bottom, window.innerHeight) : containerRect.bottom;
	
	  var scrollLeft = container.scrollLeft;
	  var scrollTop = container.scrollTop;
	
	  var scrolledX = bounding.left - scrollLeft;
	  var scrolledY = bounding.top - scrollTop;
	
	  // Check for container and viewport for each edge
	  if (scrolledX < containerRect.left + offset || scrolledX < offset) {
	    edges.left = true;
	  }
	
	  if (scrolledX + bounding.width > containerRect.right - offset || scrolledX + bounding.width > window.innerWidth - offset) {
	    edges.right = true;
	  }
	
	  if (scrolledY < containerRect.top + offset || scrolledY < offset) {
	    edges.top = true;
	  }
	
	  if (scrolledY + bounding.height > containerBottom - offset || scrolledY + bounding.height > window.innerHeight - offset) {
	    edges.bottom = true;
	  }
	
	  return edges;
	};
	
	M.checkPossibleAlignments = function (el, container, bounding, offset) {
	  var canAlign = {
	    top: true,
	    right: true,
	    bottom: true,
	    left: true,
	    spaceOnTop: null,
	    spaceOnRight: null,
	    spaceOnBottom: null,
	    spaceOnLeft: null
	  };
	
	  var containerAllowsOverflow = getComputedStyle(container).overflow === 'visible';
	  var containerRect = container.getBoundingClientRect();
	  var containerHeight = Math.min(containerRect.height, window.innerHeight);
	  var containerWidth = Math.min(containerRect.width, window.innerWidth);
	  var elOffsetRect = el.getBoundingClientRect();
	
	  var scrollLeft = container.scrollLeft;
	  var scrollTop = container.scrollTop;
	
	  var scrolledX = bounding.left - scrollLeft;
	  var scrolledYTopEdge = bounding.top - scrollTop;
	  var scrolledYBottomEdge = bounding.top + elOffsetRect.height - scrollTop;
	
	  // Check for container and viewport for left
	  canAlign.spaceOnRight = !containerAllowsOverflow ? containerWidth - (scrolledX + bounding.width) : window.innerWidth - (elOffsetRect.left + bounding.width);
	  if (canAlign.spaceOnRight < 0) {
	    canAlign.left = false;
	  }
	
	  // Check for container and viewport for Right
	  canAlign.spaceOnLeft = !containerAllowsOverflow ? scrolledX - bounding.width + elOffsetRect.width : elOffsetRect.right - bounding.width;
	  if (canAlign.spaceOnLeft < 0) {
	    canAlign.right = false;
	  }
	
	  // Check for container and viewport for Top
	  canAlign.spaceOnBottom = !containerAllowsOverflow ? containerHeight - (scrolledYTopEdge + bounding.height + offset) : window.innerHeight - (elOffsetRect.top + bounding.height + offset);
	  if (canAlign.spaceOnBottom < 0) {
	    canAlign.top = false;
	  }
	
	  // Check for container and viewport for Bottom
	  canAlign.spaceOnTop = !containerAllowsOverflow ? scrolledYBottomEdge - (bounding.height - offset) : elOffsetRect.bottom - (bounding.height + offset);
	  if (canAlign.spaceOnTop < 0) {
	    canAlign.bottom = false;
	  }
	
	  return canAlign;
	};
	
	M.getOverflowParent = function (element) {
	  if (element == null) {
	    return null;
	  }
	
	  if (element === document.body || getComputedStyle(element).overflow !== 'visible') {
	    return element;
	  }
	
	  return M.getOverflowParent(element.parentElement);
	};
	
	/**
	 * Gets id of component from a trigger
	 * @param {Element} trigger  trigger
	 * @returns {string}
	 */
	M.getIdFromTrigger = function (trigger) {
	  var id = trigger.getAttribute('data-target');
	  if (!id) {
	    id = trigger.getAttribute('href');
	    if (id) {
	      id = id.slice(1);
	    } else {
	      id = '';
	    }
	  }
	  return id;
	};
	
	/**
	 * Multi browser support for document scroll top
	 * @returns {Number}
	 */
	M.getDocumentScrollTop = function () {
	  return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
	};
	
	/**
	 * Multi browser support for document scroll left
	 * @returns {Number}
	 */
	M.getDocumentScrollLeft = function () {
	  return window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
	};
	
	/**
	 * @typedef {Object} Edges
	 * @property {Boolean} top  If the top edge was exceeded
	 * @property {Boolean} right  If the right edge was exceeded
	 * @property {Boolean} bottom  If the bottom edge was exceeded
	 * @property {Boolean} left  If the left edge was exceeded
	 */
	
	/**
	 * @typedef {Object} Bounding
	 * @property {Number} left  left offset coordinate
	 * @property {Number} top  top offset coordinate
	 * @property {Number} width
	 * @property {Number} height
	 */
	
	/**
	 * Get time in ms
	 * @license https://raw.github.com/jashkenas/underscore/master/LICENSE
	 * @type {function}
	 * @return {number}
	 */
	var getTime = Date.now || function () {
	  return new Date().getTime();
	};
	
	/**
	 * Returns a function, that, when invoked, will only be triggered at most once
	 * during a given window of time. Normally, the throttled function will run
	 * as much as it can, without ever going more than once per `wait` duration;
	 * but if you'd like to disable the execution on the leading edge, pass
	 * `{leading: false}`. To disable execution on the trailing edge, ditto.
	 * @license https://raw.github.com/jashkenas/underscore/master/LICENSE
	 * @param {function} func
	 * @param {number} wait
	 * @param {Object=} options
	 * @returns {Function}
	 */
	M.throttle = function (func, wait, options) {
	  var context = void 0,
	      args = void 0,
	      result = void 0;
	  var timeout = null;
	  var previous = 0;
	  options || (options = {});
	  var later = function later() {
	    previous = options.leading === false ? 0 : getTime();
	    timeout = null;
	    result = func.apply(context, args);
	    context = args = null;
	  };
	  return function () {
	    var now = getTime();
	    if (!previous && options.leading === false) previous = now;
	    var remaining = wait - (now - previous);
	    context = this;
	    args = arguments;
	    if (remaining <= 0) {
	      clearTimeout(timeout);
	      timeout = null;
	      previous = now;
	      result = func.apply(context, args);
	      context = args = null;
	    } else if (!timeout && options.trailing !== false) {
	      timeout = setTimeout(later, remaining);
	    }
	    return result;
	  };
	};
	; /*
	  v2.2.0
	  2017 Julian Garnier
	  Released under the MIT license
	  */
	var $jscomp = { scope: {} };$jscomp.defineProperty = "function" == typeof Object.defineProperties ? Object.defineProperty : function (e, r, p) {
	  if (p.get || p.set) throw new TypeError("ES3 does not support getters and setters.");e != Array.prototype && e != Object.prototype && (e[r] = p.value);
	};$jscomp.getGlobal = function (e) {
	  return "undefined" != typeof window && window === e ? e : "undefined" != typeof global && null != global ? global : e;
	};$jscomp.global = $jscomp.getGlobal(undefined);$jscomp.SYMBOL_PREFIX = "jscomp_symbol_";
	$jscomp.initSymbol = function () {
	  $jscomp.initSymbol = function () {};$jscomp.global.Symbol || ($jscomp.global.Symbol = $jscomp.Symbol);
	};$jscomp.symbolCounter_ = 0;$jscomp.Symbol = function (e) {
	  return $jscomp.SYMBOL_PREFIX + (e || "") + $jscomp.symbolCounter_++;
	};
	$jscomp.initSymbolIterator = function () {
	  $jscomp.initSymbol();var e = $jscomp.global.Symbol.iterator;e || (e = $jscomp.global.Symbol.iterator = $jscomp.global.Symbol("iterator"));"function" != typeof Array.prototype[e] && $jscomp.defineProperty(Array.prototype, e, { configurable: !0, writable: !0, value: function value() {
	      return $jscomp.arrayIterator(this);
	    } });$jscomp.initSymbolIterator = function () {};
	};$jscomp.arrayIterator = function (e) {
	  var r = 0;return $jscomp.iteratorPrototype(function () {
	    return r < e.length ? { done: !1, value: e[r++] } : { done: !0 };
	  });
	};
	$jscomp.iteratorPrototype = function (e) {
	  $jscomp.initSymbolIterator();e = { next: e };e[$jscomp.global.Symbol.iterator] = function () {
	    return this;
	  };return e;
	};$jscomp.array = $jscomp.array || {};$jscomp.iteratorFromArray = function (e, r) {
	  $jscomp.initSymbolIterator();e instanceof String && (e += "");var p = 0,
	      m = { next: function next() {
	      if (p < e.length) {
	        var u = p++;return { value: r(u, e[u]), done: !1 };
	      }m.next = function () {
	        return { done: !0, value: void 0 };
	      };return m.next();
	    } };m[Symbol.iterator] = function () {
	    return m;
	  };return m;
	};
	$jscomp.polyfill = function (e, r, p, m) {
	  if (r) {
	    p = $jscomp.global;e = e.split(".");for (m = 0; m < e.length - 1; m++) {
	      var u = e[m];u in p || (p[u] = {});p = p[u];
	    }e = e[e.length - 1];m = p[e];r = r(m);r != m && null != r && $jscomp.defineProperty(p, e, { configurable: !0, writable: !0, value: r });
	  }
	};$jscomp.polyfill("Array.prototype.keys", function (e) {
	  return e ? e : function () {
	    return $jscomp.iteratorFromArray(this, function (e) {
	      return e;
	    });
	  };
	}, "es6-impl", "es3");var $jscomp$this = undefined;
	(function (r) {
	  M.anime = r();
	})(function () {
	  function e(a) {
	    if (!h.col(a)) try {
	      return document.querySelectorAll(a);
	    } catch (c) {}
	  }function r(a, c) {
	    for (var d = a.length, b = 2 <= arguments.length ? arguments[1] : void 0, f = [], n = 0; n < d; n++) {
	      if (n in a) {
	        var k = a[n];c.call(b, k, n, a) && f.push(k);
	      }
	    }return f;
	  }function p(a) {
	    return a.reduce(function (a, d) {
	      return a.concat(h.arr(d) ? p(d) : d);
	    }, []);
	  }function m(a) {
	    if (h.arr(a)) return a;
	    h.str(a) && (a = e(a) || a);return a instanceof NodeList || a instanceof HTMLCollection ? [].slice.call(a) : [a];
	  }function u(a, c) {
	    return a.some(function (a) {
	      return a === c;
	    });
	  }function C(a) {
	    var c = {},
	        d;for (d in a) {
	      c[d] = a[d];
	    }return c;
	  }function D(a, c) {
	    var d = C(a),
	        b;for (b in a) {
	      d[b] = c.hasOwnProperty(b) ? c[b] : a[b];
	    }return d;
	  }function z(a, c) {
	    var d = C(a),
	        b;for (b in c) {
	      d[b] = h.und(a[b]) ? c[b] : a[b];
	    }return d;
	  }function T(a) {
	    a = a.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (a, c, d, k) {
	      return c + c + d + d + k + k;
	    });var c = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(a);
	    a = parseInt(c[1], 16);var d = parseInt(c[2], 16),
	        c = parseInt(c[3], 16);return "rgba(" + a + "," + d + "," + c + ",1)";
	  }function U(a) {
	    function c(a, c, b) {
	      0 > b && (b += 1);1 < b && --b;return b < 1 / 6 ? a + 6 * (c - a) * b : .5 > b ? c : b < 2 / 3 ? a + (c - a) * (2 / 3 - b) * 6 : a;
	    }var d = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(a) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(a);a = parseInt(d[1]) / 360;var b = parseInt(d[2]) / 100,
	        f = parseInt(d[3]) / 100,
	        d = d[4] || 1;if (0 == b) f = b = a = f;else {
	      var n = .5 > f ? f * (1 + b) : f + b - f * b,
	          k = 2 * f - n,
	          f = c(k, n, a + 1 / 3),
	          b = c(k, n, a);a = c(k, n, a - 1 / 3);
	    }return "rgba(" + 255 * f + "," + 255 * b + "," + 255 * a + "," + d + ")";
	  }function y(a) {
	    if (a = /([\+\-]?[0-9#\.]+)(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(a)) return a[2];
	  }function V(a) {
	    if (-1 < a.indexOf("translate") || "perspective" === a) return "px";if (-1 < a.indexOf("rotate") || -1 < a.indexOf("skew")) return "deg";
	  }function I(a, c) {
	    return h.fnc(a) ? a(c.target, c.id, c.total) : a;
	  }function E(a, c) {
	    if (c in a.style) return getComputedStyle(a).getPropertyValue(c.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()) || "0";
	  }function J(a, c) {
	    if (h.dom(a) && u(W, c)) return "transform";if (h.dom(a) && (a.getAttribute(c) || h.svg(a) && a[c])) return "attribute";if (h.dom(a) && "transform" !== c && E(a, c)) return "css";if (null != a[c]) return "object";
	  }function X(a, c) {
	    var d = V(c),
	        d = -1 < c.indexOf("scale") ? 1 : 0 + d;a = a.style.transform;if (!a) return d;for (var b = [], f = [], n = [], k = /(\w+)\((.+?)\)/g; b = k.exec(a);) {
	      f.push(b[1]), n.push(b[2]);
	    }a = r(n, function (a, b) {
	      return f[b] === c;
	    });return a.length ? a[0] : d;
	  }function K(a, c) {
	    switch (J(a, c)) {case "transform":
	        return X(a, c);case "css":
	        return E(a, c);case "attribute":
	        return a.getAttribute(c);}return a[c] || 0;
	  }function L(a, c) {
	    var d = /^(\*=|\+=|-=)/.exec(a);if (!d) return a;var b = y(a) || 0;c = parseFloat(c);a = parseFloat(a.replace(d[0], ""));switch (d[0][0]) {case "+":
	        return c + a + b;case "-":
	        return c - a + b;case "*":
	        return c * a + b;}
	  }function F(a, c) {
	    return Math.sqrt(Math.pow(c.x - a.x, 2) + Math.pow(c.y - a.y, 2));
	  }function M(a) {
	    a = a.points;for (var c = 0, d, b = 0; b < a.numberOfItems; b++) {
	      var f = a.getItem(b);0 < b && (c += F(d, f));d = f;
	    }return c;
	  }function N(a) {
	    if (a.getTotalLength) return a.getTotalLength();switch (a.tagName.toLowerCase()) {case "circle":
	        return 2 * Math.PI * a.getAttribute("r");case "rect":
	        return 2 * a.getAttribute("width") + 2 * a.getAttribute("height");case "line":
	        return F({ x: a.getAttribute("x1"), y: a.getAttribute("y1") }, { x: a.getAttribute("x2"), y: a.getAttribute("y2") });case "polyline":
	        return M(a);case "polygon":
	        var c = a.points;return M(a) + F(c.getItem(c.numberOfItems - 1), c.getItem(0));}
	  }function Y(a, c) {
	    function d(b) {
	      b = void 0 === b ? 0 : b;return a.el.getPointAtLength(1 <= c + b ? c + b : 0);
	    }var b = d(),
	        f = d(-1),
	        n = d(1);switch (a.property) {case "x":
	        return b.x;case "y":
	        return b.y;
	      case "angle":
	        return 180 * Math.atan2(n.y - f.y, n.x - f.x) / Math.PI;}
	  }function O(a, c) {
	    var d = /-?\d*\.?\d+/g,
	        b;b = h.pth(a) ? a.totalLength : a;if (h.col(b)) {
	      if (h.rgb(b)) {
	        var f = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(b);b = f ? "rgba(" + f[1] + ",1)" : b;
	      } else b = h.hex(b) ? T(b) : h.hsl(b) ? U(b) : void 0;
	    } else f = (f = y(b)) ? b.substr(0, b.length - f.length) : b, b = c && !/\s/g.test(b) ? f + c : f;b += "";return { original: b, numbers: b.match(d) ? b.match(d).map(Number) : [0], strings: h.str(a) || c ? b.split(d) : [] };
	  }function P(a) {
	    a = a ? p(h.arr(a) ? a.map(m) : m(a)) : [];return r(a, function (a, d, b) {
	      return b.indexOf(a) === d;
	    });
	  }function Z(a) {
	    var c = P(a);return c.map(function (a, b) {
	      return { target: a, id: b, total: c.length };
	    });
	  }function aa(a, c) {
	    var d = C(c);if (h.arr(a)) {
	      var b = a.length;2 !== b || h.obj(a[0]) ? h.fnc(c.duration) || (d.duration = c.duration / b) : a = { value: a };
	    }return m(a).map(function (a, b) {
	      b = b ? 0 : c.delay;a = h.obj(a) && !h.pth(a) ? a : { value: a };h.und(a.delay) && (a.delay = b);return a;
	    }).map(function (a) {
	      return z(a, d);
	    });
	  }function ba(a, c) {
	    var d = {},
	        b;for (b in a) {
	      var f = I(a[b], c);h.arr(f) && (f = f.map(function (a) {
	        return I(a, c);
	      }), 1 === f.length && (f = f[0]));d[b] = f;
	    }d.duration = parseFloat(d.duration);d.delay = parseFloat(d.delay);return d;
	  }function ca(a) {
	    return h.arr(a) ? A.apply(this, a) : Q[a];
	  }function da(a, c) {
	    var d;return a.tweens.map(function (b) {
	      b = ba(b, c);var f = b.value,
	          e = K(c.target, a.name),
	          k = d ? d.to.original : e,
	          k = h.arr(f) ? f[0] : k,
	          w = L(h.arr(f) ? f[1] : f, k),
	          e = y(w) || y(k) || y(e);b.from = O(k, e);b.to = O(w, e);b.start = d ? d.end : a.offset;b.end = b.start + b.delay + b.duration;b.easing = ca(b.easing);b.elasticity = (1E3 - Math.min(Math.max(b.elasticity, 1), 999)) / 1E3;b.isPath = h.pth(f);b.isColor = h.col(b.from.original);b.isColor && (b.round = 1);return d = b;
	    });
	  }function ea(a, c) {
	    return r(p(a.map(function (a) {
	      return c.map(function (b) {
	        var c = J(a.target, b.name);if (c) {
	          var d = da(b, a);b = { type: c, property: b.name, animatable: a, tweens: d, duration: d[d.length - 1].end, delay: d[0].delay };
	        } else b = void 0;return b;
	      });
	    })), function (a) {
	      return !h.und(a);
	    });
	  }function R(a, c, d, b) {
	    var f = "delay" === a;return c.length ? (f ? Math.min : Math.max).apply(Math, c.map(function (b) {
	      return b[a];
	    })) : f ? b.delay : d.offset + b.delay + b.duration;
	  }function fa(a) {
	    var c = D(ga, a),
	        d = D(S, a),
	        b = Z(a.targets),
	        f = [],
	        e = z(c, d),
	        k;for (k in a) {
	      e.hasOwnProperty(k) || "targets" === k || f.push({ name: k, offset: e.offset, tweens: aa(a[k], d) });
	    }a = ea(b, f);return z(c, { children: [], animatables: b, animations: a, duration: R("duration", a, c, d), delay: R("delay", a, c, d) });
	  }function q(a) {
	    function c() {
	      return window.Promise && new Promise(function (a) {
	        return p = a;
	      });
	    }function d(a) {
	      return g.reversed ? g.duration - a : a;
	    }function b(a) {
	      for (var b = 0, c = {}, d = g.animations, f = d.length; b < f;) {
	        var e = d[b],
	            k = e.animatable,
	            h = e.tweens,
	            n = h.length - 1,
	            l = h[n];n && (l = r(h, function (b) {
	          return a < b.end;
	        })[0] || l);for (var h = Math.min(Math.max(a - l.start - l.delay, 0), l.duration) / l.duration, w = isNaN(h) ? 1 : l.easing(h, l.elasticity), h = l.to.strings, p = l.round, n = [], m = void 0, m = l.to.numbers.length, t = 0; t < m; t++) {
	          var x = void 0,
	              x = l.to.numbers[t],
	              q = l.from.numbers[t],
	              x = l.isPath ? Y(l.value, w * x) : q + w * (x - q);p && (l.isColor && 2 < t || (x = Math.round(x * p) / p));n.push(x);
	        }if (l = h.length) for (m = h[0], w = 0; w < l; w++) {
	          p = h[w + 1], t = n[w], isNaN(t) || (m = p ? m + (t + p) : m + (t + " "));
	        } else m = n[0];ha[e.type](k.target, e.property, m, c, k.id);e.currentValue = m;b++;
	      }if (b = Object.keys(c).length) for (d = 0; d < b; d++) {
	        H || (H = E(document.body, "transform") ? "transform" : "-webkit-transform"), g.animatables[d].target.style[H] = c[d].join(" ");
	      }g.currentTime = a;g.progress = a / g.duration * 100;
	    }function f(a) {
	      if (g[a]) g[a](g);
	    }function e() {
	      g.remaining && !0 !== g.remaining && g.remaining--;
	    }function k(a) {
	      var k = g.duration,
	          n = g.offset,
	          w = n + g.delay,
	          r = g.currentTime,
	          x = g.reversed,
	          q = d(a);if (g.children.length) {
	        var u = g.children,
	            v = u.length;
	        if (q >= g.currentTime) for (var G = 0; G < v; G++) {
	          u[G].seek(q);
	        } else for (; v--;) {
	          u[v].seek(q);
	        }
	      }if (q >= w || !k) g.began || (g.began = !0, f("begin")), f("run");if (q > n && q < k) b(q);else if (q <= n && 0 !== r && (b(0), x && e()), q >= k && r !== k || !k) b(k), x || e();f("update");a >= k && (g.remaining ? (t = h, "alternate" === g.direction && (g.reversed = !g.reversed)) : (g.pause(), g.completed || (g.completed = !0, f("complete"), "Promise" in window && (p(), m = c()))), l = 0);
	    }a = void 0 === a ? {} : a;var h,
	        t,
	        l = 0,
	        p = null,
	        m = c(),
	        g = fa(a);g.reset = function () {
	      var a = g.direction,
	          c = g.loop;g.currentTime = 0;g.progress = 0;g.paused = !0;g.began = !1;g.completed = !1;g.reversed = "reverse" === a;g.remaining = "alternate" === a && 1 === c ? 2 : c;b(0);for (a = g.children.length; a--;) {
	        g.children[a].reset();
	      }
	    };g.tick = function (a) {
	      h = a;t || (t = h);k((l + h - t) * q.speed);
	    };g.seek = function (a) {
	      k(d(a));
	    };g.pause = function () {
	      var a = v.indexOf(g);-1 < a && v.splice(a, 1);g.paused = !0;
	    };g.play = function () {
	      g.paused && (g.paused = !1, t = 0, l = d(g.currentTime), v.push(g), B || ia());
	    };g.reverse = function () {
	      g.reversed = !g.reversed;t = 0;l = d(g.currentTime);
	    };g.restart = function () {
	      g.pause();
	      g.reset();g.play();
	    };g.finished = m;g.reset();g.autoplay && g.play();return g;
	  }var ga = { update: void 0, begin: void 0, run: void 0, complete: void 0, loop: 1, direction: "normal", autoplay: !0, offset: 0 },
	      S = { duration: 1E3, delay: 0, easing: "easeOutElastic", elasticity: 500, round: 0 },
	      W = "translateX translateY translateZ rotate rotateX rotateY rotateZ scale scaleX scaleY scaleZ skewX skewY perspective".split(" "),
	      H,
	      h = { arr: function arr(a) {
	      return Array.isArray(a);
	    }, obj: function obj(a) {
	      return -1 < Object.prototype.toString.call(a).indexOf("Object");
	    },
	    pth: function pth(a) {
	      return h.obj(a) && a.hasOwnProperty("totalLength");
	    }, svg: function svg(a) {
	      return a instanceof SVGElement;
	    }, dom: function dom(a) {
	      return a.nodeType || h.svg(a);
	    }, str: function str(a) {
	      return "string" === typeof a;
	    }, fnc: function fnc(a) {
	      return "function" === typeof a;
	    }, und: function und(a) {
	      return "undefined" === typeof a;
	    }, hex: function hex(a) {
	      return (/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(a)
	      );
	    }, rgb: function rgb(a) {
	      return (/^rgb/.test(a)
	      );
	    }, hsl: function hsl(a) {
	      return (/^hsl/.test(a)
	      );
	    }, col: function col(a) {
	      return h.hex(a) || h.rgb(a) || h.hsl(a);
	    } },
	      A = function () {
	    function a(a, d, b) {
	      return (((1 - 3 * b + 3 * d) * a + (3 * b - 6 * d)) * a + 3 * d) * a;
	    }return function (c, d, b, f) {
	      if (0 <= c && 1 >= c && 0 <= b && 1 >= b) {
	        var e = new Float32Array(11);if (c !== d || b !== f) for (var k = 0; 11 > k; ++k) {
	          e[k] = a(.1 * k, c, b);
	        }return function (k) {
	          if (c === d && b === f) return k;if (0 === k) return 0;if (1 === k) return 1;for (var h = 0, l = 1; 10 !== l && e[l] <= k; ++l) {
	            h += .1;
	          }--l;var l = h + (k - e[l]) / (e[l + 1] - e[l]) * .1,
	              n = 3 * (1 - 3 * b + 3 * c) * l * l + 2 * (3 * b - 6 * c) * l + 3 * c;if (.001 <= n) {
	            for (h = 0; 4 > h; ++h) {
	              n = 3 * (1 - 3 * b + 3 * c) * l * l + 2 * (3 * b - 6 * c) * l + 3 * c;if (0 === n) break;var m = a(l, c, b) - k,
	                  l = l - m / n;
	            }k = l;
	          } else if (0 === n) k = l;else {
	            var l = h,
	                h = h + .1,
	                g = 0;do {
	              m = l + (h - l) / 2, n = a(m, c, b) - k, 0 < n ? h = m : l = m;
	            } while (1e-7 < Math.abs(n) && 10 > ++g);k = m;
	          }return a(k, d, f);
	        };
	      }
	    };
	  }(),
	      Q = function () {
	    function a(a, b) {
	      return 0 === a || 1 === a ? a : -Math.pow(2, 10 * (a - 1)) * Math.sin(2 * (a - 1 - b / (2 * Math.PI) * Math.asin(1)) * Math.PI / b);
	    }var c = "Quad Cubic Quart Quint Sine Expo Circ Back Elastic".split(" "),
	        d = { In: [[.55, .085, .68, .53], [.55, .055, .675, .19], [.895, .03, .685, .22], [.755, .05, .855, .06], [.47, 0, .745, .715], [.95, .05, .795, .035], [.6, .04, .98, .335], [.6, -.28, .735, .045], a], Out: [[.25, .46, .45, .94], [.215, .61, .355, 1], [.165, .84, .44, 1], [.23, 1, .32, 1], [.39, .575, .565, 1], [.19, 1, .22, 1], [.075, .82, .165, 1], [.175, .885, .32, 1.275], function (b, c) {
	        return 1 - a(1 - b, c);
	      }], InOut: [[.455, .03, .515, .955], [.645, .045, .355, 1], [.77, 0, .175, 1], [.86, 0, .07, 1], [.445, .05, .55, .95], [1, 0, 0, 1], [.785, .135, .15, .86], [.68, -.55, .265, 1.55], function (b, c) {
	        return .5 > b ? a(2 * b, c) / 2 : 1 - a(-2 * b + 2, c) / 2;
	      }] },
	        b = { linear: A(.25, .25, .75, .75) },
	        f = {},
	        e;for (e in d) {
	      f.type = e, d[f.type].forEach(function (a) {
	        return function (d, f) {
	          b["ease" + a.type + c[f]] = h.fnc(d) ? d : A.apply($jscomp$this, d);
	        };
	      }(f)), f = { type: f.type };
	    }return b;
	  }(),
	      ha = { css: function css(a, c, d) {
	      return a.style[c] = d;
	    }, attribute: function attribute(a, c, d) {
	      return a.setAttribute(c, d);
	    }, object: function object(a, c, d) {
	      return a[c] = d;
	    }, transform: function transform(a, c, d, b, f) {
	      b[f] || (b[f] = []);b[f].push(c + "(" + d + ")");
	    } },
	      v = [],
	      B = 0,
	      ia = function () {
	    function a() {
	      B = requestAnimationFrame(c);
	    }function c(c) {
	      var b = v.length;if (b) {
	        for (var d = 0; d < b;) {
	          v[d] && v[d].tick(c), d++;
	        }a();
	      } else cancelAnimationFrame(B), B = 0;
	    }return a;
	  }();q.version = "2.2.0";q.speed = 1;q.running = v;q.remove = function (a) {
	    a = P(a);for (var c = v.length; c--;) {
	      for (var d = v[c], b = d.animations, f = b.length; f--;) {
	        u(a, b[f].animatable.target) && (b.splice(f, 1), b.length || d.pause());
	      }
	    }
	  };q.getValue = K;q.path = function (a, c) {
	    var d = h.str(a) ? e(a)[0] : a,
	        b = c || 100;return function (a) {
	      return { el: d, property: a, totalLength: N(d) * (b / 100) };
	    };
	  };q.setDashoffset = function (a) {
	    var c = N(a);a.setAttribute("stroke-dasharray", c);return c;
	  };q.bezier = A;q.easings = Q;q.timeline = function (a) {
	    var c = q(a);c.pause();c.duration = 0;c.add = function (d) {
	      c.children.forEach(function (a) {
	        a.began = !0;a.completed = !0;
	      });m(d).forEach(function (b) {
	        var d = z(b, D(S, a || {}));d.targets = d.targets || a.targets;b = c.duration;var e = d.offset;d.autoplay = !1;d.direction = c.direction;d.offset = h.und(e) ? b : L(e, b);c.began = !0;c.completed = !0;c.seek(d.offset);d = q(d);d.began = !0;d.completed = !0;d.duration > b && (c.duration = d.duration);c.children.push(d);
	      });c.seek(0);c.reset();c.autoplay && c.restart();return c;
	    };return c;
	  };q.random = function (a, c) {
	    return Math.floor(Math.random() * (c - a + 1)) + a;
	  };return q;
	});
	;(function ($, anim) {
	  'use strict';
	
	  var _defaults = {
	    accordion: true,
	    onOpenStart: undefined,
	    onOpenEnd: undefined,
	    onCloseStart: undefined,
	    onCloseEnd: undefined,
	    inDuration: 300,
	    outDuration: 300
	  };
	
	  /**
	   * @class
	   *
	   */
	
	  var Collapsible = function (_Component) {
	    _inherits(Collapsible, _Component);
	
	    /**
	     * Construct Collapsible instance
	     * @constructor
	     * @param {Element} el
	     * @param {Object} options
	     */
	    function Collapsible(el, options) {
	      _classCallCheck(this, Collapsible);
	
	      var _this3 = _possibleConstructorReturn(this, (Collapsible.__proto__ || Object.getPrototypeOf(Collapsible)).call(this, Collapsible, el, options));
	
	      _this3.el.M_Collapsible = _this3;
	
	      /**
	       * Options for the collapsible
	       * @member Collapsible#options
	       * @prop {Boolean} [accordion=false] - Type of the collapsible
	       * @prop {Function} onOpenStart - Callback function called before collapsible is opened
	       * @prop {Function} onOpenEnd - Callback function called after collapsible is opened
	       * @prop {Function} onCloseStart - Callback function called before collapsible is closed
	       * @prop {Function} onCloseEnd - Callback function called after collapsible is closed
	       * @prop {Number} inDuration - Transition in duration in milliseconds.
	       * @prop {Number} outDuration - Transition duration in milliseconds.
	       */
	      _this3.options = $.extend({}, Collapsible.defaults, options);
	
	      // Setup tab indices
	      _this3.$headers = _this3.$el.children('li').children('.collapsible-header');
	      _this3.$headers.attr('tabindex', 0);
	
	      _this3._setupEventHandlers();
	
	      // Open first active
	      var $activeBodies = _this3.$el.children('li.active').children('.collapsible-body');
	      if (_this3.options.accordion) {
	        // Handle Accordion
	        $activeBodies.first().css('display', 'block');
	      } else {
	        // Handle Expandables
	        $activeBodies.css('display', 'block');
	      }
	      return _this3;
	    }
	
	    _createClass(Collapsible, [{
	      key: "destroy",
	
	      /**
	       * Teardown component
	       */
	      value: function destroy() {
	        this._removeEventHandlers();
	        this.el.M_Collapsible = undefined;
	      }
	
	      /**
	       * Setup Event Handlers
	       */
	
	    }, {
	      key: "_setupEventHandlers",
	      value: function _setupEventHandlers() {
	        var _this4 = this;
	
	        this._handleCollapsibleClickBound = this._handleCollapsibleClick.bind(this);
	        this._handleCollapsibleKeydownBound = this._handleCollapsibleKeydown.bind(this);
	        this.el.addEventListener('click', this._handleCollapsibleClickBound);
	        this.$headers.each(function (header) {
	          header.addEventListener('keydown', _this4._handleCollapsibleKeydownBound);
	        });
	      }
	
	      /**
	       * Remove Event Handlers
	       */
	
	    }, {
	      key: "_removeEventHandlers",
	      value: function _removeEventHandlers() {
	        var _this5 = this;
	
	        this.el.removeEventListener('click', this._handleCollapsibleClickBound);
	        this.$headers.each(function (header) {
	          header.removeEventListener('keydown', _this5._handleCollapsibleKeydownBound);
	        });
	      }
	
	      /**
	       * Handle Collapsible Click
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleCollapsibleClick",
	      value: function _handleCollapsibleClick(e) {
	        var $header = $(e.target).closest('.collapsible-header');
	        if (e.target && $header.length) {
	          var $collapsible = $header.closest('.collapsible');
	          if ($collapsible[0] === this.el) {
	            var $collapsibleLi = $header.closest('li');
	            var $collapsibleLis = $collapsible.children('li');
	            var isActive = $collapsibleLi[0].classList.contains('active');
	            var index = $collapsibleLis.index($collapsibleLi);
	
	            if (isActive) {
	              this.close(index);
	            } else {
	              this.open(index);
	            }
	          }
	        }
	      }
	
	      /**
	       * Handle Collapsible Keydown
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleCollapsibleKeydown",
	      value: function _handleCollapsibleKeydown(e) {
	        if (e.keyCode === 13) {
	          this._handleCollapsibleClickBound(e);
	        }
	      }
	
	      /**
	       * Animate in collapsible slide
	       * @param {Number} index - 0th index of slide
	       */
	
	    }, {
	      key: "_animateIn",
	      value: function _animateIn(index) {
	        var _this6 = this;
	
	        var $collapsibleLi = this.$el.children('li').eq(index);
	        if ($collapsibleLi.length) {
	          var $body = $collapsibleLi.children('.collapsible-body');
	
	          anim.remove($body[0]);
	          $body.css({
	            display: 'block',
	            overflow: 'hidden',
	            height: 0,
	            paddingTop: '',
	            paddingBottom: ''
	          });
	
	          var pTop = $body.css('padding-top');
	          var pBottom = $body.css('padding-bottom');
	          var finalHeight = $body[0].scrollHeight;
	          $body.css({
	            paddingTop: 0,
	            paddingBottom: 0
	          });
	
	          anim({
	            targets: $body[0],
	            height: finalHeight,
	            paddingTop: pTop,
	            paddingBottom: pBottom,
	            duration: this.options.inDuration,
	            easing: 'easeInOutCubic',
	            complete: function complete(anim) {
	              $body.css({
	                overflow: '',
	                paddingTop: '',
	                paddingBottom: '',
	                height: ''
	              });
	
	              // onOpenEnd callback
	              if (typeof _this6.options.onOpenEnd === 'function') {
	                _this6.options.onOpenEnd.call(_this6, $collapsibleLi[0]);
	              }
	            }
	          });
	        }
	      }
	
	      /**
	       * Animate out collapsible slide
	       * @param {Number} index - 0th index of slide to open
	       */
	
	    }, {
	      key: "_animateOut",
	      value: function _animateOut(index) {
	        var _this7 = this;
	
	        var $collapsibleLi = this.$el.children('li').eq(index);
	        if ($collapsibleLi.length) {
	          var $body = $collapsibleLi.children('.collapsible-body');
	          anim.remove($body[0]);
	          $body.css('overflow', 'hidden');
	          anim({
	            targets: $body[0],
	            height: 0,
	            paddingTop: 0,
	            paddingBottom: 0,
	            duration: this.options.outDuration,
	            easing: 'easeInOutCubic',
	            complete: function complete() {
	              $body.css({
	                height: '',
	                overflow: '',
	                padding: '',
	                display: ''
	              });
	
	              // onCloseEnd callback
	              if (typeof _this7.options.onCloseEnd === 'function') {
	                _this7.options.onCloseEnd.call(_this7, $collapsibleLi[0]);
	              }
	            }
	          });
	        }
	      }
	
	      /**
	       * Open Collapsible
	       * @param {Number} index - 0th index of slide
	       */
	
	    }, {
	      key: "open",
	      value: function open(index) {
	        var _this8 = this;
	
	        var $collapsibleLi = this.$el.children('li').eq(index);
	        if ($collapsibleLi.length && !$collapsibleLi[0].classList.contains('active')) {
	          // onOpenStart callback
	          if (typeof this.options.onOpenStart === 'function') {
	            this.options.onOpenStart.call(this, $collapsibleLi[0]);
	          }
	
	          // Handle accordion behavior
	          if (this.options.accordion) {
	            var $collapsibleLis = this.$el.children('li');
	            var $activeLis = this.$el.children('li.active');
	            $activeLis.each(function (el) {
	              var index = $collapsibleLis.index($(el));
	              _this8.close(index);
	            });
	          }
	
	          // Animate in
	          $collapsibleLi[0].classList.add('active');
	          this._animateIn(index);
	        }
	      }
	
	      /**
	       * Close Collapsible
	       * @param {Number} index - 0th index of slide
	       */
	
	    }, {
	      key: "close",
	      value: function close(index) {
	        var $collapsibleLi = this.$el.children('li').eq(index);
	        if ($collapsibleLi.length && $collapsibleLi[0].classList.contains('active')) {
	          // onCloseStart callback
	          if (typeof this.options.onCloseStart === 'function') {
	            this.options.onCloseStart.call(this, $collapsibleLi[0]);
	          }
	
	          // Animate out
	          $collapsibleLi[0].classList.remove('active');
	          this._animateOut(index);
	        }
	      }
	    }], [{
	      key: "init",
	      value: function init(els, options) {
	        return _get(Collapsible.__proto__ || Object.getPrototypeOf(Collapsible), "init", this).call(this, this, els, options);
	      }
	
	      /**
	       * Get Instance
	       */
	
	    }, {
	      key: "getInstance",
	      value: function getInstance(el) {
	        var domElem = !!el.jquery ? el[0] : el;
	        return domElem.M_Collapsible;
	      }
	    }, {
	      key: "defaults",
	      get: function get() {
	        return _defaults;
	      }
	    }]);
	
	    return Collapsible;
	  }(Component);
	
	  M.Collapsible = Collapsible;
	
	  if (M.jQueryLoaded) {
	    M.initializeJqueryWrapper(Collapsible, 'collapsible', 'M_Collapsible');
	  }
	})(cash, M.anime);
	;(function ($, anim) {
	  'use strict';
	
	  var _defaults = {
	    alignment: 'left',
	    autoFocus: true,
	    constrainWidth: true,
	    container: null,
	    coverTrigger: true,
	    closeOnClick: true,
	    hover: false,
	    inDuration: 150,
	    outDuration: 250,
	    onOpenStart: null,
	    onOpenEnd: null,
	    onCloseStart: null,
	    onCloseEnd: null,
	    onItemClick: null
	  };
	
	  /**
	   * @class
	   */
	
	  var Dropdown = function (_Component2) {
	    _inherits(Dropdown, _Component2);
	
	    function Dropdown(el, options) {
	      _classCallCheck(this, Dropdown);
	
	      var _this9 = _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, Dropdown, el, options));
	
	      _this9.el.M_Dropdown = _this9;
	      Dropdown._dropdowns.push(_this9);
	
	      _this9.id = M.getIdFromTrigger(el);
	      _this9.dropdownEl = document.getElementById(_this9.id);
	      _this9.$dropdownEl = $(_this9.dropdownEl);
	
	      /**
	       * Options for the dropdown
	       * @member Dropdown#options
	       * @prop {String} [alignment='left'] - Edge which the dropdown is aligned to
	       * @prop {Boolean} [autoFocus=true] - Automatically focus dropdown el for keyboard
	       * @prop {Boolean} [constrainWidth=true] - Constrain width to width of the button
	       * @prop {Element} container - Container element to attach dropdown to (optional)
	       * @prop {Boolean} [coverTrigger=true] - Place dropdown over trigger
	       * @prop {Boolean} [closeOnClick=true] - Close on click of dropdown item
	       * @prop {Boolean} [hover=false] - Open dropdown on hover
	       * @prop {Number} [inDuration=150] - Duration of open animation in ms
	       * @prop {Number} [outDuration=250] - Duration of close animation in ms
	       * @prop {Function} onOpenStart - Function called when dropdown starts opening
	       * @prop {Function} onOpenEnd - Function called when dropdown finishes opening
	       * @prop {Function} onCloseStart - Function called when dropdown starts closing
	       * @prop {Function} onCloseEnd - Function called when dropdown finishes closing
	       */
	      _this9.options = $.extend({}, Dropdown.defaults, options);
	
	      /**
	       * Describes open/close state of dropdown
	       * @type {Boolean}
	       */
	      _this9.isOpen = false;
	
	      /**
	       * Describes if dropdown content is scrollable
	       * @type {Boolean}
	       */
	      _this9.isScrollable = false;
	
	      /**
	       * Describes if touch moving on dropdown content
	       * @type {Boolean}
	       */
	      _this9.isTouchMoving = false;
	
	      _this9.focusedIndex = -1;
	      _this9.filterQuery = [];
	
	      // Move dropdown-content after dropdown-trigger
	      if (!!_this9.options.container) {
	        $(_this9.options.container).append(_this9.dropdownEl);
	      } else {
	        _this9.$el.after(_this9.dropdownEl);
	      }
	
	      _this9._makeDropdownFocusable();
	      _this9._resetFilterQueryBound = _this9._resetFilterQuery.bind(_this9);
	      _this9._handleDocumentClickBound = _this9._handleDocumentClick.bind(_this9);
	      _this9._handleDocumentTouchmoveBound = _this9._handleDocumentTouchmove.bind(_this9);
	      _this9._handleDropdownClickBound = _this9._handleDropdownClick.bind(_this9);
	      _this9._handleDropdownKeydownBound = _this9._handleDropdownKeydown.bind(_this9);
	      _this9._handleTriggerKeydownBound = _this9._handleTriggerKeydown.bind(_this9);
	      _this9._setupEventHandlers();
	      return _this9;
	    }
	
	    _createClass(Dropdown, [{
	      key: "destroy",
	
	      /**
	       * Teardown component
	       */
	      value: function destroy() {
	        this._resetDropdownStyles();
	        this._removeEventHandlers();
	        Dropdown._dropdowns.splice(Dropdown._dropdowns.indexOf(this), 1);
	        this.el.M_Dropdown = undefined;
	      }
	
	      /**
	       * Setup Event Handlers
	       */
	
	    }, {
	      key: "_setupEventHandlers",
	      value: function _setupEventHandlers() {
	        // Trigger keydown handler
	        this.el.addEventListener('keydown', this._handleTriggerKeydownBound);
	
	        // Item click handler
	        this.dropdownEl.addEventListener('click', this._handleDropdownClickBound);
	
	        // Hover event handlers
	        if (this.options.hover) {
	          this._handleMouseEnterBound = this._handleMouseEnter.bind(this);
	          this.el.addEventListener('mouseenter', this._handleMouseEnterBound);
	          this._handleMouseLeaveBound = this._handleMouseLeave.bind(this);
	          this.el.addEventListener('mouseleave', this._handleMouseLeaveBound);
	          this.dropdownEl.addEventListener('mouseleave', this._handleMouseLeaveBound);
	
	          // Click event handlers
	        } else {
	          this._handleClickBound = this._handleClick.bind(this);
	          this.el.addEventListener('click', this._handleClickBound);
	        }
	      }
	
	      /**
	       * Remove Event Handlers
	       */
	
	    }, {
	      key: "_removeEventHandlers",
	      value: function _removeEventHandlers() {
	        this.el.removeEventListener('keydown', this._handleTriggerKeydownBound);
	        this.dropdownEl.removeEventListener('click', this._handleDropdownClickBound);
	
	        if (this.options.hover) {
	          this.el.removeEventListener('mouseenter', this._handleMouseEnterBound);
	          this.el.removeEventListener('mouseleave', this._handleMouseLeaveBound);
	          this.dropdownEl.removeEventListener('mouseleave', this._handleMouseLeaveBound);
	        } else {
	          this.el.removeEventListener('click', this._handleClickBound);
	        }
	      }
	    }, {
	      key: "_setupTemporaryEventHandlers",
	      value: function _setupTemporaryEventHandlers() {
	        // Use capture phase event handler to prevent click
	        document.body.addEventListener('click', this._handleDocumentClickBound, true);
	        document.body.addEventListener('touchend', this._handleDocumentClickBound);
	        document.body.addEventListener('touchmove', this._handleDocumentTouchmoveBound);
	        this.dropdownEl.addEventListener('keydown', this._handleDropdownKeydownBound);
	      }
	    }, {
	      key: "_removeTemporaryEventHandlers",
	      value: function _removeTemporaryEventHandlers() {
	        // Use capture phase event handler to prevent click
	        document.body.removeEventListener('click', this._handleDocumentClickBound, true);
	        document.body.removeEventListener('touchend', this._handleDocumentClickBound);
	        document.body.removeEventListener('touchmove', this._handleDocumentTouchmoveBound);
	        this.dropdownEl.removeEventListener('keydown', this._handleDropdownKeydownBound);
	      }
	    }, {
	      key: "_handleClick",
	      value: function _handleClick(e) {
	        e.preventDefault();
	        this.open();
	      }
	    }, {
	      key: "_handleMouseEnter",
	      value: function _handleMouseEnter() {
	        this.open();
	      }
	    }, {
	      key: "_handleMouseLeave",
	      value: function _handleMouseLeave(e) {
	        var toEl = e.toElement || e.relatedTarget;
	        var leaveToDropdownContent = !!$(toEl).closest('.dropdown-content').length;
	        var leaveToActiveDropdownTrigger = false;
	
	        var $closestTrigger = $(toEl).closest('.dropdown-trigger');
	        if ($closestTrigger.length && !!$closestTrigger[0].M_Dropdown && $closestTrigger[0].M_Dropdown.isOpen) {
	          leaveToActiveDropdownTrigger = true;
	        }
	
	        // Close hover dropdown if mouse did not leave to either active dropdown-trigger or dropdown-content
	        if (!leaveToActiveDropdownTrigger && !leaveToDropdownContent) {
	          this.close();
	        }
	      }
	    }, {
	      key: "_handleDocumentClick",
	      value: function _handleDocumentClick(e) {
	        var _this10 = this;
	
	        var $target = $(e.target);
	        if (this.options.closeOnClick && $target.closest('.dropdown-content').length && !this.isTouchMoving) {
	          // isTouchMoving to check if scrolling on mobile.
	          setTimeout(function () {
	            _this10.close();
	          }, 0);
	        } else if ($target.closest('.dropdown-trigger').length || !$target.closest('.dropdown-content').length) {
	          setTimeout(function () {
	            _this10.close();
	          }, 0);
	        }
	        this.isTouchMoving = false;
	      }
	    }, {
	      key: "_handleTriggerKeydown",
	      value: function _handleTriggerKeydown(e) {
	        // ARROW DOWN OR ENTER WHEN SELECT IS CLOSED - open Dropdown
	        if ((e.which === M.keys.ARROW_DOWN || e.which === M.keys.ENTER) && !this.isOpen) {
	          e.preventDefault();
	          this.open();
	        }
	      }
	
	      /**
	       * Handle Document Touchmove
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleDocumentTouchmove",
	      value: function _handleDocumentTouchmove(e) {
	        var $target = $(e.target);
	        if ($target.closest('.dropdown-content').length) {
	          this.isTouchMoving = true;
	        }
	      }
	
	      /**
	       * Handle Dropdown Click
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleDropdownClick",
	      value: function _handleDropdownClick(e) {
	        // onItemClick callback
	        if (typeof this.options.onItemClick === 'function') {
	          var itemEl = $(e.target).closest('li')[0];
	          this.options.onItemClick.call(this, itemEl);
	        }
	      }
	
	      /**
	       * Handle Dropdown Keydown
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleDropdownKeydown",
	      value: function _handleDropdownKeydown(e) {
	        if (e.which === M.keys.TAB) {
	          e.preventDefault();
	          this.close();
	
	          // Navigate down dropdown list
	        } else if ((e.which === M.keys.ARROW_DOWN || e.which === M.keys.ARROW_UP) && this.isOpen) {
	          e.preventDefault();
	          var direction = e.which === M.keys.ARROW_DOWN ? 1 : -1;
	          var newFocusedIndex = this.focusedIndex;
	          var foundNewIndex = false;
	          do {
	            newFocusedIndex = newFocusedIndex + direction;
	
	            if (!!this.dropdownEl.children[newFocusedIndex] && this.dropdownEl.children[newFocusedIndex].tabIndex !== -1) {
	              foundNewIndex = true;
	              break;
	            }
	          } while (newFocusedIndex < this.dropdownEl.children.length && newFocusedIndex >= 0);
	
	          if (foundNewIndex) {
	            this.focusedIndex = newFocusedIndex;
	            this._focusFocusedItem();
	          }
	
	          // ENTER selects choice on focused item
	        } else if (e.which === M.keys.ENTER && this.isOpen) {
	          // Search for <a> and <button>
	          var focusedElement = this.dropdownEl.children[this.focusedIndex];
	          var $activatableElement = $(focusedElement).find('a, button').first();
	
	          // Click a or button tag if exists, otherwise click li tag
	          !!$activatableElement.length ? $activatableElement[0].click() : focusedElement.click();
	
	          // Close dropdown on ESC
	        } else if (e.which === M.keys.ESC && this.isOpen) {
	          e.preventDefault();
	          this.close();
	        }
	
	        // CASE WHEN USER TYPE LETTERS
	        var letter = String.fromCharCode(e.which).toLowerCase(),
	            nonLetters = [9, 13, 27, 38, 40];
	        if (letter && nonLetters.indexOf(e.which) === -1) {
	          this.filterQuery.push(letter);
	
	          var string = this.filterQuery.join(''),
	              newOptionEl = $(this.dropdownEl).find('li').filter(function (el) {
	            return $(el).text().toLowerCase().indexOf(string) === 0;
	          })[0];
	
	          if (newOptionEl) {
	            this.focusedIndex = $(newOptionEl).index();
	            this._focusFocusedItem();
	          }
	        }
	
	        this.filterTimeout = setTimeout(this._resetFilterQueryBound, 1000);
	      }
	
	      /**
	       * Setup dropdown
	       */
	
	    }, {
	      key: "_resetFilterQuery",
	      value: function _resetFilterQuery() {
	        this.filterQuery = [];
	      }
	    }, {
	      key: "_resetDropdownStyles",
	      value: function _resetDropdownStyles() {
	        this.$dropdownEl.css({
	          display: '',
	          width: '',
	          height: '',
	          left: '',
	          top: '',
	          'transform-origin': '',
	          transform: '',
	          opacity: ''
	        });
	      }
	    }, {
	      key: "_makeDropdownFocusable",
	      value: function _makeDropdownFocusable() {
	        // Needed for arrow key navigation
	        this.dropdownEl.tabIndex = 0;
	
	        // Only set tabindex if it hasn't been set by user
	        $(this.dropdownEl).children().each(function (el) {
	          if (!el.getAttribute('tabindex')) {
	            el.setAttribute('tabindex', 0);
	          }
	        });
	      }
	    }, {
	      key: "_focusFocusedItem",
	      value: function _focusFocusedItem() {
	        if (this.focusedIndex >= 0 && this.focusedIndex < this.dropdownEl.children.length && this.options.autoFocus) {
	          this.dropdownEl.children[this.focusedIndex].focus();
	        }
	      }
	    }, {
	      key: "_getDropdownPosition",
	      value: function _getDropdownPosition() {
	        var offsetParentBRect = this.el.offsetParent.getBoundingClientRect();
	        var triggerBRect = this.el.getBoundingClientRect();
	        var dropdownBRect = this.dropdownEl.getBoundingClientRect();
	
	        var idealHeight = dropdownBRect.height;
	        var idealWidth = dropdownBRect.width;
	        var idealXPos = triggerBRect.left - dropdownBRect.left;
	        var idealYPos = triggerBRect.top - dropdownBRect.top;
	
	        var dropdownBounds = {
	          left: idealXPos,
	          top: idealYPos,
	          height: idealHeight,
	          width: idealWidth
	        };
	
	        // Countainer here will be closest ancestor with overflow: hidden
	        var closestOverflowParent = !!this.dropdownEl.offsetParent ? this.dropdownEl.offsetParent : this.dropdownEl.parentNode;
	
	        var alignments = M.checkPossibleAlignments(this.el, closestOverflowParent, dropdownBounds, this.options.coverTrigger ? 0 : triggerBRect.height);
	
	        var verticalAlignment = 'top';
	        var horizontalAlignment = this.options.alignment;
	        idealYPos += this.options.coverTrigger ? 0 : triggerBRect.height;
	
	        // Reset isScrollable
	        this.isScrollable = false;
	
	        if (!alignments.top) {
	          if (alignments.bottom) {
	            verticalAlignment = 'bottom';
	          } else {
	            this.isScrollable = true;
	
	            // Determine which side has most space and cutoff at correct height
	            if (alignments.spaceOnTop > alignments.spaceOnBottom) {
	              verticalAlignment = 'bottom';
	              idealHeight += alignments.spaceOnTop;
	              idealYPos -= alignments.spaceOnTop;
	            } else {
	              idealHeight += alignments.spaceOnBottom;
	            }
	          }
	        }
	
	        // If preferred horizontal alignment is possible
	        if (!alignments[horizontalAlignment]) {
	          var oppositeAlignment = horizontalAlignment === 'left' ? 'right' : 'left';
	          if (alignments[oppositeAlignment]) {
	            horizontalAlignment = oppositeAlignment;
	          } else {
	            // Determine which side has most space and cutoff at correct height
	            if (alignments.spaceOnLeft > alignments.spaceOnRight) {
	              horizontalAlignment = 'right';
	              idealWidth += alignments.spaceOnLeft;
	              idealXPos -= alignments.spaceOnLeft;
	            } else {
	              horizontalAlignment = 'left';
	              idealWidth += alignments.spaceOnRight;
	            }
	          }
	        }
	
	        if (verticalAlignment === 'bottom') {
	          idealYPos = idealYPos - dropdownBRect.height + (this.options.coverTrigger ? triggerBRect.height : 0);
	        }
	        if (horizontalAlignment === 'right') {
	          idealXPos = idealXPos - dropdownBRect.width + triggerBRect.width;
	        }
	        return {
	          x: idealXPos,
	          y: idealYPos,
	          verticalAlignment: verticalAlignment,
	          horizontalAlignment: horizontalAlignment,
	          height: idealHeight,
	          width: idealWidth
	        };
	      }
	
	      /**
	       * Animate in dropdown
	       */
	
	    }, {
	      key: "_animateIn",
	      value: function _animateIn() {
	        var _this11 = this;
	
	        anim.remove(this.dropdownEl);
	        anim({
	          targets: this.dropdownEl,
	          opacity: {
	            value: [0, 1],
	            easing: 'easeOutQuad'
	          },
	          scaleX: [0.3, 1],
	          scaleY: [0.3, 1],
	          duration: this.options.inDuration,
	          easing: 'easeOutQuint',
	          complete: function complete(anim) {
	            if (_this11.options.autoFocus) {
	              _this11.dropdownEl.focus();
	            }
	
	            // onOpenEnd callback
	            if (typeof _this11.options.onOpenEnd === 'function') {
	              var elem = anim.animatables[0].target;
	              _this11.options.onOpenEnd.call(elem, _this11.el);
	            }
	          }
	        });
	      }
	
	      /**
	       * Animate out dropdown
	       */
	
	    }, {
	      key: "_animateOut",
	      value: function _animateOut() {
	        var _this12 = this;
	
	        anim.remove(this.dropdownEl);
	        anim({
	          targets: this.dropdownEl,
	          opacity: {
	            value: 0,
	            easing: 'easeOutQuint'
	          },
	          scaleX: 0.3,
	          scaleY: 0.3,
	          duration: this.options.outDuration,
	          easing: 'easeOutQuint',
	          complete: function complete(anim) {
	            _this12._resetDropdownStyles();
	
	            // onCloseEnd callback
	            if (typeof _this12.options.onCloseEnd === 'function') {
	              var elem = anim.animatables[0].target;
	              _this12.options.onCloseEnd.call(_this12, _this12.el);
	            }
	          }
	        });
	      }
	
	      /**
	       * Place dropdown
	       */
	
	    }, {
	      key: "_placeDropdown",
	      value: function _placeDropdown() {
	        // Set width before calculating positionInfo
	        var idealWidth = this.options.constrainWidth ? this.el.getBoundingClientRect().width : this.dropdownEl.getBoundingClientRect().width;
	        this.dropdownEl.style.width = idealWidth + 'px';
	
	        var positionInfo = this._getDropdownPosition();
	        this.dropdownEl.style.left = positionInfo.x + 'px';
	        this.dropdownEl.style.top = positionInfo.y + 'px';
	        this.dropdownEl.style.height = positionInfo.height + 'px';
	        this.dropdownEl.style.width = positionInfo.width + 'px';
	        this.dropdownEl.style.transformOrigin = (positionInfo.horizontalAlignment === 'left' ? '0' : '100%') + " " + (positionInfo.verticalAlignment === 'top' ? '0' : '100%');
	      }
	
	      /**
	       * Open Dropdown
	       */
	
	    }, {
	      key: "open",
	      value: function open() {
	        if (this.isOpen) {
	          return;
	        }
	        this.isOpen = true;
	
	        // onOpenStart callback
	        if (typeof this.options.onOpenStart === 'function') {
	          this.options.onOpenStart.call(this, this.el);
	        }
	
	        // Reset styles
	        this._resetDropdownStyles();
	        this.dropdownEl.style.display = 'block';
	
	        this._placeDropdown();
	        this._animateIn();
	        this._setupTemporaryEventHandlers();
	      }
	
	      /**
	       * Close Dropdown
	       */
	
	    }, {
	      key: "close",
	      value: function close() {
	        if (!this.isOpen) {
	          return;
	        }
	        this.isOpen = false;
	        this.focusedIndex = -1;
	
	        // onCloseStart callback
	        if (typeof this.options.onCloseStart === 'function') {
	          this.options.onCloseStart.call(this, this.el);
	        }
	
	        this._animateOut();
	        this._removeTemporaryEventHandlers();
	
	        if (this.options.autoFocus) {
	          this.el.focus();
	        }
	      }
	
	      /**
	       * Recalculate dimensions
	       */
	
	    }, {
	      key: "recalculateDimensions",
	      value: function recalculateDimensions() {
	        if (this.isOpen) {
	          this.$dropdownEl.css({
	            width: '',
	            height: '',
	            left: '',
	            top: '',
	            'transform-origin': ''
	          });
	          this._placeDropdown();
	        }
	      }
	    }], [{
	      key: "init",
	      value: function init(els, options) {
	        return _get(Dropdown.__proto__ || Object.getPrototypeOf(Dropdown), "init", this).call(this, this, els, options);
	      }
	
	      /**
	       * Get Instance
	       */
	
	    }, {
	      key: "getInstance",
	      value: function getInstance(el) {
	        var domElem = !!el.jquery ? el[0] : el;
	        return domElem.M_Dropdown;
	      }
	    }, {
	      key: "defaults",
	      get: function get() {
	        return _defaults;
	      }
	    }]);
	
	    return Dropdown;
	  }(Component);
	
	  /**
	   * @static
	   * @memberof Dropdown
	   */
	
	  Dropdown._dropdowns = [];
	
	  window.M.Dropdown = Dropdown;
	
	  if (M.jQueryLoaded) {
	    M.initializeJqueryWrapper(Dropdown, 'dropdown', 'M_Dropdown');
	  }
	})(cash, M.anime);
	;(function ($, anim) {
	  'use strict';
	
	  var _defaults = {
	    opacity: 0.5,
	    inDuration: 250,
	    outDuration: 250,
	    onOpenStart: null,
	    onOpenEnd: null,
	    onCloseStart: null,
	    onCloseEnd: null,
	    preventScrolling: true,
	    dismissible: true,
	    startingTop: '4%',
	    endingTop: '10%'
	  };
	
	  /**
	   * @class
	   *
	   */
	
	  var Modal = function (_Component3) {
	    _inherits(Modal, _Component3);
	
	    /**
	     * Construct Modal instance and set up overlay
	     * @constructor
	     * @param {Element} el
	     * @param {Object} options
	     */
	    function Modal(el, options) {
	      _classCallCheck(this, Modal);
	
	      var _this13 = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, Modal, el, options));
	
	      _this13.el.M_Modal = _this13;
	
	      /**
	       * Options for the modal
	       * @member Modal#options
	       * @prop {Number} [opacity=0.5] - Opacity of the modal overlay
	       * @prop {Number} [inDuration=250] - Length in ms of enter transition
	       * @prop {Number} [outDuration=250] - Length in ms of exit transition
	       * @prop {Function} onOpenStart - Callback function called before modal is opened
	       * @prop {Function} onOpenEnd - Callback function called after modal is opened
	       * @prop {Function} onCloseStart - Callback function called before modal is closed
	       * @prop {Function} onCloseEnd - Callback function called after modal is closed
	       * @prop {Boolean} [dismissible=true] - Allow modal to be dismissed by keyboard or overlay click
	       * @prop {String} [startingTop='4%'] - startingTop
	       * @prop {String} [endingTop='10%'] - endingTop
	       */
	      _this13.options = $.extend({}, Modal.defaults, options);
	
	      /**
	       * Describes open/close state of modal
	       * @type {Boolean}
	       */
	      _this13.isOpen = false;
	
	      _this13.id = _this13.$el.attr('id');
	      _this13._openingTrigger = undefined;
	      _this13.$overlay = $('<div class="modal-overlay"></div>');
	      _this13.el.tabIndex = 0;
	      _this13._nthModalOpened = 0;
	
	      Modal._count++;
	      _this13._setupEventHandlers();
	      return _this13;
	    }
	
	    _createClass(Modal, [{
	      key: "destroy",
	
	      /**
	       * Teardown component
	       */
	      value: function destroy() {
	        Modal._count--;
	        this._removeEventHandlers();
	        this.el.removeAttribute('style');
	        this.$overlay.remove();
	        this.el.M_Modal = undefined;
	      }
	
	      /**
	       * Setup Event Handlers
	       */
	
	    }, {
	      key: "_setupEventHandlers",
	      value: function _setupEventHandlers() {
	        this._handleOverlayClickBound = this._handleOverlayClick.bind(this);
	        this._handleModalCloseClickBound = this._handleModalCloseClick.bind(this);
	
	        if (Modal._count === 1) {
	          document.body.addEventListener('click', this._handleTriggerClick);
	        }
	        this.$overlay[0].addEventListener('click', this._handleOverlayClickBound);
	        this.el.addEventListener('click', this._handleModalCloseClickBound);
	      }
	
	      /**
	       * Remove Event Handlers
	       */
	
	    }, {
	      key: "_removeEventHandlers",
	      value: function _removeEventHandlers() {
	        if (Modal._count === 0) {
	          document.body.removeEventListener('click', this._handleTriggerClick);
	        }
	        this.$overlay[0].removeEventListener('click', this._handleOverlayClickBound);
	        this.el.removeEventListener('click', this._handleModalCloseClickBound);
	      }
	
	      /**
	       * Handle Trigger Click
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleTriggerClick",
	      value: function _handleTriggerClick(e) {
	        var $trigger = $(e.target).closest('.modal-trigger');
	        if ($trigger.length) {
	          var modalId = M.getIdFromTrigger($trigger[0]);
	          var modalInstance = document.getElementById(modalId).M_Modal;
	          if (modalInstance) {
	            modalInstance.open($trigger);
	          }
	          e.preventDefault();
	        }
	      }
	
	      /**
	       * Handle Overlay Click
	       */
	
	    }, {
	      key: "_handleOverlayClick",
	      value: function _handleOverlayClick() {
	        if (this.options.dismissible) {
	          this.close();
	        }
	      }
	
	      /**
	       * Handle Modal Close Click
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleModalCloseClick",
	      value: function _handleModalCloseClick(e) {
	        var $closeTrigger = $(e.target).closest('.modal-close');
	        if ($closeTrigger.length) {
	          this.close();
	        }
	      }
	
	      /**
	       * Handle Keydown
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleKeydown",
	      value: function _handleKeydown(e) {
	        // ESC key
	        if (e.keyCode === 27 && this.options.dismissible) {
	          this.close();
	        }
	      }
	
	      /**
	       * Handle Focus
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleFocus",
	      value: function _handleFocus(e) {
	        // Only trap focus if this modal is the last model opened (prevents loops in nested modals).
	        if (!this.el.contains(e.target) && this._nthModalOpened === Modal._modalsOpen) {
	          this.el.focus();
	        }
	      }
	
	      /**
	       * Animate in modal
	       */
	
	    }, {
	      key: "_animateIn",
	      value: function _animateIn() {
	        var _this14 = this;
	
	        // Set initial styles
	        $.extend(this.el.style, {
	          display: 'block',
	          opacity: 0
	        });
	        $.extend(this.$overlay[0].style, {
	          display: 'block',
	          opacity: 0
	        });
	
	        // Animate overlay
	        anim({
	          targets: this.$overlay[0],
	          opacity: this.options.opacity,
	          duration: this.options.inDuration,
	          easing: 'easeOutQuad'
	        });
	
	        // Define modal animation options
	        var enterAnimOptions = {
	          targets: this.el,
	          duration: this.options.inDuration,
	          easing: 'easeOutCubic',
	          // Handle modal onOpenEnd callback
	          complete: function complete() {
	            if (typeof _this14.options.onOpenEnd === 'function') {
	              _this14.options.onOpenEnd.call(_this14, _this14.el, _this14._openingTrigger);
	            }
	          }
	        };
	
	        // Bottom sheet animation
	        if (this.el.classList.contains('bottom-sheet')) {
	          $.extend(enterAnimOptions, {
	            bottom: 0,
	            opacity: 1
	          });
	          anim(enterAnimOptions);
	
	          // Normal modal animation
	        } else {
	          $.extend(enterAnimOptions, {
	            top: [this.options.startingTop, this.options.endingTop],
	            opacity: 1,
	            scaleX: [0.8, 1],
	            scaleY: [0.8, 1]
	          });
	          anim(enterAnimOptions);
	        }
	      }
	
	      /**
	       * Animate out modal
	       */
	
	    }, {
	      key: "_animateOut",
	      value: function _animateOut() {
	        var _this15 = this;
	
	        // Animate overlay
	        anim({
	          targets: this.$overlay[0],
	          opacity: 0,
	          duration: this.options.outDuration,
	          easing: 'easeOutQuart'
	        });
	
	        // Define modal animation options
	        var exitAnimOptions = {
	          targets: this.el,
	          duration: this.options.outDuration,
	          easing: 'easeOutCubic',
	          // Handle modal ready callback
	          complete: function complete() {
	            _this15.el.style.display = 'none';
	            _this15.$overlay.remove();
	
	            // Call onCloseEnd callback
	            if (typeof _this15.options.onCloseEnd === 'function') {
	              _this15.options.onCloseEnd.call(_this15, _this15.el);
	            }
	          }
	        };
	
	        // Bottom sheet animation
	        if (this.el.classList.contains('bottom-sheet')) {
	          $.extend(exitAnimOptions, {
	            bottom: '-100%',
	            opacity: 0
	          });
	          anim(exitAnimOptions);
	
	          // Normal modal animation
	        } else {
	          $.extend(exitAnimOptions, {
	            top: [this.options.endingTop, this.options.startingTop],
	            opacity: 0,
	            scaleX: 0.8,
	            scaleY: 0.8
	          });
	          anim(exitAnimOptions);
	        }
	      }
	
	      /**
	       * Open Modal
	       * @param {cash} [$trigger]
	       */
	
	    }, {
	      key: "open",
	      value: function open($trigger) {
	        if (this.isOpen) {
	          return;
	        }
	
	        this.isOpen = true;
	        Modal._modalsOpen++;
	        this._nthModalOpened = Modal._modalsOpen;
	
	        // Set Z-Index based on number of currently open modals
	        this.$overlay[0].style.zIndex = 1000 + Modal._modalsOpen * 2;
	        this.el.style.zIndex = 1000 + Modal._modalsOpen * 2 + 1;
	
	        // Set opening trigger, undefined indicates modal was opened by javascript
	        this._openingTrigger = !!$trigger ? $trigger[0] : undefined;
	
	        // onOpenStart callback
	        if (typeof this.options.onOpenStart === 'function') {
	          this.options.onOpenStart.call(this, this.el, this._openingTrigger);
	        }
	
	        if (this.options.preventScrolling) {
	          document.body.style.overflow = 'hidden';
	        }
	
	        this.el.classList.add('open');
	        this.el.insertAdjacentElement('afterend', this.$overlay[0]);
	
	        if (this.options.dismissible) {
	          this._handleKeydownBound = this._handleKeydown.bind(this);
	          this._handleFocusBound = this._handleFocus.bind(this);
	          document.addEventListener('keydown', this._handleKeydownBound);
	          document.addEventListener('focus', this._handleFocusBound, true);
	        }
	
	        anim.remove(this.el);
	        anim.remove(this.$overlay[0]);
	        this._animateIn();
	
	        // Focus modal
	        this.el.focus();
	
	        return this;
	      }
	
	      /**
	       * Close Modal
	       */
	
	    }, {
	      key: "close",
	      value: function close() {
	        if (!this.isOpen) {
	          return;
	        }
	
	        this.isOpen = false;
	        Modal._modalsOpen--;
	        this._nthModalOpened = 0;
	
	        // Call onCloseStart callback
	        if (typeof this.options.onCloseStart === 'function') {
	          this.options.onCloseStart.call(this, this.el);
	        }
	
	        this.el.classList.remove('open');
	
	        // Enable body scrolling only if there are no more modals open.
	        if (Modal._modalsOpen === 0) {
	          document.body.style.overflow = '';
	        }
	
	        if (this.options.dismissible) {
	          document.removeEventListener('keydown', this._handleKeydownBound);
	          document.removeEventListener('focus', this._handleFocusBound, true);
	        }
	
	        anim.remove(this.el);
	        anim.remove(this.$overlay[0]);
	        this._animateOut();
	        return this;
	      }
	    }], [{
	      key: "init",
	      value: function init(els, options) {
	        return _get(Modal.__proto__ || Object.getPrototypeOf(Modal), "init", this).call(this, this, els, options);
	      }
	
	      /**
	       * Get Instance
	       */
	
	    }, {
	      key: "getInstance",
	      value: function getInstance(el) {
	        var domElem = !!el.jquery ? el[0] : el;
	        return domElem.M_Modal;
	      }
	    }, {
	      key: "defaults",
	      get: function get() {
	        return _defaults;
	      }
	    }]);
	
	    return Modal;
	  }(Component);
	
	  /**
	   * @static
	   * @memberof Modal
	   */
	
	  Modal._modalsOpen = 0;
	
	  /**
	   * @static
	   * @memberof Modal
	   */
	  Modal._count = 0;
	
	  M.Modal = Modal;
	
	  if (M.jQueryLoaded) {
	    M.initializeJqueryWrapper(Modal, 'modal', 'M_Modal');
	  }
	})(cash, M.anime);
	;(function ($, anim) {
	  'use strict';
	
	  var _defaults = {
	    inDuration: 275,
	    outDuration: 200,
	    onOpenStart: null,
	    onOpenEnd: null,
	    onCloseStart: null,
	    onCloseEnd: null
	  };
	
	  /**
	   * @class
	   *
	   */
	
	  var Materialbox = function (_Component4) {
	    _inherits(Materialbox, _Component4);
	
	    /**
	     * Construct Materialbox instance
	     * @constructor
	     * @param {Element} el
	     * @param {Object} options
	     */
	    function Materialbox(el, options) {
	      _classCallCheck(this, Materialbox);
	
	      var _this16 = _possibleConstructorReturn(this, (Materialbox.__proto__ || Object.getPrototypeOf(Materialbox)).call(this, Materialbox, el, options));
	
	      _this16.el.M_Materialbox = _this16;
	
	      /**
	       * Options for the modal
	       * @member Materialbox#options
	       * @prop {Number} [inDuration=275] - Length in ms of enter transition
	       * @prop {Number} [outDuration=200] - Length in ms of exit transition
	       * @prop {Function} onOpenStart - Callback function called before materialbox is opened
	       * @prop {Function} onOpenEnd - Callback function called after materialbox is opened
	       * @prop {Function} onCloseStart - Callback function called before materialbox is closed
	       * @prop {Function} onCloseEnd - Callback function called after materialbox is closed
	       */
	      _this16.options = $.extend({}, Materialbox.defaults, options);
	
	      _this16.overlayActive = false;
	      _this16.doneAnimating = true;
	      _this16.placeholder = $('<div></div>').addClass('material-placeholder');
	      _this16.originalWidth = 0;
	      _this16.originalHeight = 0;
	      _this16.originInlineStyles = _this16.$el.attr('style');
	      _this16.caption = _this16.el.getAttribute('data-caption') || '';
	
	      // Wrap
	      _this16.$el.before(_this16.placeholder);
	      _this16.placeholder.append(_this16.$el);
	
	      _this16._setupEventHandlers();
	      return _this16;
	    }
	
	    _createClass(Materialbox, [{
	      key: "destroy",
	
	      /**
	       * Teardown component
	       */
	      value: function destroy() {
	        this._removeEventHandlers();
	        this.el.M_Materialbox = undefined;
	
	        // Unwrap image
	        $(this.placeholder).after(this.el).remove();
	
	        this.$el.removeAttr('style');
	      }
	
	      /**
	       * Setup Event Handlers
	       */
	
	    }, {
	      key: "_setupEventHandlers",
	      value: function _setupEventHandlers() {
	        this._handleMaterialboxClickBound = this._handleMaterialboxClick.bind(this);
	        this.el.addEventListener('click', this._handleMaterialboxClickBound);
	      }
	
	      /**
	       * Remove Event Handlers
	       */
	
	    }, {
	      key: "_removeEventHandlers",
	      value: function _removeEventHandlers() {
	        this.el.removeEventListener('click', this._handleMaterialboxClickBound);
	      }
	
	      /**
	       * Handle Materialbox Click
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleMaterialboxClick",
	      value: function _handleMaterialboxClick(e) {
	        // If already modal, return to original
	        if (this.doneAnimating === false || this.overlayActive && this.doneAnimating) {
	          this.close();
	        } else {
	          this.open();
	        }
	      }
	
	      /**
	       * Handle Window Scroll
	       */
	
	    }, {
	      key: "_handleWindowScroll",
	      value: function _handleWindowScroll() {
	        if (this.overlayActive) {
	          this.close();
	        }
	      }
	
	      /**
	       * Handle Window Resize
	       */
	
	    }, {
	      key: "_handleWindowResize",
	      value: function _handleWindowResize() {
	        if (this.overlayActive) {
	          this.close();
	        }
	      }
	
	      /**
	       * Handle Window Resize
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleWindowEscape",
	      value: function _handleWindowEscape(e) {
	        // ESC key
	        if (e.keyCode === 27 && this.doneAnimating && this.overlayActive) {
	          this.close();
	        }
	      }
	
	      /**
	       * Find ancestors with overflow: hidden; and make visible
	       */
	
	    }, {
	      key: "_makeAncestorsOverflowVisible",
	      value: function _makeAncestorsOverflowVisible() {
	        this.ancestorsChanged = $();
	        var ancestor = this.placeholder[0].parentNode;
	        while (ancestor !== null && !$(ancestor).is(document)) {
	          var curr = $(ancestor);
	          if (curr.css('overflow') !== 'visible') {
	            curr.css('overflow', 'visible');
	            if (this.ancestorsChanged === undefined) {
	              this.ancestorsChanged = curr;
	            } else {
	              this.ancestorsChanged = this.ancestorsChanged.add(curr);
	            }
	          }
	          ancestor = ancestor.parentNode;
	        }
	      }
	
	      /**
	       * Animate image in
	       */
	
	    }, {
	      key: "_animateImageIn",
	      value: function _animateImageIn() {
	        var _this17 = this;
	
	        var animOptions = {
	          targets: this.el,
	          height: [this.originalHeight, this.newHeight],
	          width: [this.originalWidth, this.newWidth],
	          left: M.getDocumentScrollLeft() + this.windowWidth / 2 - this.placeholder.offset().left - this.newWidth / 2,
	          top: M.getDocumentScrollTop() + this.windowHeight / 2 - this.placeholder.offset().top - this.newHeight / 2,
	          duration: this.options.inDuration,
	          easing: 'easeOutQuad',
	          complete: function complete() {
	            _this17.doneAnimating = true;
	
	            // onOpenEnd callback
	            if (typeof _this17.options.onOpenEnd === 'function') {
	              _this17.options.onOpenEnd.call(_this17, _this17.el);
	            }
	          }
	        };
	
	        // Override max-width or max-height if needed
	        this.maxWidth = this.$el.css('max-width');
	        this.maxHeight = this.$el.css('max-height');
	        if (this.maxWidth !== 'none') {
	          animOptions.maxWidth = this.newWidth;
	        }
	        if (this.maxHeight !== 'none') {
	          animOptions.maxHeight = this.newHeight;
	        }
	
	        anim(animOptions);
	      }
	
	      /**
	       * Animate image out
	       */
	
	    }, {
	      key: "_animateImageOut",
	      value: function _animateImageOut() {
	        var _this18 = this;
	
	        var animOptions = {
	          targets: this.el,
	          width: this.originalWidth,
	          height: this.originalHeight,
	          left: 0,
	          top: 0,
	          duration: this.options.outDuration,
	          easing: 'easeOutQuad',
	          complete: function complete() {
	            _this18.placeholder.css({
	              height: '',
	              width: '',
	              position: '',
	              top: '',
	              left: ''
	            });
	
	            // Revert to width or height attribute
	            if (_this18.attrWidth) {
	              _this18.$el.attr('width', _this18.attrWidth);
	            }
	            if (_this18.attrHeight) {
	              _this18.$el.attr('height', _this18.attrHeight);
	            }
	
	            _this18.$el.removeAttr('style');
	            _this18.originInlineStyles && _this18.$el.attr('style', _this18.originInlineStyles);
	
	            // Remove class
	            _this18.$el.removeClass('active');
	            _this18.doneAnimating = true;
	
	            // Remove overflow overrides on ancestors
	            if (_this18.ancestorsChanged.length) {
	              _this18.ancestorsChanged.css('overflow', '');
	            }
	
	            // onCloseEnd callback
	            if (typeof _this18.options.onCloseEnd === 'function') {
	              _this18.options.onCloseEnd.call(_this18, _this18.el);
	            }
	          }
	        };
	
	        anim(animOptions);
	      }
	
	      /**
	       * Update open and close vars
	       */
	
	    }, {
	      key: "_updateVars",
	      value: function _updateVars() {
	        this.windowWidth = window.innerWidth;
	        this.windowHeight = window.innerHeight;
	        this.caption = this.el.getAttribute('data-caption') || '';
	      }
	
	      /**
	       * Open Materialbox
	       */
	
	    }, {
	      key: "open",
	      value: function open() {
	        var _this19 = this;
	
	        this._updateVars();
	        this.originalWidth = this.el.getBoundingClientRect().width;
	        this.originalHeight = this.el.getBoundingClientRect().height;
	
	        // Set states
	        this.doneAnimating = false;
	        this.$el.addClass('active');
	        this.overlayActive = true;
	
	        // onOpenStart callback
	        if (typeof this.options.onOpenStart === 'function') {
	          this.options.onOpenStart.call(this, this.el);
	        }
	
	        // Set positioning for placeholder
	        this.placeholder.css({
	          width: this.placeholder[0].getBoundingClientRect().width + 'px',
	          height: this.placeholder[0].getBoundingClientRect().height + 'px',
	          position: 'relative',
	          top: 0,
	          left: 0
	        });
	
	        this._makeAncestorsOverflowVisible();
	
	        // Set css on origin
	        this.$el.css({
	          position: 'absolute',
	          'z-index': 1000,
	          'will-change': 'left, top, width, height'
	        });
	
	        // Change from width or height attribute to css
	        this.attrWidth = this.$el.attr('width');
	        this.attrHeight = this.$el.attr('height');
	        if (this.attrWidth) {
	          this.$el.css('width', this.attrWidth + 'px');
	          this.$el.removeAttr('width');
	        }
	        if (this.attrHeight) {
	          this.$el.css('width', this.attrHeight + 'px');
	          this.$el.removeAttr('height');
	        }
	
	        // Add overlay
	        this.$overlay = $('<div id="materialbox-overlay"></div>').css({
	          opacity: 0
	        }).one('click', function () {
	          if (_this19.doneAnimating) {
	            _this19.close();
	          }
	        });
	
	        // Put before in origin image to preserve z-index layering.
	        this.$el.before(this.$overlay);
	
	        // Set dimensions if needed
	        var overlayOffset = this.$overlay[0].getBoundingClientRect();
	        this.$overlay.css({
	          width: this.windowWidth + 'px',
	          height: this.windowHeight + 'px',
	          left: -1 * overlayOffset.left + 'px',
	          top: -1 * overlayOffset.top + 'px'
	        });
	
	        anim.remove(this.el);
	        anim.remove(this.$overlay[0]);
	
	        // Animate Overlay
	        anim({
	          targets: this.$overlay[0],
	          opacity: 1,
	          duration: this.options.inDuration,
	          easing: 'easeOutQuad'
	        });
	
	        // Add and animate caption if it exists
	        if (this.caption !== '') {
	          if (this.$photocaption) {
	            anim.remove(this.$photoCaption[0]);
	          }
	          this.$photoCaption = $('<div class="materialbox-caption"></div>');
	          this.$photoCaption.text(this.caption);
	          $('body').append(this.$photoCaption);
	          this.$photoCaption.css({ display: 'inline' });
	
	          anim({
	            targets: this.$photoCaption[0],
	            opacity: 1,
	            duration: this.options.inDuration,
	            easing: 'easeOutQuad'
	          });
	        }
	
	        // Resize Image
	        var ratio = 0;
	        var widthPercent = this.originalWidth / this.windowWidth;
	        var heightPercent = this.originalHeight / this.windowHeight;
	        this.newWidth = 0;
	        this.newHeight = 0;
	
	        if (widthPercent > heightPercent) {
	          ratio = this.originalHeight / this.originalWidth;
	          this.newWidth = this.windowWidth * 0.9;
	          this.newHeight = this.windowWidth * 0.9 * ratio;
	        } else {
	          ratio = this.originalWidth / this.originalHeight;
	          this.newWidth = this.windowHeight * 0.9 * ratio;
	          this.newHeight = this.windowHeight * 0.9;
	        }
	
	        this._animateImageIn();
	
	        // Handle Exit triggers
	        this._handleWindowScrollBound = this._handleWindowScroll.bind(this);
	        this._handleWindowResizeBound = this._handleWindowResize.bind(this);
	        this._handleWindowEscapeBound = this._handleWindowEscape.bind(this);
	
	        window.addEventListener('scroll', this._handleWindowScrollBound);
	        window.addEventListener('resize', this._handleWindowResizeBound);
	        window.addEventListener('keyup', this._handleWindowEscapeBound);
	      }
	
	      /**
	       * Close Materialbox
	       */
	
	    }, {
	      key: "close",
	      value: function close() {
	        var _this20 = this;
	
	        this._updateVars();
	        this.doneAnimating = false;
	
	        // onCloseStart callback
	        if (typeof this.options.onCloseStart === 'function') {
	          this.options.onCloseStart.call(this, this.el);
	        }
	
	        anim.remove(this.el);
	        anim.remove(this.$overlay[0]);
	
	        if (this.caption !== '') {
	          anim.remove(this.$photoCaption[0]);
	        }
	
	        // disable exit handlers
	        window.removeEventListener('scroll', this._handleWindowScrollBound);
	        window.removeEventListener('resize', this._handleWindowResizeBound);
	        window.removeEventListener('keyup', this._handleWindowEscapeBound);
	
	        anim({
	          targets: this.$overlay[0],
	          opacity: 0,
	          duration: this.options.outDuration,
	          easing: 'easeOutQuad',
	          complete: function complete() {
	            _this20.overlayActive = false;
	            _this20.$overlay.remove();
	          }
	        });
	
	        this._animateImageOut();
	
	        // Remove Caption + reset css settings on image
	        if (this.caption !== '') {
	          anim({
	            targets: this.$photoCaption[0],
	            opacity: 0,
	            duration: this.options.outDuration,
	            easing: 'easeOutQuad',
	            complete: function complete() {
	              _this20.$photoCaption.remove();
	            }
	          });
	        }
	      }
	    }], [{
	      key: "init",
	      value: function init(els, options) {
	        return _get(Materialbox.__proto__ || Object.getPrototypeOf(Materialbox), "init", this).call(this, this, els, options);
	      }
	
	      /**
	       * Get Instance
	       */
	
	    }, {
	      key: "getInstance",
	      value: function getInstance(el) {
	        var domElem = !!el.jquery ? el[0] : el;
	        return domElem.M_Materialbox;
	      }
	    }, {
	      key: "defaults",
	      get: function get() {
	        return _defaults;
	      }
	    }]);
	
	    return Materialbox;
	  }(Component);
	
	  M.Materialbox = Materialbox;
	
	  if (M.jQueryLoaded) {
	    M.initializeJqueryWrapper(Materialbox, 'materialbox', 'M_Materialbox');
	  }
	})(cash, M.anime);
	;(function ($) {
	  'use strict';
	
	  var _defaults = {
	    responsiveThreshold: 0 // breakpoint for swipeable
	  };
	
	  var Parallax = function (_Component5) {
	    _inherits(Parallax, _Component5);
	
	    function Parallax(el, options) {
	      _classCallCheck(this, Parallax);
	
	      var _this21 = _possibleConstructorReturn(this, (Parallax.__proto__ || Object.getPrototypeOf(Parallax)).call(this, Parallax, el, options));
	
	      _this21.el.M_Parallax = _this21;
	
	      /**
	       * Options for the Parallax
	       * @member Parallax#options
	       * @prop {Number} responsiveThreshold
	       */
	      _this21.options = $.extend({}, Parallax.defaults, options);
	      _this21._enabled = window.innerWidth > _this21.options.responsiveThreshold;
	
	      _this21.$img = _this21.$el.find('img').first();
	      _this21.$img.each(function () {
	        var el = this;
	        if (el.complete) $(el).trigger('load');
	      });
	
	      _this21._updateParallax();
	      _this21._setupEventHandlers();
	      _this21._setupStyles();
	
	      Parallax._parallaxes.push(_this21);
	      return _this21;
	    }
	
	    _createClass(Parallax, [{
	      key: "destroy",
	
	      /**
	       * Teardown component
	       */
	      value: function destroy() {
	        Parallax._parallaxes.splice(Parallax._parallaxes.indexOf(this), 1);
	        this.$img[0].style.transform = '';
	        this._removeEventHandlers();
	
	        this.$el[0].M_Parallax = undefined;
	      }
	    }, {
	      key: "_setupEventHandlers",
	      value: function _setupEventHandlers() {
	        this._handleImageLoadBound = this._handleImageLoad.bind(this);
	        this.$img[0].addEventListener('load', this._handleImageLoadBound);
	
	        if (Parallax._parallaxes.length === 0) {
	          Parallax._handleScrollThrottled = M.throttle(Parallax._handleScroll, 5);
	          window.addEventListener('scroll', Parallax._handleScrollThrottled);
	
	          Parallax._handleWindowResizeThrottled = M.throttle(Parallax._handleWindowResize, 5);
	          window.addEventListener('resize', Parallax._handleWindowResizeThrottled);
	        }
	      }
	    }, {
	      key: "_removeEventHandlers",
	      value: function _removeEventHandlers() {
	        this.$img[0].removeEventListener('load', this._handleImageLoadBound);
	
	        if (Parallax._parallaxes.length === 0) {
	          window.removeEventListener('scroll', Parallax._handleScrollThrottled);
	          window.removeEventListener('resize', Parallax._handleWindowResizeThrottled);
	        }
	      }
	    }, {
	      key: "_setupStyles",
	      value: function _setupStyles() {
	        this.$img[0].style.opacity = 1;
	      }
	    }, {
	      key: "_handleImageLoad",
	      value: function _handleImageLoad() {
	        this._updateParallax();
	      }
	    }, {
	      key: "_updateParallax",
	      value: function _updateParallax() {
	        var containerHeight = this.$el.height() > 0 ? this.el.parentNode.offsetHeight : 500;
	        var imgHeight = this.$img[0].offsetHeight;
	        var parallaxDist = imgHeight - containerHeight;
	        var bottom = this.$el.offset().top + containerHeight;
	        var top = this.$el.offset().top;
	        var scrollTop = M.getDocumentScrollTop();
	        var windowHeight = window.innerHeight;
	        var windowBottom = scrollTop + windowHeight;
	        var percentScrolled = (windowBottom - top) / (containerHeight + windowHeight);
	        var parallax = parallaxDist * percentScrolled;
	
	        if (!this._enabled) {
	          this.$img[0].style.transform = '';
	        } else if (bottom > scrollTop && top < scrollTop + windowHeight) {
	          this.$img[0].style.transform = "translate3D(-50%, " + parallax + "px, 0)";
	        }
	      }
	    }], [{
	      key: "init",
	      value: function init(els, options) {
	        return _get(Parallax.__proto__ || Object.getPrototypeOf(Parallax), "init", this).call(this, this, els, options);
	      }
	
	      /**
	       * Get Instance
	       */
	
	    }, {
	      key: "getInstance",
	      value: function getInstance(el) {
	        var domElem = !!el.jquery ? el[0] : el;
	        return domElem.M_Parallax;
	      }
	    }, {
	      key: "_handleScroll",
	      value: function _handleScroll() {
	        for (var i = 0; i < Parallax._parallaxes.length; i++) {
	          var parallaxInstance = Parallax._parallaxes[i];
	          parallaxInstance._updateParallax.call(parallaxInstance);
	        }
	      }
	    }, {
	      key: "_handleWindowResize",
	      value: function _handleWindowResize() {
	        for (var i = 0; i < Parallax._parallaxes.length; i++) {
	          var parallaxInstance = Parallax._parallaxes[i];
	          parallaxInstance._enabled = window.innerWidth > parallaxInstance.options.responsiveThreshold;
	        }
	      }
	    }, {
	      key: "defaults",
	      get: function get() {
	        return _defaults;
	      }
	    }]);
	
	    return Parallax;
	  }(Component);
	
	  /**
	   * @static
	   * @memberof Parallax
	   */
	
	  Parallax._parallaxes = [];
	
	  M.Parallax = Parallax;
	
	  if (M.jQueryLoaded) {
	    M.initializeJqueryWrapper(Parallax, 'parallax', 'M_Parallax');
	  }
	})(cash);
	;(function ($, anim) {
	  'use strict';
	
	  var _defaults = {
	    duration: 300,
	    onShow: null,
	    swipeable: false,
	    responsiveThreshold: Infinity // breakpoint for swipeable
	  };
	
	  /**
	   * @class
	   *
	   */
	
	  var Tabs = function (_Component6) {
	    _inherits(Tabs, _Component6);
	
	    /**
	     * Construct Tabs instance
	     * @constructor
	     * @param {Element} el
	     * @param {Object} options
	     */
	    function Tabs(el, options) {
	      _classCallCheck(this, Tabs);
	
	      var _this22 = _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, Tabs, el, options));
	
	      _this22.el.M_Tabs = _this22;
	
	      /**
	       * Options for the Tabs
	       * @member Tabs#options
	       * @prop {Number} duration
	       * @prop {Function} onShow
	       * @prop {Boolean} swipeable
	       * @prop {Number} responsiveThreshold
	       */
	      _this22.options = $.extend({}, Tabs.defaults, options);
	
	      // Setup
	      _this22.$tabLinks = _this22.$el.children('li.tab').children('a');
	      _this22.index = 0;
	      _this22._setupActiveTabLink();
	
	      // Setup tabs content
	      if (_this22.options.swipeable) {
	        _this22._setupSwipeableTabs();
	      } else {
	        _this22._setupNormalTabs();
	      }
	
	      // Setup tabs indicator after content to ensure accurate widths
	      _this22._setTabsAndTabWidth();
	      _this22._createIndicator();
	
	      _this22._setupEventHandlers();
	      return _this22;
	    }
	
	    _createClass(Tabs, [{
	      key: "destroy",
	
	      /**
	       * Teardown component
	       */
	      value: function destroy() {
	        this._removeEventHandlers();
	        this._indicator.parentNode.removeChild(this._indicator);
	
	        if (this.options.swipeable) {
	          this._teardownSwipeableTabs();
	        } else {
	          this._teardownNormalTabs();
	        }
	
	        this.$el[0].M_Tabs = undefined;
	      }
	
	      /**
	       * Setup Event Handlers
	       */
	
	    }, {
	      key: "_setupEventHandlers",
	      value: function _setupEventHandlers() {
	        this._handleWindowResizeBound = this._handleWindowResize.bind(this);
	        window.addEventListener('resize', this._handleWindowResizeBound);
	
	        this._handleTabClickBound = this._handleTabClick.bind(this);
	        this.el.addEventListener('click', this._handleTabClickBound);
	      }
	
	      /**
	       * Remove Event Handlers
	       */
	
	    }, {
	      key: "_removeEventHandlers",
	      value: function _removeEventHandlers() {
	        window.removeEventListener('resize', this._handleWindowResizeBound);
	        this.el.removeEventListener('click', this._handleTabClickBound);
	      }
	
	      /**
	       * Handle window Resize
	       */
	
	    }, {
	      key: "_handleWindowResize",
	      value: function _handleWindowResize() {
	        this._setTabsAndTabWidth();
	
	        if (this.tabWidth !== 0 && this.tabsWidth !== 0) {
	          this._indicator.style.left = this._calcLeftPos(this.$activeTabLink) + 'px';
	          this._indicator.style.right = this._calcRightPos(this.$activeTabLink) + 'px';
	        }
	      }
	
	      /**
	       * Handle tab click
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleTabClick",
	      value: function _handleTabClick(e) {
	        var _this23 = this;
	
	        var tab = $(e.target).closest('li.tab');
	        var tabLink = $(e.target).closest('a');
	
	        // Handle click on tab link only
	        if (!tabLink.length || !tabLink.parent().hasClass('tab')) {
	          return;
	        }
	
	        if (tab.hasClass('disabled')) {
	          e.preventDefault();
	          return;
	        }
	
	        // Act as regular link if target attribute is specified.
	        if (!!tabLink.attr('target')) {
	          return;
	        }
	
	        // Make the old tab inactive.
	        this.$activeTabLink.removeClass('active');
	        var $oldContent = this.$content;
	
	        // Update the variables with the new link and content
	        this.$activeTabLink = tabLink;
	        this.$content = $(M.escapeHash(tabLink[0].hash));
	        this.$tabLinks = this.$el.children('li.tab').children('a');
	
	        // Make the tab active.
	        this.$activeTabLink.addClass('active');
	        var prevIndex = this.index;
	        this.index = Math.max(this.$tabLinks.index(tabLink), 0);
	
	        // Swap content
	        if (this.options.swipeable) {
	          if (this._tabsCarousel) {
	            this._tabsCarousel.set(this.index, function () {
	              if (typeof _this23.options.onShow === 'function') {
	                _this23.options.onShow.call(_this23, _this23.$content[0]);
	              }
	            });
	          }
	        } else {
	          if (this.$content.length) {
	            this.$content[0].style.display = 'block';
	            this.$content.addClass('active');
	            if (typeof this.options.onShow === 'function') {
	              this.options.onShow.call(this, this.$content[0]);
	            }
	
	            if ($oldContent.length && !$oldContent.is(this.$content)) {
	              $oldContent[0].style.display = 'none';
	              $oldContent.removeClass('active');
	            }
	          }
	        }
	
	        // Update widths after content is swapped (scrollbar bugfix)
	        this._setTabsAndTabWidth();
	
	        // Update indicator
	        this._animateIndicator(prevIndex);
	
	        // Prevent the anchor's default click action
	        e.preventDefault();
	      }
	
	      /**
	       * Generate elements for tab indicator.
	       */
	
	    }, {
	      key: "_createIndicator",
	      value: function _createIndicator() {
	        var _this24 = this;
	
	        var indicator = document.createElement('li');
	        indicator.classList.add('indicator');
	
	        this.el.appendChild(indicator);
	        this._indicator = indicator;
	
	        setTimeout(function () {
	          _this24._indicator.style.left = _this24._calcLeftPos(_this24.$activeTabLink) + 'px';
	          _this24._indicator.style.right = _this24._calcRightPos(_this24.$activeTabLink) + 'px';
	        }, 0);
	      }
	
	      /**
	       * Setup first active tab link.
	       */
	
	    }, {
	      key: "_setupActiveTabLink",
	      value: function _setupActiveTabLink() {
	        // If the location.hash matches one of the links, use that as the active tab.
	        this.$activeTabLink = $(this.$tabLinks.filter('[href="' + location.hash + '"]'));
	
	        // If no match is found, use the first link or any with class 'active' as the initial active tab.
	        if (this.$activeTabLink.length === 0) {
	          this.$activeTabLink = this.$el.children('li.tab').children('a.active').first();
	        }
	        if (this.$activeTabLink.length === 0) {
	          this.$activeTabLink = this.$el.children('li.tab').children('a').first();
	        }
	
	        this.$tabLinks.removeClass('active');
	        this.$activeTabLink[0].classList.add('active');
	
	        this.index = Math.max(this.$tabLinks.index(this.$activeTabLink), 0);
	
	        if (this.$activeTabLink.length) {
	          this.$content = $(M.escapeHash(this.$activeTabLink[0].hash));
	          this.$content.addClass('active');
	        }
	      }
	
	      /**
	       * Setup swipeable tabs
	       */
	
	    }, {
	      key: "_setupSwipeableTabs",
	      value: function _setupSwipeableTabs() {
	        var _this25 = this;
	
	        // Change swipeable according to responsive threshold
	        if (window.innerWidth > this.options.responsiveThreshold) {
	          this.options.swipeable = false;
	        }
	
	        var $tabsContent = $();
	        this.$tabLinks.each(function (link) {
	          var $currContent = $(M.escapeHash(link.hash));
	          $currContent.addClass('carousel-item');
	          $tabsContent = $tabsContent.add($currContent);
	        });
	
	        var $tabsWrapper = $('<div class="tabs-content carousel carousel-slider"></div>');
	        $tabsContent.first().before($tabsWrapper);
	        $tabsWrapper.append($tabsContent);
	        $tabsContent[0].style.display = '';
	
	        // Keep active tab index to set initial carousel slide
	        var activeTabIndex = this.$activeTabLink.closest('.tab').index();
	
	        this._tabsCarousel = M.Carousel.init($tabsWrapper[0], {
	          fullWidth: true,
	          noWrap: true,
	          onCycleTo: function onCycleTo(item) {
	            var prevIndex = _this25.index;
	            _this25.index = $(item).index();
	            _this25.$activeTabLink.removeClass('active');
	            _this25.$activeTabLink = _this25.$tabLinks.eq(_this25.index);
	            _this25.$activeTabLink.addClass('active');
	            _this25._animateIndicator(prevIndex);
	            if (typeof _this25.options.onShow === 'function') {
	              _this25.options.onShow.call(_this25, _this25.$content[0]);
	            }
	          }
	        });
	
	        // Set initial carousel slide to active tab
	        this._tabsCarousel.set(activeTabIndex);
	      }
	
	      /**
	       * Teardown normal tabs.
	       */
	
	    }, {
	      key: "_teardownSwipeableTabs",
	      value: function _teardownSwipeableTabs() {
	        var $tabsWrapper = this._tabsCarousel.$el;
	        this._tabsCarousel.destroy();
	
	        // Unwrap
	        $tabsWrapper.after($tabsWrapper.children());
	        $tabsWrapper.remove();
	      }
	
	      /**
	       * Setup normal tabs.
	       */
	
	    }, {
	      key: "_setupNormalTabs",
	      value: function _setupNormalTabs() {
	        // Hide Tabs Content
	        this.$tabLinks.not(this.$activeTabLink).each(function (link) {
	          if (!!link.hash) {
	            var $currContent = $(M.escapeHash(link.hash));
	            if ($currContent.length) {
	              $currContent[0].style.display = 'none';
	            }
	          }
	        });
	      }
	
	      /**
	       * Teardown normal tabs.
	       */
	
	    }, {
	      key: "_teardownNormalTabs",
	      value: function _teardownNormalTabs() {
	        // show Tabs Content
	        this.$tabLinks.each(function (link) {
	          if (!!link.hash) {
	            var $currContent = $(M.escapeHash(link.hash));
	            if ($currContent.length) {
	              $currContent[0].style.display = '';
	            }
	          }
	        });
	      }
	
	      /**
	       * set tabs and tab width
	       */
	
	    }, {
	      key: "_setTabsAndTabWidth",
	      value: function _setTabsAndTabWidth() {
	        this.tabsWidth = this.$el.width();
	        this.tabWidth = Math.max(this.tabsWidth, this.el.scrollWidth) / this.$tabLinks.length;
	      }
	
	      /**
	       * Finds right attribute for indicator based on active tab.
	       * @param {cash} el
	       */
	
	    }, {
	      key: "_calcRightPos",
	      value: function _calcRightPos(el) {
	        return Math.ceil(this.tabsWidth - el.position().left - el[0].getBoundingClientRect().width);
	      }
	
	      /**
	       * Finds left attribute for indicator based on active tab.
	       * @param {cash} el
	       */
	
	    }, {
	      key: "_calcLeftPos",
	      value: function _calcLeftPos(el) {
	        return Math.floor(el.position().left);
	      }
	    }, {
	      key: "updateTabIndicator",
	      value: function updateTabIndicator() {
	        this._setTabsAndTabWidth();
	        this._animateIndicator(this.index);
	      }
	
	      /**
	       * Animates Indicator to active tab.
	       * @param {Number} prevIndex
	       */
	
	    }, {
	      key: "_animateIndicator",
	      value: function _animateIndicator(prevIndex) {
	        var leftDelay = 0,
	            rightDelay = 0;
	
	        if (this.index - prevIndex >= 0) {
	          leftDelay = 90;
	        } else {
	          rightDelay = 90;
	        }
	
	        // Animate
	        var animOptions = {
	          targets: this._indicator,
	          left: {
	            value: this._calcLeftPos(this.$activeTabLink),
	            delay: leftDelay
	          },
	          right: {
	            value: this._calcRightPos(this.$activeTabLink),
	            delay: rightDelay
	          },
	          duration: this.options.duration,
	          easing: 'easeOutQuad'
	        };
	        anim.remove(this._indicator);
	        anim(animOptions);
	      }
	
	      /**
	       * Select tab.
	       * @param {String} tabId
	       */
	
	    }, {
	      key: "select",
	      value: function select(tabId) {
	        var tab = this.$tabLinks.filter('[href="#' + tabId + '"]');
	        if (tab.length) {
	          tab.trigger('click');
	        }
	      }
	    }], [{
	      key: "init",
	      value: function init(els, options) {
	        return _get(Tabs.__proto__ || Object.getPrototypeOf(Tabs), "init", this).call(this, this, els, options);
	      }
	
	      /**
	       * Get Instance
	       */
	
	    }, {
	      key: "getInstance",
	      value: function getInstance(el) {
	        var domElem = !!el.jquery ? el[0] : el;
	        return domElem.M_Tabs;
	      }
	    }, {
	      key: "defaults",
	      get: function get() {
	        return _defaults;
	      }
	    }]);
	
	    return Tabs;
	  }(Component);
	
	  window.M.Tabs = Tabs;
	
	  if (M.jQueryLoaded) {
	    M.initializeJqueryWrapper(Tabs, 'tabs', 'M_Tabs');
	  }
	})(cash, M.anime);
	;(function ($, anim) {
	  'use strict';
	
	  var _defaults = {
	    exitDelay: 200,
	    enterDelay: 0,
	    html: null,
	    margin: 5,
	    inDuration: 250,
	    outDuration: 200,
	    position: 'bottom',
	    transitionMovement: 10
	  };
	
	  /**
	   * @class
	   *
	   */
	
	  var Tooltip = function (_Component7) {
	    _inherits(Tooltip, _Component7);
	
	    /**
	     * Construct Tooltip instance
	     * @constructor
	     * @param {Element} el
	     * @param {Object} options
	     */
	    function Tooltip(el, options) {
	      _classCallCheck(this, Tooltip);
	
	      var _this26 = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, Tooltip, el, options));
	
	      _this26.el.M_Tooltip = _this26;
	      _this26.options = $.extend({}, Tooltip.defaults, options);
	
	      _this26.isOpen = false;
	      _this26.isHovered = false;
	      _this26.isFocused = false;
	      _this26._appendTooltipEl();
	      _this26._setupEventHandlers();
	      return _this26;
	    }
	
	    _createClass(Tooltip, [{
	      key: "destroy",
	
	      /**
	       * Teardown component
	       */
	      value: function destroy() {
	        $(this.tooltipEl).remove();
	        this._removeEventHandlers();
	        this.el.M_Tooltip = undefined;
	      }
	    }, {
	      key: "_appendTooltipEl",
	      value: function _appendTooltipEl() {
	        var tooltipEl = document.createElement('div');
	        tooltipEl.classList.add('material-tooltip');
	        this.tooltipEl = tooltipEl;
	
	        var tooltipContentEl = document.createElement('div');
	        tooltipContentEl.classList.add('tooltip-content');
	        tooltipContentEl.innerHTML = this.options.html;
	        tooltipEl.appendChild(tooltipContentEl);
	        document.body.appendChild(tooltipEl);
	      }
	    }, {
	      key: "_updateTooltipContent",
	      value: function _updateTooltipContent() {
	        this.tooltipEl.querySelector('.tooltip-content').innerHTML = this.options.html;
	      }
	    }, {
	      key: "_setupEventHandlers",
	      value: function _setupEventHandlers() {
	        this._handleMouseEnterBound = this._handleMouseEnter.bind(this);
	        this._handleMouseLeaveBound = this._handleMouseLeave.bind(this);
	        this._handleFocusBound = this._handleFocus.bind(this);
	        this._handleBlurBound = this._handleBlur.bind(this);
	        this.el.addEventListener('mouseenter', this._handleMouseEnterBound);
	        this.el.addEventListener('mouseleave', this._handleMouseLeaveBound);
	        this.el.addEventListener('focus', this._handleFocusBound, true);
	        this.el.addEventListener('blur', this._handleBlurBound, true);
	      }
	    }, {
	      key: "_removeEventHandlers",
	      value: function _removeEventHandlers() {
	        this.el.removeEventListener('mouseenter', this._handleMouseEnterBound);
	        this.el.removeEventListener('mouseleave', this._handleMouseLeaveBound);
	        this.el.removeEventListener('focus', this._handleFocusBound, true);
	        this.el.removeEventListener('blur', this._handleBlurBound, true);
	      }
	    }, {
	      key: "open",
	      value: function open(isManual) {
	        if (this.isOpen) {
	          return;
	        }
	        isManual = isManual === undefined ? true : undefined; // Default value true
	        this.isOpen = true;
	        // Update tooltip content with HTML attribute options
	        this.options = $.extend({}, this.options, this._getAttributeOptions());
	        this._updateTooltipContent();
	        this._setEnterDelayTimeout(isManual);
	      }
	    }, {
	      key: "close",
	      value: function close() {
	        if (!this.isOpen) {
	          return;
	        }
	
	        this.isHovered = false;
	        this.isFocused = false;
	        this.isOpen = false;
	        this._setExitDelayTimeout();
	      }
	
	      /**
	       * Create timeout which delays when the tooltip closes
	       */
	
	    }, {
	      key: "_setExitDelayTimeout",
	      value: function _setExitDelayTimeout() {
	        var _this27 = this;
	
	        clearTimeout(this._exitDelayTimeout);
	
	        this._exitDelayTimeout = setTimeout(function () {
	          if (_this27.isHovered || _this27.isFocused) {
	            return;
	          }
	
	          _this27._animateOut();
	        }, this.options.exitDelay);
	      }
	
	      /**
	       * Create timeout which delays when the toast closes
	       */
	
	    }, {
	      key: "_setEnterDelayTimeout",
	      value: function _setEnterDelayTimeout(isManual) {
	        var _this28 = this;
	
	        clearTimeout(this._enterDelayTimeout);
	
	        this._enterDelayTimeout = setTimeout(function () {
	          if (!_this28.isHovered && !_this28.isFocused && !isManual) {
	            return;
	          }
	
	          _this28._animateIn();
	        }, this.options.enterDelay);
	      }
	    }, {
	      key: "_positionTooltip",
	      value: function _positionTooltip() {
	        var origin = this.el,
	            tooltip = this.tooltipEl,
	            originHeight = origin.offsetHeight,
	            originWidth = origin.offsetWidth,
	            tooltipHeight = tooltip.offsetHeight,
	            tooltipWidth = tooltip.offsetWidth,
	            newCoordinates = void 0,
	            margin = this.options.margin,
	            targetTop = void 0,
	            targetLeft = void 0;
	
	        this.xMovement = 0, this.yMovement = 0;
	
	        targetTop = origin.getBoundingClientRect().top + M.getDocumentScrollTop();
	        targetLeft = origin.getBoundingClientRect().left + M.getDocumentScrollLeft();
	
	        if (this.options.position === 'top') {
	          targetTop += -tooltipHeight - margin;
	          targetLeft += originWidth / 2 - tooltipWidth / 2;
	          this.yMovement = -this.options.transitionMovement;
	        } else if (this.options.position === 'right') {
	          targetTop += originHeight / 2 - tooltipHeight / 2;
	          targetLeft += originWidth + margin;
	          this.xMovement = this.options.transitionMovement;
	        } else if (this.options.position === 'left') {
	          targetTop += originHeight / 2 - tooltipHeight / 2;
	          targetLeft += -tooltipWidth - margin;
	          this.xMovement = -this.options.transitionMovement;
	        } else {
	          targetTop += originHeight + margin;
	          targetLeft += originWidth / 2 - tooltipWidth / 2;
	          this.yMovement = this.options.transitionMovement;
	        }
	
	        newCoordinates = this._repositionWithinScreen(targetLeft, targetTop, tooltipWidth, tooltipHeight);
	        $(tooltip).css({
	          top: newCoordinates.y + 'px',
	          left: newCoordinates.x + 'px'
	        });
	      }
	    }, {
	      key: "_repositionWithinScreen",
	      value: function _repositionWithinScreen(x, y, width, height) {
	        var scrollLeft = M.getDocumentScrollLeft();
	        var scrollTop = M.getDocumentScrollTop();
	        var newX = x - scrollLeft;
	        var newY = y - scrollTop;
	
	        var bounding = {
	          left: newX,
	          top: newY,
	          width: width,
	          height: height
	        };
	
	        var offset = this.options.margin + this.options.transitionMovement;
	        var edges = M.checkWithinContainer(document.body, bounding, offset);
	
	        if (edges.left) {
	          newX = offset;
	        } else if (edges.right) {
	          newX -= newX + width - window.innerWidth;
	        }
	
	        if (edges.top) {
	          newY = offset;
	        } else if (edges.bottom) {
	          newY -= newY + height - window.innerHeight;
	        }
	
	        return {
	          x: newX + scrollLeft,
	          y: newY + scrollTop
	        };
	      }
	    }, {
	      key: "_animateIn",
	      value: function _animateIn() {
	        this._positionTooltip();
	        this.tooltipEl.style.visibility = 'visible';
	        anim.remove(this.tooltipEl);
	        anim({
	          targets: this.tooltipEl,
	          opacity: 1,
	          translateX: this.xMovement,
	          translateY: this.yMovement,
	          duration: this.options.inDuration,
	          easing: 'easeOutCubic'
	        });
	      }
	    }, {
	      key: "_animateOut",
	      value: function _animateOut() {
	        anim.remove(this.tooltipEl);
	        anim({
	          targets: this.tooltipEl,
	          opacity: 0,
	          translateX: 0,
	          translateY: 0,
	          duration: this.options.outDuration,
	          easing: 'easeOutCubic'
	        });
	      }
	    }, {
	      key: "_handleMouseEnter",
	      value: function _handleMouseEnter() {
	        this.isHovered = true;
	        this.isFocused = false; // Allows close of tooltip when opened by focus.
	        this.open(false);
	      }
	    }, {
	      key: "_handleMouseLeave",
	      value: function _handleMouseLeave() {
	        this.isHovered = false;
	        this.isFocused = false; // Allows close of tooltip when opened by focus.
	        this.close();
	      }
	    }, {
	      key: "_handleFocus",
	      value: function _handleFocus() {
	        if (M.tabPressed) {
	          this.isFocused = true;
	          this.open(false);
	        }
	      }
	    }, {
	      key: "_handleBlur",
	      value: function _handleBlur() {
	        this.isFocused = false;
	        this.close();
	      }
	    }, {
	      key: "_getAttributeOptions",
	      value: function _getAttributeOptions() {
	        var attributeOptions = {};
	        var tooltipTextOption = this.el.getAttribute('data-tooltip');
	        var positionOption = this.el.getAttribute('data-position');
	
	        if (tooltipTextOption) {
	          attributeOptions.html = tooltipTextOption;
	        }
	
	        if (positionOption) {
	          attributeOptions.position = positionOption;
	        }
	        return attributeOptions;
	      }
	    }], [{
	      key: "init",
	      value: function init(els, options) {
	        return _get(Tooltip.__proto__ || Object.getPrototypeOf(Tooltip), "init", this).call(this, this, els, options);
	      }
	
	      /**
	       * Get Instance
	       */
	
	    }, {
	      key: "getInstance",
	      value: function getInstance(el) {
	        var domElem = !!el.jquery ? el[0] : el;
	        return domElem.M_Tooltip;
	      }
	    }, {
	      key: "defaults",
	      get: function get() {
	        return _defaults;
	      }
	    }]);
	
	    return Tooltip;
	  }(Component);
	
	  M.Tooltip = Tooltip;
	
	  if (M.jQueryLoaded) {
	    M.initializeJqueryWrapper(Tooltip, 'tooltip', 'M_Tooltip');
	  }
	})(cash, M.anime);
	; /*!
	  * Waves v0.6.4
	  * http://fian.my.id/Waves
	  *
	  * Copyright 2014 Alfiana E. Sibuea and other contributors
	  * Released under the MIT license
	  * https://github.com/fians/Waves/blob/master/LICENSE
	  */
	
	;(function (window) {
	  'use strict';
	
	  var Waves = Waves || {};
	  var $$ = document.querySelectorAll.bind(document);
	
	  // Find exact position of element
	  function isWindow(obj) {
	    return obj !== null && obj === obj.window;
	  }
	
	  function getWindow(elem) {
	    return isWindow(elem) ? elem : elem.nodeType === 9 && elem.defaultView;
	  }
	
	  function offset(elem) {
	    var docElem,
	        win,
	        box = { top: 0, left: 0 },
	        doc = elem && elem.ownerDocument;
	
	    docElem = doc.documentElement;
	
	    if (typeof elem.getBoundingClientRect !== typeof undefined) {
	      box = elem.getBoundingClientRect();
	    }
	    win = getWindow(doc);
	    return {
	      top: box.top + win.pageYOffset - docElem.clientTop,
	      left: box.left + win.pageXOffset - docElem.clientLeft
	    };
	  }
	
	  function convertStyle(obj) {
	    var style = '';
	
	    for (var a in obj) {
	      if (obj.hasOwnProperty(a)) {
	        style += a + ':' + obj[a] + ';';
	      }
	    }
	
	    return style;
	  }
	
	  var Effect = {
	
	    // Effect delay
	    duration: 750,
	
	    show: function show(e, element) {
	
	      // Disable right click
	      if (e.button === 2) {
	        return false;
	      }
	
	      var el = element || this;
	
	      // Create ripple
	      var ripple = document.createElement('div');
	      ripple.className = 'waves-ripple';
	      el.appendChild(ripple);
	
	      // Get click coordinate and element witdh
	      var pos = offset(el);
	      var relativeY = e.pageY - pos.top;
	      var relativeX = e.pageX - pos.left;
	      var scale = 'scale(' + el.clientWidth / 100 * 10 + ')';
	
	      // Support for touch devices
	      if ('touches' in e) {
	        relativeY = e.touches[0].pageY - pos.top;
	        relativeX = e.touches[0].pageX - pos.left;
	      }
	
	      // Attach data to element
	      ripple.setAttribute('data-hold', Date.now());
	      ripple.setAttribute('data-scale', scale);
	      ripple.setAttribute('data-x', relativeX);
	      ripple.setAttribute('data-y', relativeY);
	
	      // Set ripple position
	      var rippleStyle = {
	        'top': relativeY + 'px',
	        'left': relativeX + 'px'
	      };
	
	      ripple.className = ripple.className + ' waves-notransition';
	      ripple.setAttribute('style', convertStyle(rippleStyle));
	      ripple.className = ripple.className.replace('waves-notransition', '');
	
	      // Scale the ripple
	      rippleStyle['-webkit-transform'] = scale;
	      rippleStyle['-moz-transform'] = scale;
	      rippleStyle['-ms-transform'] = scale;
	      rippleStyle['-o-transform'] = scale;
	      rippleStyle.transform = scale;
	      rippleStyle.opacity = '1';
	
	      rippleStyle['-webkit-transition-duration'] = Effect.duration + 'ms';
	      rippleStyle['-moz-transition-duration'] = Effect.duration + 'ms';
	      rippleStyle['-o-transition-duration'] = Effect.duration + 'ms';
	      rippleStyle['transition-duration'] = Effect.duration + 'ms';
	
	      rippleStyle['-webkit-transition-timing-function'] = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';
	      rippleStyle['-moz-transition-timing-function'] = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';
	      rippleStyle['-o-transition-timing-function'] = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';
	      rippleStyle['transition-timing-function'] = 'cubic-bezier(0.250, 0.460, 0.450, 0.940)';
	
	      ripple.setAttribute('style', convertStyle(rippleStyle));
	    },
	
	    hide: function hide(e) {
	      TouchHandler.touchup(e);
	
	      var el = this;
	      var width = el.clientWidth * 1.4;
	
	      // Get first ripple
	      var ripple = null;
	      var ripples = el.getElementsByClassName('waves-ripple');
	      if (ripples.length > 0) {
	        ripple = ripples[ripples.length - 1];
	      } else {
	        return false;
	      }
	
	      var relativeX = ripple.getAttribute('data-x');
	      var relativeY = ripple.getAttribute('data-y');
	      var scale = ripple.getAttribute('data-scale');
	
	      // Get delay beetween mousedown and mouse leave
	      var diff = Date.now() - Number(ripple.getAttribute('data-hold'));
	      var delay = 350 - diff;
	
	      if (delay < 0) {
	        delay = 0;
	      }
	
	      // Fade out ripple after delay
	      setTimeout(function () {
	        var style = {
	          'top': relativeY + 'px',
	          'left': relativeX + 'px',
	          'opacity': '0',
	
	          // Duration
	          '-webkit-transition-duration': Effect.duration + 'ms',
	          '-moz-transition-duration': Effect.duration + 'ms',
	          '-o-transition-duration': Effect.duration + 'ms',
	          'transition-duration': Effect.duration + 'ms',
	          '-webkit-transform': scale,
	          '-moz-transform': scale,
	          '-ms-transform': scale,
	          '-o-transform': scale,
	          'transform': scale
	        };
	
	        ripple.setAttribute('style', convertStyle(style));
	
	        setTimeout(function () {
	          try {
	            el.removeChild(ripple);
	          } catch (e) {
	            return false;
	          }
	        }, Effect.duration);
	      }, delay);
	    },
	
	    // Little hack to make <input> can perform waves effect
	    wrapInput: function wrapInput(elements) {
	      for (var a = 0; a < elements.length; a++) {
	        var el = elements[a];
	
	        if (el.tagName.toLowerCase() === 'input') {
	          var parent = el.parentNode;
	
	          // If input already have parent just pass through
	          if (parent.tagName.toLowerCase() === 'i' && parent.className.indexOf('waves-effect') !== -1) {
	            continue;
	          }
	
	          // Put element class and style to the specified parent
	          var wrapper = document.createElement('i');
	          wrapper.className = el.className + ' waves-input-wrapper';
	
	          var elementStyle = el.getAttribute('style');
	
	          if (!elementStyle) {
	            elementStyle = '';
	          }
	
	          wrapper.setAttribute('style', elementStyle);
	
	          el.className = 'waves-button-input';
	          el.removeAttribute('style');
	
	          // Put element as child
	          parent.replaceChild(wrapper, el);
	          wrapper.appendChild(el);
	        }
	      }
	    }
	  };
	
	  /**
	   * Disable mousedown event for 500ms during and after touch
	   */
	  var TouchHandler = {
	    /* uses an integer rather than bool so there's no issues with
	     * needing to clear timeouts if another touch event occurred
	     * within the 500ms. Cannot mouseup between touchstart and
	     * touchend, nor in the 500ms after touchend. */
	    touches: 0,
	    allowEvent: function allowEvent(e) {
	      var allow = true;
	
	      if (e.type === 'touchstart') {
	        TouchHandler.touches += 1; //push
	      } else if (e.type === 'touchend' || e.type === 'touchcancel') {
	        setTimeout(function () {
	          if (TouchHandler.touches > 0) {
	            TouchHandler.touches -= 1; //pop after 500ms
	          }
	        }, 500);
	      } else if (e.type === 'mousedown' && TouchHandler.touches > 0) {
	        allow = false;
	      }
	
	      return allow;
	    },
	    touchup: function touchup(e) {
	      TouchHandler.allowEvent(e);
	    }
	  };
	
	  /**
	   * Delegated click handler for .waves-effect element.
	   * returns null when .waves-effect element not in "click tree"
	   */
	  function getWavesEffectElement(e) {
	    if (TouchHandler.allowEvent(e) === false) {
	      return null;
	    }
	
	    var element = null;
	    var target = e.target || e.srcElement;
	
	    while (target.parentNode !== null) {
	      if (!(target instanceof SVGElement) && target.className.indexOf('waves-effect') !== -1) {
	        element = target;
	        break;
	      }
	      target = target.parentNode;
	    }
	    return element;
	  }
	
	  /**
	   * Bubble the click and show effect if .waves-effect elem was found
	   */
	  function showEffect(e) {
	    var element = getWavesEffectElement(e);
	
	    if (element !== null) {
	      Effect.show(e, element);
	
	      if ('ontouchstart' in window) {
	        element.addEventListener('touchend', Effect.hide, false);
	        element.addEventListener('touchcancel', Effect.hide, false);
	      }
	
	      element.addEventListener('mouseup', Effect.hide, false);
	      element.addEventListener('mouseleave', Effect.hide, false);
	      element.addEventListener('dragend', Effect.hide, false);
	    }
	  }
	
	  Waves.displayEffect = function (options) {
	    options = options || {};
	
	    if ('duration' in options) {
	      Effect.duration = options.duration;
	    }
	
	    //Wrap input inside <i> tag
	    Effect.wrapInput($$('.waves-effect'));
	
	    if ('ontouchstart' in window) {
	      document.body.addEventListener('touchstart', showEffect, false);
	    }
	
	    document.body.addEventListener('mousedown', showEffect, false);
	  };
	
	  /**
	   * Attach Waves to an input element (or any element which doesn't
	   * bubble mouseup/mousedown events).
	   *   Intended to be used with dynamically loaded forms/inputs, or
	   * where the user doesn't want a delegated click handler.
	   */
	  Waves.attach = function (element) {
	    //FUTURE: automatically add waves classes and allow users
	    // to specify them with an options param? Eg. light/classic/button
	    if (element.tagName.toLowerCase() === 'input') {
	      Effect.wrapInput([element]);
	      element = element.parentNode;
	    }
	
	    if ('ontouchstart' in window) {
	      element.addEventListener('touchstart', showEffect, false);
	    }
	
	    element.addEventListener('mousedown', showEffect, false);
	  };
	
	  window.Waves = Waves;
	
	  document.addEventListener('DOMContentLoaded', function () {
	    Waves.displayEffect();
	  }, false);
	})(window);
	;(function ($, anim) {
	  'use strict';
	
	  var _defaults = {
	    html: '',
	    displayLength: 4000,
	    inDuration: 300,
	    outDuration: 375,
	    classes: '',
	    completeCallback: null,
	    activationPercent: 0.8
	  };
	
	  var Toast = function () {
	    function Toast(options) {
	      _classCallCheck(this, Toast);
	
	      /**
	       * Options for the toast
	       * @member Toast#options
	       */
	      this.options = $.extend({}, Toast.defaults, options);
	      this.message = this.options.html;
	
	      /**
	       * Describes current pan state toast
	       * @type {Boolean}
	       */
	      this.panning = false;
	
	      /**
	       * Time remaining until toast is removed
	       */
	      this.timeRemaining = this.options.displayLength;
	
	      if (Toast._toasts.length === 0) {
	        Toast._createContainer();
	      }
	
	      // Create new toast
	      Toast._toasts.push(this);
	      var toastElement = this._createToast();
	      toastElement.M_Toast = this;
	      this.el = toastElement;
	      this.$el = $(toastElement);
	      this._animateIn();
	      this._setTimer();
	    }
	
	    _createClass(Toast, [{
	      key: "_createToast",
	
	      /**
	       * Create toast and append it to toast container
	       */
	      value: function _createToast() {
	        var toast = document.createElement('div');
	        toast.classList.add('toast');
	
	        // Add custom classes onto toast
	        if (!!this.options.classes.length) {
	          $(toast).addClass(this.options.classes);
	        }
	
	        // Set content
	        if (typeof HTMLElement === 'object' ? this.message instanceof HTMLElement : this.message && typeof this.message === 'object' && this.message !== null && this.message.nodeType === 1 && typeof this.message.nodeName === 'string') {
	          toast.appendChild(this.message);
	
	          // Check if it is jQuery object
	        } else if (!!this.message.jquery) {
	          $(toast).append(this.message[0]);
	
	          // Insert as html;
	        } else {
	          toast.innerHTML = this.message;
	        }
	
	        // Append toasft
	        Toast._container.appendChild(toast);
	        return toast;
	      }
	
	      /**
	       * Animate in toast
	       */
	
	    }, {
	      key: "_animateIn",
	      value: function _animateIn() {
	        // Animate toast in
	        anim({
	          targets: this.el,
	          top: 0,
	          opacity: 1,
	          duration: this.options.inDuration,
	          easing: 'easeOutCubic'
	        });
	      }
	
	      /**
	       * Create setInterval which automatically removes toast when timeRemaining >= 0
	       * has been reached
	       */
	
	    }, {
	      key: "_setTimer",
	      value: function _setTimer() {
	        var _this29 = this;
	
	        if (this.timeRemaining !== Infinity) {
	          this.counterInterval = setInterval(function () {
	            // If toast is not being dragged, decrease its time remaining
	            if (!_this29.panning) {
	              _this29.timeRemaining -= 20;
	            }
	
	            // Animate toast out
	            if (_this29.timeRemaining <= 0) {
	              _this29.dismiss();
	            }
	          }, 20);
	        }
	      }
	
	      /**
	       * Dismiss toast with animation
	       */
	
	    }, {
	      key: "dismiss",
	      value: function dismiss() {
	        var _this30 = this;
	
	        window.clearInterval(this.counterInterval);
	        var activationDistance = this.el.offsetWidth * this.options.activationPercent;
	
	        if (this.wasSwiped) {
	          this.el.style.transition = 'transform .05s, opacity .05s';
	          this.el.style.transform = "translateX(" + activationDistance + "px)";
	          this.el.style.opacity = 0;
	        }
	
	        anim({
	          targets: this.el,
	          opacity: 0,
	          marginTop: -40,
	          duration: this.options.outDuration,
	          easing: 'easeOutExpo',
	          complete: function complete() {
	            // Call the optional callback
	            if (typeof _this30.options.completeCallback === 'function') {
	              _this30.options.completeCallback();
	            }
	            // Remove toast from DOM
	            _this30.$el.remove();
	            Toast._toasts.splice(Toast._toasts.indexOf(_this30), 1);
	            if (Toast._toasts.length === 0) {
	              Toast._removeContainer();
	            }
	          }
	        });
	      }
	    }], [{
	      key: "getInstance",
	
	      /**
	       * Get Instance
	       */
	      value: function getInstance(el) {
	        var domElem = !!el.jquery ? el[0] : el;
	        return domElem.M_Toast;
	      }
	
	      /**
	       * Append toast container and add event handlers
	       */
	
	    }, {
	      key: "_createContainer",
	      value: function _createContainer() {
	        var container = document.createElement('div');
	        container.setAttribute('id', 'toast-container');
	
	        // Add event handler
	        container.addEventListener('touchstart', Toast._onDragStart);
	        container.addEventListener('touchmove', Toast._onDragMove);
	        container.addEventListener('touchend', Toast._onDragEnd);
	
	        container.addEventListener('mousedown', Toast._onDragStart);
	        document.addEventListener('mousemove', Toast._onDragMove);
	        document.addEventListener('mouseup', Toast._onDragEnd);
	
	        document.body.appendChild(container);
	        Toast._container = container;
	      }
	
	      /**
	       * Remove toast container and event handlers
	       */
	
	    }, {
	      key: "_removeContainer",
	      value: function _removeContainer() {
	        // Add event handler
	        document.removeEventListener('mousemove', Toast._onDragMove);
	        document.removeEventListener('mouseup', Toast._onDragEnd);
	
	        $(Toast._container).remove();
	        Toast._container = null;
	      }
	
	      /**
	       * Begin drag handler
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_onDragStart",
	      value: function _onDragStart(e) {
	        if (e.target && $(e.target).closest('.toast').length) {
	          var $toast = $(e.target).closest('.toast');
	          var toast = $toast[0].M_Toast;
	          toast.panning = true;
	          Toast._draggedToast = toast;
	          toast.el.classList.add('panning');
	          toast.el.style.transition = '';
	          toast.startingXPos = Toast._xPos(e);
	          toast.time = Date.now();
	          toast.xPos = Toast._xPos(e);
	        }
	      }
	
	      /**
	       * Drag move handler
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_onDragMove",
	      value: function _onDragMove(e) {
	        if (!!Toast._draggedToast) {
	          e.preventDefault();
	          var toast = Toast._draggedToast;
	          toast.deltaX = Math.abs(toast.xPos - Toast._xPos(e));
	          toast.xPos = Toast._xPos(e);
	          toast.velocityX = toast.deltaX / (Date.now() - toast.time);
	          toast.time = Date.now();
	
	          var totalDeltaX = toast.xPos - toast.startingXPos;
	          var activationDistance = toast.el.offsetWidth * toast.options.activationPercent;
	          toast.el.style.transform = "translateX(" + totalDeltaX + "px)";
	          toast.el.style.opacity = 1 - Math.abs(totalDeltaX / activationDistance);
	        }
	      }
	
	      /**
	       * End drag handler
	       */
	
	    }, {
	      key: "_onDragEnd",
	      value: function _onDragEnd() {
	        if (!!Toast._draggedToast) {
	          var toast = Toast._draggedToast;
	          toast.panning = false;
	          toast.el.classList.remove('panning');
	
	          var totalDeltaX = toast.xPos - toast.startingXPos;
	          var activationDistance = toast.el.offsetWidth * toast.options.activationPercent;
	          var shouldBeDismissed = Math.abs(totalDeltaX) > activationDistance || toast.velocityX > 1;
	
	          // Remove toast
	          if (shouldBeDismissed) {
	            toast.wasSwiped = true;
	            toast.dismiss();
	
	            // Animate toast back to original position
	          } else {
	            toast.el.style.transition = 'transform .2s, opacity .2s';
	            toast.el.style.transform = '';
	            toast.el.style.opacity = '';
	          }
	          Toast._draggedToast = null;
	        }
	      }
	
	      /**
	       * Get x position of mouse or touch event
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_xPos",
	      value: function _xPos(e) {
	        if (e.targetTouches && e.targetTouches.length >= 1) {
	          return e.targetTouches[0].clientX;
	        }
	        // mouse event
	        return e.clientX;
	      }
	
	      /**
	       * Remove all toasts
	       */
	
	    }, {
	      key: "dismissAll",
	      value: function dismissAll() {
	        for (var toastIndex in Toast._toasts) {
	          Toast._toasts[toastIndex].dismiss();
	        }
	      }
	    }, {
	      key: "defaults",
	      get: function get() {
	        return _defaults;
	      }
	    }]);
	
	    return Toast;
	  }();
	
	  /**
	   * @static
	   * @memberof Toast
	   * @type {Array.<Toast>}
	   */
	
	  Toast._toasts = [];
	
	  /**
	   * @static
	   * @memberof Toast
	   */
	  Toast._container = null;
	
	  /**
	   * @static
	   * @memberof Toast
	   * @type {Toast}
	   */
	  Toast._draggedToast = null;
	
	  M.Toast = Toast;
	  M.toast = function (options) {
	    return new Toast(options);
	  };
	})(cash, M.anime);
	;(function ($, anim) {
	  'use strict';
	
	  var _defaults = {
	    edge: 'left',
	    draggable: true,
	    inDuration: 250,
	    outDuration: 200,
	    onOpenStart: null,
	    onOpenEnd: null,
	    onCloseStart: null,
	    onCloseEnd: null,
	    preventScrolling: true
	  };
	
	  /**
	   * @class
	   */
	
	  var Sidenav = function (_Component8) {
	    _inherits(Sidenav, _Component8);
	
	    /**
	     * Construct Sidenav instance and set up overlay
	     * @constructor
	     * @param {Element} el
	     * @param {Object} options
	     */
	    function Sidenav(el, options) {
	      _classCallCheck(this, Sidenav);
	
	      var _this31 = _possibleConstructorReturn(this, (Sidenav.__proto__ || Object.getPrototypeOf(Sidenav)).call(this, Sidenav, el, options));
	
	      _this31.el.M_Sidenav = _this31;
	      _this31.id = _this31.$el.attr('id');
	
	      /**
	       * Options for the Sidenav
	       * @member Sidenav#options
	       * @prop {String} [edge='left'] - Side of screen on which Sidenav appears
	       * @prop {Boolean} [draggable=true] - Allow swipe gestures to open/close Sidenav
	       * @prop {Number} [inDuration=250] - Length in ms of enter transition
	       * @prop {Number} [outDuration=200] - Length in ms of exit transition
	       * @prop {Function} onOpenStart - Function called when sidenav starts entering
	       * @prop {Function} onOpenEnd - Function called when sidenav finishes entering
	       * @prop {Function} onCloseStart - Function called when sidenav starts exiting
	       * @prop {Function} onCloseEnd - Function called when sidenav finishes exiting
	       */
	      _this31.options = $.extend({}, Sidenav.defaults, options);
	
	      /**
	       * Describes open/close state of Sidenav
	       * @type {Boolean}
	       */
	      _this31.isOpen = false;
	
	      /**
	       * Describes if Sidenav is fixed
	       * @type {Boolean}
	       */
	      _this31.isFixed = _this31.el.classList.contains('sidenav-fixed');
	
	      /**
	       * Describes if Sidenav is being draggeed
	       * @type {Boolean}
	       */
	      _this31.isDragged = false;
	
	      // Window size variables for window resize checks
	      _this31.lastWindowWidth = window.innerWidth;
	      _this31.lastWindowHeight = window.innerHeight;
	
	      _this31._createOverlay();
	      _this31._createDragTarget();
	      _this31._setupEventHandlers();
	      _this31._setupClasses();
	      _this31._setupFixed();
	
	      Sidenav._sidenavs.push(_this31);
	      return _this31;
	    }
	
	    _createClass(Sidenav, [{
	      key: "destroy",
	
	      /**
	       * Teardown component
	       */
	      value: function destroy() {
	        this._removeEventHandlers();
	        this._enableBodyScrolling();
	        this._overlay.parentNode.removeChild(this._overlay);
	        this.dragTarget.parentNode.removeChild(this.dragTarget);
	        this.el.M_Sidenav = undefined;
	        this.el.style.transform = '';
	
	        var index = Sidenav._sidenavs.indexOf(this);
	        if (index >= 0) {
	          Sidenav._sidenavs.splice(index, 1);
	        }
	      }
	    }, {
	      key: "_createOverlay",
	      value: function _createOverlay() {
	        var overlay = document.createElement('div');
	        this._closeBound = this.close.bind(this);
	        overlay.classList.add('sidenav-overlay');
	
	        overlay.addEventListener('click', this._closeBound);
	
	        document.body.appendChild(overlay);
	        this._overlay = overlay;
	      }
	    }, {
	      key: "_setupEventHandlers",
	      value: function _setupEventHandlers() {
	        if (Sidenav._sidenavs.length === 0) {
	          document.body.addEventListener('click', this._handleTriggerClick);
	        }
	
	        this._handleDragTargetDragBound = this._handleDragTargetDrag.bind(this);
	        this._handleDragTargetReleaseBound = this._handleDragTargetRelease.bind(this);
	        this._handleCloseDragBound = this._handleCloseDrag.bind(this);
	        this._handleCloseReleaseBound = this._handleCloseRelease.bind(this);
	        this._handleCloseTriggerClickBound = this._handleCloseTriggerClick.bind(this);
	
	        this.dragTarget.addEventListener('touchmove', this._handleDragTargetDragBound);
	        this.dragTarget.addEventListener('touchend', this._handleDragTargetReleaseBound);
	        this._overlay.addEventListener('touchmove', this._handleCloseDragBound);
	        this._overlay.addEventListener('touchend', this._handleCloseReleaseBound);
	        this.el.addEventListener('touchmove', this._handleCloseDragBound);
	        this.el.addEventListener('touchend', this._handleCloseReleaseBound);
	        this.el.addEventListener('click', this._handleCloseTriggerClickBound);
	
	        // Add resize for side nav fixed
	        if (this.isFixed) {
	          this._handleWindowResizeBound = this._handleWindowResize.bind(this);
	          window.addEventListener('resize', this._handleWindowResizeBound);
	        }
	      }
	    }, {
	      key: "_removeEventHandlers",
	      value: function _removeEventHandlers() {
	        if (Sidenav._sidenavs.length === 1) {
	          document.body.removeEventListener('click', this._handleTriggerClick);
	        }
	
	        this.dragTarget.removeEventListener('touchmove', this._handleDragTargetDragBound);
	        this.dragTarget.removeEventListener('touchend', this._handleDragTargetReleaseBound);
	        this._overlay.removeEventListener('touchmove', this._handleCloseDragBound);
	        this._overlay.removeEventListener('touchend', this._handleCloseReleaseBound);
	        this.el.removeEventListener('touchmove', this._handleCloseDragBound);
	        this.el.removeEventListener('touchend', this._handleCloseReleaseBound);
	        this.el.removeEventListener('click', this._handleCloseTriggerClickBound);
	
	        // Remove resize for side nav fixed
	        if (this.isFixed) {
	          window.removeEventListener('resize', this._handleWindowResizeBound);
	        }
	      }
	
	      /**
	       * Handle Trigger Click
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleTriggerClick",
	      value: function _handleTriggerClick(e) {
	        var $trigger = $(e.target).closest('.sidenav-trigger');
	        if (e.target && $trigger.length) {
	          var sidenavId = M.getIdFromTrigger($trigger[0]);
	
	          var sidenavInstance = document.getElementById(sidenavId).M_Sidenav;
	          if (sidenavInstance) {
	            sidenavInstance.open($trigger);
	          }
	          e.preventDefault();
	        }
	      }
	
	      /**
	       * Set variables needed at the beggining of drag
	       * and stop any current transition.
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_startDrag",
	      value: function _startDrag(e) {
	        var clientX = e.targetTouches[0].clientX;
	        this.isDragged = true;
	        this._startingXpos = clientX;
	        this._xPos = this._startingXpos;
	        this._time = Date.now();
	        this._width = this.el.getBoundingClientRect().width;
	        this._overlay.style.display = 'block';
	        this._initialScrollTop = this.isOpen ? this.el.scrollTop : M.getDocumentScrollTop();
	        this._verticallyScrolling = false;
	        anim.remove(this.el);
	        anim.remove(this._overlay);
	      }
	
	      /**
	       * Set variables needed at each drag move update tick
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_dragMoveUpdate",
	      value: function _dragMoveUpdate(e) {
	        var clientX = e.targetTouches[0].clientX;
	        var currentScrollTop = this.isOpen ? this.el.scrollTop : M.getDocumentScrollTop();
	        this.deltaX = Math.abs(this._xPos - clientX);
	        this._xPos = clientX;
	        this.velocityX = this.deltaX / (Date.now() - this._time);
	        this._time = Date.now();
	        if (this._initialScrollTop !== currentScrollTop) {
	          this._verticallyScrolling = true;
	        }
	      }
	
	      /**
	       * Handles Dragging of Sidenav
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleDragTargetDrag",
	      value: function _handleDragTargetDrag(e) {
	        // Check if draggable
	        if (!this.options.draggable || this._isCurrentlyFixed() || this._verticallyScrolling) {
	          return;
	        }
	
	        // If not being dragged, set initial drag start variables
	        if (!this.isDragged) {
	          this._startDrag(e);
	        }
	
	        // Run touchmove updates
	        this._dragMoveUpdate(e);
	
	        // Calculate raw deltaX
	        var totalDeltaX = this._xPos - this._startingXpos;
	
	        // dragDirection is the attempted user drag direction
	        var dragDirection = totalDeltaX > 0 ? 'right' : 'left';
	
	        // Don't allow totalDeltaX to exceed Sidenav width or be dragged in the opposite direction
	        totalDeltaX = Math.min(this._width, Math.abs(totalDeltaX));
	        if (this.options.edge === dragDirection) {
	          totalDeltaX = 0;
	        }
	
	        /**
	         * transformX is the drag displacement
	         * transformPrefix is the initial transform placement
	         * Invert values if Sidenav is right edge
	         */
	        var transformX = totalDeltaX;
	        var transformPrefix = 'translateX(-100%)';
	        if (this.options.edge === 'right') {
	          transformPrefix = 'translateX(100%)';
	          transformX = -transformX;
	        }
	
	        // Calculate open/close percentage of sidenav, with open = 1 and close = 0
	        this.percentOpen = Math.min(1, totalDeltaX / this._width);
	
	        // Set transform and opacity styles
	        this.el.style.transform = transformPrefix + " translateX(" + transformX + "px)";
	        this._overlay.style.opacity = this.percentOpen;
	      }
	
	      /**
	       * Handle Drag Target Release
	       */
	
	    }, {
	      key: "_handleDragTargetRelease",
	      value: function _handleDragTargetRelease() {
	        if (this.isDragged) {
	          if (this.percentOpen > 0.2) {
	            this.open();
	          } else {
	            this._animateOut();
	          }
	
	          this.isDragged = false;
	          this._verticallyScrolling = false;
	        }
	      }
	
	      /**
	       * Handle Close Drag
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleCloseDrag",
	      value: function _handleCloseDrag(e) {
	        if (this.isOpen) {
	          // Check if draggable
	          if (!this.options.draggable || this._isCurrentlyFixed() || this._verticallyScrolling) {
	            return;
	          }
	
	          // If not being dragged, set initial drag start variables
	          if (!this.isDragged) {
	            this._startDrag(e);
	          }
	
	          // Run touchmove updates
	          this._dragMoveUpdate(e);
	
	          // Calculate raw deltaX
	          var totalDeltaX = this._xPos - this._startingXpos;
	
	          // dragDirection is the attempted user drag direction
	          var dragDirection = totalDeltaX > 0 ? 'right' : 'left';
	
	          // Don't allow totalDeltaX to exceed Sidenav width or be dragged in the opposite direction
	          totalDeltaX = Math.min(this._width, Math.abs(totalDeltaX));
	          if (this.options.edge !== dragDirection) {
	            totalDeltaX = 0;
	          }
	
	          var transformX = -totalDeltaX;
	          if (this.options.edge === 'right') {
	            transformX = -transformX;
	          }
	
	          // Calculate open/close percentage of sidenav, with open = 1 and close = 0
	          this.percentOpen = Math.min(1, 1 - totalDeltaX / this._width);
	
	          // Set transform and opacity styles
	          this.el.style.transform = "translateX(" + transformX + "px)";
	          this._overlay.style.opacity = this.percentOpen;
	        }
	      }
	
	      /**
	       * Handle Close Release
	       */
	
	    }, {
	      key: "_handleCloseRelease",
	      value: function _handleCloseRelease() {
	        if (this.isOpen && this.isDragged) {
	          if (this.percentOpen > 0.8) {
	            this._animateIn();
	          } else {
	            this.close();
	          }
	
	          this.isDragged = false;
	          this._verticallyScrolling = false;
	        }
	      }
	
	      /**
	       * Handles closing of Sidenav when element with class .sidenav-close
	       */
	
	    }, {
	      key: "_handleCloseTriggerClick",
	      value: function _handleCloseTriggerClick(e) {
	        var $closeTrigger = $(e.target).closest('.sidenav-close');
	        if ($closeTrigger.length && !this._isCurrentlyFixed()) {
	          this.close();
	        }
	      }
	
	      /**
	       * Handle Window Resize
	       */
	
	    }, {
	      key: "_handleWindowResize",
	      value: function _handleWindowResize() {
	        // Only handle horizontal resizes
	        if (this.lastWindowWidth !== window.innerWidth) {
	          if (window.innerWidth > 992) {
	            this.open();
	          } else {
	            this.close();
	          }
	        }
	
	        this.lastWindowWidth = window.innerWidth;
	        this.lastWindowHeight = window.innerHeight;
	      }
	    }, {
	      key: "_setupClasses",
	      value: function _setupClasses() {
	        if (this.options.edge === 'right') {
	          this.el.classList.add('right-aligned');
	          this.dragTarget.classList.add('right-aligned');
	        }
	      }
	    }, {
	      key: "_removeClasses",
	      value: function _removeClasses() {
	        this.el.classList.remove('right-aligned');
	        this.dragTarget.classList.remove('right-aligned');
	      }
	    }, {
	      key: "_setupFixed",
	      value: function _setupFixed() {
	        if (this._isCurrentlyFixed()) {
	          this.open();
	        }
	      }
	    }, {
	      key: "_isCurrentlyFixed",
	      value: function _isCurrentlyFixed() {
	        return this.isFixed && window.innerWidth > 992;
	      }
	    }, {
	      key: "_createDragTarget",
	      value: function _createDragTarget() {
	        var dragTarget = document.createElement('div');
	        dragTarget.classList.add('drag-target');
	        document.body.appendChild(dragTarget);
	        this.dragTarget = dragTarget;
	      }
	    }, {
	      key: "_preventBodyScrolling",
	      value: function _preventBodyScrolling() {
	        var body = document.body;
	        body.style.overflow = 'hidden';
	      }
	    }, {
	      key: "_enableBodyScrolling",
	      value: function _enableBodyScrolling() {
	        var body = document.body;
	        body.style.overflow = '';
	      }
	    }, {
	      key: "open",
	      value: function open() {
	        if (this.isOpen === true) {
	          return;
	        }
	
	        this.isOpen = true;
	
	        // Run onOpenStart callback
	        if (typeof this.options.onOpenStart === 'function') {
	          this.options.onOpenStart.call(this, this.el);
	        }
	
	        // Handle fixed Sidenav
	        if (this._isCurrentlyFixed()) {
	          anim.remove(this.el);
	          anim({
	            targets: this.el,
	            translateX: 0,
	            duration: 0,
	            easing: 'easeOutQuad'
	          });
	          this._enableBodyScrolling();
	          this._overlay.style.display = 'none';
	
	          // Handle non-fixed Sidenav
	        } else {
	          if (this.options.preventScrolling) {
	            this._preventBodyScrolling();
	          }
	
	          if (!this.isDragged || this.percentOpen != 1) {
	            this._animateIn();
	          }
	        }
	      }
	    }, {
	      key: "close",
	      value: function close() {
	        if (this.isOpen === false) {
	          return;
	        }
	
	        this.isOpen = false;
	
	        // Run onCloseStart callback
	        if (typeof this.options.onCloseStart === 'function') {
	          this.options.onCloseStart.call(this, this.el);
	        }
	
	        // Handle fixed Sidenav
	        if (this._isCurrentlyFixed()) {
	          var transformX = this.options.edge === 'left' ? '-105%' : '105%';
	          this.el.style.transform = "translateX(" + transformX + ")";
	
	          // Handle non-fixed Sidenav
	        } else {
	          this._enableBodyScrolling();
	
	          if (!this.isDragged || this.percentOpen != 0) {
	            this._animateOut();
	          } else {
	            this._overlay.style.display = 'none';
	          }
	        }
	      }
	    }, {
	      key: "_animateIn",
	      value: function _animateIn() {
	        this._animateSidenavIn();
	        this._animateOverlayIn();
	      }
	    }, {
	      key: "_animateSidenavIn",
	      value: function _animateSidenavIn() {
	        var _this32 = this;
	
	        var slideOutPercent = this.options.edge === 'left' ? -1 : 1;
	        if (this.isDragged) {
	          slideOutPercent = this.options.edge === 'left' ? slideOutPercent + this.percentOpen : slideOutPercent - this.percentOpen;
	        }
	
	        anim.remove(this.el);
	        anim({
	          targets: this.el,
	          translateX: [slideOutPercent * 100 + "%", 0],
	          duration: this.options.inDuration,
	          easing: 'easeOutQuad',
	          complete: function complete() {
	            // Run onOpenEnd callback
	            if (typeof _this32.options.onOpenEnd === 'function') {
	              _this32.options.onOpenEnd.call(_this32, _this32.el);
	            }
	          }
	        });
	      }
	    }, {
	      key: "_animateOverlayIn",
	      value: function _animateOverlayIn() {
	        var start = 0;
	        if (this.isDragged) {
	          start = this.percentOpen;
	        } else {
	          $(this._overlay).css({
	            display: 'block'
	          });
	        }
	
	        anim.remove(this._overlay);
	        anim({
	          targets: this._overlay,
	          opacity: [start, 1],
	          duration: this.options.inDuration,
	          easing: 'easeOutQuad'
	        });
	      }
	    }, {
	      key: "_animateOut",
	      value: function _animateOut() {
	        this._animateSidenavOut();
	        this._animateOverlayOut();
	      }
	    }, {
	      key: "_animateSidenavOut",
	      value: function _animateSidenavOut() {
	        var _this33 = this;
	
	        var endPercent = this.options.edge === 'left' ? -1 : 1;
	        var slideOutPercent = 0;
	        if (this.isDragged) {
	          slideOutPercent = this.options.edge === 'left' ? endPercent + this.percentOpen : endPercent - this.percentOpen;
	        }
	
	        anim.remove(this.el);
	        anim({
	          targets: this.el,
	          translateX: [slideOutPercent * 100 + "%", endPercent * 105 + "%"],
	          duration: this.options.outDuration,
	          easing: 'easeOutQuad',
	          complete: function complete() {
	            // Run onOpenEnd callback
	            if (typeof _this33.options.onCloseEnd === 'function') {
	              _this33.options.onCloseEnd.call(_this33, _this33.el);
	            }
	          }
	        });
	      }
	    }, {
	      key: "_animateOverlayOut",
	      value: function _animateOverlayOut() {
	        var _this34 = this;
	
	        anim.remove(this._overlay);
	        anim({
	          targets: this._overlay,
	          opacity: 0,
	          duration: this.options.outDuration,
	          easing: 'easeOutQuad',
	          complete: function complete() {
	            $(_this34._overlay).css('display', 'none');
	          }
	        });
	      }
	    }], [{
	      key: "init",
	      value: function init(els, options) {
	        return _get(Sidenav.__proto__ || Object.getPrototypeOf(Sidenav), "init", this).call(this, this, els, options);
	      }
	
	      /**
	       * Get Instance
	       */
	
	    }, {
	      key: "getInstance",
	      value: function getInstance(el) {
	        var domElem = !!el.jquery ? el[0] : el;
	        return domElem.M_Sidenav;
	      }
	    }, {
	      key: "defaults",
	      get: function get() {
	        return _defaults;
	      }
	    }]);
	
	    return Sidenav;
	  }(Component);
	
	  /**
	   * @static
	   * @memberof Sidenav
	   * @type {Array.<Sidenav>}
	   */
	
	  Sidenav._sidenavs = [];
	
	  window.M.Sidenav = Sidenav;
	
	  if (M.jQueryLoaded) {
	    M.initializeJqueryWrapper(Sidenav, 'sidenav', 'M_Sidenav');
	  }
	})(cash, M.anime);
	;(function ($, anim) {
	  'use strict';
	
	  var _defaults = {
	    throttle: 100,
	    scrollOffset: 200, // offset - 200 allows elements near bottom of page to scroll
	    activeClass: 'active',
	    getActiveElement: function getActiveElement(id) {
	      return 'a[href="#' + id + '"]';
	    }
	  };
	
	  /**
	   * @class
	   *
	   */
	
	  var ScrollSpy = function (_Component9) {
	    _inherits(ScrollSpy, _Component9);
	
	    /**
	     * Construct ScrollSpy instance
	     * @constructor
	     * @param {Element} el
	     * @param {Object} options
	     */
	    function ScrollSpy(el, options) {
	      _classCallCheck(this, ScrollSpy);
	
	      var _this35 = _possibleConstructorReturn(this, (ScrollSpy.__proto__ || Object.getPrototypeOf(ScrollSpy)).call(this, ScrollSpy, el, options));
	
	      _this35.el.M_ScrollSpy = _this35;
	
	      /**
	       * Options for the modal
	       * @member Modal#options
	       * @prop {Number} [throttle=100] - Throttle of scroll handler
	       * @prop {Number} [scrollOffset=200] - Offset for centering element when scrolled to
	       * @prop {String} [activeClass='active'] - Class applied to active elements
	       * @prop {Function} [getActiveElement] - Used to find active element
	       */
	      _this35.options = $.extend({}, ScrollSpy.defaults, options);
	
	      // setup
	      ScrollSpy._elements.push(_this35);
	      ScrollSpy._count++;
	      ScrollSpy._increment++;
	      _this35.tickId = -1;
	      _this35.id = ScrollSpy._increment;
	      _this35._setupEventHandlers();
	      _this35._handleWindowScroll();
	      return _this35;
	    }
	
	    _createClass(ScrollSpy, [{
	      key: "destroy",
	
	      /**
	       * Teardown component
	       */
	      value: function destroy() {
	        ScrollSpy._elements.splice(ScrollSpy._elements.indexOf(this), 1);
	        ScrollSpy._elementsInView.splice(ScrollSpy._elementsInView.indexOf(this), 1);
	        ScrollSpy._visibleElements.splice(ScrollSpy._visibleElements.indexOf(this.$el), 1);
	        ScrollSpy._count--;
	        this._removeEventHandlers();
	        $(this.options.getActiveElement(this.$el.attr('id'))).removeClass(this.options.activeClass);
	        this.el.M_ScrollSpy = undefined;
	      }
	
	      /**
	       * Setup Event Handlers
	       */
	
	    }, {
	      key: "_setupEventHandlers",
	      value: function _setupEventHandlers() {
	        var throttledResize = M.throttle(this._handleWindowScroll, 200);
	        this._handleThrottledResizeBound = throttledResize.bind(this);
	        this._handleWindowScrollBound = this._handleWindowScroll.bind(this);
	        if (ScrollSpy._count === 1) {
	          window.addEventListener('scroll', this._handleWindowScrollBound);
	          window.addEventListener('resize', this._handleThrottledResizeBound);
	          document.body.addEventListener('click', this._handleTriggerClick);
	        }
	      }
	
	      /**
	       * Remove Event Handlers
	       */
	
	    }, {
	      key: "_removeEventHandlers",
	      value: function _removeEventHandlers() {
	        if (ScrollSpy._count === 0) {
	          window.removeEventListener('scroll', this._handleWindowScrollBound);
	          window.removeEventListener('resize', this._handleThrottledResizeBound);
	          document.body.removeEventListener('click', this._handleTriggerClick);
	        }
	      }
	
	      /**
	       * Handle Trigger Click
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleTriggerClick",
	      value: function _handleTriggerClick(e) {
	        var $trigger = $(e.target);
	        for (var i = ScrollSpy._elements.length - 1; i >= 0; i--) {
	          var scrollspy = ScrollSpy._elements[i];
	          if ($trigger.is('a[href="#' + scrollspy.$el.attr('id') + '"]')) {
	            e.preventDefault();
	            var offset = scrollspy.$el.offset().top + 1;
	
	            anim({
	              targets: [document.documentElement, document.body],
	              scrollTop: offset - scrollspy.options.scrollOffset,
	              duration: 400,
	              easing: 'easeOutCubic'
	            });
	            break;
	          }
	        }
	      }
	
	      /**
	       * Handle Window Scroll
	       */
	
	    }, {
	      key: "_handleWindowScroll",
	      value: function _handleWindowScroll() {
	        // unique tick id
	        ScrollSpy._ticks++;
	
	        // viewport rectangle
	        var top = M.getDocumentScrollTop(),
	            left = M.getDocumentScrollLeft(),
	            right = left + window.innerWidth,
	            bottom = top + window.innerHeight;
	
	        // determine which elements are in view
	        var intersections = ScrollSpy._findElements(top, right, bottom, left);
	        for (var i = 0; i < intersections.length; i++) {
	          var scrollspy = intersections[i];
	          var lastTick = scrollspy.tickId;
	          if (lastTick < 0) {
	            // entered into view
	            scrollspy._enter();
	          }
	
	          // update tick id
	          scrollspy.tickId = ScrollSpy._ticks;
	        }
	
	        for (var _i = 0; _i < ScrollSpy._elementsInView.length; _i++) {
	          var _scrollspy = ScrollSpy._elementsInView[_i];
	          var _lastTick = _scrollspy.tickId;
	          if (_lastTick >= 0 && _lastTick !== ScrollSpy._ticks) {
	            // exited from view
	            _scrollspy._exit();
	            _scrollspy.tickId = -1;
	          }
	        }
	
	        // remember elements in view for next tick
	        ScrollSpy._elementsInView = intersections;
	      }
	
	      /**
	       * Find elements that are within the boundary
	       * @param {number} top
	       * @param {number} right
	       * @param {number} bottom
	       * @param {number} left
	       * @return {Array.<ScrollSpy>}   A collection of elements
	       */
	
	    }, {
	      key: "_enter",
	      value: function _enter() {
	        ScrollSpy._visibleElements = ScrollSpy._visibleElements.filter(function (value) {
	          return value.height() != 0;
	        });
	
	        if (ScrollSpy._visibleElements[0]) {
	          $(this.options.getActiveElement(ScrollSpy._visibleElements[0].attr('id'))).removeClass(this.options.activeClass);
	          if (ScrollSpy._visibleElements[0][0].M_ScrollSpy && this.id < ScrollSpy._visibleElements[0][0].M_ScrollSpy.id) {
	            ScrollSpy._visibleElements.unshift(this.$el);
	          } else {
	            ScrollSpy._visibleElements.push(this.$el);
	          }
	        } else {
	          ScrollSpy._visibleElements.push(this.$el);
	        }
	
	        $(this.options.getActiveElement(ScrollSpy._visibleElements[0].attr('id'))).addClass(this.options.activeClass);
	      }
	    }, {
	      key: "_exit",
	      value: function _exit() {
	        var _this36 = this;
	
	        ScrollSpy._visibleElements = ScrollSpy._visibleElements.filter(function (value) {
	          return value.height() != 0;
	        });
	
	        if (ScrollSpy._visibleElements[0]) {
	          $(this.options.getActiveElement(ScrollSpy._visibleElements[0].attr('id'))).removeClass(this.options.activeClass);
	
	          ScrollSpy._visibleElements = ScrollSpy._visibleElements.filter(function (el) {
	            return el.attr('id') != _this36.$el.attr('id');
	          });
	          if (ScrollSpy._visibleElements[0]) {
	            // Check if empty
	            $(this.options.getActiveElement(ScrollSpy._visibleElements[0].attr('id'))).addClass(this.options.activeClass);
	          }
	        }
	      }
	    }], [{
	      key: "init",
	      value: function init(els, options) {
	        return _get(ScrollSpy.__proto__ || Object.getPrototypeOf(ScrollSpy), "init", this).call(this, this, els, options);
	      }
	
	      /**
	       * Get Instance
	       */
	
	    }, {
	      key: "getInstance",
	      value: function getInstance(el) {
	        var domElem = !!el.jquery ? el[0] : el;
	        return domElem.M_ScrollSpy;
	      }
	    }, {
	      key: "_findElements",
	      value: function _findElements(top, right, bottom, left) {
	        var hits = [];
	        for (var i = 0; i < ScrollSpy._elements.length; i++) {
	          var scrollspy = ScrollSpy._elements[i];
	          var currTop = top + scrollspy.options.scrollOffset || 200;
	
	          if (scrollspy.$el.height() > 0) {
	            var elTop = scrollspy.$el.offset().top,
	                elLeft = scrollspy.$el.offset().left,
	                elRight = elLeft + scrollspy.$el.width(),
	                elBottom = elTop + scrollspy.$el.height();
	
	            var isIntersect = !(elLeft > right || elRight < left || elTop > bottom || elBottom < currTop);
	
	            if (isIntersect) {
	              hits.push(scrollspy);
	            }
	          }
	        }
	        return hits;
	      }
	    }, {
	      key: "defaults",
	      get: function get() {
	        return _defaults;
	      }
	    }]);
	
	    return ScrollSpy;
	  }(Component);
	
	  /**
	   * @static
	   * @memberof ScrollSpy
	   * @type {Array.<ScrollSpy>}
	   */
	
	  ScrollSpy._elements = [];
	
	  /**
	   * @static
	   * @memberof ScrollSpy
	   * @type {Array.<ScrollSpy>}
	   */
	  ScrollSpy._elementsInView = [];
	
	  /**
	   * @static
	   * @memberof ScrollSpy
	   * @type {Array.<cash>}
	   */
	  ScrollSpy._visibleElements = [];
	
	  /**
	   * @static
	   * @memberof ScrollSpy
	   */
	  ScrollSpy._count = 0;
	
	  /**
	   * @static
	   * @memberof ScrollSpy
	   */
	  ScrollSpy._increment = 0;
	
	  /**
	   * @static
	   * @memberof ScrollSpy
	   */
	  ScrollSpy._ticks = 0;
	
	  M.ScrollSpy = ScrollSpy;
	
	  if (M.jQueryLoaded) {
	    M.initializeJqueryWrapper(ScrollSpy, 'scrollSpy', 'M_ScrollSpy');
	  }
	})(cash, M.anime);
	;(function ($) {
	  'use strict';
	
	  var _defaults = {
	    data: {}, // Autocomplete data set
	    limit: Infinity, // Limit of results the autocomplete shows
	    onAutocomplete: null, // Callback for when autocompleted
	    minLength: 1, // Min characters before autocomplete starts
	    sortFunction: function sortFunction(a, b, inputString) {
	      // Sort function for sorting autocomplete results
	      return a.indexOf(inputString) - b.indexOf(inputString);
	    }
	  };
	
	  /**
	   * @class
	   *
	   */
	
	  var Autocomplete = function (_Component10) {
	    _inherits(Autocomplete, _Component10);
	
	    /**
	     * Construct Autocomplete instance
	     * @constructor
	     * @param {Element} el
	     * @param {Object} options
	     */
	    function Autocomplete(el, options) {
	      _classCallCheck(this, Autocomplete);
	
	      var _this37 = _possibleConstructorReturn(this, (Autocomplete.__proto__ || Object.getPrototypeOf(Autocomplete)).call(this, Autocomplete, el, options));
	
	      _this37.el.M_Autocomplete = _this37;
	
	      /**
	       * Options for the autocomplete
	       * @member Autocomplete#options
	       * @prop {Number} duration
	       * @prop {Number} dist
	       * @prop {number} shift
	       * @prop {number} padding
	       * @prop {Boolean} fullWidth
	       * @prop {Boolean} indicators
	       * @prop {Boolean} noWrap
	       * @prop {Function} onCycleTo
	       */
	      _this37.options = $.extend({}, Autocomplete.defaults, options);
	
	      // Setup
	      _this37.isOpen = false;
	      _this37.count = 0;
	      _this37.activeIndex = -1;
	      _this37.oldVal;
	      _this37.$inputField = _this37.$el.closest('.input-field');
	      _this37.$active = $();
	      _this37._mousedown = false;
	      _this37._setupDropdown();
	
	      _this37._setupEventHandlers();
	      return _this37;
	    }
	
	    _createClass(Autocomplete, [{
	      key: "destroy",
	
	      /**
	       * Teardown component
	       */
	      value: function destroy() {
	        this._removeEventHandlers();
	        this._removeDropdown();
	        this.el.M_Autocomplete = undefined;
	      }
	
	      /**
	       * Setup Event Handlers
	       */
	
	    }, {
	      key: "_setupEventHandlers",
	      value: function _setupEventHandlers() {
	        this._handleInputBlurBound = this._handleInputBlur.bind(this);
	        this._handleInputKeyupAndFocusBound = this._handleInputKeyupAndFocus.bind(this);
	        this._handleInputKeydownBound = this._handleInputKeydown.bind(this);
	        this._handleInputClickBound = this._handleInputClick.bind(this);
	        this._handleContainerMousedownAndTouchstartBound = this._handleContainerMousedownAndTouchstart.bind(this);
	        this._handleContainerMouseupAndTouchendBound = this._handleContainerMouseupAndTouchend.bind(this);
	
	        this.el.addEventListener('blur', this._handleInputBlurBound);
	        this.el.addEventListener('keyup', this._handleInputKeyupAndFocusBound);
	        this.el.addEventListener('focus', this._handleInputKeyupAndFocusBound);
	        this.el.addEventListener('keydown', this._handleInputKeydownBound);
	        this.el.addEventListener('click', this._handleInputClickBound);
	        this.container.addEventListener('mousedown', this._handleContainerMousedownAndTouchstartBound);
	        this.container.addEventListener('mouseup', this._handleContainerMouseupAndTouchendBound);
	
	        if (typeof window.ontouchstart !== 'undefined') {
	          this.container.addEventListener('touchstart', this._handleContainerMousedownAndTouchstartBound);
	          this.container.addEventListener('touchend', this._handleContainerMouseupAndTouchendBound);
	        }
	      }
	
	      /**
	       * Remove Event Handlers
	       */
	
	    }, {
	      key: "_removeEventHandlers",
	      value: function _removeEventHandlers() {
	        this.el.removeEventListener('blur', this._handleInputBlurBound);
	        this.el.removeEventListener('keyup', this._handleInputKeyupAndFocusBound);
	        this.el.removeEventListener('focus', this._handleInputKeyupAndFocusBound);
	        this.el.removeEventListener('keydown', this._handleInputKeydownBound);
	        this.el.removeEventListener('click', this._handleInputClickBound);
	        this.container.removeEventListener('mousedown', this._handleContainerMousedownAndTouchstartBound);
	        this.container.removeEventListener('mouseup', this._handleContainerMouseupAndTouchendBound);
	
	        if (typeof window.ontouchstart !== 'undefined') {
	          this.container.removeEventListener('touchstart', this._handleContainerMousedownAndTouchstartBound);
	          this.container.removeEventListener('touchend', this._handleContainerMouseupAndTouchendBound);
	        }
	      }
	
	      /**
	       * Setup dropdown
	       */
	
	    }, {
	      key: "_setupDropdown",
	      value: function _setupDropdown() {
	        var _this38 = this;
	
	        this.container = document.createElement('ul');
	        this.container.id = "autocomplete-options-" + M.guid();
	        $(this.container).addClass('autocomplete-content dropdown-content');
	        this.$inputField.append(this.container);
	        this.el.setAttribute('data-target', this.container.id);
	
	        this.dropdown = M.Dropdown.init(this.el, {
	          autoFocus: false,
	          closeOnClick: false,
	          coverTrigger: false,
	          onItemClick: function onItemClick(itemEl) {
	            _this38.selectOption($(itemEl));
	          }
	        });
	
	        // Sketchy removal of dropdown click handler
	        this.el.removeEventListener('click', this.dropdown._handleClickBound);
	      }
	
	      /**
	       * Remove dropdown
	       */
	
	    }, {
	      key: "_removeDropdown",
	      value: function _removeDropdown() {
	        this.container.parentNode.removeChild(this.container);
	      }
	
	      /**
	       * Handle Input Blur
	       */
	
	    }, {
	      key: "_handleInputBlur",
	      value: function _handleInputBlur() {
	        if (!this._mousedown) {
	          this.close();
	          this._resetAutocomplete();
	        }
	      }
	
	      /**
	       * Handle Input Keyup and Focus
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleInputKeyupAndFocus",
	      value: function _handleInputKeyupAndFocus(e) {
	        if (e.type === 'keyup') {
	          Autocomplete._keydown = false;
	        }
	
	        this.count = 0;
	        var val = this.el.value.toLowerCase();
	
	        // Don't capture enter or arrow key usage.
	        if (e.keyCode === 13 || e.keyCode === 38 || e.keyCode === 40) {
	          return;
	        }
	
	        // Check if the input isn't empty
	        // Check if focus triggered by tab
	        if (this.oldVal !== val && (M.tabPressed || e.type !== 'focus')) {
	          this.open();
	        }
	
	        // Update oldVal
	        this.oldVal = val;
	      }
	
	      /**
	       * Handle Input Keydown
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleInputKeydown",
	      value: function _handleInputKeydown(e) {
	        Autocomplete._keydown = true;
	
	        // Arrow keys and enter key usage
	        var keyCode = e.keyCode,
	            liElement = void 0,
	            numItems = $(this.container).children('li').length;
	
	        // select element on Enter
	        if (keyCode === M.keys.ENTER && this.activeIndex >= 0) {
	          liElement = $(this.container).children('li').eq(this.activeIndex);
	          if (liElement.length) {
	            this.selectOption(liElement);
	            e.preventDefault();
	          }
	          return;
	        }
	
	        // Capture up and down key
	        if (keyCode === M.keys.ARROW_UP || keyCode === M.keys.ARROW_DOWN) {
	          e.preventDefault();
	
	          if (keyCode === M.keys.ARROW_UP && this.activeIndex > 0) {
	            this.activeIndex--;
	          }
	
	          if (keyCode === M.keys.ARROW_DOWN && this.activeIndex < numItems - 1) {
	            this.activeIndex++;
	          }
	
	          this.$active.removeClass('active');
	          if (this.activeIndex >= 0) {
	            this.$active = $(this.container).children('li').eq(this.activeIndex);
	            this.$active.addClass('active');
	          }
	        }
	      }
	
	      /**
	       * Handle Input Click
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleInputClick",
	      value: function _handleInputClick(e) {
	        this.open();
	      }
	
	      /**
	       * Handle Container Mousedown and Touchstart
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleContainerMousedownAndTouchstart",
	      value: function _handleContainerMousedownAndTouchstart(e) {
	        this._mousedown = true;
	      }
	
	      /**
	       * Handle Container Mouseup and Touchend
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleContainerMouseupAndTouchend",
	      value: function _handleContainerMouseupAndTouchend(e) {
	        this._mousedown = false;
	      }
	
	      /**
	       * Highlight partial match
	       */
	
	    }, {
	      key: "_highlight",
	      value: function _highlight(string, $el) {
	        var img = $el.find('img');
	        var matchStart = $el.text().toLowerCase().indexOf('' + string.toLowerCase() + ''),
	            matchEnd = matchStart + string.length - 1,
	            beforeMatch = $el.text().slice(0, matchStart),
	            matchText = $el.text().slice(matchStart, matchEnd + 1),
	            afterMatch = $el.text().slice(matchEnd + 1);
	        $el.html("<span>" + beforeMatch + "<span class='highlight'>" + matchText + "</span>" + afterMatch + "</span>");
	        if (img.length) {
	          $el.prepend(img);
	        }
	      }
	
	      /**
	       * Reset current element position
	       */
	
	    }, {
	      key: "_resetCurrentElement",
	      value: function _resetCurrentElement() {
	        this.activeIndex = -1;
	        this.$active.removeClass('active');
	      }
	
	      /**
	       * Reset autocomplete elements
	       */
	
	    }, {
	      key: "_resetAutocomplete",
	      value: function _resetAutocomplete() {
	        $(this.container).empty();
	        this._resetCurrentElement();
	        this.oldVal = null;
	        this.isOpen = false;
	        this._mousedown = false;
	      }
	
	      /**
	       * Select autocomplete option
	       * @param {Element} el  Autocomplete option list item element
	       */
	
	    }, {
	      key: "selectOption",
	      value: function selectOption(el) {
	        var text = el.text().trim();
	        this.el.value = text;
	        this.$el.trigger('change');
	        this._resetAutocomplete();
	        this.close();
	
	        // Handle onAutocomplete callback.
	        if (typeof this.options.onAutocomplete === 'function') {
	          this.options.onAutocomplete.call(this, text);
	        }
	      }
	
	      /**
	       * Render dropdown content
	       * @param {Object} data  data set
	       * @param {String} val  current input value
	       */
	
	    }, {
	      key: "_renderDropdown",
	      value: function _renderDropdown(data, val) {
	        var _this39 = this;
	
	        this._resetAutocomplete();
	
	        var matchingData = [];
	
	        // Gather all matching data
	        for (var key in data) {
	          if (data.hasOwnProperty(key) && key.toLowerCase().indexOf(val) !== -1) {
	            // Break if past limit
	            if (this.count >= this.options.limit) {
	              break;
	            }
	
	            var entry = {
	              data: data[key],
	              key: key
	            };
	            matchingData.push(entry);
	
	            this.count++;
	          }
	        }
	
	        // Sort
	        if (this.options.sortFunction) {
	          var sortFunctionBound = function sortFunctionBound(a, b) {
	            return _this39.options.sortFunction(a.key.toLowerCase(), b.key.toLowerCase(), val.toLowerCase());
	          };
	          matchingData.sort(sortFunctionBound);
	        }
	
	        // Render
	        for (var i = 0; i < matchingData.length; i++) {
	          var _entry = matchingData[i];
	          var $autocompleteOption = $('<li></li>');
	          if (!!_entry.data) {
	            $autocompleteOption.append("<img src=\"" + _entry.data + "\" class=\"right circle\"><span>" + _entry.key + "</span>");
	          } else {
	            $autocompleteOption.append('<span>' + _entry.key + '</span>');
	          }
	
	          $(this.container).append($autocompleteOption);
	          this._highlight(val, $autocompleteOption);
	        }
	      }
	
	      /**
	       * Open Autocomplete Dropdown
	       */
	
	    }, {
	      key: "open",
	      value: function open() {
	        var val = this.el.value.toLowerCase();
	
	        this._resetAutocomplete();
	
	        if (val.length >= this.options.minLength) {
	          this.isOpen = true;
	          this._renderDropdown(this.options.data, val);
	        }
	
	        // Open dropdown
	        if (!this.dropdown.isOpen) {
	          this.dropdown.open();
	        } else {
	          // Recalculate dropdown when its already open
	          this.dropdown.recalculateDimensions();
	        }
	      }
	
	      /**
	       * Close Autocomplete Dropdown
	       */
	
	    }, {
	      key: "close",
	      value: function close() {
	        this.dropdown.close();
	      }
	
	      /**
	       * Update Data
	       * @param {Object} data
	       */
	
	    }, {
	      key: "updateData",
	      value: function updateData(data) {
	        var val = this.el.value.toLowerCase();
	        this.options.data = data;
	
	        if (this.isOpen) {
	          this._renderDropdown(data, val);
	        }
	      }
	    }], [{
	      key: "init",
	      value: function init(els, options) {
	        return _get(Autocomplete.__proto__ || Object.getPrototypeOf(Autocomplete), "init", this).call(this, this, els, options);
	      }
	
	      /**
	       * Get Instance
	       */
	
	    }, {
	      key: "getInstance",
	      value: function getInstance(el) {
	        var domElem = !!el.jquery ? el[0] : el;
	        return domElem.M_Autocomplete;
	      }
	    }, {
	      key: "defaults",
	      get: function get() {
	        return _defaults;
	      }
	    }]);
	
	    return Autocomplete;
	  }(Component);
	
	  /**
	   * @static
	   * @memberof Autocomplete
	   */
	
	  Autocomplete._keydown = false;
	
	  M.Autocomplete = Autocomplete;
	
	  if (M.jQueryLoaded) {
	    M.initializeJqueryWrapper(Autocomplete, 'autocomplete', 'M_Autocomplete');
	  }
	})(cash);
	;(function ($) {
	  // Function to update labels of text fields
	  M.updateTextFields = function () {
	    var input_selector = 'input[type=text], input[type=password], input[type=email], input[type=url], input[type=tel], input[type=number], input[type=search], input[type=date], input[type=time], textarea';
	    $(input_selector).each(function (element, index) {
	      var $this = $(this);
	      if (element.value.length > 0 || $(element).is(':focus') || element.autofocus || $this.attr('placeholder') !== null) {
	        $this.siblings('label').addClass('active');
	      } else if (element.validity) {
	        $this.siblings('label').toggleClass('active', element.validity.badInput === true);
	      } else {
	        $this.siblings('label').removeClass('active');
	      }
	    });
	  };
	
	  M.validate_field = function (object) {
	    var hasLength = object.attr('data-length') !== null;
	    var lenAttr = parseInt(object.attr('data-length'));
	    var len = object[0].value.length;
	
	    if (len === 0 && object[0].validity.badInput === false && !object.is(':required')) {
	      if (object.hasClass('validate')) {
	        object.removeClass('valid');
	        object.removeClass('invalid');
	      }
	    } else {
	      if (object.hasClass('validate')) {
	        // Check for character counter attributes
	        if (object.is(':valid') && hasLength && len <= lenAttr || object.is(':valid') && !hasLength) {
	          object.removeClass('invalid');
	          object.addClass('valid');
	        } else {
	          object.removeClass('valid');
	          object.addClass('invalid');
	        }
	      }
	    }
	  };
	
	  M.textareaAutoResize = function ($textarea) {
	    // Wrap if native element
	    if ($textarea instanceof Element) {
	      $textarea = $($textarea);
	    }
	
	    if (!$textarea.length) {
	      console.error('No textarea element found');
	      return;
	    }
	
	    // Textarea Auto Resize
	    var hiddenDiv = $('.hiddendiv').first();
	    if (!hiddenDiv.length) {
	      hiddenDiv = $('<div class="hiddendiv common"></div>');
	      $('body').append(hiddenDiv);
	    }
	
	    // Set font properties of hiddenDiv
	    var fontFamily = $textarea.css('font-family');
	    var fontSize = $textarea.css('font-size');
	    var lineHeight = $textarea.css('line-height');
	
	    // Firefox can't handle padding shorthand.
	    var paddingTop = $textarea.css('padding-top');
	    var paddingRight = $textarea.css('padding-right');
	    var paddingBottom = $textarea.css('padding-bottom');
	    var paddingLeft = $textarea.css('padding-left');
	
	    if (fontSize) {
	      hiddenDiv.css('font-size', fontSize);
	    }
	    if (fontFamily) {
	      hiddenDiv.css('font-family', fontFamily);
	    }
	    if (lineHeight) {
	      hiddenDiv.css('line-height', lineHeight);
	    }
	    if (paddingTop) {
	      hiddenDiv.css('padding-top', paddingTop);
	    }
	    if (paddingRight) {
	      hiddenDiv.css('padding-right', paddingRight);
	    }
	    if (paddingBottom) {
	      hiddenDiv.css('padding-bottom', paddingBottom);
	    }
	    if (paddingLeft) {
	      hiddenDiv.css('padding-left', paddingLeft);
	    }
	
	    // Set original-height, if none
	    if (!$textarea.data('original-height')) {
	      $textarea.data('original-height', $textarea.height());
	    }
	
	    if ($textarea.attr('wrap') === 'off') {
	      hiddenDiv.css('overflow-wrap', 'normal').css('white-space', 'pre');
	    }
	
	    hiddenDiv.text($textarea[0].value + '\n');
	    var content = hiddenDiv.html().replace(/\n/g, '<br>');
	    hiddenDiv.html(content);
	
	    // When textarea is hidden, width goes crazy.
	    // Approximate with half of window size
	
	    if ($textarea[0].offsetWidth > 0 && $textarea[0].offsetHeight > 0) {
	      hiddenDiv.css('width', $textarea.width() + 'px');
	    } else {
	      hiddenDiv.css('width', window.innerWidth / 2 + 'px');
	    }
	
	    /**
	     * Resize if the new height is greater than the
	     * original height of the textarea
	     */
	    if ($textarea.data('original-height') <= hiddenDiv.innerHeight()) {
	      $textarea.css('height', hiddenDiv.innerHeight() + 'px');
	    } else if ($textarea[0].value.length < $textarea.data('previous-length')) {
	      /**
	       * In case the new height is less than original height, it
	       * means the textarea has less text than before
	       * So we set the height to the original one
	       */
	      $textarea.css('height', $textarea.data('original-height') + 'px');
	    }
	    $textarea.data('previous-length', $textarea[0].value.length);
	  };
	
	  $(document).ready(function () {
	    // Text based inputs
	    var input_selector = 'input[type=text], input[type=password], input[type=email], input[type=url], input[type=tel], input[type=number], input[type=search], input[type=date], input[type=time], textarea';
	
	    // Add active if form auto complete
	    $(document).on('change', input_selector, function () {
	      if (this.value.length !== 0 || $(this).attr('placeholder') !== null) {
	        $(this).siblings('label').addClass('active');
	      }
	      M.validate_field($(this));
	    });
	
	    // Add active if input element has been pre-populated on document ready
	    $(document).ready(function () {
	      M.updateTextFields();
	    });
	
	    // HTML DOM FORM RESET handling
	    $(document).on('reset', function (e) {
	      var formReset = $(e.target);
	      if (formReset.is('form')) {
	        formReset.find(input_selector).removeClass('valid').removeClass('invalid');
	        formReset.find(input_selector).each(function (e) {
	          if (this.value.length) {
	            $(this).siblings('label').removeClass('active');
	          }
	        });
	
	        // Reset select (after native reset)
	        setTimeout(function () {
	          formReset.find('select').each(function () {
	            // check if initialized
	            if (this.M_FormSelect) {
	              $(this).trigger('change');
	            }
	          });
	        }, 0);
	      }
	    });
	
	    /**
	     * Add active when element has focus
	     * @param {Event} e
	     */
	    document.addEventListener('focus', function (e) {
	      if ($(e.target).is(input_selector)) {
	        $(e.target).siblings('label, .prefix').addClass('active');
	      }
	    }, true);
	
	    /**
	     * Remove active when element is blurred
	     * @param {Event} e
	     */
	    document.addEventListener('blur', function (e) {
	      var $inputElement = $(e.target);
	      if ($inputElement.is(input_selector)) {
	        var selector = '.prefix';
	
	        if ($inputElement[0].value.length === 0 && $inputElement[0].validity.badInput !== true && $inputElement.attr('placeholder') === null) {
	          selector += ', label';
	        }
	        $inputElement.siblings(selector).removeClass('active');
	        M.validate_field($inputElement);
	      }
	    }, true);
	
	    // Radio and Checkbox focus class
	    var radio_checkbox = 'input[type=radio], input[type=checkbox]';
	    $(document).on('keyup', radio_checkbox, function (e) {
	      // TAB, check if tabbing to radio or checkbox.
	      if (e.which === M.keys.TAB) {
	        $(this).addClass('tabbed');
	        var $this = $(this);
	        $this.one('blur', function (e) {
	          $(this).removeClass('tabbed');
	        });
	        return;
	      }
	    });
	
	    var text_area_selector = '.materialize-textarea';
	    $(text_area_selector).each(function () {
	      var $textarea = $(this);
	      /**
	       * Resize textarea on document load after storing
	       * the original height and the original length
	       */
	      $textarea.data('original-height', $textarea.height());
	      $textarea.data('previous-length', this.value.length);
	      M.textareaAutoResize($textarea);
	    });
	
	    $(document).on('keyup', text_area_selector, function () {
	      M.textareaAutoResize($(this));
	    });
	    $(document).on('keydown', text_area_selector, function () {
	      M.textareaAutoResize($(this));
	    });
	
	    // File Input Path
	    $(document).on('change', '.file-field input[type="file"]', function () {
	      var file_field = $(this).closest('.file-field');
	      var path_input = file_field.find('input.file-path');
	      var files = $(this)[0].files;
	      var file_names = [];
	      for (var i = 0; i < files.length; i++) {
	        file_names.push(files[i].name);
	      }
	      path_input[0].value = file_names.join(', ');
	      path_input.trigger('change');
	    });
	  }); // End of $(document).ready
	})(cash);
	;(function ($, anim) {
	  'use strict';
	
	  var _defaults = {
	    indicators: true,
	    height: 400,
	    duration: 500,
	    interval: 6000
	  };
	
	  /**
	   * @class
	   *
	   */
	
	  var Slider = function (_Component11) {
	    _inherits(Slider, _Component11);
	
	    /**
	     * Construct Slider instance and set up overlay
	     * @constructor
	     * @param {Element} el
	     * @param {Object} options
	     */
	    function Slider(el, options) {
	      _classCallCheck(this, Slider);
	
	      var _this40 = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, Slider, el, options));
	
	      _this40.el.M_Slider = _this40;
	
	      /**
	       * Options for the modal
	       * @member Slider#options
	       * @prop {Boolean} [indicators=true] - Show indicators
	       * @prop {Number} [height=400] - height of slider
	       * @prop {Number} [duration=500] - Length in ms of slide transition
	       * @prop {Number} [interval=6000] - Length in ms of slide interval
	       */
	      _this40.options = $.extend({}, Slider.defaults, options);
	
	      // setup
	      _this40.$slider = _this40.$el.find('.slides');
	      _this40.$slides = _this40.$slider.children('li');
	      _this40.activeIndex = _this40.$slides.filter(function (item) {
	        return $(item).hasClass('active');
	      }).first().index();
	      if (_this40.activeIndex != -1) {
	        _this40.$active = _this40.$slides.eq(_this40.activeIndex);
	      }
	
	      _this40._setSliderHeight();
	
	      // Set initial positions of captions
	      _this40.$slides.find('.caption').each(function (el) {
	        _this40._animateCaptionIn(el, 0);
	      });
	
	      // Move img src into background-image
	      _this40.$slides.find('img').each(function (el) {
	        var placeholderBase64 = 'data:image/gif;base64,R0lGODlhAQABAIABAP///wAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
	        if ($(el).attr('src') !== placeholderBase64) {
	          $(el).css('background-image', 'url("' + $(el).attr('src') + '")');
	          $(el).attr('src', placeholderBase64);
	        }
	      });
	
	      _this40._setupIndicators();
	
	      // Show active slide
	      if (_this40.$active) {
	        _this40.$active.css('display', 'block');
	      } else {
	        _this40.$slides.first().addClass('active');
	        anim({
	          targets: _this40.$slides.first()[0],
	          opacity: 1,
	          duration: _this40.options.duration,
	          easing: 'easeOutQuad'
	        });
	
	        _this40.activeIndex = 0;
	        _this40.$active = _this40.$slides.eq(_this40.activeIndex);
	
	        // Update indicators
	        if (_this40.options.indicators) {
	          _this40.$indicators.eq(_this40.activeIndex).addClass('active');
	        }
	      }
	
	      // Adjust height to current slide
	      _this40.$active.find('img').each(function (el) {
	        anim({
	          targets: _this40.$active.find('.caption')[0],
	          opacity: 1,
	          translateX: 0,
	          translateY: 0,
	          duration: _this40.options.duration,
	          easing: 'easeOutQuad'
	        });
	      });
	
	      _this40._setupEventHandlers();
	
	      // auto scroll
	      _this40.start();
	      return _this40;
	    }
	
	    _createClass(Slider, [{
	      key: "destroy",
	
	      /**
	       * Teardown component
	       */
	      value: function destroy() {
	        this.pause();
	        this._removeIndicators();
	        this._removeEventHandlers();
	        this.el.M_Slider = undefined;
	      }
	
	      /**
	       * Setup Event Handlers
	       */
	
	    }, {
	      key: "_setupEventHandlers",
	      value: function _setupEventHandlers() {
	        var _this41 = this;
	
	        this._handleIntervalBound = this._handleInterval.bind(this);
	        this._handleIndicatorClickBound = this._handleIndicatorClick.bind(this);
	
	        if (this.options.indicators) {
	          this.$indicators.each(function (el) {
	            el.addEventListener('click', _this41._handleIndicatorClickBound);
	          });
	        }
	      }
	
	      /**
	       * Remove Event Handlers
	       */
	
	    }, {
	      key: "_removeEventHandlers",
	      value: function _removeEventHandlers() {
	        var _this42 = this;
	
	        if (this.options.indicators) {
	          this.$indicators.each(function (el) {
	            el.removeEventListener('click', _this42._handleIndicatorClickBound);
	          });
	        }
	      }
	
	      /**
	       * Handle indicator click
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleIndicatorClick",
	      value: function _handleIndicatorClick(e) {
	        var currIndex = $(e.target).index();
	        this.set(currIndex);
	      }
	
	      /**
	       * Handle Interval
	       */
	
	    }, {
	      key: "_handleInterval",
	      value: function _handleInterval() {
	        var newActiveIndex = this.$slider.find('.active').index();
	        if (this.$slides.length === newActiveIndex + 1) newActiveIndex = 0;
	        // loop to start
	        else newActiveIndex += 1;
	
	        this.set(newActiveIndex);
	      }
	
	      /**
	       * Animate in caption
	       * @param {Element} caption
	       * @param {Number} duration
	       */
	
	    }, {
	      key: "_animateCaptionIn",
	      value: function _animateCaptionIn(caption, duration) {
	        var animOptions = {
	          targets: caption,
	          opacity: 0,
	          duration: duration,
	          easing: 'easeOutQuad'
	        };
	
	        if ($(caption).hasClass('center-align')) {
	          animOptions.translateY = -100;
	        } else if ($(caption).hasClass('right-align')) {
	          animOptions.translateX = 100;
	        } else if ($(caption).hasClass('left-align')) {
	          animOptions.translateX = -100;
	        }
	
	        anim(animOptions);
	      }
	
	      /**
	       * Set height of slider
	       */
	
	    }, {
	      key: "_setSliderHeight",
	      value: function _setSliderHeight() {
	        // If fullscreen, do nothing
	        if (!this.$el.hasClass('fullscreen')) {
	          if (this.options.indicators) {
	            // Add height if indicators are present
	            this.$el.css('height', this.options.height + 40 + 'px');
	          } else {
	            this.$el.css('height', this.options.height + 'px');
	          }
	          this.$slider.css('height', this.options.height + 'px');
	        }
	      }
	
	      /**
	       * Setup indicators
	       */
	
	    }, {
	      key: "_setupIndicators",
	      value: function _setupIndicators() {
	        var _this43 = this;
	
	        if (this.options.indicators) {
	          this.$indicators = $('<ul class="indicators"></ul>');
	          this.$slides.each(function (el, index) {
	            var $indicator = $('<li class="indicator-item"></li>');
	            _this43.$indicators.append($indicator[0]);
	          });
	          this.$el.append(this.$indicators[0]);
	          this.$indicators = this.$indicators.children('li.indicator-item');
	        }
	      }
	
	      /**
	       * Remove indicators
	       */
	
	    }, {
	      key: "_removeIndicators",
	      value: function _removeIndicators() {
	        this.$el.find('ul.indicators').remove();
	      }
	
	      /**
	       * Cycle to nth item
	       * @param {Number} index
	       */
	
	    }, {
	      key: "set",
	      value: function set(index) {
	        var _this44 = this;
	
	        // Wrap around indices.
	        if (index >= this.$slides.length) index = 0;else if (index < 0) index = this.$slides.length - 1;
	
	        // Only do if index changes
	        if (this.activeIndex != index) {
	          this.$active = this.$slides.eq(this.activeIndex);
	          var $caption = this.$active.find('.caption');
	          this.$active.removeClass('active');
	
	          anim({
	            targets: this.$active[0],
	            opacity: 0,
	            duration: this.options.duration,
	            easing: 'easeOutQuad',
	            complete: function complete() {
	              _this44.$slides.not('.active').each(function (el) {
	                anim({
	                  targets: el,
	                  opacity: 0,
	                  translateX: 0,
	                  translateY: 0,
	                  duration: 0,
	                  easing: 'easeOutQuad'
	                });
	              });
	            }
	          });
	
	          this._animateCaptionIn($caption[0], this.options.duration);
	
	          // Update indicators
	          if (this.options.indicators) {
	            this.$indicators.eq(this.activeIndex).removeClass('active');
	            this.$indicators.eq(index).addClass('active');
	          }
	
	          anim({
	            targets: this.$slides.eq(index)[0],
	            opacity: 1,
	            duration: this.options.duration,
	            easing: 'easeOutQuad'
	          });
	
	          anim({
	            targets: this.$slides.eq(index).find('.caption')[0],
	            opacity: 1,
	            translateX: 0,
	            translateY: 0,
	            duration: this.options.duration,
	            delay: this.options.duration,
	            easing: 'easeOutQuad'
	          });
	
	          this.$slides.eq(index).addClass('active');
	          this.activeIndex = index;
	
	          // Reset interval
	          this.start();
	        }
	      }
	
	      /**
	       * Pause slider interval
	       */
	
	    }, {
	      key: "pause",
	      value: function pause() {
	        clearInterval(this.interval);
	      }
	
	      /**
	       * Start slider interval
	       */
	
	    }, {
	      key: "start",
	      value: function start() {
	        clearInterval(this.interval);
	        this.interval = setInterval(this._handleIntervalBound, this.options.duration + this.options.interval);
	      }
	
	      /**
	       * Move to next slide
	       */
	
	    }, {
	      key: "next",
	      value: function next() {
	        var newIndex = this.activeIndex + 1;
	
	        // Wrap around indices.
	        if (newIndex >= this.$slides.length) newIndex = 0;else if (newIndex < 0) newIndex = this.$slides.length - 1;
	
	        this.set(newIndex);
	      }
	
	      /**
	       * Move to previous slide
	       */
	
	    }, {
	      key: "prev",
	      value: function prev() {
	        var newIndex = this.activeIndex - 1;
	
	        // Wrap around indices.
	        if (newIndex >= this.$slides.length) newIndex = 0;else if (newIndex < 0) newIndex = this.$slides.length - 1;
	
	        this.set(newIndex);
	      }
	    }], [{
	      key: "init",
	      value: function init(els, options) {
	        return _get(Slider.__proto__ || Object.getPrototypeOf(Slider), "init", this).call(this, this, els, options);
	      }
	
	      /**
	       * Get Instance
	       */
	
	    }, {
	      key: "getInstance",
	      value: function getInstance(el) {
	        var domElem = !!el.jquery ? el[0] : el;
	        return domElem.M_Slider;
	      }
	    }, {
	      key: "defaults",
	      get: function get() {
	        return _defaults;
	      }
	    }]);
	
	    return Slider;
	  }(Component);
	
	  M.Slider = Slider;
	
	  if (M.jQueryLoaded) {
	    M.initializeJqueryWrapper(Slider, 'slider', 'M_Slider');
	  }
	})(cash, M.anime);
	;(function ($, anim) {
	  $(document).on('click', '.card', function (e) {
	    if ($(this).children('.card-reveal').length) {
	      var $card = $(e.target).closest('.card');
	      if ($card.data('initialOverflow') === undefined) {
	        $card.data('initialOverflow', $card.css('overflow') === undefined ? '' : $card.css('overflow'));
	      }
	      var $cardReveal = $(this).find('.card-reveal');
	      if ($(e.target).is($('.card-reveal .card-title')) || $(e.target).is($('.card-reveal .card-title i'))) {
	        // Make Reveal animate down and display none
	        anim({
	          targets: $cardReveal[0],
	          translateY: 0,
	          duration: 225,
	          easing: 'easeInOutQuad',
	          complete: function complete(anim) {
	            var el = anim.animatables[0].target;
	            $(el).css({ display: 'none' });
	            $card.css('overflow', $card.data('initialOverflow'));
	          }
	        });
	      } else if ($(e.target).is($('.card .activator')) || $(e.target).is($('.card .activator i'))) {
	        $card.css('overflow', 'hidden');
	        $cardReveal.css({ display: 'block' });
	        anim({
	          targets: $cardReveal[0],
	          translateY: '-100%',
	          duration: 300,
	          easing: 'easeInOutQuad'
	        });
	      }
	    }
	  });
	})(cash, M.anime);
	;(function ($) {
	  'use strict';
	
	  var _defaults = {
	    data: [],
	    placeholder: '',
	    secondaryPlaceholder: '',
	    autocompleteOptions: {},
	    limit: Infinity,
	    onChipAdd: null,
	    onChipSelect: null,
	    onChipDelete: null
	  };
	
	  /**
	   * @typedef {Object} chip
	   * @property {String} tag  chip tag string
	   * @property {String} [image]  chip avatar image string
	   */
	
	  /**
	   * @class
	   *
	   */
	
	  var Chips = function (_Component12) {
	    _inherits(Chips, _Component12);
	
	    /**
	     * Construct Chips instance and set up overlay
	     * @constructor
	     * @param {Element} el
	     * @param {Object} options
	     */
	    function Chips(el, options) {
	      _classCallCheck(this, Chips);
	
	      var _this45 = _possibleConstructorReturn(this, (Chips.__proto__ || Object.getPrototypeOf(Chips)).call(this, Chips, el, options));
	
	      _this45.el.M_Chips = _this45;
	
	      /**
	       * Options for the modal
	       * @member Chips#options
	       * @prop {Array} data
	       * @prop {String} placeholder
	       * @prop {String} secondaryPlaceholder
	       * @prop {Object} autocompleteOptions
	       */
	      _this45.options = $.extend({}, Chips.defaults, options);
	
	      _this45.$el.addClass('chips input-field');
	      _this45.chipsData = [];
	      _this45.$chips = $();
	      _this45._setupInput();
	      _this45.hasAutocomplete = Object.keys(_this45.options.autocompleteOptions).length > 0;
	
	      // Set input id
	      if (!_this45.$input.attr('id')) {
	        _this45.$input.attr('id', M.guid());
	      }
	
	      // Render initial chips
	      if (_this45.options.data.length) {
	        _this45.chipsData = _this45.options.data;
	        _this45._renderChips(_this45.chipsData);
	      }
	
	      // Setup autocomplete if needed
	      if (_this45.hasAutocomplete) {
	        _this45._setupAutocomplete();
	      }
	
	      _this45._setPlaceholder();
	      _this45._setupLabel();
	      _this45._setupEventHandlers();
	      return _this45;
	    }
	
	    _createClass(Chips, [{
	      key: "getData",
	
	      /**
	       * Get Chips Data
	       */
	      value: function getData() {
	        return this.chipsData;
	      }
	
	      /**
	       * Teardown component
	       */
	
	    }, {
	      key: "destroy",
	      value: function destroy() {
	        this._removeEventHandlers();
	        this.$chips.remove();
	        this.el.M_Chips = undefined;
	      }
	
	      /**
	       * Setup Event Handlers
	       */
	
	    }, {
	      key: "_setupEventHandlers",
	      value: function _setupEventHandlers() {
	        this._handleChipClickBound = this._handleChipClick.bind(this);
	        this._handleInputKeydownBound = this._handleInputKeydown.bind(this);
	        this._handleInputFocusBound = this._handleInputFocus.bind(this);
	        this._handleInputBlurBound = this._handleInputBlur.bind(this);
	
	        this.el.addEventListener('click', this._handleChipClickBound);
	        document.addEventListener('keydown', Chips._handleChipsKeydown);
	        document.addEventListener('keyup', Chips._handleChipsKeyup);
	        this.el.addEventListener('blur', Chips._handleChipsBlur, true);
	        this.$input[0].addEventListener('focus', this._handleInputFocusBound);
	        this.$input[0].addEventListener('blur', this._handleInputBlurBound);
	        this.$input[0].addEventListener('keydown', this._handleInputKeydownBound);
	      }
	
	      /**
	       * Remove Event Handlers
	       */
	
	    }, {
	      key: "_removeEventHandlers",
	      value: function _removeEventHandlers() {
	        this.el.removeEventListener('click', this._handleChipClickBound);
	        document.removeEventListener('keydown', Chips._handleChipsKeydown);
	        document.removeEventListener('keyup', Chips._handleChipsKeyup);
	        this.el.removeEventListener('blur', Chips._handleChipsBlur, true);
	        this.$input[0].removeEventListener('focus', this._handleInputFocusBound);
	        this.$input[0].removeEventListener('blur', this._handleInputBlurBound);
	        this.$input[0].removeEventListener('keydown', this._handleInputKeydownBound);
	      }
	
	      /**
	       * Handle Chip Click
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleChipClick",
	      value: function _handleChipClick(e) {
	        var $chip = $(e.target).closest('.chip');
	        var clickedClose = $(e.target).is('.close');
	        if ($chip.length) {
	          var index = $chip.index();
	          if (clickedClose) {
	            // delete chip
	            this.deleteChip(index);
	            this.$input[0].focus();
	          } else {
	            // select chip
	            this.selectChip(index);
	          }
	
	          // Default handle click to focus on input
	        } else {
	          this.$input[0].focus();
	        }
	      }
	
	      /**
	       * Handle Chips Keydown
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleInputFocus",
	
	      /**
	       * Handle Input Focus
	       */
	      value: function _handleInputFocus() {
	        this.$el.addClass('focus');
	      }
	
	      /**
	       * Handle Input Blur
	       */
	
	    }, {
	      key: "_handleInputBlur",
	      value: function _handleInputBlur() {
	        this.$el.removeClass('focus');
	      }
	
	      /**
	       * Handle Input Keydown
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleInputKeydown",
	      value: function _handleInputKeydown(e) {
	        Chips._keydown = true;
	
	        // enter
	        if (e.keyCode === 13) {
	          // Override enter if autocompleting.
	          if (this.hasAutocomplete && this.autocomplete && this.autocomplete.isOpen) {
	            return;
	          }
	
	          e.preventDefault();
	          this.addChip({
	            tag: this.$input[0].value
	          });
	          this.$input[0].value = '';
	
	          // delete or left
	        } else if ((e.keyCode === 8 || e.keyCode === 37) && this.$input[0].value === '' && this.chipsData.length) {
	          e.preventDefault();
	          this.selectChip(this.chipsData.length - 1);
	        }
	      }
	
	      /**
	       * Render Chip
	       * @param {chip} chip
	       * @return {Element}
	       */
	
	    }, {
	      key: "_renderChip",
	      value: function _renderChip(chip) {
	        if (!chip.tag) {
	          return;
	        }
	
	        var renderedChip = document.createElement('div');
	        var closeIcon = document.createElement('i');
	        renderedChip.classList.add('chip');
	        renderedChip.textContent = chip.tag;
	        renderedChip.setAttribute('tabindex', 0);
	        $(closeIcon).addClass('material-icons close');
	        closeIcon.textContent = 'close';
	
	        // attach image if needed
	        if (chip.image) {
	          var img = document.createElement('img');
	          img.setAttribute('src', chip.image);
	          renderedChip.insertBefore(img, renderedChip.firstChild);
	        }
	
	        renderedChip.appendChild(closeIcon);
	        return renderedChip;
	      }
	
	      /**
	       * Render Chips
	       */
	
	    }, {
	      key: "_renderChips",
	      value: function _renderChips() {
	        this.$chips.remove();
	        for (var i = 0; i < this.chipsData.length; i++) {
	          var chipEl = this._renderChip(this.chipsData[i]);
	          this.$el.append(chipEl);
	          this.$chips.add(chipEl);
	        }
	
	        // move input to end
	        this.$el.append(this.$input[0]);
	      }
	
	      /**
	       * Setup Autocomplete
	       */
	
	    }, {
	      key: "_setupAutocomplete",
	      value: function _setupAutocomplete() {
	        var _this46 = this;
	
	        this.options.autocompleteOptions.onAutocomplete = function (val) {
	          _this46.addChip({
	            tag: val
	          });
	          _this46.$input[0].value = '';
	          _this46.$input[0].focus();
	        };
	
	        this.autocomplete = M.Autocomplete.init(this.$input[0], this.options.autocompleteOptions);
	      }
	
	      /**
	       * Setup Input
	       */
	
	    }, {
	      key: "_setupInput",
	      value: function _setupInput() {
	        this.$input = this.$el.find('input');
	        if (!this.$input.length) {
	          this.$input = $('<input></input>');
	          this.$el.append(this.$input);
	        }
	
	        this.$input.addClass('input');
	      }
	
	      /**
	       * Setup Label
	       */
	
	    }, {
	      key: "_setupLabel",
	      value: function _setupLabel() {
	        this.$label = this.$el.find('label');
	        if (this.$label.length) {
	          this.$label.setAttribute('for', this.$input.attr('id'));
	        }
	      }
	
	      /**
	       * Set placeholder
	       */
	
	    }, {
	      key: "_setPlaceholder",
	      value: function _setPlaceholder() {
	        if (this.chipsData !== undefined && !this.chipsData.length && this.options.placeholder) {
	          $(this.$input).prop('placeholder', this.options.placeholder);
	        } else if ((this.chipsData === undefined || !!this.chipsData.length) && this.options.secondaryPlaceholder) {
	          $(this.$input).prop('placeholder', this.options.secondaryPlaceholder);
	        }
	      }
	
	      /**
	       * Check if chip is valid
	       * @param {chip} chip
	       */
	
	    }, {
	      key: "_isValid",
	      value: function _isValid(chip) {
	        if (chip.hasOwnProperty('tag') && chip.tag !== '') {
	          var exists = false;
	          for (var i = 0; i < this.chipsData.length; i++) {
	            if (this.chipsData[i].tag === chip.tag) {
	              exists = true;
	              break;
	            }
	          }
	          return !exists;
	        }
	
	        return false;
	      }
	
	      /**
	       * Add chip
	       * @param {chip} chip
	       */
	
	    }, {
	      key: "addChip",
	      value: function addChip(chip) {
	        if (!this._isValid(chip) || this.chipsData.length >= this.options.limit) {
	          return;
	        }
	
	        var renderedChip = this._renderChip(chip);
	        this.$chips.add(renderedChip);
	        this.chipsData.push(chip);
	        $(this.$input).before(renderedChip);
	        this._setPlaceholder();
	
	        // fire chipAdd callback
	        if (typeof this.options.onChipAdd === 'function') {
	          this.options.onChipAdd.call(this, this.$el, renderedChip);
	        }
	      }
	
	      /**
	       * Delete chip
	       * @param {Number} chip
	       */
	
	    }, {
	      key: "deleteChip",
	      value: function deleteChip(chipIndex) {
	        var $chip = this.$chips.eq(chipIndex);
	        this.$chips.eq(chipIndex).remove();
	        this.$chips = this.$chips.filter(function (el) {
	          return $(el).index() >= 0;
	        });
	        this.chipsData.splice(chipIndex, 1);
	        this._setPlaceholder();
	
	        // fire chipDelete callback
	        if (typeof this.options.onChipDelete === 'function') {
	          this.options.onChipDelete.call(this, this.$el, $chip[0]);
	        }
	      }
	
	      /**
	       * Select chip
	       * @param {Number} chip
	       */
	
	    }, {
	      key: "selectChip",
	      value: function selectChip(chipIndex) {
	        var $chip = this.$chips.eq(chipIndex);
	        this._selectedChip = $chip;
	        $chip[0].focus();
	
	        // fire chipSelect callback
	        if (typeof this.options.onChipSelect === 'function') {
	          this.options.onChipSelect.call(this, this.$el, $chip[0]);
	        }
	      }
	    }], [{
	      key: "init",
	      value: function init(els, options) {
	        return _get(Chips.__proto__ || Object.getPrototypeOf(Chips), "init", this).call(this, this, els, options);
	      }
	
	      /**
	       * Get Instance
	       */
	
	    }, {
	      key: "getInstance",
	      value: function getInstance(el) {
	        var domElem = !!el.jquery ? el[0] : el;
	        return domElem.M_Chips;
	      }
	    }, {
	      key: "_handleChipsKeydown",
	      value: function _handleChipsKeydown(e) {
	        Chips._keydown = true;
	
	        var $chips = $(e.target).closest('.chips');
	        var chipsKeydown = e.target && $chips.length;
	
	        // Don't handle keydown inputs on input and textarea
	        if ($(e.target).is('input, textarea') || !chipsKeydown) {
	          return;
	        }
	
	        var currChips = $chips[0].M_Chips;
	
	        // backspace and delete
	        if (e.keyCode === 8 || e.keyCode === 46) {
	          e.preventDefault();
	
	          var selectIndex = currChips.chipsData.length;
	          if (currChips._selectedChip) {
	            var index = currChips._selectedChip.index();
	            currChips.deleteChip(index);
	            currChips._selectedChip = null;
	
	            // Make sure selectIndex doesn't go negative
	            selectIndex = Math.max(index - 1, 0);
	          }
	
	          if (currChips.chipsData.length) {
	            currChips.selectChip(selectIndex);
	          }
	
	          // left arrow key
	        } else if (e.keyCode === 37) {
	          if (currChips._selectedChip) {
	            var _selectIndex = currChips._selectedChip.index() - 1;
	            if (_selectIndex < 0) {
	              return;
	            }
	            currChips.selectChip(_selectIndex);
	          }
	
	          // right arrow key
	        } else if (e.keyCode === 39) {
	          if (currChips._selectedChip) {
	            var _selectIndex2 = currChips._selectedChip.index() + 1;
	
	            if (_selectIndex2 >= currChips.chipsData.length) {
	              currChips.$input[0].focus();
	            } else {
	              currChips.selectChip(_selectIndex2);
	            }
	          }
	        }
	      }
	
	      /**
	       * Handle Chips Keyup
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleChipsKeyup",
	      value: function _handleChipsKeyup(e) {
	        Chips._keydown = false;
	      }
	
	      /**
	       * Handle Chips Blur
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleChipsBlur",
	      value: function _handleChipsBlur(e) {
	        if (!Chips._keydown) {
	          var $chips = $(e.target).closest('.chips');
	          var currChips = $chips[0].M_Chips;
	
	          currChips._selectedChip = null;
	        }
	      }
	    }, {
	      key: "defaults",
	      get: function get() {
	        return _defaults;
	      }
	    }]);
	
	    return Chips;
	  }(Component);
	
	  /**
	   * @static
	   * @memberof Chips
	   */
	
	  Chips._keydown = false;
	
	  M.Chips = Chips;
	
	  if (M.jQueryLoaded) {
	    M.initializeJqueryWrapper(Chips, 'chips', 'M_Chips');
	  }
	
	  $(document).ready(function () {
	    // Handle removal of static chips.
	    $(document.body).on('click', '.chip .close', function () {
	      var $chips = $(this).closest('.chips');
	      if ($chips.length && $chips[0].M_Chips) {
	        return;
	      }
	      $(this).closest('.chip').remove();
	    });
	  });
	})(cash);
	;(function ($) {
	  'use strict';
	
	  var _defaults = {
	    top: 0,
	    bottom: Infinity,
	    offset: 0,
	    onPositionChange: null
	  };
	
	  /**
	   * @class
	   *
	   */
	
	  var Pushpin = function (_Component13) {
	    _inherits(Pushpin, _Component13);
	
	    /**
	     * Construct Pushpin instance
	     * @constructor
	     * @param {Element} el
	     * @param {Object} options
	     */
	    function Pushpin(el, options) {
	      _classCallCheck(this, Pushpin);
	
	      var _this47 = _possibleConstructorReturn(this, (Pushpin.__proto__ || Object.getPrototypeOf(Pushpin)).call(this, Pushpin, el, options));
	
	      _this47.el.M_Pushpin = _this47;
	
	      /**
	       * Options for the modal
	       * @member Pushpin#options
	       */
	      _this47.options = $.extend({}, Pushpin.defaults, options);
	
	      _this47.originalOffset = _this47.el.offsetTop;
	      Pushpin._pushpins.push(_this47);
	      _this47._setupEventHandlers();
	      _this47._updatePosition();
	      return _this47;
	    }
	
	    _createClass(Pushpin, [{
	      key: "destroy",
	
	      /**
	       * Teardown component
	       */
	      value: function destroy() {
	        this.el.style.top = null;
	        this._removePinClasses();
	        this._removeEventHandlers();
	
	        // Remove pushpin Inst
	        var index = Pushpin._pushpins.indexOf(this);
	        Pushpin._pushpins.splice(index, 1);
	      }
	    }, {
	      key: "_setupEventHandlers",
	      value: function _setupEventHandlers() {
	        document.addEventListener('scroll', Pushpin._updateElements);
	      }
	    }, {
	      key: "_removeEventHandlers",
	      value: function _removeEventHandlers() {
	        document.removeEventListener('scroll', Pushpin._updateElements);
	      }
	    }, {
	      key: "_updatePosition",
	      value: function _updatePosition() {
	        var scrolled = M.getDocumentScrollTop() + this.options.offset;
	
	        if (this.options.top <= scrolled && this.options.bottom >= scrolled && !this.el.classList.contains('pinned')) {
	          this._removePinClasses();
	          this.el.style.top = this.options.offset + "px";
	          this.el.classList.add('pinned');
	
	          // onPositionChange callback
	          if (typeof this.options.onPositionChange === 'function') {
	            this.options.onPositionChange.call(this, 'pinned');
	          }
	        }
	
	        // Add pin-top (when scrolled position is above top)
	        if (scrolled < this.options.top && !this.el.classList.contains('pin-top')) {
	          this._removePinClasses();
	          this.el.style.top = 0;
	          this.el.classList.add('pin-top');
	
	          // onPositionChange callback
	          if (typeof this.options.onPositionChange === 'function') {
	            this.options.onPositionChange.call(this, 'pin-top');
	          }
	        }
	
	        // Add pin-bottom (when scrolled position is below bottom)
	        if (scrolled > this.options.bottom && !this.el.classList.contains('pin-bottom')) {
	          this._removePinClasses();
	          this.el.classList.add('pin-bottom');
	          this.el.style.top = this.options.bottom - this.originalOffset + "px";
	
	          // onPositionChange callback
	          if (typeof this.options.onPositionChange === 'function') {
	            this.options.onPositionChange.call(this, 'pin-bottom');
	          }
	        }
	      }
	    }, {
	      key: "_removePinClasses",
	      value: function _removePinClasses() {
	        // IE 11 bug (can't remove multiple classes in one line)
	        this.el.classList.remove('pin-top');
	        this.el.classList.remove('pinned');
	        this.el.classList.remove('pin-bottom');
	      }
	    }], [{
	      key: "init",
	      value: function init(els, options) {
	        return _get(Pushpin.__proto__ || Object.getPrototypeOf(Pushpin), "init", this).call(this, this, els, options);
	      }
	
	      /**
	       * Get Instance
	       */
	
	    }, {
	      key: "getInstance",
	      value: function getInstance(el) {
	        var domElem = !!el.jquery ? el[0] : el;
	        return domElem.M_Pushpin;
	      }
	    }, {
	      key: "_updateElements",
	      value: function _updateElements() {
	        for (var elIndex in Pushpin._pushpins) {
	          var pInstance = Pushpin._pushpins[elIndex];
	          pInstance._updatePosition();
	        }
	      }
	    }, {
	      key: "defaults",
	      get: function get() {
	        return _defaults;
	      }
	    }]);
	
	    return Pushpin;
	  }(Component);
	
	  /**
	   * @static
	   * @memberof Pushpin
	   */
	
	  Pushpin._pushpins = [];
	
	  M.Pushpin = Pushpin;
	
	  if (M.jQueryLoaded) {
	    M.initializeJqueryWrapper(Pushpin, 'pushpin', 'M_Pushpin');
	  }
	})(cash);
	;(function ($, anim) {
	  'use strict';
	
	  var _defaults = {
	    direction: 'top',
	    hoverEnabled: true,
	    toolbarEnabled: false
	  };
	
	  $.fn.reverse = [].reverse;
	
	  /**
	   * @class
	   *
	   */
	
	  var FloatingActionButton = function (_Component14) {
	    _inherits(FloatingActionButton, _Component14);
	
	    /**
	     * Construct FloatingActionButton instance
	     * @constructor
	     * @param {Element} el
	     * @param {Object} options
	     */
	    function FloatingActionButton(el, options) {
	      _classCallCheck(this, FloatingActionButton);
	
	      var _this48 = _possibleConstructorReturn(this, (FloatingActionButton.__proto__ || Object.getPrototypeOf(FloatingActionButton)).call(this, FloatingActionButton, el, options));
	
	      _this48.el.M_FloatingActionButton = _this48;
	
	      /**
	       * Options for the fab
	       * @member FloatingActionButton#options
	       * @prop {Boolean} [direction] - Direction fab menu opens
	       * @prop {Boolean} [hoverEnabled=true] - Enable hover vs click
	       * @prop {Boolean} [toolbarEnabled=false] - Enable toolbar transition
	       */
	      _this48.options = $.extend({}, FloatingActionButton.defaults, options);
	
	      _this48.isOpen = false;
	      _this48.$anchor = _this48.$el.children('a').first();
	      _this48.$menu = _this48.$el.children('ul').first();
	      _this48.$floatingBtns = _this48.$el.find('ul .btn-floating');
	      _this48.$floatingBtnsReverse = _this48.$el.find('ul .btn-floating').reverse();
	      _this48.offsetY = 0;
	      _this48.offsetX = 0;
	
	      _this48.$el.addClass("direction-" + _this48.options.direction);
	      if (_this48.options.direction === 'top') {
	        _this48.offsetY = 40;
	      } else if (_this48.options.direction === 'right') {
	        _this48.offsetX = -40;
	      } else if (_this48.options.direction === 'bottom') {
	        _this48.offsetY = -40;
	      } else {
	        _this48.offsetX = 40;
	      }
	      _this48._setupEventHandlers();
	      return _this48;
	    }
	
	    _createClass(FloatingActionButton, [{
	      key: "destroy",
	
	      /**
	       * Teardown component
	       */
	      value: function destroy() {
	        this._removeEventHandlers();
	        this.el.M_FloatingActionButton = undefined;
	      }
	
	      /**
	       * Setup Event Handlers
	       */
	
	    }, {
	      key: "_setupEventHandlers",
	      value: function _setupEventHandlers() {
	        this._handleFABClickBound = this._handleFABClick.bind(this);
	        this._handleOpenBound = this.open.bind(this);
	        this._handleCloseBound = this.close.bind(this);
	
	        if (this.options.hoverEnabled && !this.options.toolbarEnabled) {
	          this.el.addEventListener('mouseenter', this._handleOpenBound);
	          this.el.addEventListener('mouseleave', this._handleCloseBound);
	        } else {
	          this.el.addEventListener('click', this._handleFABClickBound);
	        }
	      }
	
	      /**
	       * Remove Event Handlers
	       */
	
	    }, {
	      key: "_removeEventHandlers",
	      value: function _removeEventHandlers() {
	        if (this.options.hoverEnabled && !this.options.toolbarEnabled) {
	          this.el.removeEventListener('mouseenter', this._handleOpenBound);
	          this.el.removeEventListener('mouseleave', this._handleCloseBound);
	        } else {
	          this.el.removeEventListener('click', this._handleFABClickBound);
	        }
	      }
	
	      /**
	       * Handle FAB Click
	       */
	
	    }, {
	      key: "_handleFABClick",
	      value: function _handleFABClick() {
	        if (this.isOpen) {
	          this.close();
	        } else {
	          this.open();
	        }
	      }
	
	      /**
	       * Handle Document Click
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleDocumentClick",
	      value: function _handleDocumentClick(e) {
	        if (!$(e.target).closest(this.$menu).length) {
	          this.close();
	        }
	      }
	
	      /**
	       * Open FAB
	       */
	
	    }, {
	      key: "open",
	      value: function open() {
	        if (this.isOpen) {
	          return;
	        }
	
	        if (this.options.toolbarEnabled) {
	          this._animateInToolbar();
	        } else {
	          this._animateInFAB();
	        }
	        this.isOpen = true;
	      }
	
	      /**
	       * Close FAB
	       */
	
	    }, {
	      key: "close",
	      value: function close() {
	        if (!this.isOpen) {
	          return;
	        }
	
	        if (this.options.toolbarEnabled) {
	          window.removeEventListener('scroll', this._handleCloseBound, true);
	          document.body.removeEventListener('click', this._handleDocumentClickBound, true);
	          this._animateOutToolbar();
	        } else {
	          this._animateOutFAB();
	        }
	        this.isOpen = false;
	      }
	
	      /**
	       * Classic FAB Menu open
	       */
	
	    }, {
	      key: "_animateInFAB",
	      value: function _animateInFAB() {
	        var _this49 = this;
	
	        this.$el.addClass('active');
	
	        var time = 0;
	        this.$floatingBtnsReverse.each(function (el) {
	          anim({
	            targets: el,
	            opacity: 1,
	            scale: [0.4, 1],
	            translateY: [_this49.offsetY, 0],
	            translateX: [_this49.offsetX, 0],
	            duration: 275,
	            delay: time,
	            easing: 'easeInOutQuad'
	          });
	          time += 40;
	        });
	      }
	
	      /**
	       * Classic FAB Menu close
	       */
	
	    }, {
	      key: "_animateOutFAB",
	      value: function _animateOutFAB() {
	        var _this50 = this;
	
	        this.$floatingBtnsReverse.each(function (el) {
	          anim.remove(el);
	          anim({
	            targets: el,
	            opacity: 0,
	            scale: 0.4,
	            translateY: _this50.offsetY,
	            translateX: _this50.offsetX,
	            duration: 175,
	            easing: 'easeOutQuad',
	            complete: function complete() {
	              _this50.$el.removeClass('active');
	            }
	          });
	        });
	      }
	
	      /**
	       * Toolbar transition Menu open
	       */
	
	    }, {
	      key: "_animateInToolbar",
	      value: function _animateInToolbar() {
	        var _this51 = this;
	
	        var scaleFactor = void 0;
	        var windowWidth = window.innerWidth;
	        var windowHeight = window.innerHeight;
	        var btnRect = this.el.getBoundingClientRect();
	        var backdrop = $('<div class="fab-backdrop"></div>');
	        var fabColor = this.$anchor.css('background-color');
	        this.$anchor.append(backdrop);
	
	        this.offsetX = btnRect.left - windowWidth / 2 + btnRect.width / 2;
	        this.offsetY = windowHeight - btnRect.bottom;
	        scaleFactor = windowWidth / backdrop[0].clientWidth;
	        this.btnBottom = btnRect.bottom;
	        this.btnLeft = btnRect.left;
	        this.btnWidth = btnRect.width;
	
	        // Set initial state
	        this.$el.addClass('active');
	        this.$el.css({
	          'text-align': 'center',
	          width: '100%',
	          bottom: 0,
	          left: 0,
	          transform: 'translateX(' + this.offsetX + 'px)',
	          transition: 'none'
	        });
	        this.$anchor.css({
	          transform: 'translateY(' + -this.offsetY + 'px)',
	          transition: 'none'
	        });
	        backdrop.css({
	          'background-color': fabColor
	        });
	
	        setTimeout(function () {
	          _this51.$el.css({
	            transform: '',
	            transition: 'transform .2s cubic-bezier(0.550, 0.085, 0.680, 0.530), background-color 0s linear .2s'
	          });
	          _this51.$anchor.css({
	            overflow: 'visible',
	            transform: '',
	            transition: 'transform .2s'
	          });
	
	          setTimeout(function () {
	            _this51.$el.css({
	              overflow: 'hidden',
	              'background-color': fabColor
	            });
	            backdrop.css({
	              transform: 'scale(' + scaleFactor + ')',
	              transition: 'transform .2s cubic-bezier(0.550, 0.055, 0.675, 0.190)'
	            });
	            _this51.$menu.children('li').children('a').css({
	              opacity: 1
	            });
	
	            // Scroll to close.
	            _this51._handleDocumentClickBound = _this51._handleDocumentClick.bind(_this51);
	            window.addEventListener('scroll', _this51._handleCloseBound, true);
	            document.body.addEventListener('click', _this51._handleDocumentClickBound, true);
	          }, 100);
	        }, 0);
	      }
	
	      /**
	       * Toolbar transition Menu close
	       */
	
	    }, {
	      key: "_animateOutToolbar",
	      value: function _animateOutToolbar() {
	        var _this52 = this;
	
	        var windowWidth = window.innerWidth;
	        var windowHeight = window.innerHeight;
	        var backdrop = this.$el.find('.fab-backdrop');
	        var fabColor = this.$anchor.css('background-color');
	
	        this.offsetX = this.btnLeft - windowWidth / 2 + this.btnWidth / 2;
	        this.offsetY = windowHeight - this.btnBottom;
	
	        // Hide backdrop
	        this.$el.removeClass('active');
	        this.$el.css({
	          'background-color': 'transparent',
	          transition: 'none'
	        });
	        this.$anchor.css({
	          transition: 'none'
	        });
	        backdrop.css({
	          transform: 'scale(0)',
	          'background-color': fabColor
	        });
	        this.$menu.children('li').children('a').css({
	          opacity: ''
	        });
	
	        setTimeout(function () {
	          backdrop.remove();
	
	          // Set initial state.
	          _this52.$el.css({
	            'text-align': '',
	            width: '',
	            bottom: '',
	            left: '',
	            overflow: '',
	            'background-color': '',
	            transform: 'translate3d(' + -_this52.offsetX + 'px,0,0)'
	          });
	          _this52.$anchor.css({
	            overflow: '',
	            transform: 'translate3d(0,' + _this52.offsetY + 'px,0)'
	          });
	
	          setTimeout(function () {
	            _this52.$el.css({
	              transform: 'translate3d(0,0,0)',
	              transition: 'transform .2s'
	            });
	            _this52.$anchor.css({
	              transform: 'translate3d(0,0,0)',
	              transition: 'transform .2s cubic-bezier(0.550, 0.055, 0.675, 0.190)'
	            });
	          }, 20);
	        }, 200);
	      }
	    }], [{
	      key: "init",
	      value: function init(els, options) {
	        return _get(FloatingActionButton.__proto__ || Object.getPrototypeOf(FloatingActionButton), "init", this).call(this, this, els, options);
	      }
	
	      /**
	       * Get Instance
	       */
	
	    }, {
	      key: "getInstance",
	      value: function getInstance(el) {
	        var domElem = !!el.jquery ? el[0] : el;
	        return domElem.M_FloatingActionButton;
	      }
	    }, {
	      key: "defaults",
	      get: function get() {
	        return _defaults;
	      }
	    }]);
	
	    return FloatingActionButton;
	  }(Component);
	
	  M.FloatingActionButton = FloatingActionButton;
	
	  if (M.jQueryLoaded) {
	    M.initializeJqueryWrapper(FloatingActionButton, 'floatingActionButton', 'M_FloatingActionButton');
	  }
	})(cash, M.anime);
	;(function ($) {
	  'use strict';
	
	  var _defaults = {
	    // Close when date is selected
	    autoClose: false,
	
	    // the default output format for the input field value
	    format: 'mmm dd, yyyy',
	
	    // Used to create date object from current input string
	    parse: null,
	
	    // The initial date to view when first opened
	    defaultDate: null,
	
	    // Make the `defaultDate` the initial selected value
	    setDefaultDate: false,
	
	    disableWeekends: false,
	
	    disableDayFn: null,
	
	    // First day of week (0: Sunday, 1: Monday etc)
	    firstDay: 0,
	
	    // The earliest date that can be selected
	    minDate: null,
	    // Thelatest date that can be selected
	    maxDate: null,
	
	    // Number of years either side, or array of upper/lower range
	    yearRange: 10,
	
	    // used internally (don't config outside)
	    minYear: 0,
	    maxYear: 9999,
	    minMonth: undefined,
	    maxMonth: undefined,
	
	    startRange: null,
	    endRange: null,
	
	    isRTL: false,
	
	    // Render the month after year in the calendar title
	    showMonthAfterYear: false,
	
	    // Render days of the calendar grid that fall in the next or previous month
	    showDaysInNextAndPreviousMonths: false,
	
	    // Specify a DOM element to render the calendar in
	    container: null,
	
	    // Show clear button
	    showClearBtn: false,
	
	    // internationalization
	    i18n: {
	      cancel: 'Cancel',
	      clear: 'Clear',
	      done: 'Ok',
	      previousMonth: '‹',
	      nextMonth: '›',
	      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	      monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	      weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
	      weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	      weekdaysAbbrev: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
	    },
	
	    // events array
	    events: [],
	
	    // callback function
	    onSelect: null,
	    onOpen: null,
	    onClose: null,
	    onDraw: null
	  };
	
	  /**
	   * @class
	   *
	   */
	
	  var Datepicker = function (_Component15) {
	    _inherits(Datepicker, _Component15);
	
	    /**
	     * Construct Datepicker instance and set up overlay
	     * @constructor
	     * @param {Element} el
	     * @param {Object} options
	     */
	    function Datepicker(el, options) {
	      _classCallCheck(this, Datepicker);
	
	      var _this53 = _possibleConstructorReturn(this, (Datepicker.__proto__ || Object.getPrototypeOf(Datepicker)).call(this, Datepicker, el, options));
	
	      _this53.el.M_Datepicker = _this53;
	
	      _this53.options = $.extend({}, Datepicker.defaults, options);
	
	      // make sure i18n defaults are not lost when only few i18n option properties are passed
	      if (!!options && options.hasOwnProperty('i18n') && typeof options.i18n === 'object') {
	        _this53.options.i18n = $.extend({}, Datepicker.defaults.i18n, options.i18n);
	      }
	
	      // Remove time component from minDate and maxDate options
	      if (_this53.options.minDate) _this53.options.minDate.setHours(0, 0, 0, 0);
	      if (_this53.options.maxDate) _this53.options.maxDate.setHours(0, 0, 0, 0);
	
	      _this53.id = M.guid();
	
	      _this53._setupVariables();
	      _this53._insertHTMLIntoDOM();
	      _this53._setupModal();
	
	      _this53._setupEventHandlers();
	
	      if (!_this53.options.defaultDate) {
	        _this53.options.defaultDate = new Date(Date.parse(_this53.el.value));
	      }
	
	      var defDate = _this53.options.defaultDate;
	      if (Datepicker._isDate(defDate)) {
	        if (_this53.options.setDefaultDate) {
	          _this53.setDate(defDate, true);
	          _this53.setInputValue();
	        } else {
	          _this53.gotoDate(defDate);
	        }
	      } else {
	        _this53.gotoDate(new Date());
	      }
	
	      /**
	       * Describes open/close state of datepicker
	       * @type {Boolean}
	       */
	      _this53.isOpen = false;
	      return _this53;
	    }
	
	    _createClass(Datepicker, [{
	      key: "destroy",
	
	      /**
	       * Teardown component
	       */
	      value: function destroy() {
	        this._removeEventHandlers();
	        this.modal.destroy();
	        $(this.modalEl).remove();
	        this.destroySelects();
	        this.el.M_Datepicker = undefined;
	      }
	    }, {
	      key: "destroySelects",
	      value: function destroySelects() {
	        var oldYearSelect = this.calendarEl.querySelector('.orig-select-year');
	        if (oldYearSelect) {
	          M.FormSelect.getInstance(oldYearSelect).destroy();
	        }
	        var oldMonthSelect = this.calendarEl.querySelector('.orig-select-month');
	        if (oldMonthSelect) {
	          M.FormSelect.getInstance(oldMonthSelect).destroy();
	        }
	      }
	    }, {
	      key: "_insertHTMLIntoDOM",
	      value: function _insertHTMLIntoDOM() {
	        if (this.options.showClearBtn) {
	          $(this.clearBtn).css({ visibility: '' });
	          this.clearBtn.innerHTML = this.options.i18n.clear;
	        }
	
	        this.doneBtn.innerHTML = this.options.i18n.done;
	        this.cancelBtn.innerHTML = this.options.i18n.cancel;
	
	        if (this.options.container) {
	          this.$modalEl.appendTo(this.options.container);
	        } else {
	          this.$modalEl.insertBefore(this.el);
	        }
	      }
	    }, {
	      key: "_setupModal",
	      value: function _setupModal() {
	        var _this54 = this;
	
	        this.modalEl.id = 'modal-' + this.id;
	        this.modal = M.Modal.init(this.modalEl, {
	          onCloseEnd: function onCloseEnd() {
	            _this54.isOpen = false;
	          }
	        });
	      }
	    }, {
	      key: "toString",
	      value: function toString(format) {
	        var _this55 = this;
	
	        format = format || this.options.format;
	        if (!Datepicker._isDate(this.date)) {
	          return '';
	        }
	
	        var formatArray = format.split(/(d{1,4}|m{1,4}|y{4}|yy|!.)/g);
	        var formattedDate = formatArray.map(function (label) {
	          if (_this55.formats[label]) {
	            return _this55.formats[label]();
	          }
	
	          return label;
	        }).join('');
	        return formattedDate;
	      }
	    }, {
	      key: "setDate",
	      value: function setDate(date, preventOnSelect) {
	        if (!date) {
	          this.date = null;
	          this._renderDateDisplay();
	          return this.draw();
	        }
	        if (typeof date === 'string') {
	          date = new Date(Date.parse(date));
	        }
	        if (!Datepicker._isDate(date)) {
	          return;
	        }
	
	        var min = this.options.minDate,
	            max = this.options.maxDate;
	
	        if (Datepicker._isDate(min) && date < min) {
	          date = min;
	        } else if (Datepicker._isDate(max) && date > max) {
	          date = max;
	        }
	
	        this.date = new Date(date.getTime());
	
	        this._renderDateDisplay();
	
	        Datepicker._setToStartOfDay(this.date);
	        this.gotoDate(this.date);
	
	        if (!preventOnSelect && typeof this.options.onSelect === 'function') {
	          this.options.onSelect.call(this, this.date);
	        }
	      }
	    }, {
	      key: "setInputValue",
	      value: function setInputValue() {
	        this.el.value = this.toString();
	        this.$el.trigger('change', { firedBy: this });
	      }
	    }, {
	      key: "_renderDateDisplay",
	      value: function _renderDateDisplay() {
	        var displayDate = Datepicker._isDate(this.date) ? this.date : new Date();
	        var i18n = this.options.i18n;
	        var day = i18n.weekdaysShort[displayDate.getDay()];
	        var month = i18n.monthsShort[displayDate.getMonth()];
	        var date = displayDate.getDate();
	        this.yearTextEl.innerHTML = displayDate.getFullYear();
	        this.dateTextEl.innerHTML = day + ", " + month + " " + date;
	      }
	
	      /**
	       * change view to a specific date
	       */
	
	    }, {
	      key: "gotoDate",
	      value: function gotoDate(date) {
	        var newCalendar = true;
	
	        if (!Datepicker._isDate(date)) {
	          return;
	        }
	
	        if (this.calendars) {
	          var firstVisibleDate = new Date(this.calendars[0].year, this.calendars[0].month, 1),
	              lastVisibleDate = new Date(this.calendars[this.calendars.length - 1].year, this.calendars[this.calendars.length - 1].month, 1),
	              visibleDate = date.getTime();
	          // get the end of the month
	          lastVisibleDate.setMonth(lastVisibleDate.getMonth() + 1);
	          lastVisibleDate.setDate(lastVisibleDate.getDate() - 1);
	          newCalendar = visibleDate < firstVisibleDate.getTime() || lastVisibleDate.getTime() < visibleDate;
	        }
	
	        if (newCalendar) {
	          this.calendars = [{
	            month: date.getMonth(),
	            year: date.getFullYear()
	          }];
	        }
	
	        this.adjustCalendars();
	      }
	    }, {
	      key: "adjustCalendars",
	      value: function adjustCalendars() {
	        this.calendars[0] = this.adjustCalendar(this.calendars[0]);
	        this.draw();
	      }
	    }, {
	      key: "adjustCalendar",
	      value: function adjustCalendar(calendar) {
	        if (calendar.month < 0) {
	          calendar.year -= Math.ceil(Math.abs(calendar.month) / 12);
	          calendar.month += 12;
	        }
	        if (calendar.month > 11) {
	          calendar.year += Math.floor(Math.abs(calendar.month) / 12);
	          calendar.month -= 12;
	        }
	        return calendar;
	      }
	    }, {
	      key: "nextMonth",
	      value: function nextMonth() {
	        this.calendars[0].month++;
	        this.adjustCalendars();
	      }
	    }, {
	      key: "prevMonth",
	      value: function prevMonth() {
	        this.calendars[0].month--;
	        this.adjustCalendars();
	      }
	    }, {
	      key: "render",
	      value: function render(year, month, randId) {
	        var opts = this.options,
	            now = new Date(),
	            days = Datepicker._getDaysInMonth(year, month),
	            before = new Date(year, month, 1).getDay(),
	            data = [],
	            row = [];
	        Datepicker._setToStartOfDay(now);
	        if (opts.firstDay > 0) {
	          before -= opts.firstDay;
	          if (before < 0) {
	            before += 7;
	          }
	        }
	        var previousMonth = month === 0 ? 11 : month - 1,
	            nextMonth = month === 11 ? 0 : month + 1,
	            yearOfPreviousMonth = month === 0 ? year - 1 : year,
	            yearOfNextMonth = month === 11 ? year + 1 : year,
	            daysInPreviousMonth = Datepicker._getDaysInMonth(yearOfPreviousMonth, previousMonth);
	        var cells = days + before,
	            after = cells;
	        while (after > 7) {
	          after -= 7;
	        }
	        cells += 7 - after;
	        var isWeekSelected = false;
	        for (var i = 0, r = 0; i < cells; i++) {
	          var day = new Date(year, month, 1 + (i - before)),
	              isSelected = Datepicker._isDate(this.date) ? Datepicker._compareDates(day, this.date) : false,
	              isToday = Datepicker._compareDates(day, now),
	              hasEvent = opts.events.indexOf(day.toDateString()) !== -1 ? true : false,
	              isEmpty = i < before || i >= days + before,
	              dayNumber = 1 + (i - before),
	              monthNumber = month,
	              yearNumber = year,
	              isStartRange = opts.startRange && Datepicker._compareDates(opts.startRange, day),
	              isEndRange = opts.endRange && Datepicker._compareDates(opts.endRange, day),
	              isInRange = opts.startRange && opts.endRange && opts.startRange < day && day < opts.endRange,
	              isDisabled = opts.minDate && day < opts.minDate || opts.maxDate && day > opts.maxDate || opts.disableWeekends && Datepicker._isWeekend(day) || opts.disableDayFn && opts.disableDayFn(day);
	
	          if (isEmpty) {
	            if (i < before) {
	              dayNumber = daysInPreviousMonth + dayNumber;
	              monthNumber = previousMonth;
	              yearNumber = yearOfPreviousMonth;
	            } else {
	              dayNumber = dayNumber - days;
	              monthNumber = nextMonth;
	              yearNumber = yearOfNextMonth;
	            }
	          }
	
	          var dayConfig = {
	            day: dayNumber,
	            month: monthNumber,
	            year: yearNumber,
	            hasEvent: hasEvent,
	            isSelected: isSelected,
	            isToday: isToday,
	            isDisabled: isDisabled,
	            isEmpty: isEmpty,
	            isStartRange: isStartRange,
	            isEndRange: isEndRange,
	            isInRange: isInRange,
	            showDaysInNextAndPreviousMonths: opts.showDaysInNextAndPreviousMonths
	          };
	
	          row.push(this.renderDay(dayConfig));
	
	          if (++r === 7) {
	            data.push(this.renderRow(row, opts.isRTL, isWeekSelected));
	            row = [];
	            r = 0;
	            isWeekSelected = false;
	          }
	        }
	        return this.renderTable(opts, data, randId);
	      }
	    }, {
	      key: "renderDay",
	      value: function renderDay(opts) {
	        var arr = [];
	        var ariaSelected = 'false';
	        if (opts.isEmpty) {
	          if (opts.showDaysInNextAndPreviousMonths) {
	            arr.push('is-outside-current-month');
	            arr.push('is-selection-disabled');
	          } else {
	            return '<td class="is-empty"></td>';
	          }
	        }
	        if (opts.isDisabled) {
	          arr.push('is-disabled');
	        }
	
	        if (opts.isToday) {
	          arr.push('is-today');
	        }
	        if (opts.isSelected) {
	          arr.push('is-selected');
	          ariaSelected = 'true';
	        }
	        if (opts.hasEvent) {
	          arr.push('has-event');
	        }
	        if (opts.isInRange) {
	          arr.push('is-inrange');
	        }
	        if (opts.isStartRange) {
	          arr.push('is-startrange');
	        }
	        if (opts.isEndRange) {
	          arr.push('is-endrange');
	        }
	        return "<td data-day=\"" + opts.day + "\" class=\"" + arr.join(' ') + "\" aria-selected=\"" + ariaSelected + "\">" + ("<button class=\"datepicker-day-button\" type=\"button\" data-year=\"" + opts.year + "\" data-month=\"" + opts.month + "\" data-day=\"" + opts.day + "\">" + opts.day + "</button>") + '</td>';
	      }
	    }, {
	      key: "renderRow",
	      value: function renderRow(days, isRTL, isRowSelected) {
	        return '<tr class="datepicker-row' + (isRowSelected ? ' is-selected' : '') + '">' + (isRTL ? days.reverse() : days).join('') + '</tr>';
	      }
	    }, {
	      key: "renderTable",
	      value: function renderTable(opts, data, randId) {
	        return '<div class="datepicker-table-wrapper"><table cellpadding="0" cellspacing="0" class="datepicker-table" role="grid" aria-labelledby="' + randId + '">' + this.renderHead(opts) + this.renderBody(data) + '</table></div>';
	      }
	    }, {
	      key: "renderHead",
	      value: function renderHead(opts) {
	        var i = void 0,
	            arr = [];
	        for (i = 0; i < 7; i++) {
	          arr.push("<th scope=\"col\"><abbr title=\"" + this.renderDayName(opts, i) + "\">" + this.renderDayName(opts, i, true) + "</abbr></th>");
	        }
	        return '<thead><tr>' + (opts.isRTL ? arr.reverse() : arr).join('') + '</tr></thead>';
	      }
	    }, {
	      key: "renderBody",
	      value: function renderBody(rows) {
	        return '<tbody>' + rows.join('') + '</tbody>';
	      }
	    }, {
	      key: "renderTitle",
	      value: function renderTitle(instance, c, year, month, refYear, randId) {
	        var i = void 0,
	            j = void 0,
	            arr = void 0,
	            opts = this.options,
	            isMinYear = year === opts.minYear,
	            isMaxYear = year === opts.maxYear,
	            html = '<div id="' + randId + '" class="datepicker-controls" role="heading" aria-live="assertive">',
	            monthHtml = void 0,
	            yearHtml = void 0,
	            prev = true,
	            next = true;
	
	        for (arr = [], i = 0; i < 12; i++) {
	          arr.push('<option value="' + (year === refYear ? i - c : 12 + i - c) + '"' + (i === month ? ' selected="selected"' : '') + (isMinYear && i < opts.minMonth || isMaxYear && i > opts.maxMonth ? 'disabled="disabled"' : '') + '>' + opts.i18n.months[i] + '</option>');
	        }
	
	        monthHtml = '<select class="datepicker-select orig-select-month" tabindex="-1">' + arr.join('') + '</select>';
	
	        if ($.isArray(opts.yearRange)) {
	          i = opts.yearRange[0];
	          j = opts.yearRange[1] + 1;
	        } else {
	          i = year - opts.yearRange;
	          j = 1 + year + opts.yearRange;
	        }
	
	        for (arr = []; i < j && i <= opts.maxYear; i++) {
	          if (i >= opts.minYear) {
	            arr.push("<option value=\"" + i + "\" " + (i === year ? 'selected="selected"' : '') + ">" + i + "</option>");
	          }
	        }
	
	        yearHtml = "<select class=\"datepicker-select orig-select-year\" tabindex=\"-1\">" + arr.join('') + "</select>";
	
	        var leftArrow = '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"/><path d="M0-.5h24v24H0z" fill="none"/></svg>';
	        html += "<button class=\"month-prev" + (prev ? '' : ' is-disabled') + "\" type=\"button\">" + leftArrow + "</button>";
	
	        html += '<div class="selects-container">';
	        if (opts.showMonthAfterYear) {
	          html += yearHtml + monthHtml;
	        } else {
	          html += monthHtml + yearHtml;
	        }
	        html += '</div>';
	
	        if (isMinYear && (month === 0 || opts.minMonth >= month)) {
	          prev = false;
	        }
	
	        if (isMaxYear && (month === 11 || opts.maxMonth <= month)) {
	          next = false;
	        }
	
	        var rightArrow = '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"/><path d="M0-.25h24v24H0z" fill="none"/></svg>';
	        html += "<button class=\"month-next" + (next ? '' : ' is-disabled') + "\" type=\"button\">" + rightArrow + "</button>";
	
	        return html += '</div>';
	      }
	
	      /**
	       * refresh the HTML
	       */
	
	    }, {
	      key: "draw",
	      value: function draw(force) {
	        if (!this.isOpen && !force) {
	          return;
	        }
	        var opts = this.options,
	            minYear = opts.minYear,
	            maxYear = opts.maxYear,
	            minMonth = opts.minMonth,
	            maxMonth = opts.maxMonth,
	            html = '',
	            randId = void 0;
	
	        if (this._y <= minYear) {
	          this._y = minYear;
	          if (!isNaN(minMonth) && this._m < minMonth) {
	            this._m = minMonth;
	          }
	        }
	        if (this._y >= maxYear) {
	          this._y = maxYear;
	          if (!isNaN(maxMonth) && this._m > maxMonth) {
	            this._m = maxMonth;
	          }
	        }
	
	        randId = 'datepicker-title-' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 2);
	
	        for (var c = 0; c < 1; c++) {
	          this._renderDateDisplay();
	          html += this.renderTitle(this, c, this.calendars[c].year, this.calendars[c].month, this.calendars[0].year, randId) + this.render(this.calendars[c].year, this.calendars[c].month, randId);
	        }
	
	        this.destroySelects();
	
	        this.calendarEl.innerHTML = html;
	
	        // Init Materialize Select
	        var yearSelect = this.calendarEl.querySelector('.orig-select-year');
	        var monthSelect = this.calendarEl.querySelector('.orig-select-month');
	        M.FormSelect.init(yearSelect, {
	          classes: 'select-year',
	          dropdownOptions: { container: document.body, constrainWidth: false }
	        });
	        M.FormSelect.init(monthSelect, {
	          classes: 'select-month',
	          dropdownOptions: { container: document.body, constrainWidth: false }
	        });
	
	        // Add change handlers for select
	        yearSelect.addEventListener('change', this._handleYearChange.bind(this));
	        monthSelect.addEventListener('change', this._handleMonthChange.bind(this));
	
	        if (typeof this.options.onDraw === 'function') {
	          this.options.onDraw(this);
	        }
	      }
	
	      /**
	       * Setup Event Handlers
	       */
	
	    }, {
	      key: "_setupEventHandlers",
	      value: function _setupEventHandlers() {
	        this._handleInputKeydownBound = this._handleInputKeydown.bind(this);
	        this._handleInputClickBound = this._handleInputClick.bind(this);
	        this._handleInputChangeBound = this._handleInputChange.bind(this);
	        this._handleCalendarClickBound = this._handleCalendarClick.bind(this);
	        this._finishSelectionBound = this._finishSelection.bind(this);
	        this._handleMonthChange = this._handleMonthChange.bind(this);
	        this._closeBound = this.close.bind(this);
	
	        this.el.addEventListener('click', this._handleInputClickBound);
	        this.el.addEventListener('keydown', this._handleInputKeydownBound);
	        this.el.addEventListener('change', this._handleInputChangeBound);
	        this.calendarEl.addEventListener('click', this._handleCalendarClickBound);
	        this.doneBtn.addEventListener('click', this._finishSelectionBound);
	        this.cancelBtn.addEventListener('click', this._closeBound);
	
	        if (this.options.showClearBtn) {
	          this._handleClearClickBound = this._handleClearClick.bind(this);
	          this.clearBtn.addEventListener('click', this._handleClearClickBound);
	        }
	      }
	    }, {
	      key: "_setupVariables",
	      value: function _setupVariables() {
	        var _this56 = this;
	
	        this.$modalEl = $(Datepicker._template);
	        this.modalEl = this.$modalEl[0];
	
	        this.calendarEl = this.modalEl.querySelector('.datepicker-calendar');
	
	        this.yearTextEl = this.modalEl.querySelector('.year-text');
	        this.dateTextEl = this.modalEl.querySelector('.date-text');
	        if (this.options.showClearBtn) {
	          this.clearBtn = this.modalEl.querySelector('.datepicker-clear');
	        }
	        this.doneBtn = this.modalEl.querySelector('.datepicker-done');
	        this.cancelBtn = this.modalEl.querySelector('.datepicker-cancel');
	
	        this.formats = {
	          d: function d() {
	            return _this56.date.getDate();
	          },
	          dd: function dd() {
	            var d = _this56.date.getDate();
	            return (d < 10 ? '0' : '') + d;
	          },
	          ddd: function ddd() {
	            return _this56.options.i18n.weekdaysShort[_this56.date.getDay()];
	          },
	          dddd: function dddd() {
	            return _this56.options.i18n.weekdays[_this56.date.getDay()];
	          },
	          m: function m() {
	            return _this56.date.getMonth() + 1;
	          },
	          mm: function mm() {
	            var m = _this56.date.getMonth() + 1;
	            return (m < 10 ? '0' : '') + m;
	          },
	          mmm: function mmm() {
	            return _this56.options.i18n.monthsShort[_this56.date.getMonth()];
	          },
	          mmmm: function mmmm() {
	            return _this56.options.i18n.months[_this56.date.getMonth()];
	          },
	          yy: function yy() {
	            return ('' + _this56.date.getFullYear()).slice(2);
	          },
	          yyyy: function yyyy() {
	            return _this56.date.getFullYear();
	          }
	        };
	      }
	
	      /**
	       * Remove Event Handlers
	       */
	
	    }, {
	      key: "_removeEventHandlers",
	      value: function _removeEventHandlers() {
	        this.el.removeEventListener('click', this._handleInputClickBound);
	        this.el.removeEventListener('keydown', this._handleInputKeydownBound);
	        this.el.removeEventListener('change', this._handleInputChangeBound);
	        this.calendarEl.removeEventListener('click', this._handleCalendarClickBound);
	      }
	    }, {
	      key: "_handleInputClick",
	      value: function _handleInputClick() {
	        this.open();
	      }
	    }, {
	      key: "_handleInputKeydown",
	      value: function _handleInputKeydown(e) {
	        if (e.which === M.keys.ENTER) {
	          e.preventDefault();
	          this.open();
	        }
	      }
	    }, {
	      key: "_handleCalendarClick",
	      value: function _handleCalendarClick(e) {
	        if (!this.isOpen) {
	          return;
	        }
	
	        var $target = $(e.target);
	        if (!$target.hasClass('is-disabled')) {
	          if ($target.hasClass('datepicker-day-button') && !$target.hasClass('is-empty') && !$target.parent().hasClass('is-disabled')) {
	            this.setDate(new Date(e.target.getAttribute('data-year'), e.target.getAttribute('data-month'), e.target.getAttribute('data-day')));
	            if (this.options.autoClose) {
	              this._finishSelection();
	            }
	          } else if ($target.closest('.month-prev').length) {
	            this.prevMonth();
	          } else if ($target.closest('.month-next').length) {
	            this.nextMonth();
	          }
	        }
	      }
	    }, {
	      key: "_handleClearClick",
	      value: function _handleClearClick() {
	        this.date = null;
	        this.setInputValue();
	        this.close();
	      }
	    }, {
	      key: "_handleMonthChange",
	      value: function _handleMonthChange(e) {
	        this.gotoMonth(e.target.value);
	      }
	    }, {
	      key: "_handleYearChange",
	      value: function _handleYearChange(e) {
	        this.gotoYear(e.target.value);
	      }
	
	      /**
	       * change view to a specific month (zero-index, e.g. 0: January)
	       */
	
	    }, {
	      key: "gotoMonth",
	      value: function gotoMonth(month) {
	        if (!isNaN(month)) {
	          this.calendars[0].month = parseInt(month, 10);
	          this.adjustCalendars();
	        }
	      }
	
	      /**
	       * change view to a specific full year (e.g. "2012")
	       */
	
	    }, {
	      key: "gotoYear",
	      value: function gotoYear(year) {
	        if (!isNaN(year)) {
	          this.calendars[0].year = parseInt(year, 10);
	          this.adjustCalendars();
	        }
	      }
	    }, {
	      key: "_handleInputChange",
	      value: function _handleInputChange(e) {
	        var date = void 0;
	
	        // Prevent change event from being fired when triggered by the plugin
	        if (e.firedBy === this) {
	          return;
	        }
	        if (this.options.parse) {
	          date = this.options.parse(this.el.value, this.options.format);
	        } else {
	          date = new Date(Date.parse(this.el.value));
	        }
	
	        if (Datepicker._isDate(date)) {
	          this.setDate(date);
	        }
	      }
	    }, {
	      key: "renderDayName",
	      value: function renderDayName(opts, day, abbr) {
	        day += opts.firstDay;
	        while (day >= 7) {
	          day -= 7;
	        }
	        return abbr ? opts.i18n.weekdaysAbbrev[day] : opts.i18n.weekdays[day];
	      }
	
	      /**
	       * Set input value to the selected date and close Datepicker
	       */
	
	    }, {
	      key: "_finishSelection",
	      value: function _finishSelection() {
	        this.setInputValue();
	        this.close();
	      }
	
	      /**
	       * Open Datepicker
	       */
	
	    }, {
	      key: "open",
	      value: function open() {
	        if (this.isOpen) {
	          return;
	        }
	
	        this.isOpen = true;
	        if (typeof this.options.onOpen === 'function') {
	          this.options.onOpen.call(this);
	        }
	        this.draw();
	        this.modal.open();
	        return this;
	      }
	
	      /**
	       * Close Datepicker
	       */
	
	    }, {
	      key: "close",
	      value: function close() {
	        if (!this.isOpen) {
	          return;
	        }
	
	        this.isOpen = false;
	        if (typeof this.options.onClose === 'function') {
	          this.options.onClose.call(this);
	        }
	        this.modal.close();
	        return this;
	      }
	    }], [{
	      key: "init",
	      value: function init(els, options) {
	        return _get(Datepicker.__proto__ || Object.getPrototypeOf(Datepicker), "init", this).call(this, this, els, options);
	      }
	    }, {
	      key: "_isDate",
	      value: function _isDate(obj) {
	        return (/Date/.test(Object.prototype.toString.call(obj)) && !isNaN(obj.getTime())
	        );
	      }
	    }, {
	      key: "_isWeekend",
	      value: function _isWeekend(date) {
	        var day = date.getDay();
	        return day === 0 || day === 6;
	      }
	    }, {
	      key: "_setToStartOfDay",
	      value: function _setToStartOfDay(date) {
	        if (Datepicker._isDate(date)) date.setHours(0, 0, 0, 0);
	      }
	    }, {
	      key: "_getDaysInMonth",
	      value: function _getDaysInMonth(year, month) {
	        return [31, Datepicker._isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
	      }
	    }, {
	      key: "_isLeapYear",
	      value: function _isLeapYear(year) {
	        // solution by Matti Virkkunen: http://stackoverflow.com/a/4881951
	        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
	      }
	    }, {
	      key: "_compareDates",
	      value: function _compareDates(a, b) {
	        // weak date comparison (use setToStartOfDay(date) to ensure correct result)
	        return a.getTime() === b.getTime();
	      }
	    }, {
	      key: "_setToStartOfDay",
	      value: function _setToStartOfDay(date) {
	        if (Datepicker._isDate(date)) date.setHours(0, 0, 0, 0);
	      }
	
	      /**
	       * Get Instance
	       */
	
	    }, {
	      key: "getInstance",
	      value: function getInstance(el) {
	        var domElem = !!el.jquery ? el[0] : el;
	        return domElem.M_Datepicker;
	      }
	    }, {
	      key: "defaults",
	      get: function get() {
	        return _defaults;
	      }
	    }]);
	
	    return Datepicker;
	  }(Component);
	
	  Datepicker._template = ['<div class= "modal datepicker-modal">', '<div class="modal-content datepicker-container">', '<div class="datepicker-date-display">', '<span class="year-text"></span>', '<span class="date-text"></span>', '</div>', '<div class="datepicker-calendar-container">', '<div class="datepicker-calendar"></div>', '<div class="datepicker-footer">', '<button class="btn-flat datepicker-clear waves-effect" style="visibility: hidden;" type="button"></button>', '<div class="confirmation-btns">', '<button class="btn-flat datepicker-cancel waves-effect" type="button"></button>', '<button class="btn-flat datepicker-done waves-effect" type="button"></button>', '</div>', '</div>', '</div>', '</div>', '</div>'].join('');
	
	  M.Datepicker = Datepicker;
	
	  if (M.jQueryLoaded) {
	    M.initializeJqueryWrapper(Datepicker, 'datepicker', 'M_Datepicker');
	  }
	})(cash);
	;(function ($) {
	  'use strict';
	
	  var _defaults = {
	    dialRadius: 135,
	    outerRadius: 105,
	    innerRadius: 70,
	    tickRadius: 20,
	    duration: 350,
	    container: null,
	    defaultTime: 'now', // default time, 'now' or '13:14' e.g.
	    fromNow: 0, // Millisecond offset from the defaultTime
	    showClearBtn: false,
	
	    // internationalization
	    i18n: {
	      cancel: 'Cancel',
	      clear: 'Clear',
	      done: 'Ok'
	    },
	
	    autoClose: false, // auto close when minute is selected
	    twelveHour: true, // change to 12 hour AM/PM clock from 24 hour
	    vibrate: true, // vibrate the device when dragging clock hand
	
	    // Callbacks
	    onOpenStart: null,
	    onOpenEnd: null,
	    onCloseStart: null,
	    onCloseEnd: null,
	    onSelect: null
	  };
	
	  /**
	   * @class
	   *
	   */
	
	  var Timepicker = function (_Component16) {
	    _inherits(Timepicker, _Component16);
	
	    function Timepicker(el, options) {
	      _classCallCheck(this, Timepicker);
	
	      var _this57 = _possibleConstructorReturn(this, (Timepicker.__proto__ || Object.getPrototypeOf(Timepicker)).call(this, Timepicker, el, options));
	
	      _this57.el.M_Timepicker = _this57;
	
	      _this57.options = $.extend({}, Timepicker.defaults, options);
	
	      _this57.id = M.guid();
	      _this57._insertHTMLIntoDOM();
	      _this57._setupModal();
	      _this57._setupVariables();
	      _this57._setupEventHandlers();
	
	      _this57._clockSetup();
	      _this57._pickerSetup();
	      return _this57;
	    }
	
	    _createClass(Timepicker, [{
	      key: "destroy",
	
	      /**
	       * Teardown component
	       */
	      value: function destroy() {
	        this._removeEventHandlers();
	        this.modal.destroy();
	        $(this.modalEl).remove();
	        this.el.M_Timepicker = undefined;
	      }
	
	      /**
	       * Setup Event Handlers
	       */
	
	    }, {
	      key: "_setupEventHandlers",
	      value: function _setupEventHandlers() {
	        this._handleInputKeydownBound = this._handleInputKeydown.bind(this);
	        this._handleInputClickBound = this._handleInputClick.bind(this);
	        this._handleClockClickStartBound = this._handleClockClickStart.bind(this);
	        this._handleDocumentClickMoveBound = this._handleDocumentClickMove.bind(this);
	        this._handleDocumentClickEndBound = this._handleDocumentClickEnd.bind(this);
	
	        this.el.addEventListener('click', this._handleInputClickBound);
	        this.el.addEventListener('keydown', this._handleInputKeydownBound);
	        this.plate.addEventListener('mousedown', this._handleClockClickStartBound);
	        this.plate.addEventListener('touchstart', this._handleClockClickStartBound);
	
	        $(this.spanHours).on('click', this.showView.bind(this, 'hours'));
	        $(this.spanMinutes).on('click', this.showView.bind(this, 'minutes'));
	      }
	    }, {
	      key: "_removeEventHandlers",
	      value: function _removeEventHandlers() {
	        this.el.removeEventListener('click', this._handleInputClickBound);
	        this.el.removeEventListener('keydown', this._handleInputKeydownBound);
	      }
	    }, {
	      key: "_handleInputClick",
	      value: function _handleInputClick() {
	        this.open();
	      }
	    }, {
	      key: "_handleInputKeydown",
	      value: function _handleInputKeydown(e) {
	        if (e.which === M.keys.ENTER) {
	          e.preventDefault();
	          this.open();
	        }
	      }
	    }, {
	      key: "_handleClockClickStart",
	      value: function _handleClockClickStart(e) {
	        e.preventDefault();
	        var clockPlateBR = this.plate.getBoundingClientRect();
	        var offset = { x: clockPlateBR.left, y: clockPlateBR.top };
	
	        this.x0 = offset.x + this.options.dialRadius;
	        this.y0 = offset.y + this.options.dialRadius;
	        this.moved = false;
	        var clickPos = Timepicker._Pos(e);
	        this.dx = clickPos.x - this.x0;
	        this.dy = clickPos.y - this.y0;
	
	        // Set clock hands
	        this.setHand(this.dx, this.dy, false);
	
	        // Mousemove on document
	        document.addEventListener('mousemove', this._handleDocumentClickMoveBound);
	        document.addEventListener('touchmove', this._handleDocumentClickMoveBound);
	
	        // Mouseup on document
	        document.addEventListener('mouseup', this._handleDocumentClickEndBound);
	        document.addEventListener('touchend', this._handleDocumentClickEndBound);
	      }
	    }, {
	      key: "_handleDocumentClickMove",
	      value: function _handleDocumentClickMove(e) {
	        e.preventDefault();
	        var clickPos = Timepicker._Pos(e);
	        var x = clickPos.x - this.x0;
	        var y = clickPos.y - this.y0;
	        this.moved = true;
	        this.setHand(x, y, false, true);
	      }
	    }, {
	      key: "_handleDocumentClickEnd",
	      value: function _handleDocumentClickEnd(e) {
	        var _this58 = this;
	
	        e.preventDefault();
	        document.removeEventListener('mouseup', this._handleDocumentClickEndBound);
	        document.removeEventListener('touchend', this._handleDocumentClickEndBound);
	        var clickPos = Timepicker._Pos(e);
	        var x = clickPos.x - this.x0;
	        var y = clickPos.y - this.y0;
	        if (this.moved && x === this.dx && y === this.dy) {
	          this.setHand(x, y);
	        }
	
	        if (this.currentView === 'hours') {
	          this.showView('minutes', this.options.duration / 2);
	        } else if (this.options.autoClose) {
	          $(this.minutesView).addClass('timepicker-dial-out');
	          setTimeout(function () {
	            _this58.done();
	          }, this.options.duration / 2);
	        }
	
	        if (typeof this.options.onSelect === 'function') {
	          this.options.onSelect.call(this, this.hours, this.minutes);
	        }
	
	        // Unbind mousemove event
	        document.removeEventListener('mousemove', this._handleDocumentClickMoveBound);
	        document.removeEventListener('touchmove', this._handleDocumentClickMoveBound);
	      }
	    }, {
	      key: "_insertHTMLIntoDOM",
	      value: function _insertHTMLIntoDOM() {
	        this.$modalEl = $(Timepicker._template);
	        this.modalEl = this.$modalEl[0];
	        this.modalEl.id = 'modal-' + this.id;
	
	        // Append popover to input by default
	        var containerEl = document.querySelector(this.options.container);
	        if (this.options.container && !!containerEl) {
	          this.$modalEl.appendTo(containerEl);
	        } else {
	          this.$modalEl.insertBefore(this.el);
	        }
	      }
	    }, {
	      key: "_setupModal",
	      value: function _setupModal() {
	        var _this59 = this;
	
	        this.modal = M.Modal.init(this.modalEl, {
	          onOpenStart: this.options.onOpenStart,
	          onOpenEnd: this.options.onOpenEnd,
	          onCloseStart: this.options.onCloseStart,
	          onCloseEnd: function onCloseEnd() {
	            if (typeof _this59.options.onCloseEnd === 'function') {
	              _this59.options.onCloseEnd.call(_this59);
	            }
	            _this59.isOpen = false;
	          }
	        });
	      }
	    }, {
	      key: "_setupVariables",
	      value: function _setupVariables() {
	        this.currentView = 'hours';
	        this.vibrate = navigator.vibrate ? 'vibrate' : navigator.webkitVibrate ? 'webkitVibrate' : null;
	
	        this._canvas = this.modalEl.querySelector('.timepicker-canvas');
	        this.plate = this.modalEl.querySelector('.timepicker-plate');
	
	        this.hoursView = this.modalEl.querySelector('.timepicker-hours');
	        this.minutesView = this.modalEl.querySelector('.timepicker-minutes');
	        this.spanHours = this.modalEl.querySelector('.timepicker-span-hours');
	        this.spanMinutes = this.modalEl.querySelector('.timepicker-span-minutes');
	        this.spanAmPm = this.modalEl.querySelector('.timepicker-span-am-pm');
	        this.footer = this.modalEl.querySelector('.timepicker-footer');
	        this.amOrPm = 'PM';
	      }
	    }, {
	      key: "_pickerSetup",
	      value: function _pickerSetup() {
	        var $clearBtn = $("<button class=\"btn-flat timepicker-clear waves-effect\" style=\"visibility: hidden;\" type=\"button\" tabindex=\"" + (this.options.twelveHour ? '3' : '1') + "\">" + this.options.i18n.clear + "</button>").appendTo(this.footer).on('click', this.clear.bind(this));
	        if (this.options.showClearBtn) {
	          $clearBtn.css({ visibility: '' });
	        }
	
	        var confirmationBtnsContainer = $('<div class="confirmation-btns"></div>');
	        $('<button class="btn-flat timepicker-close waves-effect" type="button" tabindex="' + (this.options.twelveHour ? '3' : '1') + '">' + this.options.i18n.cancel + '</button>').appendTo(confirmationBtnsContainer).on('click', this.close.bind(this));
	        $('<button class="btn-flat timepicker-close waves-effect" type="button" tabindex="' + (this.options.twelveHour ? '3' : '1') + '">' + this.options.i18n.done + '</button>').appendTo(confirmationBtnsContainer).on('click', this.done.bind(this));
	        confirmationBtnsContainer.appendTo(this.footer);
	      }
	    }, {
	      key: "_clockSetup",
	      value: function _clockSetup() {
	        if (this.options.twelveHour) {
	          this.$amBtn = $('<div class="am-btn">AM</div>');
	          this.$pmBtn = $('<div class="pm-btn">PM</div>');
	          this.$amBtn.on('click', this._handleAmPmClick.bind(this)).appendTo(this.spanAmPm);
	          this.$pmBtn.on('click', this._handleAmPmClick.bind(this)).appendTo(this.spanAmPm);
	        }
	
	        this._buildHoursView();
	        this._buildMinutesView();
	        this._buildSVGClock();
	      }
	    }, {
	      key: "_buildSVGClock",
	      value: function _buildSVGClock() {
	        // Draw clock hands and others
	        var dialRadius = this.options.dialRadius;
	        var tickRadius = this.options.tickRadius;
	        var diameter = dialRadius * 2;
	
	        var svg = Timepicker._createSVGEl('svg');
	        svg.setAttribute('class', 'timepicker-svg');
	        svg.setAttribute('width', diameter);
	        svg.setAttribute('height', diameter);
	        var g = Timepicker._createSVGEl('g');
	        g.setAttribute('transform', 'translate(' + dialRadius + ',' + dialRadius + ')');
	        var bearing = Timepicker._createSVGEl('circle');
	        bearing.setAttribute('class', 'timepicker-canvas-bearing');
	        bearing.setAttribute('cx', 0);
	        bearing.setAttribute('cy', 0);
	        bearing.setAttribute('r', 4);
	        var hand = Timepicker._createSVGEl('line');
	        hand.setAttribute('x1', 0);
	        hand.setAttribute('y1', 0);
	        var bg = Timepicker._createSVGEl('circle');
	        bg.setAttribute('class', 'timepicker-canvas-bg');
	        bg.setAttribute('r', tickRadius);
	        g.appendChild(hand);
	        g.appendChild(bg);
	        g.appendChild(bearing);
	        svg.appendChild(g);
	        this._canvas.appendChild(svg);
	
	        this.hand = hand;
	        this.bg = bg;
	        this.bearing = bearing;
	        this.g = g;
	      }
	    }, {
	      key: "_buildHoursView",
	      value: function _buildHoursView() {
	        var $tick = $('<div class="timepicker-tick"></div>');
	        // Hours view
	        if (this.options.twelveHour) {
	          for (var i = 1; i < 13; i += 1) {
	            var tick = $tick.clone();
	            var radian = i / 6 * Math.PI;
	            var radius = this.options.outerRadius;
	            tick.css({
	              left: this.options.dialRadius + Math.sin(radian) * radius - this.options.tickRadius + 'px',
	              top: this.options.dialRadius - Math.cos(radian) * radius - this.options.tickRadius + 'px'
	            });
	            tick.html(i === 0 ? '00' : i);
	            this.hoursView.appendChild(tick[0]);
	            // tick.on(mousedownEvent, mousedown);
	          }
	        } else {
	          for (var _i2 = 0; _i2 < 24; _i2 += 1) {
	            var _tick = $tick.clone();
	            var _radian = _i2 / 6 * Math.PI;
	            var inner = _i2 > 0 && _i2 < 13;
	            var _radius = inner ? this.options.innerRadius : this.options.outerRadius;
	            _tick.css({
	              left: this.options.dialRadius + Math.sin(_radian) * _radius - this.options.tickRadius + 'px',
	              top: this.options.dialRadius - Math.cos(_radian) * _radius - this.options.tickRadius + 'px'
	            });
	            _tick.html(_i2 === 0 ? '00' : _i2);
	            this.hoursView.appendChild(_tick[0]);
	            // tick.on(mousedownEvent, mousedown);
	          }
	        }
	      }
	    }, {
	      key: "_buildMinutesView",
	      value: function _buildMinutesView() {
	        var $tick = $('<div class="timepicker-tick"></div>');
	        // Minutes view
	        for (var i = 0; i < 60; i += 5) {
	          var tick = $tick.clone();
	          var radian = i / 30 * Math.PI;
	          tick.css({
	            left: this.options.dialRadius + Math.sin(radian) * this.options.outerRadius - this.options.tickRadius + 'px',
	            top: this.options.dialRadius - Math.cos(radian) * this.options.outerRadius - this.options.tickRadius + 'px'
	          });
	          tick.html(Timepicker._addLeadingZero(i));
	          this.minutesView.appendChild(tick[0]);
	        }
	      }
	    }, {
	      key: "_handleAmPmClick",
	      value: function _handleAmPmClick(e) {
	        var $btnClicked = $(e.target);
	        this.amOrPm = $btnClicked.hasClass('am-btn') ? 'AM' : 'PM';
	        this._updateAmPmView();
	      }
	    }, {
	      key: "_updateAmPmView",
	      value: function _updateAmPmView() {
	        if (this.options.twelveHour) {
	          this.$amBtn.toggleClass('text-primary', this.amOrPm === 'AM');
	          this.$pmBtn.toggleClass('text-primary', this.amOrPm === 'PM');
	        }
	      }
	    }, {
	      key: "_updateTimeFromInput",
	      value: function _updateTimeFromInput() {
	        // Get the time
	        var value = ((this.el.value || this.options.defaultTime || '') + '').split(':');
	        if (this.options.twelveHour && !(typeof value[1] === 'undefined')) {
	          if (value[1].toUpperCase().indexOf('AM') > 0) {
	            this.amOrPm = 'AM';
	          } else {
	            this.amOrPm = 'PM';
	          }
	          value[1] = value[1].replace('AM', '').replace('PM', '');
	        }
	        if (value[0] === 'now') {
	          var now = new Date(+new Date() + this.options.fromNow);
	          value = [now.getHours(), now.getMinutes()];
	          if (this.options.twelveHour) {
	            this.amOrPm = value[0] >= 12 && value[0] < 24 ? 'PM' : 'AM';
	          }
	        }
	        this.hours = +value[0] || 0;
	        this.minutes = +value[1] || 0;
	        this.spanHours.innerHTML = this.hours;
	        this.spanMinutes.innerHTML = Timepicker._addLeadingZero(this.minutes);
	
	        this._updateAmPmView();
	      }
	    }, {
	      key: "showView",
	      value: function showView(view, delay) {
	        if (view === 'minutes' && $(this.hoursView).css('visibility') === 'visible') {
	          // raiseCallback(this.options.beforeHourSelect);
	        }
	        var isHours = view === 'hours',
	            nextView = isHours ? this.hoursView : this.minutesView,
	            hideView = isHours ? this.minutesView : this.hoursView;
	        this.currentView = view;
	
	        $(this.spanHours).toggleClass('text-primary', isHours);
	        $(this.spanMinutes).toggleClass('text-primary', !isHours);
	
	        // Transition view
	        hideView.classList.add('timepicker-dial-out');
	        $(nextView).css('visibility', 'visible').removeClass('timepicker-dial-out');
	
	        // Reset clock hand
	        this.resetClock(delay);
	
	        // After transitions ended
	        clearTimeout(this.toggleViewTimer);
	        this.toggleViewTimer = setTimeout(function () {
	          $(hideView).css('visibility', 'hidden');
	        }, this.options.duration);
	      }
	    }, {
	      key: "resetClock",
	      value: function resetClock(delay) {
	        var view = this.currentView,
	            value = this[view],
	            isHours = view === 'hours',
	            unit = Math.PI / (isHours ? 6 : 30),
	            radian = value * unit,
	            radius = isHours && value > 0 && value < 13 ? this.options.innerRadius : this.options.outerRadius,
	            x = Math.sin(radian) * radius,
	            y = -Math.cos(radian) * radius,
	            self = this;
	
	        if (delay) {
	          $(this.canvas).addClass('timepicker-canvas-out');
	          setTimeout(function () {
	            $(self.canvas).removeClass('timepicker-canvas-out');
	            self.setHand(x, y);
	          }, delay);
	        } else {
	          this.setHand(x, y);
	        }
	      }
	    }, {
	      key: "setHand",
	      value: function setHand(x, y, roundBy5) {
	        var _this60 = this;
	
	        var radian = Math.atan2(x, -y),
	            isHours = this.currentView === 'hours',
	            unit = Math.PI / (isHours || roundBy5 ? 6 : 30),
	            z = Math.sqrt(x * x + y * y),
	            inner = isHours && z < (this.options.outerRadius + this.options.innerRadius) / 2,
	            radius = inner ? this.options.innerRadius : this.options.outerRadius;
	
	        if (this.options.twelveHour) {
	          radius = this.options.outerRadius;
	        }
	
	        // Radian should in range [0, 2PI]
	        if (radian < 0) {
	          radian = Math.PI * 2 + radian;
	        }
	
	        // Get the round value
	        var value = Math.round(radian / unit);
	
	        // Get the round radian
	        radian = value * unit;
	
	        // Correct the hours or minutes
	        if (this.options.twelveHour) {
	          if (isHours) {
	            if (value === 0) value = 12;
	          } else {
	            if (roundBy5) value *= 5;
	            if (value === 60) value = 0;
	          }
	        } else {
	          if (isHours) {
	            if (value === 12) {
	              value = 0;
	            }
	            value = inner ? value === 0 ? 12 : value : value === 0 ? 0 : value + 12;
	          } else {
	            if (roundBy5) {
	              value *= 5;
	            }
	            if (value === 60) {
	              value = 0;
	            }
	          }
	        }
	
	        // Once hours or minutes changed, vibrate the device
	        if (this[this.currentView] !== value) {
	          if (this.vibrate && this.options.vibrate) {
	            // Do not vibrate too frequently
	            if (!this.vibrateTimer) {
	              navigator[this.vibrate](10);
	              this.vibrateTimer = setTimeout(function () {
	                _this60.vibrateTimer = null;
	              }, 100);
	            }
	          }
	        }
	
	        this[this.currentView] = value;
	        if (isHours) {
	          this['spanHours'].innerHTML = value;
	        } else {
	          this['spanMinutes'].innerHTML = Timepicker._addLeadingZero(value);
	        }
	
	        // Set clock hand and others' position
	        var cx1 = Math.sin(radian) * (radius - this.options.tickRadius),
	            cy1 = -Math.cos(radian) * (radius - this.options.tickRadius),
	            cx2 = Math.sin(radian) * radius,
	            cy2 = -Math.cos(radian) * radius;
	        this.hand.setAttribute('x2', cx1);
	        this.hand.setAttribute('y2', cy1);
	        this.bg.setAttribute('cx', cx2);
	        this.bg.setAttribute('cy', cy2);
	      }
	    }, {
	      key: "open",
	      value: function open() {
	        if (this.isOpen) {
	          return;
	        }
	
	        this.isOpen = true;
	        this._updateTimeFromInput();
	        this.showView('hours');
	
	        this.modal.open();
	      }
	    }, {
	      key: "close",
	      value: function close() {
	        if (!this.isOpen) {
	          return;
	        }
	
	        this.isOpen = false;
	        this.modal.close();
	      }
	
	      /**
	       * Finish timepicker selection.
	       */
	
	    }, {
	      key: "done",
	      value: function done(e, clearValue) {
	        // Set input value
	        var last = this.el.value;
	        var value = clearValue ? '' : Timepicker._addLeadingZero(this.hours) + ':' + Timepicker._addLeadingZero(this.minutes);
	        this.time = value;
	        if (!clearValue && this.options.twelveHour) {
	          value = value + " " + this.amOrPm;
	        }
	        this.el.value = value;
	
	        // Trigger change event
	        if (value !== last) {
	          this.$el.trigger('change');
	        }
	
	        this.close();
	        this.el.focus();
	      }
	    }, {
	      key: "clear",
	      value: function clear() {
	        this.done(null, true);
	      }
	    }], [{
	      key: "init",
	      value: function init(els, options) {
	        return _get(Timepicker.__proto__ || Object.getPrototypeOf(Timepicker), "init", this).call(this, this, els, options);
	      }
	    }, {
	      key: "_addLeadingZero",
	      value: function _addLeadingZero(num) {
	        return (num < 10 ? '0' : '') + num;
	      }
	    }, {
	      key: "_createSVGEl",
	      value: function _createSVGEl(name) {
	        var svgNS = 'http://www.w3.org/2000/svg';
	        return document.createElementNS(svgNS, name);
	      }
	
	      /**
	       * @typedef {Object} Point
	       * @property {number} x The X Coordinate
	       * @property {number} y The Y Coordinate
	       */
	
	      /**
	       * Get x position of mouse or touch event
	       * @param {Event} e
	       * @return {Point} x and y location
	       */
	
	    }, {
	      key: "_Pos",
	      value: function _Pos(e) {
	        if (e.targetTouches && e.targetTouches.length >= 1) {
	          return { x: e.targetTouches[0].clientX, y: e.targetTouches[0].clientY };
	        }
	        // mouse event
	        return { x: e.clientX, y: e.clientY };
	      }
	
	      /**
	       * Get Instance
	       */
	
	    }, {
	      key: "getInstance",
	      value: function getInstance(el) {
	        var domElem = !!el.jquery ? el[0] : el;
	        return domElem.M_Timepicker;
	      }
	    }, {
	      key: "defaults",
	      get: function get() {
	        return _defaults;
	      }
	    }]);
	
	    return Timepicker;
	  }(Component);
	
	  Timepicker._template = ['<div class= "modal timepicker-modal">', '<div class="modal-content timepicker-container">', '<div class="timepicker-digital-display">', '<div class="timepicker-text-container">', '<div class="timepicker-display-column">', '<span class="timepicker-span-hours text-primary"></span>', ':', '<span class="timepicker-span-minutes"></span>', '</div>', '<div class="timepicker-display-column timepicker-display-am-pm">', '<div class="timepicker-span-am-pm"></div>', '</div>', '</div>', '</div>', '<div class="timepicker-analog-display">', '<div class="timepicker-plate">', '<div class="timepicker-canvas"></div>', '<div class="timepicker-dial timepicker-hours"></div>', '<div class="timepicker-dial timepicker-minutes timepicker-dial-out"></div>', '</div>', '<div class="timepicker-footer"></div>', '</div>', '</div>', '</div>'].join('');
	
	  M.Timepicker = Timepicker;
	
	  if (M.jQueryLoaded) {
	    M.initializeJqueryWrapper(Timepicker, 'timepicker', 'M_Timepicker');
	  }
	})(cash);
	;(function ($) {
	  'use strict';
	
	  var _defaults = {};
	
	  /**
	   * @class
	   *
	   */
	
	  var CharacterCounter = function (_Component17) {
	    _inherits(CharacterCounter, _Component17);
	
	    /**
	     * Construct CharacterCounter instance
	     * @constructor
	     * @param {Element} el
	     * @param {Object} options
	     */
	    function CharacterCounter(el, options) {
	      _classCallCheck(this, CharacterCounter);
	
	      var _this61 = _possibleConstructorReturn(this, (CharacterCounter.__proto__ || Object.getPrototypeOf(CharacterCounter)).call(this, CharacterCounter, el, options));
	
	      _this61.el.M_CharacterCounter = _this61;
	
	      /**
	       * Options for the character counter
	       */
	      _this61.options = $.extend({}, CharacterCounter.defaults, options);
	
	      _this61.isInvalid = false;
	      _this61.isValidLength = false;
	      _this61._setupCounter();
	      _this61._setupEventHandlers();
	      return _this61;
	    }
	
	    _createClass(CharacterCounter, [{
	      key: "destroy",
	
	      /**
	       * Teardown component
	       */
	      value: function destroy() {
	        this._removeEventHandlers();
	        this.el.CharacterCounter = undefined;
	        this._removeCounter();
	      }
	
	      /**
	       * Setup Event Handlers
	       */
	
	    }, {
	      key: "_setupEventHandlers",
	      value: function _setupEventHandlers() {
	        this._handleUpdateCounterBound = this.updateCounter.bind(this);
	
	        this.el.addEventListener('focus', this._handleUpdateCounterBound, true);
	        this.el.addEventListener('input', this._handleUpdateCounterBound, true);
	      }
	
	      /**
	       * Remove Event Handlers
	       */
	
	    }, {
	      key: "_removeEventHandlers",
	      value: function _removeEventHandlers() {
	        this.el.removeEventListener('focus', this._handleUpdateCounterBound, true);
	        this.el.removeEventListener('input', this._handleUpdateCounterBound, true);
	      }
	
	      /**
	       * Setup counter element
	       */
	
	    }, {
	      key: "_setupCounter",
	      value: function _setupCounter() {
	        this.counterEl = document.createElement('span');
	        $(this.counterEl).addClass('character-counter').css({
	          float: 'right',
	          'font-size': '12px',
	          height: 1
	        });
	
	        this.$el.parent().append(this.counterEl);
	      }
	
	      /**
	       * Remove counter element
	       */
	
	    }, {
	      key: "_removeCounter",
	      value: function _removeCounter() {
	        $(this.counterEl).remove();
	      }
	
	      /**
	       * Update counter
	       */
	
	    }, {
	      key: "updateCounter",
	      value: function updateCounter() {
	        var maxLength = +this.$el.attr('data-length'),
	            actualLength = this.el.value.length;
	        this.isValidLength = actualLength <= maxLength;
	        var counterString = actualLength;
	
	        if (maxLength) {
	          counterString += '/' + maxLength;
	          this._validateInput();
	        }
	
	        $(this.counterEl).html(counterString);
	      }
	
	      /**
	       * Add validation classes
	       */
	
	    }, {
	      key: "_validateInput",
	      value: function _validateInput() {
	        if (this.isValidLength && this.isInvalid) {
	          this.isInvalid = false;
	          this.$el.removeClass('invalid');
	        } else if (!this.isValidLength && !this.isInvalid) {
	          this.isInvalid = true;
	          this.$el.removeClass('valid');
	          this.$el.addClass('invalid');
	        }
	      }
	    }], [{
	      key: "init",
	      value: function init(els, options) {
	        return _get(CharacterCounter.__proto__ || Object.getPrototypeOf(CharacterCounter), "init", this).call(this, this, els, options);
	      }
	
	      /**
	       * Get Instance
	       */
	
	    }, {
	      key: "getInstance",
	      value: function getInstance(el) {
	        var domElem = !!el.jquery ? el[0] : el;
	        return domElem.M_CharacterCounter;
	      }
	    }, {
	      key: "defaults",
	      get: function get() {
	        return _defaults;
	      }
	    }]);
	
	    return CharacterCounter;
	  }(Component);
	
	  M.CharacterCounter = CharacterCounter;
	
	  if (M.jQueryLoaded) {
	    M.initializeJqueryWrapper(CharacterCounter, 'characterCounter', 'M_CharacterCounter');
	  }
	})(cash);
	;(function ($) {
	  'use strict';
	
	  var _defaults = {
	    duration: 200, // ms
	    dist: -100, // zoom scale TODO: make this more intuitive as an option
	    shift: 0, // spacing for center image
	    padding: 0, // Padding between non center items
	    numVisible: 5, // Number of visible items in carousel
	    fullWidth: false, // Change to full width styles
	    indicators: false, // Toggle indicators
	    noWrap: false, // Don't wrap around and cycle through items.
	    onCycleTo: null // Callback for when a new slide is cycled to.
	  };
	
	  /**
	   * @class
	   *
	   */
	
	  var Carousel = function (_Component18) {
	    _inherits(Carousel, _Component18);
	
	    /**
	     * Construct Carousel instance
	     * @constructor
	     * @param {Element} el
	     * @param {Object} options
	     */
	    function Carousel(el, options) {
	      _classCallCheck(this, Carousel);
	
	      var _this62 = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, Carousel, el, options));
	
	      _this62.el.M_Carousel = _this62;
	
	      /**
	       * Options for the carousel
	       * @member Carousel#options
	       * @prop {Number} duration
	       * @prop {Number} dist
	       * @prop {Number} shift
	       * @prop {Number} padding
	       * @prop {Number} numVisible
	       * @prop {Boolean} fullWidth
	       * @prop {Boolean} indicators
	       * @prop {Boolean} noWrap
	       * @prop {Function} onCycleTo
	       */
	      _this62.options = $.extend({}, Carousel.defaults, options);
	
	      // Setup
	      _this62.hasMultipleSlides = _this62.$el.find('.carousel-item').length > 1;
	      _this62.showIndicators = _this62.options.indicators && _this62.hasMultipleSlides;
	      _this62.noWrap = _this62.options.noWrap || !_this62.hasMultipleSlides;
	      _this62.pressed = false;
	      _this62.dragged = false;
	      _this62.offset = _this62.target = 0;
	      _this62.images = [];
	      _this62.itemWidth = _this62.$el.find('.carousel-item').first().innerWidth();
	      _this62.itemHeight = _this62.$el.find('.carousel-item').first().innerHeight();
	      _this62.dim = _this62.itemWidth * 2 + _this62.options.padding || 1; // Make sure dim is non zero for divisions.
	      _this62._autoScrollBound = _this62._autoScroll.bind(_this62);
	      _this62._trackBound = _this62._track.bind(_this62);
	
	      // Full Width carousel setup
	      if (_this62.options.fullWidth) {
	        _this62.options.dist = 0;
	        _this62._setCarouselHeight();
	
	        // Offset fixed items when indicators.
	        if (_this62.showIndicators) {
	          _this62.$el.find('.carousel-fixed-item').addClass('with-indicators');
	        }
	      }
	
	      // Iterate through slides
	      _this62.$indicators = $('<ul class="indicators"></ul>');
	      _this62.$el.find('.carousel-item').each(function (el, i) {
	        _this62.images.push(el);
	        if (_this62.showIndicators) {
	          var $indicator = $('<li class="indicator-item"></li>');
	
	          // Add active to first by default.
	          if (i === 0) {
	            $indicator[0].classList.add('active');
	          }
	
	          _this62.$indicators.append($indicator);
	        }
	      });
	      if (_this62.showIndicators) {
	        _this62.$el.append(_this62.$indicators);
	      }
	      _this62.count = _this62.images.length;
	
	      // Cap numVisible at count
	      _this62.options.numVisible = Math.min(_this62.count, _this62.options.numVisible);
	
	      // Setup cross browser string
	      _this62.xform = 'transform';
	      ['webkit', 'Moz', 'O', 'ms'].every(function (prefix) {
	        var e = prefix + 'Transform';
	        if (typeof document.body.style[e] !== 'undefined') {
	          _this62.xform = e;
	          return false;
	        }
	        return true;
	      });
	
	      _this62._setupEventHandlers();
	      _this62._scroll(_this62.offset);
	      return _this62;
	    }
	
	    _createClass(Carousel, [{
	      key: "destroy",
	
	      /**
	       * Teardown component
	       */
	      value: function destroy() {
	        this._removeEventHandlers();
	        this.el.M_Carousel = undefined;
	      }
	
	      /**
	       * Setup Event Handlers
	       */
	
	    }, {
	      key: "_setupEventHandlers",
	      value: function _setupEventHandlers() {
	        var _this63 = this;
	
	        this._handleCarouselTapBound = this._handleCarouselTap.bind(this);
	        this._handleCarouselDragBound = this._handleCarouselDrag.bind(this);
	        this._handleCarouselReleaseBound = this._handleCarouselRelease.bind(this);
	        this._handleCarouselClickBound = this._handleCarouselClick.bind(this);
	
	        if (typeof window.ontouchstart !== 'undefined') {
	          this.el.addEventListener('touchstart', this._handleCarouselTapBound);
	          this.el.addEventListener('touchmove', this._handleCarouselDragBound);
	          this.el.addEventListener('touchend', this._handleCarouselReleaseBound);
	        }
	
	        this.el.addEventListener('mousedown', this._handleCarouselTapBound);
	        this.el.addEventListener('mousemove', this._handleCarouselDragBound);
	        this.el.addEventListener('mouseup', this._handleCarouselReleaseBound);
	        this.el.addEventListener('mouseleave', this._handleCarouselReleaseBound);
	        this.el.addEventListener('click', this._handleCarouselClickBound);
	
	        if (this.showIndicators && this.$indicators) {
	          this._handleIndicatorClickBound = this._handleIndicatorClick.bind(this);
	          this.$indicators.find('.indicator-item').each(function (el, i) {
	            el.addEventListener('click', _this63._handleIndicatorClickBound);
	          });
	        }
	
	        // Resize
	        var throttledResize = M.throttle(this._handleResize, 200);
	        this._handleThrottledResizeBound = throttledResize.bind(this);
	
	        window.addEventListener('resize', this._handleThrottledResizeBound);
	      }
	
	      /**
	       * Remove Event Handlers
	       */
	
	    }, {
	      key: "_removeEventHandlers",
	      value: function _removeEventHandlers() {
	        var _this64 = this;
	
	        if (typeof window.ontouchstart !== 'undefined') {
	          this.el.removeEventListener('touchstart', this._handleCarouselTapBound);
	          this.el.removeEventListener('touchmove', this._handleCarouselDragBound);
	          this.el.removeEventListener('touchend', this._handleCarouselReleaseBound);
	        }
	        this.el.removeEventListener('mousedown', this._handleCarouselTapBound);
	        this.el.removeEventListener('mousemove', this._handleCarouselDragBound);
	        this.el.removeEventListener('mouseup', this._handleCarouselReleaseBound);
	        this.el.removeEventListener('mouseleave', this._handleCarouselReleaseBound);
	        this.el.removeEventListener('click', this._handleCarouselClickBound);
	
	        if (this.showIndicators && this.$indicators) {
	          this.$indicators.find('.indicator-item').each(function (el, i) {
	            el.removeEventListener('click', _this64._handleIndicatorClickBound);
	          });
	        }
	
	        window.removeEventListener('resize', this._handleThrottledResizeBound);
	      }
	
	      /**
	       * Handle Carousel Tap
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleCarouselTap",
	      value: function _handleCarouselTap(e) {
	        // Fixes firefox draggable image bug
	        if (e.type === 'mousedown' && $(e.target).is('img')) {
	          e.preventDefault();
	        }
	        this.pressed = true;
	        this.dragged = false;
	        this.verticalDragged = false;
	        this.reference = this._xpos(e);
	        this.referenceY = this._ypos(e);
	
	        this.velocity = this.amplitude = 0;
	        this.frame = this.offset;
	        this.timestamp = Date.now();
	        clearInterval(this.ticker);
	        this.ticker = setInterval(this._trackBound, 100);
	      }
	
	      /**
	       * Handle Carousel Drag
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleCarouselDrag",
	      value: function _handleCarouselDrag(e) {
	        var x = void 0,
	            y = void 0,
	            delta = void 0,
	            deltaY = void 0;
	        if (this.pressed) {
	          x = this._xpos(e);
	          y = this._ypos(e);
	          delta = this.reference - x;
	          deltaY = Math.abs(this.referenceY - y);
	          if (deltaY < 30 && !this.verticalDragged) {
	            // If vertical scrolling don't allow dragging.
	            if (delta > 2 || delta < -2) {
	              this.dragged = true;
	              this.reference = x;
	              this._scroll(this.offset + delta);
	            }
	          } else if (this.dragged) {
	            // If dragging don't allow vertical scroll.
	            e.preventDefault();
	            e.stopPropagation();
	            return false;
	          } else {
	            // Vertical scrolling.
	            this.verticalDragged = true;
	          }
	        }
	
	        if (this.dragged) {
	          // If dragging don't allow vertical scroll.
	          e.preventDefault();
	          e.stopPropagation();
	          return false;
	        }
	      }
	
	      /**
	       * Handle Carousel Release
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleCarouselRelease",
	      value: function _handleCarouselRelease(e) {
	        if (this.pressed) {
	          this.pressed = false;
	        } else {
	          return;
	        }
	
	        clearInterval(this.ticker);
	        this.target = this.offset;
	        if (this.velocity > 10 || this.velocity < -10) {
	          this.amplitude = 0.9 * this.velocity;
	          this.target = this.offset + this.amplitude;
	        }
	        this.target = Math.round(this.target / this.dim) * this.dim;
	
	        // No wrap of items.
	        if (this.noWrap) {
	          if (this.target >= this.dim * (this.count - 1)) {
	            this.target = this.dim * (this.count - 1);
	          } else if (this.target < 0) {
	            this.target = 0;
	          }
	        }
	        this.amplitude = this.target - this.offset;
	        this.timestamp = Date.now();
	        requestAnimationFrame(this._autoScrollBound);
	
	        if (this.dragged) {
	          e.preventDefault();
	          e.stopPropagation();
	        }
	        return false;
	      }
	
	      /**
	       * Handle Carousel CLick
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleCarouselClick",
	      value: function _handleCarouselClick(e) {
	        // Disable clicks if carousel was dragged.
	        if (this.dragged) {
	          e.preventDefault();
	          e.stopPropagation();
	          return false;
	        } else if (!this.options.fullWidth) {
	          var clickedIndex = $(e.target).closest('.carousel-item').index();
	          var diff = this._wrap(this.center) - clickedIndex;
	
	          // Disable clicks if carousel was shifted by click
	          if (diff !== 0) {
	            e.preventDefault();
	            e.stopPropagation();
	          }
	          this._cycleTo(clickedIndex);
	        }
	      }
	
	      /**
	       * Handle Indicator CLick
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleIndicatorClick",
	      value: function _handleIndicatorClick(e) {
	        e.stopPropagation();
	
	        var indicator = $(e.target).closest('.indicator-item');
	        if (indicator.length) {
	          this._cycleTo(indicator.index());
	        }
	      }
	
	      /**
	       * Handle Throttle Resize
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleResize",
	      value: function _handleResize(e) {
	        if (this.options.fullWidth) {
	          this.itemWidth = this.$el.find('.carousel-item').first().innerWidth();
	          this.imageHeight = this.$el.find('.carousel-item.active').height();
	          this.dim = this.itemWidth * 2 + this.options.padding;
	          this.offset = this.center * 2 * this.itemWidth;
	          this.target = this.offset;
	          this._setCarouselHeight(true);
	        } else {
	          this._scroll();
	        }
	      }
	
	      /**
	       * Set carousel height based on first slide
	       * @param {Booleam} imageOnly - true for image slides
	       */
	
	    }, {
	      key: "_setCarouselHeight",
	      value: function _setCarouselHeight(imageOnly) {
	        var _this65 = this;
	
	        var firstSlide = this.$el.find('.carousel-item.active').length ? this.$el.find('.carousel-item.active').first() : this.$el.find('.carousel-item').first();
	        var firstImage = firstSlide.find('img').first();
	        if (firstImage.length) {
	          if (firstImage[0].complete) {
	            // If image won't trigger the load event
	            var imageHeight = firstImage.height();
	            if (imageHeight > 0) {
	              this.$el.css('height', imageHeight + 'px');
	            } else {
	              // If image still has no height, use the natural dimensions to calculate
	              var naturalWidth = firstImage[0].naturalWidth;
	              var naturalHeight = firstImage[0].naturalHeight;
	              var adjustedHeight = this.$el.width() / naturalWidth * naturalHeight;
	              this.$el.css('height', adjustedHeight + 'px');
	            }
	          } else {
	            // Get height when image is loaded normally
	            firstImage.one('load', function (el, i) {
	              _this65.$el.css('height', el.offsetHeight + 'px');
	            });
	          }
	        } else if (!imageOnly) {
	          var slideHeight = firstSlide.height();
	          this.$el.css('height', slideHeight + 'px');
	        }
	      }
	
	      /**
	       * Get x position from event
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_xpos",
	      value: function _xpos(e) {
	        // touch event
	        if (e.targetTouches && e.targetTouches.length >= 1) {
	          return e.targetTouches[0].clientX;
	        }
	
	        // mouse event
	        return e.clientX;
	      }
	
	      /**
	       * Get y position from event
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_ypos",
	      value: function _ypos(e) {
	        // touch event
	        if (e.targetTouches && e.targetTouches.length >= 1) {
	          return e.targetTouches[0].clientY;
	        }
	
	        // mouse event
	        return e.clientY;
	      }
	
	      /**
	       * Wrap index
	       * @param {Number} x
	       */
	
	    }, {
	      key: "_wrap",
	      value: function _wrap(x) {
	        return x >= this.count ? x % this.count : x < 0 ? this._wrap(this.count + x % this.count) : x;
	      }
	
	      /**
	       * Tracks scrolling information
	       */
	
	    }, {
	      key: "_track",
	      value: function _track() {
	        var now = void 0,
	            elapsed = void 0,
	            delta = void 0,
	            v = void 0;
	
	        now = Date.now();
	        elapsed = now - this.timestamp;
	        this.timestamp = now;
	        delta = this.offset - this.frame;
	        this.frame = this.offset;
	
	        v = 1000 * delta / (1 + elapsed);
	        this.velocity = 0.8 * v + 0.2 * this.velocity;
	      }
	
	      /**
	       * Auto scrolls to nearest carousel item.
	       */
	
	    }, {
	      key: "_autoScroll",
	      value: function _autoScroll() {
	        var elapsed = void 0,
	            delta = void 0;
	
	        if (this.amplitude) {
	          elapsed = Date.now() - this.timestamp;
	          delta = this.amplitude * Math.exp(-elapsed / this.options.duration);
	          if (delta > 2 || delta < -2) {
	            this._scroll(this.target - delta);
	            requestAnimationFrame(this._autoScrollBound);
	          } else {
	            this._scroll(this.target);
	          }
	        }
	      }
	
	      /**
	       * Scroll to target
	       * @param {Number} x
	       */
	
	    }, {
	      key: "_scroll",
	      value: function _scroll(x) {
	        var _this66 = this;
	
	        // Track scrolling state
	        if (!this.$el.hasClass('scrolling')) {
	          this.el.classList.add('scrolling');
	        }
	        if (this.scrollingTimeout != null) {
	          window.clearTimeout(this.scrollingTimeout);
	        }
	        this.scrollingTimeout = window.setTimeout(function () {
	          _this66.$el.removeClass('scrolling');
	        }, this.options.duration);
	
	        // Start actual scroll
	        var i = void 0,
	            half = void 0,
	            delta = void 0,
	            dir = void 0,
	            tween = void 0,
	            el = void 0,
	            alignment = void 0,
	            zTranslation = void 0,
	            tweenedOpacity = void 0,
	            centerTweenedOpacity = void 0;
	        var lastCenter = this.center;
	        var numVisibleOffset = 1 / this.options.numVisible;
	
	        this.offset = typeof x === 'number' ? x : this.offset;
	        this.center = Math.floor((this.offset + this.dim / 2) / this.dim);
	        delta = this.offset - this.center * this.dim;
	        dir = delta < 0 ? 1 : -1;
	        tween = -dir * delta * 2 / this.dim;
	        half = this.count >> 1;
	
	        if (this.options.fullWidth) {
	          alignment = 'translateX(0)';
	          centerTweenedOpacity = 1;
	        } else {
	          alignment = 'translateX(' + (this.el.clientWidth - this.itemWidth) / 2 + 'px) ';
	          alignment += 'translateY(' + (this.el.clientHeight - this.itemHeight) / 2 + 'px)';
	          centerTweenedOpacity = 1 - numVisibleOffset * tween;
	        }
	
	        // Set indicator active
	        if (this.showIndicators) {
	          var diff = this.center % this.count;
	          var activeIndicator = this.$indicators.find('.indicator-item.active');
	          if (activeIndicator.index() !== diff) {
	            activeIndicator.removeClass('active');
	            this.$indicators.find('.indicator-item').eq(diff)[0].classList.add('active');
	          }
	        }
	
	        // center
	        // Don't show wrapped items.
	        if (!this.noWrap || this.center >= 0 && this.center < this.count) {
	          el = this.images[this._wrap(this.center)];
	
	          // Add active class to center item.
	          if (!$(el).hasClass('active')) {
	            this.$el.find('.carousel-item').removeClass('active');
	            el.classList.add('active');
	          }
	          var transformString = alignment + " translateX(" + -delta / 2 + "px) translateX(" + dir * this.options.shift * tween * i + "px) translateZ(" + this.options.dist * tween + "px)";
	          this._updateItemStyle(el, centerTweenedOpacity, 0, transformString);
	        }
	
	        for (i = 1; i <= half; ++i) {
	          // right side
	          if (this.options.fullWidth) {
	            zTranslation = this.options.dist;
	            tweenedOpacity = i === half && delta < 0 ? 1 - tween : 1;
	          } else {
	            zTranslation = this.options.dist * (i * 2 + tween * dir);
	            tweenedOpacity = 1 - numVisibleOffset * (i * 2 + tween * dir);
	          }
	          // Don't show wrapped items.
	          if (!this.noWrap || this.center + i < this.count) {
	            el = this.images[this._wrap(this.center + i)];
	            var _transformString = alignment + " translateX(" + (this.options.shift + (this.dim * i - delta) / 2) + "px) translateZ(" + zTranslation + "px)";
	            this._updateItemStyle(el, tweenedOpacity, -i, _transformString);
	          }
	
	          // left side
	          if (this.options.fullWidth) {
	            zTranslation = this.options.dist;
	            tweenedOpacity = i === half && delta > 0 ? 1 - tween : 1;
	          } else {
	            zTranslation = this.options.dist * (i * 2 - tween * dir);
	            tweenedOpacity = 1 - numVisibleOffset * (i * 2 - tween * dir);
	          }
	          // Don't show wrapped items.
	          if (!this.noWrap || this.center - i >= 0) {
	            el = this.images[this._wrap(this.center - i)];
	            var _transformString2 = alignment + " translateX(" + (-this.options.shift + (-this.dim * i - delta) / 2) + "px) translateZ(" + zTranslation + "px)";
	            this._updateItemStyle(el, tweenedOpacity, -i, _transformString2);
	          }
	        }
	
	        // center
	        // Don't show wrapped items.
	        if (!this.noWrap || this.center >= 0 && this.center < this.count) {
	          el = this.images[this._wrap(this.center)];
	          var _transformString3 = alignment + " translateX(" + -delta / 2 + "px) translateX(" + dir * this.options.shift * tween + "px) translateZ(" + this.options.dist * tween + "px)";
	          this._updateItemStyle(el, centerTweenedOpacity, 0, _transformString3);
	        }
	
	        // onCycleTo callback
	        var $currItem = this.$el.find('.carousel-item').eq(this._wrap(this.center));
	        if (lastCenter !== this.center && typeof this.options.onCycleTo === 'function') {
	          this.options.onCycleTo.call(this, $currItem[0], this.dragged);
	        }
	
	        // One time callback
	        if (typeof this.oneTimeCallback === 'function') {
	          this.oneTimeCallback.call(this, $currItem[0], this.dragged);
	          this.oneTimeCallback = null;
	        }
	      }
	
	      /**
	       * Cycle to target
	       * @param {Element} el
	       * @param {Number} opacity
	       * @param {Number} zIndex
	       * @param {String} transform
	       */
	
	    }, {
	      key: "_updateItemStyle",
	      value: function _updateItemStyle(el, opacity, zIndex, transform) {
	        el.style[this.xform] = transform;
	        el.style.zIndex = zIndex;
	        el.style.opacity = opacity;
	        el.style.visibility = 'visible';
	      }
	
	      /**
	       * Cycle to target
	       * @param {Number} n
	       * @param {Function} callback
	       */
	
	    }, {
	      key: "_cycleTo",
	      value: function _cycleTo(n, callback) {
	        var diff = this.center % this.count - n;
	
	        // Account for wraparound.
	        if (!this.noWrap) {
	          if (diff < 0) {
	            if (Math.abs(diff + this.count) < Math.abs(diff)) {
	              diff += this.count;
	            }
	          } else if (diff > 0) {
	            if (Math.abs(diff - this.count) < diff) {
	              diff -= this.count;
	            }
	          }
	        }
	
	        this.target = this.dim * Math.round(this.offset / this.dim);
	        // Next
	        if (diff < 0) {
	          this.target += this.dim * Math.abs(diff);
	
	          // Prev
	        } else if (diff > 0) {
	          this.target -= this.dim * diff;
	        }
	
	        // Set one time callback
	        if (typeof callback === 'function') {
	          this.oneTimeCallback = callback;
	        }
	
	        // Scroll
	        if (this.offset !== this.target) {
	          this.amplitude = this.target - this.offset;
	          this.timestamp = Date.now();
	          requestAnimationFrame(this._autoScrollBound);
	        }
	      }
	
	      /**
	       * Cycle to next item
	       * @param {Number} [n]
	       */
	
	    }, {
	      key: "next",
	      value: function next(n) {
	        if (n === undefined || isNaN(n)) {
	          n = 1;
	        }
	
	        var index = this.center + n;
	        if (index >= this.count || index < 0) {
	          if (this.noWrap) {
	            return;
	          }
	
	          index = this._wrap(index);
	        }
	        this._cycleTo(index);
	      }
	
	      /**
	       * Cycle to previous item
	       * @param {Number} [n]
	       */
	
	    }, {
	      key: "prev",
	      value: function prev(n) {
	        if (n === undefined || isNaN(n)) {
	          n = 1;
	        }
	
	        var index = this.center - n;
	        if (index >= this.count || index < 0) {
	          if (this.noWrap) {
	            return;
	          }
	
	          index = this._wrap(index);
	        }
	
	        this._cycleTo(index);
	      }
	
	      /**
	       * Cycle to nth item
	       * @param {Number} [n]
	       * @param {Function} callback
	       */
	
	    }, {
	      key: "set",
	      value: function set(n, callback) {
	        if (n === undefined || isNaN(n)) {
	          n = 0;
	        }
	
	        if (n > this.count || n < 0) {
	          if (this.noWrap) {
	            return;
	          }
	
	          n = this._wrap(n);
	        }
	
	        this._cycleTo(n, callback);
	      }
	    }], [{
	      key: "init",
	      value: function init(els, options) {
	        return _get(Carousel.__proto__ || Object.getPrototypeOf(Carousel), "init", this).call(this, this, els, options);
	      }
	
	      /**
	       * Get Instance
	       */
	
	    }, {
	      key: "getInstance",
	      value: function getInstance(el) {
	        var domElem = !!el.jquery ? el[0] : el;
	        return domElem.M_Carousel;
	      }
	    }, {
	      key: "defaults",
	      get: function get() {
	        return _defaults;
	      }
	    }]);
	
	    return Carousel;
	  }(Component);
	
	  M.Carousel = Carousel;
	
	  if (M.jQueryLoaded) {
	    M.initializeJqueryWrapper(Carousel, 'carousel', 'M_Carousel');
	  }
	})(cash);
	;(function ($) {
	  'use strict';
	
	  var _defaults = {
	    onOpen: undefined,
	    onClose: undefined
	  };
	
	  /**
	   * @class
	   *
	   */
	
	  var TapTarget = function (_Component19) {
	    _inherits(TapTarget, _Component19);
	
	    /**
	     * Construct TapTarget instance
	     * @constructor
	     * @param {Element} el
	     * @param {Object} options
	     */
	    function TapTarget(el, options) {
	      _classCallCheck(this, TapTarget);
	
	      var _this67 = _possibleConstructorReturn(this, (TapTarget.__proto__ || Object.getPrototypeOf(TapTarget)).call(this, TapTarget, el, options));
	
	      _this67.el.M_TapTarget = _this67;
	
	      /**
	       * Options for the select
	       * @member TapTarget#options
	       * @prop {Function} onOpen - Callback function called when feature discovery is opened
	       * @prop {Function} onClose - Callback function called when feature discovery is closed
	       */
	      _this67.options = $.extend({}, TapTarget.defaults, options);
	
	      _this67.isOpen = false;
	
	      // setup
	      _this67.$origin = $('#' + _this67.$el.attr('data-target'));
	      _this67._setup();
	
	      _this67._calculatePositioning();
	      _this67._setupEventHandlers();
	      return _this67;
	    }
	
	    _createClass(TapTarget, [{
	      key: "destroy",
	
	      /**
	       * Teardown component
	       */
	      value: function destroy() {
	        this._removeEventHandlers();
	        this.el.TapTarget = undefined;
	      }
	
	      /**
	       * Setup Event Handlers
	       */
	
	    }, {
	      key: "_setupEventHandlers",
	      value: function _setupEventHandlers() {
	        this._handleDocumentClickBound = this._handleDocumentClick.bind(this);
	        this._handleTargetClickBound = this._handleTargetClick.bind(this);
	        this._handleOriginClickBound = this._handleOriginClick.bind(this);
	
	        this.el.addEventListener('click', this._handleTargetClickBound);
	        this.originEl.addEventListener('click', this._handleOriginClickBound);
	
	        // Resize
	        var throttledResize = M.throttle(this._handleResize, 200);
	        this._handleThrottledResizeBound = throttledResize.bind(this);
	
	        window.addEventListener('resize', this._handleThrottledResizeBound);
	      }
	
	      /**
	       * Remove Event Handlers
	       */
	
	    }, {
	      key: "_removeEventHandlers",
	      value: function _removeEventHandlers() {
	        this.el.removeEventListener('click', this._handleTargetClickBound);
	        this.originEl.removeEventListener('click', this._handleOriginClickBound);
	        window.removeEventListener('resize', this._handleThrottledResizeBound);
	      }
	
	      /**
	       * Handle Target Click
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleTargetClick",
	      value: function _handleTargetClick(e) {
	        this.open();
	      }
	
	      /**
	       * Handle Origin Click
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleOriginClick",
	      value: function _handleOriginClick(e) {
	        this.close();
	      }
	
	      /**
	       * Handle Resize
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleResize",
	      value: function _handleResize(e) {
	        this._calculatePositioning();
	      }
	
	      /**
	       * Handle Resize
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleDocumentClick",
	      value: function _handleDocumentClick(e) {
	        if (!$(e.target).closest('.tap-target-wrapper').length) {
	          this.close();
	          e.preventDefault();
	          e.stopPropagation();
	        }
	      }
	
	      /**
	       * Setup Tap Target
	       */
	
	    }, {
	      key: "_setup",
	      value: function _setup() {
	        // Creating tap target
	        this.wrapper = this.$el.parent()[0];
	        this.waveEl = $(this.wrapper).find('.tap-target-wave')[0];
	        this.originEl = $(this.wrapper).find('.tap-target-origin')[0];
	        this.contentEl = this.$el.find('.tap-target-content')[0];
	
	        // Creating wrapper
	        if (!$(this.wrapper).hasClass('.tap-target-wrapper')) {
	          this.wrapper = document.createElement('div');
	          this.wrapper.classList.add('tap-target-wrapper');
	          this.$el.before($(this.wrapper));
	          this.wrapper.append(this.el);
	        }
	
	        // Creating content
	        if (!this.contentEl) {
	          this.contentEl = document.createElement('div');
	          this.contentEl.classList.add('tap-target-content');
	          this.$el.append(this.contentEl);
	        }
	
	        // Creating foreground wave
	        if (!this.waveEl) {
	          this.waveEl = document.createElement('div');
	          this.waveEl.classList.add('tap-target-wave');
	
	          // Creating origin
	          if (!this.originEl) {
	            this.originEl = this.$origin.clone(true, true);
	            this.originEl.addClass('tap-target-origin');
	            this.originEl.removeAttr('id');
	            this.originEl.removeAttr('style');
	            this.originEl = this.originEl[0];
	            this.waveEl.append(this.originEl);
	          }
	
	          this.wrapper.append(this.waveEl);
	        }
	      }
	
	      /**
	       * Calculate positioning
	       */
	
	    }, {
	      key: "_calculatePositioning",
	      value: function _calculatePositioning() {
	        // Element or parent is fixed position?
	        var isFixed = this.$origin.css('position') === 'fixed';
	        if (!isFixed) {
	          var parents = this.$origin.parents();
	          for (var i = 0; i < parents.length; i++) {
	            isFixed = $(parents[i]).css('position') == 'fixed';
	            if (isFixed) {
	              break;
	            }
	          }
	        }
	
	        // Calculating origin
	        var originWidth = this.$origin.outerWidth();
	        var originHeight = this.$origin.outerHeight();
	        var originTop = isFixed ? this.$origin.offset().top - M.getDocumentScrollTop() : this.$origin.offset().top;
	        var originLeft = isFixed ? this.$origin.offset().left - M.getDocumentScrollLeft() : this.$origin.offset().left;
	
	        // Calculating screen
	        var windowWidth = window.innerWidth;
	        var windowHeight = window.innerHeight;
	        var centerX = windowWidth / 2;
	        var centerY = windowHeight / 2;
	        var isLeft = originLeft <= centerX;
	        var isRight = originLeft > centerX;
	        var isTop = originTop <= centerY;
	        var isBottom = originTop > centerY;
	        var isCenterX = originLeft >= windowWidth * 0.25 && originLeft <= windowWidth * 0.75;
	
	        // Calculating tap target
	        var tapTargetWidth = this.$el.outerWidth();
	        var tapTargetHeight = this.$el.outerHeight();
	        var tapTargetTop = originTop + originHeight / 2 - tapTargetHeight / 2;
	        var tapTargetLeft = originLeft + originWidth / 2 - tapTargetWidth / 2;
	        var tapTargetPosition = isFixed ? 'fixed' : 'absolute';
	
	        // Calculating content
	        var tapTargetTextWidth = isCenterX ? tapTargetWidth : tapTargetWidth / 2 + originWidth;
	        var tapTargetTextHeight = tapTargetHeight / 2;
	        var tapTargetTextTop = isTop ? tapTargetHeight / 2 : 0;
	        var tapTargetTextBottom = 0;
	        var tapTargetTextLeft = isLeft && !isCenterX ? tapTargetWidth / 2 - originWidth : 0;
	        var tapTargetTextRight = 0;
	        var tapTargetTextPadding = originWidth;
	        var tapTargetTextAlign = isBottom ? 'bottom' : 'top';
	
	        // Calculating wave
	        var tapTargetWaveWidth = originWidth > originHeight ? originWidth * 2 : originWidth * 2;
	        var tapTargetWaveHeight = tapTargetWaveWidth;
	        var tapTargetWaveTop = tapTargetHeight / 2 - tapTargetWaveHeight / 2;
	        var tapTargetWaveLeft = tapTargetWidth / 2 - tapTargetWaveWidth / 2;
	
	        // Setting tap target
	        var tapTargetWrapperCssObj = {};
	        tapTargetWrapperCssObj.top = isTop ? tapTargetTop + 'px' : '';
	        tapTargetWrapperCssObj.right = isRight ? windowWidth - tapTargetLeft - tapTargetWidth + 'px' : '';
	        tapTargetWrapperCssObj.bottom = isBottom ? windowHeight - tapTargetTop - tapTargetHeight + 'px' : '';
	        tapTargetWrapperCssObj.left = isLeft ? tapTargetLeft + 'px' : '';
	        tapTargetWrapperCssObj.position = tapTargetPosition;
	        $(this.wrapper).css(tapTargetWrapperCssObj);
	
	        // Setting content
	        $(this.contentEl).css({
	          width: tapTargetTextWidth + 'px',
	          height: tapTargetTextHeight + 'px',
	          top: tapTargetTextTop + 'px',
	          right: tapTargetTextRight + 'px',
	          bottom: tapTargetTextBottom + 'px',
	          left: tapTargetTextLeft + 'px',
	          padding: tapTargetTextPadding + 'px',
	          verticalAlign: tapTargetTextAlign
	        });
	
	        // Setting wave
	        $(this.waveEl).css({
	          top: tapTargetWaveTop + 'px',
	          left: tapTargetWaveLeft + 'px',
	          width: tapTargetWaveWidth + 'px',
	          height: tapTargetWaveHeight + 'px'
	        });
	      }
	
	      /**
	       * Open TapTarget
	       */
	
	    }, {
	      key: "open",
	      value: function open() {
	        if (this.isOpen) {
	          return;
	        }
	
	        // onOpen callback
	        if (typeof this.options.onOpen === 'function') {
	          this.options.onOpen.call(this, this.$origin[0]);
	        }
	
	        this.isOpen = true;
	        this.wrapper.classList.add('open');
	
	        document.body.addEventListener('click', this._handleDocumentClickBound, true);
	        document.body.addEventListener('touchend', this._handleDocumentClickBound);
	      }
	
	      /**
	       * Close Tap Target
	       */
	
	    }, {
	      key: "close",
	      value: function close() {
	        if (!this.isOpen) {
	          return;
	        }
	
	        // onClose callback
	        if (typeof this.options.onClose === 'function') {
	          this.options.onClose.call(this, this.$origin[0]);
	        }
	
	        this.isOpen = false;
	        this.wrapper.classList.remove('open');
	
	        document.body.removeEventListener('click', this._handleDocumentClickBound, true);
	        document.body.removeEventListener('touchend', this._handleDocumentClickBound);
	      }
	    }], [{
	      key: "init",
	      value: function init(els, options) {
	        return _get(TapTarget.__proto__ || Object.getPrototypeOf(TapTarget), "init", this).call(this, this, els, options);
	      }
	
	      /**
	       * Get Instance
	       */
	
	    }, {
	      key: "getInstance",
	      value: function getInstance(el) {
	        var domElem = !!el.jquery ? el[0] : el;
	        return domElem.M_TapTarget;
	      }
	    }, {
	      key: "defaults",
	      get: function get() {
	        return _defaults;
	      }
	    }]);
	
	    return TapTarget;
	  }(Component);
	
	  M.TapTarget = TapTarget;
	
	  if (M.jQueryLoaded) {
	    M.initializeJqueryWrapper(TapTarget, 'tapTarget', 'M_TapTarget');
	  }
	})(cash);
	;(function ($) {
	  'use strict';
	
	  var _defaults = {
	    classes: '',
	    dropdownOptions: {}
	  };
	
	  /**
	   * @class
	   *
	   */
	
	  var FormSelect = function (_Component20) {
	    _inherits(FormSelect, _Component20);
	
	    /**
	     * Construct FormSelect instance
	     * @constructor
	     * @param {Element} el
	     * @param {Object} options
	     */
	    function FormSelect(el, options) {
	      _classCallCheck(this, FormSelect);
	
	      // Don't init if browser default version
	      var _this68 = _possibleConstructorReturn(this, (FormSelect.__proto__ || Object.getPrototypeOf(FormSelect)).call(this, FormSelect, el, options));
	
	      if (_this68.$el.hasClass('browser-default')) {
	        return _possibleConstructorReturn(_this68);
	      }
	
	      _this68.el.M_FormSelect = _this68;
	
	      /**
	       * Options for the select
	       * @member FormSelect#options
	       */
	      _this68.options = $.extend({}, FormSelect.defaults, options);
	
	      _this68.isMultiple = _this68.$el.prop('multiple');
	
	      // Setup
	      _this68.el.tabIndex = -1;
	      _this68._keysSelected = {};
	      _this68._valueDict = {}; // Maps key to original and generated option element.
	      _this68._setupDropdown();
	
	      _this68._setupEventHandlers();
	      return _this68;
	    }
	
	    _createClass(FormSelect, [{
	      key: "destroy",
	
	      /**
	       * Teardown component
	       */
	      value: function destroy() {
	        this._removeEventHandlers();
	        this._removeDropdown();
	        this.el.M_FormSelect = undefined;
	      }
	
	      /**
	       * Setup Event Handlers
	       */
	
	    }, {
	      key: "_setupEventHandlers",
	      value: function _setupEventHandlers() {
	        var _this69 = this;
	
	        this._handleSelectChangeBound = this._handleSelectChange.bind(this);
	        this._handleOptionClickBound = this._handleOptionClick.bind(this);
	        this._handleInputClickBound = this._handleInputClick.bind(this);
	
	        $(this.dropdownOptions).find('li:not(.optgroup)').each(function (el) {
	          el.addEventListener('click', _this69._handleOptionClickBound);
	        });
	        this.el.addEventListener('change', this._handleSelectChangeBound);
	        this.input.addEventListener('click', this._handleInputClickBound);
	      }
	
	      /**
	       * Remove Event Handlers
	       */
	
	    }, {
	      key: "_removeEventHandlers",
	      value: function _removeEventHandlers() {
	        var _this70 = this;
	
	        $(this.dropdownOptions).find('li:not(.optgroup)').each(function (el) {
	          el.removeEventListener('click', _this70._handleOptionClickBound);
	        });
	        this.el.removeEventListener('change', this._handleSelectChangeBound);
	        this.input.removeEventListener('click', this._handleInputClickBound);
	      }
	
	      /**
	       * Handle Select Change
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleSelectChange",
	      value: function _handleSelectChange(e) {
	        this._setValueToInput();
	      }
	
	      /**
	       * Handle Option Click
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleOptionClick",
	      value: function _handleOptionClick(e) {
	        e.preventDefault();
	        var option = $(e.target).closest('li')[0];
	        var key = option.id;
	        if (!$(option).hasClass('disabled') && !$(option).hasClass('optgroup') && key.length) {
	          var selected = true;
	
	          if (this.isMultiple) {
	            // Deselect placeholder option if still selected.
	            var placeholderOption = $(this.dropdownOptions).find('li.disabled.selected');
	            if (placeholderOption.length) {
	              placeholderOption.removeClass('selected');
	              placeholderOption.find('input[type="checkbox"]').prop('checked', false);
	              this._toggleEntryFromArray(placeholderOption[0].id);
	            }
	            selected = this._toggleEntryFromArray(key);
	          } else {
	            $(this.dropdownOptions).find('li').removeClass('selected');
	            $(option).toggleClass('selected', selected);
	          }
	
	          // Set selected on original select option
	          // Only trigger if selected state changed
	          var prevSelected = $(this._valueDict[key].el).prop('selected');
	          if (prevSelected !== selected) {
	            $(this._valueDict[key].el).prop('selected', selected);
	            this.$el.trigger('change');
	          }
	        }
	
	        e.stopPropagation();
	      }
	
	      /**
	       * Handle Input Click
	       */
	
	    }, {
	      key: "_handleInputClick",
	      value: function _handleInputClick() {
	        if (this.dropdown && this.dropdown.isOpen) {
	          this._setValueToInput();
	          this._setSelectedStates();
	        }
	      }
	
	      /**
	       * Setup dropdown
	       */
	
	    }, {
	      key: "_setupDropdown",
	      value: function _setupDropdown() {
	        var _this71 = this;
	
	        this.wrapper = document.createElement('div');
	        $(this.wrapper).addClass('select-wrapper ' + this.options.classes);
	        this.$el.before($(this.wrapper));
	        this.wrapper.appendChild(this.el);
	
	        if (this.el.disabled) {
	          this.wrapper.classList.add('disabled');
	        }
	
	        // Create dropdown
	        this.$selectOptions = this.$el.children('option, optgroup');
	        this.dropdownOptions = document.createElement('ul');
	        this.dropdownOptions.id = "select-options-" + M.guid();
	        $(this.dropdownOptions).addClass('dropdown-content select-dropdown ' + (this.isMultiple ? 'multiple-select-dropdown' : ''));
	
	        // Create dropdown structure.
	        if (this.$selectOptions.length) {
	          this.$selectOptions.each(function (el) {
	            if ($(el).is('option')) {
	              // Direct descendant option.
	              var optionEl = void 0;
	              if (_this71.isMultiple) {
	                optionEl = _this71._appendOptionWithIcon(_this71.$el, el, 'multiple');
	              } else {
	                optionEl = _this71._appendOptionWithIcon(_this71.$el, el);
	              }
	
	              _this71._addOptionToValueDict(el, optionEl);
	            } else if ($(el).is('optgroup')) {
	              // Optgroup.
	              var selectOptions = $(el).children('option');
	              $(_this71.dropdownOptions).append($('<li class="optgroup"><span>' + el.getAttribute('label') + '</span></li>')[0]);
	
	              selectOptions.each(function (el) {
	                var optionEl = _this71._appendOptionWithIcon(_this71.$el, el, 'optgroup-option');
	                _this71._addOptionToValueDict(el, optionEl);
	              });
	            }
	          });
	        }
	
	        this.$el.after(this.dropdownOptions);
	
	        // Add input dropdown
	        this.input = document.createElement('input');
	        $(this.input).addClass('select-dropdown dropdown-trigger');
	        this.input.setAttribute('type', 'text');
	        this.input.setAttribute('readonly', 'true');
	        this.input.setAttribute('data-target', this.dropdownOptions.id);
	        if (this.el.disabled) {
	          $(this.input).prop('disabled', 'true');
	        }
	
	        this.$el.before(this.input);
	        this._setValueToInput();
	
	        // Add caret
	        var dropdownIcon = $('<svg class="caret" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/><path d="M0 0h24v24H0z" fill="none"/></svg>');
	        this.$el.before(dropdownIcon[0]);
	
	        // Initialize dropdown
	        if (!this.el.disabled) {
	          var dropdownOptions = $.extend({}, this.options.dropdownOptions);
	
	          // Add callback for centering selected option when dropdown content is scrollable
	          dropdownOptions.onOpenEnd = function (el) {
	            var selectedOption = $(_this71.dropdownOptions).find('.selected').first();
	            if (_this71.dropdown.isScrollable && selectedOption.length) {
	              var scrollOffset = selectedOption[0].getBoundingClientRect().top - _this71.dropdownOptions.getBoundingClientRect().top; // scroll to selected option
	              scrollOffset -= _this71.dropdownOptions.clientHeight / 2; // center in dropdown
	              _this71.dropdownOptions.scrollTop = scrollOffset;
	            }
	          };
	
	          if (this.isMultiple) {
	            dropdownOptions.closeOnClick = false;
	          }
	          this.dropdown = M.Dropdown.init(this.input, dropdownOptions);
	        }
	
	        // Add initial selections
	        this._setSelectedStates();
	      }
	
	      /**
	       * Add option to value dict
	       * @param {Element} el  original option element
	       * @param {Element} optionEl  generated option element
	       */
	
	    }, {
	      key: "_addOptionToValueDict",
	      value: function _addOptionToValueDict(el, optionEl) {
	        var index = Object.keys(this._valueDict).length;
	        var key = this.dropdownOptions.id + index;
	        var obj = {};
	        optionEl.id = key;
	
	        obj.el = el;
	        obj.optionEl = optionEl;
	        this._valueDict[key] = obj;
	      }
	
	      /**
	       * Remove dropdown
	       */
	
	    }, {
	      key: "_removeDropdown",
	      value: function _removeDropdown() {
	        $(this.wrapper).find('.caret').remove();
	        $(this.input).remove();
	        $(this.dropdownOptions).remove();
	        $(this.wrapper).before(this.$el);
	        $(this.wrapper).remove();
	      }
	
	      /**
	       * Setup dropdown
	       * @param {Element} select  select element
	       * @param {Element} option  option element from select
	       * @param {String} type
	       * @return {Element}  option element added
	       */
	
	    }, {
	      key: "_appendOptionWithIcon",
	      value: function _appendOptionWithIcon(select, option, type) {
	        // Add disabled attr if disabled
	        var disabledClass = option.disabled ? 'disabled ' : '';
	        var optgroupClass = type === 'optgroup-option' ? 'optgroup-option ' : '';
	        var multipleCheckbox = this.isMultiple ? "<label><input type=\"checkbox\"" + disabledClass + "\"/><span>" + option.innerHTML + "</span></label>" : option.innerHTML;
	        var liEl = $('<li></li>');
	        var spanEl = $('<span></span>');
	        spanEl.html(multipleCheckbox);
	        liEl.addClass(disabledClass + " " + optgroupClass);
	        liEl.append(spanEl);
	
	        // add icons
	        var iconUrl = option.getAttribute('data-icon');
	        if (!!iconUrl) {
	          var imgEl = $("<img alt=\"\" src=\"" + iconUrl + "\">");
	          liEl.prepend(imgEl);
	        }
	
	        // Check for multiple type.
	        $(this.dropdownOptions).append(liEl[0]);
	        return liEl[0];
	      }
	
	      /**
	       * Toggle entry from option
	       * @param {String} key  Option key
	       * @return {Boolean}  if entry was added or removed
	       */
	
	    }, {
	      key: "_toggleEntryFromArray",
	      value: function _toggleEntryFromArray(key) {
	        var notAdded = !this._keysSelected.hasOwnProperty(key);
	        var $optionLi = $(this._valueDict[key].optionEl);
	
	        if (notAdded) {
	          this._keysSelected[key] = true;
	        } else {
	          delete this._keysSelected[key];
	        }
	
	        $optionLi.toggleClass('selected', notAdded);
	
	        // Set checkbox checked value
	        $optionLi.find('input[type="checkbox"]').prop('checked', notAdded);
	
	        // use notAdded instead of true (to detect if the option is selected or not)
	        $optionLi.prop('selected', notAdded);
	
	        return notAdded;
	      }
	
	      /**
	       * Set text value to input
	       */
	
	    }, {
	      key: "_setValueToInput",
	      value: function _setValueToInput() {
	        var values = [];
	        var options = this.$el.find('option');
	
	        options.each(function (el) {
	          if ($(el).prop('selected')) {
	            var text = $(el).text();
	            values.push(text);
	          }
	        });
	
	        if (!values.length) {
	          var firstDisabled = this.$el.find('option:disabled').eq(0);
	          if (firstDisabled.length && firstDisabled[0].value === '') {
	            values.push(firstDisabled.text());
	          }
	        }
	
	        this.input.value = values.join(', ');
	      }
	
	      /**
	       * Set selected state of dropdown to match actual select element
	       */
	
	    }, {
	      key: "_setSelectedStates",
	      value: function _setSelectedStates() {
	        this._keysSelected = {};
	
	        for (var key in this._valueDict) {
	          var option = this._valueDict[key];
	          var optionIsSelected = $(option.el).prop('selected');
	          $(option.optionEl).find('input[type="checkbox"]').prop('checked', optionIsSelected);
	          if (optionIsSelected) {
	            this._activateOption($(this.dropdownOptions), $(option.optionEl));
	            this._keysSelected[key] = true;
	          } else {
	            $(option.optionEl).removeClass('selected');
	          }
	        }
	      }
	
	      /**
	       * Make option as selected and scroll to selected position
	       * @param {jQuery} collection  Select options jQuery element
	       * @param {Element} newOption  element of the new option
	       */
	
	    }, {
	      key: "_activateOption",
	      value: function _activateOption(collection, newOption) {
	        if (newOption) {
	          if (!this.isMultiple) {
	            collection.find('li.selected').removeClass('selected');
	          }
	          var option = $(newOption);
	          option.addClass('selected');
	        }
	      }
	
	      /**
	       * Get Selected Values
	       * @return {Array}  Array of selected values
	       */
	
	    }, {
	      key: "getSelectedValues",
	      value: function getSelectedValues() {
	        var selectedValues = [];
	        for (var key in this._keysSelected) {
	          selectedValues.push(this._valueDict[key].el.value);
	        }
	        return selectedValues;
	      }
	    }], [{
	      key: "init",
	      value: function init(els, options) {
	        return _get(FormSelect.__proto__ || Object.getPrototypeOf(FormSelect), "init", this).call(this, this, els, options);
	      }
	
	      /**
	       * Get Instance
	       */
	
	    }, {
	      key: "getInstance",
	      value: function getInstance(el) {
	        var domElem = !!el.jquery ? el[0] : el;
	        return domElem.M_FormSelect;
	      }
	    }, {
	      key: "defaults",
	      get: function get() {
	        return _defaults;
	      }
	    }]);
	
	    return FormSelect;
	  }(Component);
	
	  M.FormSelect = FormSelect;
	
	  if (M.jQueryLoaded) {
	    M.initializeJqueryWrapper(FormSelect, 'formSelect', 'M_FormSelect');
	  }
	})(cash);
	;(function ($, anim) {
	  'use strict';
	
	  var _defaults = {};
	
	  /**
	   * @class
	   *
	   */
	
	  var Range = function (_Component21) {
	    _inherits(Range, _Component21);
	
	    /**
	     * Construct Range instance
	     * @constructor
	     * @param {Element} el
	     * @param {Object} options
	     */
	    function Range(el, options) {
	      _classCallCheck(this, Range);
	
	      var _this72 = _possibleConstructorReturn(this, (Range.__proto__ || Object.getPrototypeOf(Range)).call(this, Range, el, options));
	
	      _this72.el.M_Range = _this72;
	
	      /**
	       * Options for the range
	       * @member Range#options
	       */
	      _this72.options = $.extend({}, Range.defaults, options);
	
	      _this72._mousedown = false;
	
	      // Setup
	      _this72._setupThumb();
	
	      _this72._setupEventHandlers();
	      return _this72;
	    }
	
	    _createClass(Range, [{
	      key: "destroy",
	
	      /**
	       * Teardown component
	       */
	      value: function destroy() {
	        this._removeEventHandlers();
	        this._removeThumb();
	        this.el.M_Range = undefined;
	      }
	
	      /**
	       * Setup Event Handlers
	       */
	
	    }, {
	      key: "_setupEventHandlers",
	      value: function _setupEventHandlers() {
	        this._handleRangeChangeBound = this._handleRangeChange.bind(this);
	        this._handleRangeMousedownTouchstartBound = this._handleRangeMousedownTouchstart.bind(this);
	        this._handleRangeInputMousemoveTouchmoveBound = this._handleRangeInputMousemoveTouchmove.bind(this);
	        this._handleRangeMouseupTouchendBound = this._handleRangeMouseupTouchend.bind(this);
	        this._handleRangeBlurMouseoutTouchleaveBound = this._handleRangeBlurMouseoutTouchleave.bind(this);
	
	        this.el.addEventListener('change', this._handleRangeChangeBound);
	
	        this.el.addEventListener('mousedown', this._handleRangeMousedownTouchstartBound);
	        this.el.addEventListener('touchstart', this._handleRangeMousedownTouchstartBound);
	
	        this.el.addEventListener('input', this._handleRangeInputMousemoveTouchmoveBound);
	        this.el.addEventListener('mousemove', this._handleRangeInputMousemoveTouchmoveBound);
	        this.el.addEventListener('touchmove', this._handleRangeInputMousemoveTouchmoveBound);
	
	        this.el.addEventListener('mouseup', this._handleRangeMouseupTouchendBound);
	        this.el.addEventListener('touchend', this._handleRangeMouseupTouchendBound);
	
	        this.el.addEventListener('blur', this._handleRangeBlurMouseoutTouchleaveBound);
	        this.el.addEventListener('mouseout', this._handleRangeBlurMouseoutTouchleaveBound);
	        this.el.addEventListener('touchleave', this._handleRangeBlurMouseoutTouchleaveBound);
	      }
	
	      /**
	       * Remove Event Handlers
	       */
	
	    }, {
	      key: "_removeEventHandlers",
	      value: function _removeEventHandlers() {
	        this.el.removeEventListener('change', this._handleRangeChangeBound);
	
	        this.el.removeEventListener('mousedown', this._handleRangeMousedownTouchstartBound);
	        this.el.removeEventListener('touchstart', this._handleRangeMousedownTouchstartBound);
	
	        this.el.removeEventListener('input', this._handleRangeInputMousemoveTouchmoveBound);
	        this.el.removeEventListener('mousemove', this._handleRangeInputMousemoveTouchmoveBound);
	        this.el.removeEventListener('touchmove', this._handleRangeInputMousemoveTouchmoveBound);
	
	        this.el.removeEventListener('mouseup', this._handleRangeMouseupTouchendBound);
	        this.el.removeEventListener('touchend', this._handleRangeMouseupTouchendBound);
	
	        this.el.removeEventListener('blur', this._handleRangeBlurMouseoutTouchleaveBound);
	        this.el.removeEventListener('mouseout', this._handleRangeBlurMouseoutTouchleaveBound);
	        this.el.removeEventListener('touchleave', this._handleRangeBlurMouseoutTouchleaveBound);
	      }
	
	      /**
	       * Handle Range Change
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleRangeChange",
	      value: function _handleRangeChange() {
	        $(this.value).html(this.$el.val());
	
	        if (!$(this.thumb).hasClass('active')) {
	          this._showRangeBubble();
	        }
	
	        var offsetLeft = this._calcRangeOffset();
	        $(this.thumb).addClass('active').css('left', offsetLeft + 'px');
	      }
	
	      /**
	       * Handle Range Mousedown and Touchstart
	       * @param {Event} e
	       */
	
	    }, {
	      key: "_handleRangeMousedownTouchstart",
	      value: function _handleRangeMousedownTouchstart(e) {
	        // Set indicator value
	        $(this.value).html(this.$el.val());
	
	        this._mousedown = true;
	        this.$el.addClass('active');
	
	        if (!$(this.thumb).hasClass('active')) {
	          this._showRangeBubble();
	        }
	
	        if (e.type !== 'input') {
	          var offsetLeft = this._calcRangeOffset();
	          $(this.thumb).addClass('active').css('left', offsetLeft + 'px');
	        }
	      }
	
	      /**
	       * Handle Range Input, Mousemove and Touchmove
	       */
	
	    }, {
	      key: "_handleRangeInputMousemoveTouchmove",
	      value: function _handleRangeInputMousemoveTouchmove() {
	        if (this._mousedown) {
	          if (!$(this.thumb).hasClass('active')) {
	            this._showRangeBubble();
	          }
	
	          var offsetLeft = this._calcRangeOffset();
	          $(this.thumb).addClass('active').css('left', offsetLeft + 'px');
	          $(this.value).html(this.$el.val());
	        }
	      }
	
	      /**
	       * Handle Range Mouseup and Touchend
	       */
	
	    }, {
	      key: "_handleRangeMouseupTouchend",
	      value: function _handleRangeMouseupTouchend() {
	        this._mousedown = false;
	        this.$el.removeClass('active');
	      }
	
	      /**
	       * Handle Range Blur, Mouseout and Touchleave
	       */
	
	    }, {
	      key: "_handleRangeBlurMouseoutTouchleave",
	      value: function _handleRangeBlurMouseoutTouchleave() {
	        if (!this._mousedown) {
	          var paddingLeft = parseInt(this.$el.css('padding-left'));
	          var marginLeft = 7 + paddingLeft + 'px';
	
	          if ($(this.thumb).hasClass('active')) {
	            anim.remove(this.thumb);
	            anim({
	              targets: this.thumb,
	              height: 0,
	              width: 0,
	              top: 10,
	              easing: 'easeOutQuad',
	              marginLeft: marginLeft,
	              duration: 100
	            });
	          }
	          $(this.thumb).removeClass('active');
	        }
	      }
	
	      /**
	       * Setup dropdown
	       */
	
	    }, {
	      key: "_setupThumb",
	      value: function _setupThumb() {
	        this.thumb = document.createElement('span');
	        this.value = document.createElement('span');
	        $(this.thumb).addClass('thumb');
	        $(this.value).addClass('value');
	        $(this.thumb).append(this.value);
	        this.$el.after(this.thumb);
	      }
	
	      /**
	       * Remove dropdown
	       */
	
	    }, {
	      key: "_removeThumb",
	      value: function _removeThumb() {
	        $(this.thumb).remove();
	      }
	
	      /**
	       * morph thumb into bubble
	       */
	
	    }, {
	      key: "_showRangeBubble",
	      value: function _showRangeBubble() {
	        var paddingLeft = parseInt($(this.thumb).parent().css('padding-left'));
	        var marginLeft = -7 + paddingLeft + 'px'; // TODO: fix magic number?
	        anim.remove(this.thumb);
	        anim({
	          targets: this.thumb,
	          height: 30,
	          width: 30,
	          top: -30,
	          marginLeft: marginLeft,
	          duration: 300,
	          easing: 'easeOutQuint'
	        });
	      }
	
	      /**
	       * Calculate the offset of the thumb
	       * @return {Number}  offset in pixels
	       */
	
	    }, {
	      key: "_calcRangeOffset",
	      value: function _calcRangeOffset() {
	        var width = this.$el.width() - 15;
	        var max = parseFloat(this.$el.attr('max')) || 100; // Range default max
	        var min = parseFloat(this.$el.attr('min')) || 0; // Range default min
	        var percent = (parseFloat(this.$el.val()) - min) / (max - min);
	        return percent * width;
	      }
	    }], [{
	      key: "init",
	      value: function init(els, options) {
	        return _get(Range.__proto__ || Object.getPrototypeOf(Range), "init", this).call(this, this, els, options);
	      }
	
	      /**
	       * Get Instance
	       */
	
	    }, {
	      key: "getInstance",
	      value: function getInstance(el) {
	        var domElem = !!el.jquery ? el[0] : el;
	        return domElem.M_Range;
	      }
	    }, {
	      key: "defaults",
	      get: function get() {
	        return _defaults;
	      }
	    }]);
	
	    return Range;
	  }(Component);
	
	  M.Range = Range;
	
	  if (M.jQueryLoaded) {
	    M.initializeJqueryWrapper(Range, 'range', 'M_Range');
	  }
	
	  Range.init($('input[type=range]'));
	})(cash, M.anime);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-cef6a9aa92292e62b26b.js